import { KeyValue } from 'types/general';

export const svgIcons: KeyValue = {
  arrowDown: (
    <svg
      width="12"
      height="7"
      viewBox="0 0 12 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.861939 0.528721C0.986958 0.40374 1.1565 0.33353 1.33327 0.33353C1.51005 0.33353 1.67959 0.40374 1.80461 0.528721L5.99994 4.72405L10.1953 0.528721C10.2568 0.465047 10.3303 0.414259 10.4117 0.37932C10.493 0.34438 10.5805 0.32599 10.669 0.32522C10.7575 0.324451 10.8453 0.341319 10.9272 0.37484C11.0092 0.40836 11.0836 0.457863 11.1462 0.520458C11.2088 0.583053 11.2583 0.657487 11.2918 0.739418C11.3253 0.821349 11.3422 0.909135 11.3414 0.997655C11.3407 1.08617 11.3223 1.17365 11.2873 1.25499C11.2524 1.33633 11.2016 1.40989 11.1379 1.47139L6.47127 6.13805C6.34625 6.26304 6.17672 6.33325 5.99994 6.33325C5.82316 6.33325 5.65362 6.26304 5.52861 6.13805L0.861939 1.47139C0.736958 1.34637 0.666748 1.17683 0.666748 1.00005C0.666748 0.823278 0.736958 0.653739 0.861939 0.528721V0.528721Z"
        fill="#2661C5"
      />
    </svg>
  ),
  search: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.33317 0.083252C7.49815 0.0832051 8.63996 0.408763 9.62974 1.02319C10.6195 1.63761 11.4179 2.51644 11.9347 3.56051C12.4515 4.60457 12.6663 5.7723 12.5547 6.93193C12.4431 8.09155 12.0096 9.19691 11.3032 10.1233L15.2557 14.0774C15.4051 14.2274 15.4919 14.4286 15.4984 14.6402C15.5048 14.8519 15.4305 15.058 15.2905 15.2168C15.1504 15.3756 14.9552 15.4752 14.7444 15.4953C14.5337 15.5153 14.3232 15.4544 14.1557 15.3249L14.0773 15.2558L10.1232 11.3033C9.334 11.905 8.41288 12.3102 7.43604 12.4852C6.45919 12.6603 5.45469 12.6002 4.50567 12.31C3.55664 12.0198 2.69038 11.5077 1.97855 10.8162C1.26671 10.1247 0.729787 9.27363 0.41219 8.33341C0.0945934 7.39319 0.00545908 6.39085 0.152163 5.40934C0.298866 4.42784 0.67719 3.49537 1.25583 2.68911C1.83447 1.88285 2.59679 1.22597 3.4797 0.772824C4.36262 0.319681 5.34075 0.0833043 6.33317 0.083252ZM6.33317 1.74992C5.11759 1.74992 3.9518 2.2328 3.09226 3.09235C2.23272 3.95189 1.74983 5.11768 1.74983 6.33325C1.74983 7.54883 2.23272 8.71462 3.09226 9.57416C3.9518 10.4337 5.11759 10.9166 6.33317 10.9166C7.54874 10.9166 8.71453 10.4337 9.57407 9.57416C10.4336 8.71462 10.9165 7.54883 10.9165 6.33325C10.9165 5.11768 10.4336 3.95189 9.57407 3.09235C8.71453 2.2328 7.54874 1.74992 6.33317 1.74992Z"
        fill="#737373"
      />
    </svg>
  ),
  leftArrow: (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="47" height="47" rx="23.5" fill="#F6F7F9" />
      <path
        d="M27 17L20 24L27 31"
        stroke="#DC343B"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="0.5" y="0.5" width="47" height="47" rx="23.5" stroke="#F6F7F9" />
    </svg>
  ),
  rightArrow: (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="47.5"
        y="47.5"
        width="47"
        height="47"
        rx="23.5"
        transform="rotate(-180 47.5 47.5)"
        fill="#F6F7F9"
      />
      <path
        d="M21 31L28 24L21 17"
        stroke="#DC343B"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="47.5"
        y="47.5"
        width="47"
        height="47"
        rx="23.5"
        transform="rotate(-180 47.5 47.5)"
        stroke="#F6F7F9"
      />
    </svg>
  ),
  gstIcon: (
    <svg
      width="41"
      height="50"
      viewBox="0 0 41 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M40.3846 16.9496C40.3846 13.7014 40.3846 5.40743 39.7096 4.16677C39.1158 3.07546 38.1683 2.1882 37.0029 1.63215C35.678 1 33.9437 1 30.475 1H10.9096C7.44095 1 5.70659 1 4.38173 1.63215C3.21634 2.1882 2.26885 3.07546 1.67505 4.16677C1 5.40743 1 7.03153 1 10.2798V49L6.6774 45.1334L11.8387 49L17.5161 45.1334L23.1935 49L28.3548 45.1334L34.0322 49V8.24981"
        stroke="black"
        strokeWidth="1.10079"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="6.94336"
        y="10.3458"
        width="15.5752"
        height="16.6386"
        rx="0.551136"
        fill="#D92D20"
        stroke="black"
        strokeWidth="0.375"
      />
      <path
        d="M25.4707 13.561L25.4707 22.0678"
        stroke="black"
        strokeLinecap="round"
      />
      <path
        d="M10.1582 13.561H15.5592M20.1886 13.561H15.5592M16.0092 23.5914C13.5402 22.9741 11.7656 20.698 10.9941 19.4121C12.7944 19.4121 15.5592 17.8818 15.5592 13.561M10.9941 16.0686H17.681"
        stroke="white"
        strokeWidth="0.842215"
      />
      <rect
        x="6.75586"
        y="30.5746"
        width="20.2462"
        height="2.3819"
        fill="#D9D9D9"
      />
      <rect
        x="6.75586"
        y="35.6787"
        width="20.2462"
        height="2.3819"
        fill="#D9D9D9"
      />
    </svg>
  ),
  gstBills: (
    <svg
      width="435"
      height="228"
      viewBox="0 0 466 279"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M367.854 186.953C357.61 196.74 376 195.448 366 209.948C358.5 230.448 384.497 225.61 375.605 278.568C353.736 279.434 292.522 278.56 273.5 278.5C254.478 278.44 256.5 263.5 241 248.5C225 237.5 234.5 243 213.471 227.717C204.923 225.42 224.348 230.711 209.006 226.429C193.665 222.152 171.818 213.824 153.5 209.948C165.312 185.846 161.372 165.477 182.227 142.581C201.954 120.919 236.094 107.618 278.768 103.5C326 98.9426 377.5 154 377.5 191.5L367.854 186.953Z"
        fill="#DC343B"
      />
      <path
        d="M292.316 268.395L292.626 267.816C300.522 277.9 310.979 274.895 311.084 274.865L311.006 275.522C310.902 275.555 300.307 278.603 292.316 268.399V268.395Z"
        fill="#A0252A"
      />
      <path
        d="M288.249 268.892L288.575 268.315C297.974 278.94 309.712 276.394 309.83 276.368L309.773 277.031C309.655 277.057 297.766 279.643 288.252 268.892H288.249Z"
        fill="#A0252A"
      />
      <path
        d="M288.296 253.137L288.434 252.517C298.392 259.933 307.373 254.499 307.461 254.443L307.559 255.072C307.468 255.129 298.372 260.639 288.296 253.133V253.137Z"
        fill="#A0252A"
      />
      <path
        d="M284.632 254.622L284.787 254.003C296.289 261.542 306.578 256.218 306.679 256.162L306.794 256.795C306.689 256.851 296.269 262.252 284.629 254.622H284.632Z"
        fill="#A0252A"
      />
      <path
        d="M285.718 258.237L285.835 257.604C297.472 264.041 307.202 257.757 307.299 257.694L307.448 258.314C307.35 258.381 297.496 264.754 285.718 258.237V258.237Z"
        fill="#A0252A"
      />
      <path
        d="M269.063 250.758L269.299 250.058C279.898 259.793 290.921 254.583 291.029 254.529L291.066 255.269C290.955 255.322 279.79 260.609 269.063 250.758Z"
        fill="#A0252A"
      />
      <path
        d="M264.655 252.044L264.911 251.348C277.276 261.409 289.799 256.478 289.923 256.425L289.981 257.168C289.853 257.218 277.171 262.225 264.658 252.04L264.655 252.044Z"
        fill="#A0252A"
      />
      <path
        d="M265.47 256.342L265.683 255.625C278.337 264.431 290.328 258.324 290.449 258.261L290.547 258.994C290.426 259.057 278.28 265.25 265.474 256.338L265.47 256.342Z"
        fill="#A0252A"
      />
      <path
        d="M267.428 217.915L268.106 217.565C268.921 232.211 280.811 236.119 280.929 236.156L280.423 236.725C280.302 236.689 268.254 232.734 267.428 217.912V217.915Z"
        fill="#A0252A"
      />
      <path
        d="M263.249 215.763L263.937 215.43C265.821 231.558 278.617 236.725 278.745 236.775L278.253 237.365C278.121 237.315 265.154 232.088 263.246 215.763H263.249Z"
        fill="#A0252A"
      />
      <path
        d="M260.756 219.511L261.426 219.131C264.429 234.536 277.677 238.464 277.811 238.501L277.356 239.111C277.222 239.071 263.795 235.099 260.756 219.511V219.511Z"
        fill="#A0252A"
      />
      <path
        d="M269.902 206.204L270.6 205.951C269.498 220.191 280.467 225.461 280.578 225.514L280.015 226.001C279.904 225.947 268.783 220.614 269.899 206.204H269.902Z"
        fill="#A0252A"
      />
      <path
        d="M266.144 203.599L266.852 203.363C266.589 219.168 278.273 225.771 278.391 225.834L277.838 226.341C277.721 226.274 265.878 219.594 266.141 203.596L266.144 203.599Z"
        fill="#A0252A"
      />
      <path
        d="M263.256 206.901L263.954 206.621C264.864 221.87 277.148 227.33 277.269 227.383L276.75 227.913C276.625 227.86 264.176 222.333 263.256 206.901V206.901Z"
        fill="#A0252A"
      />
      <path
        d="M263.87 196.013L264.473 195.547C267.954 209.829 280.379 211.555 280.504 211.568L280.11 212.221C279.982 212.205 267.391 210.466 263.87 196.01V196.013Z"
        fill="#A0252A"
      />
      <path
        d="M259.36 194.637L259.977 194.184C264.783 209.736 278.33 212.541 278.469 212.568L278.091 213.237C277.953 213.211 264.223 210.379 259.36 194.637V194.637Z"
        fill="#A0252A"
      />
      <path
        d="M257.591 198.775L258.184 198.282C263.957 212.921 277.727 214.424 277.865 214.437L277.528 215.12C277.387 215.106 263.435 213.594 257.591 198.778V198.775Z"
        fill="#A0252A"
      />
      <path
        d="M266.569 184.273L267.054 183.82C271.264 195.933 282.189 196.423 282.3 196.426L282.014 197.026C281.903 197.023 270.829 196.533 266.569 184.273V184.273Z"
        fill="#A0252A"
      />
      <path
        d="M262.542 183.443L263.041 183C268.503 196.11 280.497 197.446 280.615 197.456L280.342 198.065C280.221 198.052 268.069 196.706 262.538 183.44L262.542 183.443Z"
        fill="#A0252A"
      />
      <path
        d="M261.345 187.178L261.817 186.701C268.045 198.938 280.12 199.128 280.241 199.128L280.005 199.748C279.884 199.748 267.647 199.565 261.345 187.178V187.178Z"
        fill="#A0252A"
      />
      <path
        d="M239.902 148.127C230.327 150.206 221.638 142.044 211.882 143.123C211.435 137.888 209.225 136.784 208.754 132.903C208.275 129.022 208.483 130.075 208.279 128.181C208.074 126.287 208.172 126.922 208.011 125.41C215.504 120.312 222.861 114.902 230.211 109.516C230.984 112.452 231.335 114.091 232.149 117.209C232.964 120.336 232.647 119.344 234.141 124.251C235.635 129.159 238.591 141.689 239.91 148.127L239.902 148.127Z"
        fill="#C67764"
      />
      <path
        d="M232.455 118.594C231.096 120.579 229.724 123.526 228.411 125.341C226.04 128.613 223.73 131.233 220.574 133.45C216.94 136.005 213.584 136.872 209.205 136.561C209 134.979 208.735 132.992 208.585 131.527C208.435 130.062 208.354 129.146 208.225 127.784C216.212 124.285 224.144 120.653 232.094 117.068C232.209 117.582 232.354 118.047 232.455 118.594Z"
        fill="#541C1C"
      />
      <path
        d="M195.651 92.5996C196.153 95.2545 199.413 100.556 195.522 101.46C191.632 102.363 188.501 97.5268 187.548 94.2075C186.603 90.8878 186.676 86.5373 190.574 85.7856C194.472 85.0339 195.15 89.9447 195.651 92.5996V92.5996Z"
        fill="#C67764"
      />
      <path
        d="M195.651 92.5996C196.089 95.2499 199.654 100.431 195.548 101.642C189.937 102.701 186.208 94.743 186.742 90.0319C186.87 87.1754 189.554 84.8152 192.406 85.7681C194.935 86.9544 195.124 90.2022 195.643 92.6L195.651 92.5996ZM195.651 92.5996C195.135 90.2657 194.842 87.0153 192.331 86.0043C190.77 85.559 188.866 86.3247 188.077 87.7435C186.325 91.5349 188.262 96.3467 190.83 99.3239C191.921 100.563 193.485 101.528 195.154 101.311C195.966 101.228 196.787 100.856 197.106 100.079C197.851 97.5415 196.11 95.0487 195.651 92.5996V92.5996Z"
        fill="black"
      />
      <path
        d="M195.466 94.2344C195.611 95.4514 195.037 96.9948 194.059 95.4619C193.08 93.929 192.695 88.6344 189.971 90.0921C187.239 91.5503 188.92 95.4792 191.215 96.6378"
        fill="#C67764"
      />
      <path
        d="M195.466 94.2344C195.579 94.8448 195.529 96.4644 194.558 96.1238C193.237 95.0654 193.236 93.2484 192.545 91.8363C192.259 91.1311 191.868 90.3994 191.237 90.1208C190.608 89.8822 189.838 90.2994 189.336 90.8063C188.277 91.9673 188.743 93.8076 189.552 95.0053C189.97 95.6555 190.529 96.2261 191.207 96.6383C189.786 95.9454 188.701 94.5223 188.432 92.9117C188.065 91.2822 189.613 89.2466 191.377 89.7452C192.913 90.632 193.075 92.4725 193.603 93.9653C194.071 95.9976 195.398 97.1598 195.45 94.2352L195.466 94.2344Z"
        fill="black"
      />
      <path
        d="M194.346 87.786C188.619 81.9911 195.998 54.2864 215.931 56.7079C244.346 60.151 213.34 107.003 194.346 87.786Z"
        fill="black"
      />
      <path
        d="M236.206 116.713C235.67 117.622 234.973 117.763 233.959 118.274C225.891 122.345 216.004 128.186 208.209 131.683C201.002 133.653 197.856 134.931 194.301 127.7C194.533 114.904 194.046 94.9182 194.444 83.8906C194.841 72.8629 195.949 74.7331 200.051 66.8143C206.835 65.5408 213.291 60.6506 220.066 59.6498C226.84 58.649 229.209 63.5899 231.12 69.1236C232.302 72.5347 233.01 76.8116 233.95 80.1876C234.89 83.5636 236.003 88.2272 236.73 91.0702C239.195 100.681 241.293 108.07 236.198 116.714L236.206 116.713Z"
        fill="#C67764"
      />
      <path
        d="M208.147 114.572C207.281 115.595 205.913 115.307 205.242 113.686C204.056 110.803 204.673 107.192 206.31 104.416C209.166 99.573 219.741 97.4735 223.1 100.289C226.46 103.096 228.282 107.409 223.398 108.437C219.187 109.326 211.664 110.415 208.139 114.572L208.147 114.572Z"
        fill="black"
      />
      <path
        d="M206.396 84.063C206.816 90.6046 207.204 97.1478 207.64 103.688C210.482 105.058 212.545 104.86 214.855 102.68"
        fill="#C67764"
      />
      <path
        d="M206.395 84.0631C207.23 90.5666 207.682 97.1144 207.975 103.663L207.783 103.377C209.474 104.303 211.48 104.709 213.231 103.759C213.808 103.464 214.34 103.084 214.854 102.672C214.408 103.16 213.911 103.603 213.346 103.961C211.557 105.241 209.156 104.809 207.315 103.906L207.304 103.698C206.772 97.1628 206.392 90.6112 206.395 84.0551L206.395 84.0631Z"
        fill="black"
      />
      <path
        d="M213.691 112.852C215.046 112.892 216.367 112.91 217.542 112.415C218.718 111.945 219.652 111.006 220.593 110.028C219.508 112.807 216.413 114.068 213.699 112.852L213.691 112.852Z"
        fill="black"
      />
      <path
        d="M202.449 59.8348C207.695 55.8255 216.349 47.4243 222.847 53.4023C223.634 54.2009 224.274 55.1114 224.791 56.0925C218.718 46.5058 208.955 55.7424 202.449 59.8348Z"
        fill="black"
      />
      <path
        d="M211.475 66.2386C216.485 64.7233 225.806 63.2828 222.437 55.9376C222.801 56.5986 223.086 57.3039 223.255 58.0554C224.328 64.234 215.835 65.2942 211.467 66.239L211.475 66.2386Z"
        fill="black"
      />
      <path
        d="M232.306 66.7473C232.975 69.0891 233.92 78.1162 233.647 77.9546C230.705 76.222 225.481 69.6639 224.094 66.1596C222.707 62.6553 223.725 59.6794 226.401 58.6645C231.571 56.7004 231.637 64.4055 232.306 66.7473V66.7473Z"
        fill="black"
      />
      <path
        d="M215.12 62.0743C212.382 63.1165 197.717 69.8843 197.526 68.5577C196.591 62.1156 208.74 56.9625 213.1 55.1136C217.461 53.2646 222.528 53.5714 224.089 56.7382C227.088 62.8544 217.858 61.0321 215.128 62.0739L215.12 62.0743Z"
        fill="black"
      />
      <path
        d="M254.771 82.1696C252.884 86.8727 236.372 78.778 232.972 77.6141C229.572 76.4502 220.873 74.8398 222.657 70.4543C224.441 66.0609 232.986 70.5131 236.337 71.7997C239.687 73.0863 256.666 77.4661 254.771 82.1696V82.1696Z"
        fill="#E4B63C"
      />
      <path
        d="M222.094 72.3494C222.942 73.0967 224.307 73.7686 225.265 74.478C226.083 72.7055 226.805 70.93 227.663 69.1554C225.935 69.1673 225.02 68.5195 223.109 68.7093C221.198 68.899 220.263 70.7418 222.094 72.3494V72.3494Z"
        fill="white"
      />
      <path
        d="M220.746 70.9323C220.863 71.1823 221.298 71.5274 221.502 71.7566C221.944 70.7325 222.353 69.6942 222.778 68.6549C222.335 68.7506 221.918 68.5966 221.481 68.796C220.559 69.2213 220.271 69.9731 220.738 70.9408L220.746 70.9323Z"
        fill="black"
      />
      <path
        d="M207.805 103.208C208.571 105.433 211.737 104.304 213.349 103.746C214.96 103.188 217.238 101.626 216.619 99.7694C216 97.9132 214.626 97.9623 212.958 98.5074C211.29 99.0524 207.046 100.975 207.804 103.2L207.805 103.208Z"
        fill="#C4524A"
      />
      <path
        d="M194.154 84.3223C195.347 95.4654 194.664 106.7 194.714 117.872C194.756 121.504 194.761 125.362 195.174 128.91C195.307 129.768 195.564 130.531 196.036 130.978C197.959 132.372 201.232 131.75 203.527 131.556C214.664 129.947 223.609 122.338 234.044 118.509C223.963 123.272 215.126 131.259 203.752 133.073C200.014 133.528 194.118 134.346 193.595 129.179C192.32 114.093 194.522 99.3596 194.147 84.3307L194.154 84.3223Z"
        fill="black"
      />
      <path
        d="M196.173 82.1016C198.239 78.9419 201.732 76.7469 205.427 76.078C201.969 77.5828 198.9 79.4831 196.173 82.1016Z"
        fill="black"
      />
      <path
        d="M217.021 79.4555C220.571 78.0258 224.738 78.2604 228.206 79.7969C224.461 79.0756 220.799 78.8462 217.021 79.4555Z"
        fill="black"
      />
      <path
        d="M199.199 85.7108C201.176 87.6548 203.168 89.59 205.167 91.5168C205.598 90.1411 206.038 88.7729 206.477 87.3968C206.147 86.1576 205.801 84.9193 205.495 83.6788C203.394 84.3589 201.301 85.0386 199.199 85.7187L199.199 85.7108Z"
        fill="#C4524A"
      />
      <path
        d="M216.891 83.4727C217.303 85.2118 217.717 86.9589 218.129 88.6979C219.738 88.3962 221.339 88.0949 222.948 87.8012C223.161 86.373 223.381 84.9525 223.593 83.5243C221.359 83.5071 219.117 83.4904 216.883 83.4731L216.891 83.4727Z"
        fill="#C4524A"
      />
      <path
        d="M220.894 87.7022C221.06 88.4218 221.113 89.5637 220.226 89.747C219.339 89.9302 218.89 88.8655 218.724 88.1459C218.558 87.4263 218.505 86.2844 219.392 86.1012C220.279 85.9179 220.727 86.9827 220.894 87.7022Z"
        fill="black"
      />
      <path
        d="M218.112 86.1293C219.674 85.5419 220.961 86.1218 222.361 86.8558"
        stroke="black"
        strokeWidth="0.399671"
        strokeMiterlimit="10"
      />
      <path
        d="M218.794 89.6232C219.648 90.0261 220.489 89.8773 221.384 89.7096"
        stroke="black"
        strokeWidth="0.399671"
        strokeMiterlimit="10"
      />
      <path
        d="M205.542 83.9804C204.337 84.4928 201.702 84.9212 200.692 85.199C198.799 85.724 197.76 85.4591 196.934 84.0702C196.864 83.9539 196.759 84.0875 196.934 84.0702C196.108 82.6813 197.649 81.7028 198.377 80.9436C200.311 78.9276 202.234 77.7607 204.884 77.1794C206.562 76.81 207.123 77.5726 207.004 79.2599C206.978 79.6615 206.952 80.2392 206.946 80.8719C206.946 81.9206 206.779 83.4583 205.543 83.9884L205.542 83.9804Z"
        fill="black"
      />
      <path
        d="M217.544 81.1567C219.404 79.1125 224.002 78.4116 226.732 80.3876C227.302 81.1737 228.911 82.6811 227.027 83.2216C225.143 83.7621 222.465 83.8326 220.363 84.5047C218.262 85.1768 214.935 84.0251 217.544 81.1567V81.1567Z"
        fill="black"
      />
      <path
        d="M236.449 117.677C232.143 119.643 227.91 121.773 223.667 123.872C233.788 111.143 234.691 99.2395 232.064 83.554C232.767 82.7881 233.409 81.9055 234.157 81.2253C234.956 84.3607 236.171 89.1389 236.898 91.9659C239.368 101.528 241.337 108.908 236.456 117.669L236.449 117.677Z"
        fill="#D37041"
      />
      <path
        d="M231.764 80.7842C232.111 83.5434 230.627 89.9461 234.729 89.7119C238.831 89.4856 240.191 83.6018 240.062 80.1266C239.933 76.6514 238.672 72.0598 234.569 72.4142C230.465 72.7686 231.417 78.0251 231.764 80.7842V80.7842Z"
        fill="#C67764"
      />
      <path
        d="M234.626 90.3418C238.797 88.6951 240.084 84.4561 240.069 80.4145C240.046 76.3734 238.628 72.8867 234.636 72.4748C232.189 72.2207 232.264 74.386 231.472 75.893"
        fill="#C67764"
      />
      <path
        d="M234.626 90.3419C236.75 89.3483 238.299 87.4728 238.985 85.3151C240.087 81.5102 240.403 75.2577 236.268 73.2044C235.342 72.8134 234.064 72.4091 233.15 72.9781C232.231 73.6193 232.071 74.9726 231.48 75.8926C231.966 74.8021 231.953 73.514 232.917 72.6623C233.988 71.8929 235.36 72.2521 236.51 72.6392C238.901 73.5046 240.065 76.1322 240.343 78.4869C240.945 83.0255 239.502 88.8577 234.626 90.3419V90.3419Z"
        fill="black"
      />
      <path
        d="M232.069 83.5137C233.678 85.9175 234.23 84.3993 233.504 82.3407C233.15 80.7986 232.261 79.1409 233.114 77.5666C233.725 76.8617 234.71 76.8733 235.537 77.0775C238.039 77.9049 238.299 81.4452 237.033 83.3697C238.027 81.4437 237.743 78.2089 235.436 77.4271C234.738 77.2481 233.86 77.2948 233.431 77.8059C232.692 79.11 233.529 80.8585 233.796 82.2611C233.948 83.0215 234.257 83.8536 233.86 84.6751C233.203 85.4145 232.3 84.0778 232.061 83.5141L232.069 83.5137Z"
        fill="black"
      />
      <rect
        x="26"
        y="213.874"
        width="85.1476"
        height="20.1258"
        rx="5.01628"
        fill="#D3DCEB"
      />
      <path
        d="M347.706 70.5963C347.706 67.676 350.073 65.3087 352.993 65.3087H456.304C459.224 65.3087 461.591 67.676 461.591 70.5963V70.5963C461.591 73.5165 459.224 75.8838 456.304 75.8838H352.993C350.073 75.8838 347.706 73.5165 347.706 70.5963V70.5963Z"
        fill="#D3DCEB"
      />
      <path
        d="M403.591 152H440.848V152C440.848 159.673 434.628 165.892 426.956 165.892H403.591V152Z"
        fill="#1E4486"
      />
      <path
        d="M424.375 164.353C424.79 164.84 425.244 165.211 425.722 165.5H384.591C377.135 165.5 371.091 159.456 371.091 152V109.573C371.091 107.876 372.467 106.5 374.164 106.5H419.04C420.737 106.5 422.113 107.876 422.113 109.573V157.064V157.084L422.114 157.104C422.409 160.778 423.208 162.985 424.375 164.353Z"
        fill="#8CBFBA"
        stroke="#0E1725"
      />
      <rect
        x="377.158"
        y="117.067"
        width="39.1513"
        height="4.42031"
        fill="#F5F5F5"
      />
      <rect
        x="377.158"
        y="128.432"
        width="39.1513"
        height="4.42031"
        fill="#F5F5F5"
      />
      <rect
        x="377.158"
        y="140.43"
        width="39.1513"
        height="4.42031"
        fill="#F5F5F5"
      />
      <rect
        x="32.5547"
        y="209.15"
        width="15.6641"
        height="15.6641"
        rx="2.86645"
        fill="#F5F5F5"
      />
      <rect
        x="56.9639"
        y="221.615"
        width="43.3479"
        height="3.09628"
        rx="1.54814"
        fill="#F5F5F5"
      />
      <rect
        x="31.4442"
        y="208.04"
        width="17.8845"
        height="17.8845"
        rx="2.50814"
        stroke="#121515"
        strokeWidth="0.716612"
      />
      <path
        d="M106.615 64.1003C112.349 69.8342 113.274 77.9212 109.011 82.1841C104.748 86.4471 96.6608 85.5227 90.9269 79.7888C85.193 74.0549 84.2685 65.9679 88.5315 61.7049C92.7945 57.4419 100.882 58.3664 106.615 64.1003Z"
        fill="#FFE298"
        stroke="#FFBD00"
        strokeWidth="0.873563"
      />
      <path
        d="M96.1815 65.1776L100.359 66.8071M104.237 68.4595L100.359 66.8071M102.447 75.9185C98.6912 74.7988 97.5923 73.353 95.8832 70.5481C97.6733 70.8464 101.552 70.5481 100.359 66.8071M96.1815 68.1612L101.85 70.2497"
        stroke="white"
        strokeWidth="1.19088"
      />
      <path
        d="M110.201 80.9901C107.516 83.9736 98.3633 83.9919 92.5317 78.1603C88.1231 73.7517 85.1205 64.897 89.0175 61.0001"
        stroke="#FFBD00"
        strokeWidth="0.873563"
      />
      <path
        d="M134.852 64.7746C138.671 66.9986 140.217 71.0845 138.63 73.8364C137.043 76.5883 132.746 77.2713 128.928 75.0473C125.109 72.8233 123.563 68.7374 125.15 65.9855C126.737 63.2336 131.034 62.5506 134.852 64.7746Z"
        fill="#FFE298"
        stroke="#FFBD00"
        strokeWidth="0.873563"
      />
      <path
        d="M129.549 66.6597L132.005 66.9391M134.305 67.273L132.005 66.9391M134.414 71.5148C132.255 71.4484 131.464 70.8311 130.155 69.5735C131.15 69.4794 133.173 68.7702 132.005 66.9391M129.974 68.255L133.289 68.5684"
        stroke="white"
        strokeWidth="0.873563"
      />
      <path
        d="M139.143 73.0574C138.136 75.0321 133.323 76.3726 129.462 74.1238C126.543 72.4238 123.759 68.1584 125.279 65.5225"
        stroke="#FFBD00"
        strokeWidth="0.873563"
      />
      <path
        d="M199.891 90.6273L203.988 89.9786"
        stroke="black"
        strokeWidth="1.19088"
        strokeLinecap="round"
      />
      <path
        d="M200.406 92.0167L204.167 90.0666"
        stroke="black"
        strokeWidth="1.19089"
        strokeLinecap="round"
      />
      <circle
        cx="226.696"
        cy="87.5996"
        r="20.1046"
        transform="rotate(15.763 226.696 87.5996)"
        fill="black"
      />
      <circle
        cx="226.696"
        cy="87.6"
        r="16.0016"
        transform="rotate(15.763 226.696 87.6)"
        fill="#D9D9D9"
      />
      <rect
        x="229.766"
        y="104.112"
        width="7.92678"
        height="29.6357"
        rx="3.19737"
        transform="rotate(-25.6891 229.766 104.112)"
        fill="black"
      />
      <ellipse
        cx="226.153"
        cy="89.3421"
        rx="2.70799"
        ry="2.16104"
        transform="rotate(-96.806 226.153 89.3421)"
        fill="black"
      />
      <path
        d="M218.923 79.7144C222.731 79.773 226.539 78.093 229.185 75.3826C225.974 77.423 222.652 78.9146 218.923 79.7144Z"
        fill="black"
      />
      <path
        d="M227.764 77.9309C224.049 79.368 222.624 79.9164 221.671 80.3724C219.881 81.2242 219.951 81.3369 220.24 82.9414C220.095 83.044 220.263 83.0765 220.24 82.9414C220.528 84.5459 222.349 84.2725 223.406 84.3695C226.212 84.6267 228.449 84.2442 230.853 82.9344C232.375 82.1068 232.787 80.6066 231.581 79.3994C230.616 78.4264 230.162 77.0032 227.764 77.9309Z"
        fill="black"
      />
      <path
        d="M268 108.5C278.167 107 301.2 105.7 312 112.5C325.5 121 356.5 144 363.5 159"
        stroke="#FFE298"
      />
      <path
        d="M224.193 136.526C224.193 136.526 220.91 140.295 221.369 145.905C221.579 148.507 216.823 145.948 218.679 155.458C219.044 157.348 222.706 161.755 226.743 166.332C230.781 170.909 244.456 170.972 250.207 172.625C260.971 175.722 315.858 225.571 342.54 231.002C355.681 231.002 384.457 225.62 379.661 195.645C375.978 172.625 364.096 160.351 330.102 155.458C312.885 152.974 279.286 149.294 276.109 146.25C272.546 142.827 263.145 138.603 264.232 132.122C264.923 128.029 257.879 123.902 250.803 116.114C247.669 112.669 237.697 117.589 237.697 117.589C233.039 116.378 223.011 126.384 224.193 136.526Z"
        fill="#C67764"
      />
      <path
        d="M272.114 142.518C268.032 141.367 265.255 137.733 264.061 133.793C263.403 131.9 263.117 129.945 261.816 128.378C259.309 125.204 255.366 123.513 252.746 120.28C251.464 118.91 251.123 116.725 249.142 116.173C245.618 115.195 241.417 116.921 238.162 118.433L237.886 118.567C235.262 118.129 232.681 119.009 230.73 120.803C228.799 122.542 227.312 124.97 226.397 127.378C225.642 128.478 225.135 129.973 225.218 131.344C225.375 132.991 225.961 134.567 225.419 136.299C224.602 138.959 222.062 139.63 221.713 141.949C221.614 142.893 222.704 144.21 222.41 145.452C221.627 148.025 218.403 149.542 218.687 152.421C218.87 155.3 220.818 158.08 222.321 160.543C224.017 163.12 225.893 165.632 228.095 167.749C230.3 170.137 233.37 169.705 236.604 170.327C239.711 170.762 242.831 171.215 245.903 171.888C248.889 172.638 252.234 173.259 254.523 175.46C252.145 173.376 248.817 172.943 245.83 172.294C242.751 171.743 239.64 171.389 236.515 171.068C233.393 170.605 229.76 171.045 227.389 168.529C225.015 166.354 223.062 163.857 221.241 161.264C219.483 158.528 217.494 155.898 217.185 152.47C216.919 149.839 218.965 147.755 220.41 145.898C220.846 145.232 220.868 145.087 220.662 144.433C219.117 141.495 220.606 139.5 222.7 137.457C224.503 135.783 223.656 133.585 223.386 131.456C223.286 129.636 223.758 127.957 224.767 126.396L224.643 126.641C225.175 125.222 225.82 123.972 226.599 122.736C228.896 118.926 233.197 115.835 237.841 116.616L237.266 116.717C241.629 114.729 249.15 111.78 252.508 116.749C253.054 117.749 253.365 118.423 254.03 119.259C256.46 122.448 260.408 124.268 262.78 127.679C264.062 129.361 264.387 131.569 264.897 133.531C265.821 137.483 268.239 140.975 272.122 142.507L272.114 142.518Z"
        fill="black"
      />
      <path
        d="M281 148C304 150.833 352.4 158.3 362 165.5C374 174.5 377 188 379.5 195"
        stroke="black"
      />
      <path
        d="M344.091 214.5C344.091 214.5 294.187 199.801 252.591 171C257.42 175.42 267.091 187 291.769 203.996C325.367 227.135 347.5 241 368 227.5L344.091 214.5Z"
        fill="#9E3F3F"
      />
      <path d="M250 173C277.833 195.333 337.8 236.9 355 224.5" stroke="black" />
      <path
        d="M345.449 227.024H401.394V226.603C401.394 216.079 392.864 207.549 382.34 207.549H345.449V227.024Z"
        fill="#375A8D"
      />
      <path
        d="M230.589 207.574C284.463 207.574 336.961 207.574 384.593 207.574C334.486 206.679 375.129 265.877 327.497 265.877H240.116L230.589 207.574Z"
        fill="white"
      />
      <path
        d="M151.349 181.613C149.33 167.31 146.615 152.66 141.243 139.025H216.521C226.205 139.025 233.596 140.892 239.314 144.143C245.028 147.392 249.107 152.043 252.136 157.672C257.71 168.026 259.709 181.622 261.791 195.778C261.98 197.065 262.17 198.356 262.363 199.649C264.675 215.124 267.476 230.942 275.589 243.333C282.716 254.219 293.91 262.417 312.32 265.5H312.32H312.189H312.057H311.924H311.79H311.655H311.519H311.383H311.245H311.106H310.967H310.826H310.685H310.542H310.399H310.255H310.109H309.963H309.816H309.668H309.519H309.37H309.219H309.067H308.915H308.761H308.607H308.452H308.295H308.138H307.98H307.821H307.661H307.501H307.339H307.176H307.013H306.849H306.683H306.517H306.35H306.182H306.014H305.844H305.673H305.502H305.329H305.156H304.982H304.807H304.631H304.455H304.277H304.099H303.919H303.739H303.558H303.376H303.193H303.01H302.825H302.64H302.453H302.266H302.078H301.89H301.7H301.509H301.318H301.126H300.933H300.739H300.544H300.349H300.152H299.955H299.757H299.558H299.358H299.158H298.957H298.754H298.551H298.347H298.143H297.937H297.731H297.524H297.316H297.107H296.898H296.687H296.476H296.264H296.051H295.838H295.623H295.408H295.192H294.975H294.758H294.539H294.32H294.1H293.879H293.658H293.436H293.212H292.989H292.764H292.538H292.312H292.085H291.857H291.629H291.399H291.169H290.939H290.707H290.474H290.241H290.007H289.773H289.537H289.301H289.064H288.826H288.588H288.349H288.109H287.868H287.627H287.384H287.141H286.898H286.653H286.408H286.162H285.916H285.668H285.42H285.171H284.922H284.671H284.42H284.169H283.916H283.663H283.409H283.154H282.899H282.643H282.386H282.129H281.871H281.612H281.352H281.092H280.831H280.569H280.307H280.044H279.78H279.515H279.25H278.984H278.718H278.451H278.183H277.914H277.645H277.375H277.104H276.833H276.561H276.288H276.015H275.741H275.466H275.19H274.914H274.638H274.36H274.082H273.804H273.524H273.244H272.963H272.682H272.4H272.117H271.834H271.55H271.266H270.98H270.695H270.408H270.121H269.833H269.545H269.256H268.966H268.675H268.384H268.093H267.801H267.508H267.214H266.92H266.626H266.33H266.034H265.738H265.44H265.143H264.844H264.545H264.246H263.945H263.644H263.343H263.041H262.738H262.435H262.131H261.827H261.522H261.216H260.91H260.603H260.296H259.988H259.679H259.37H259.06H258.75H258.439H258.128H257.815H257.503H257.19H256.876H256.562H256.247H255.931H255.615H255.299H254.982H254.664H254.346H254.027H253.707H253.387H253.067H252.746H252.424H252.102H251.78H251.456H251.133H250.808H250.484H250.158H249.832H249.506H249.179H248.851H248.523H248.195H247.866H247.536H247.206H246.875H246.544H246.213H245.88H245.548H245.214H244.881H244.547H244.212H243.877H243.541H243.205H242.868H242.531H242.193H241.855H241.516H241.177H240.837H240.497H240.156H239.815H239.473H239.131H238.788H238.445H238.101H237.757H237.413H237.068H236.722H236.376H236.03H235.683H235.336H234.988H234.639H234.291H233.941H233.592H233.242H232.891H232.54H232.188H231.836H231.484H231.131H230.778H230.424H230.07H229.715H229.36H229.005H228.649H228.292H227.936H227.578H227.221H226.863H226.504H226.145H225.786H225.426H225.066H224.705H224.344H223.983H223.621H223.259H222.896H222.533H222.169H221.805H221.441H221.076H220.711H220.346H219.98H219.614H219.247H218.88H218.512H218.144H217.776H217.408H217.039H216.669H216.299H215.929H215.559H215.188H214.816H214.445H214.073H213.7H213.327H212.954H212.581H212.207H211.833H211.458H211.083H210.708H210.332H209.956H209.58H209.203H208.826H208.448H208.071H207.692H207.314H206.935H206.556H206.177H205.797H205.417C189.289 265.5 178.644 261.007 171.361 253.481C164.06 245.935 160.074 235.277 157.406 222.815C155.544 214.119 154.333 204.596 153.073 194.687C152.526 190.39 151.971 186.02 151.349 181.613Z"
        fill="#8CBFBA"
        stroke="#0E1725"
      />
      <path
        d="M89.3088 139.12H213.921C208.054 140.715 202.78 143.909 199.019 148.681C193.48 155.711 191.302 166.066 195.211 179.536H73.2094C68.2093 168.148 69.5814 158.405 73.5028 151.336C77.4758 144.173 84.0486 139.773 89.3088 139.12Z"
        fill="white"
        stroke="#0E1725"
        strokeWidth="1.19088"
      />
      <path
        d="M95.4654 131C74.6031 131 58.4743 142.628 61.3281 170.393"
        stroke="#6FB9B1"
        strokeWidth="1.59868"
      />
      <rect
        x="88.3528"
        y="150.919"
        width="90.0823"
        height="7.08196"
        fill="#D3DCEB"
      />
      <path
        d="M274.206 235.016H332.048V238.557H277.552L274.206 235.016Z"
        fill="#D3DCEB"
      />
      <path
        d="M278.947 242.983H325.41V246.524H281.635L278.947 242.983Z"
        fill="#D3DCEB"
      />
      <path
        d="M137.844 214.249C139.467 206.783 139.567 200.077 148.621 196.661C157.486 194.402 169.5 197.5 169.5 211C172 214.249 175.5 226.5 174 233.5C173.463 236.007 160.5 245.5 148.621 240.5C142.977 236.481 137.357 221.843 137.844 214.249Z"
        fill="#C67764"
      />
      <path
        d="M140.574 224.95C139.594 223.175 135.694 216.651 139.272 213.745C145.041 209.058 159.658 203.902 164.928 206.815C169.143 209.145 171.01 214.036 171.416 216.19"
        stroke="black"
      />
      <path
        d="M141.972 230.039C141.119 228.631 140.093 225.32 142.813 223.335C146.213 220.855 162.847 214.987 167.855 217.064C171.861 218.726 173.39 222.656 173.654 224.414"
        stroke="black"
      />
      <path
        d="M146.834 237.867C146.03 236.442 144.985 233.138 147.23 231.321C150.036 229.05 164.07 224.099 168.484 226.386C172.015 228.215 173.524 232.153 173.838 233.893"
        stroke="black"
      />
      <path
        d="M169.5 210C166.5 186.5 135.5 196.5 138.468 212.968"
        stroke="black"
      />
    </svg>
  ),
  inventoryLanding: (
    <svg
      width="503"
      height="273"
      viewBox="0 0 503 273"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1284_23673)">
        <rect x="173" y="25" width="88" height="5" rx="2.5" fill="#DDE2EB" />
        <rect
          x="35.6328"
          y="71.5013"
          width="170.433"
          height="41.4502"
          rx="7.6635"
          fill="#8CBFBB"
          stroke="#0E1725"
        />
        <rect
          x="113.502"
          y="82.4302"
          width="80.0023"
          height="6.5308"
          rx="3.2654"
          fill="white"
        />
        <rect x="173" y="37" width="41" height="5" rx="2.5" fill="#DDE2EB" />
        <rect
          x="113.502"
          y="124.88"
          width="70.2061"
          height="9.7962"
          rx="4.8981"
          fill="#BEDFDD"
        />
        <rect
          x="142"
          y="22"
          width="23"
          height="23"
          rx="4.8981"
          fill="#DDE2EB"
        />
        <rect
          x="55.2246"
          y="50.2767"
          width="43.0829"
          height="43.0829"
          rx="4.3981"
          fill="white"
          stroke="#0E1725"
        />
        <path
          d="M66.3663 73.7281L70.9808 78.1792L87.0278 63.8534"
          stroke="#375A8D"
          strokeWidth="3.2654"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M268.109 176.155C268.109 172.203 264.906 169 260.954 169H114V183.31H260.954C264.906 183.31 268.109 180.107 268.109 176.155V176.155Z"
          fill="#D3DCEB"
        />
        <path
          d="M386.361 205.976C386.96 167.268 420.575 137.375 459.088 141.302V141.302C485.696 144.015 501.002 172.902 488.304 196.442L435.702 293.957H385L386.361 205.976Z"
          fill="#EFBD87"
        />
        <path
          d="M467.525 126.932C467.737 125.955 473.314 108.197 473.59 102.952C473.865 97.7064 472.355 93.2881 466.534 89.9441C461.705 87.1687 455.774 89.637 454.567 90.2153C453.141 90.8971 448.165 90.3457 446.521 91.0982C444.876 91.8507 442.272 95.1893 441.646 96.7785C441.021 98.3678 438.212 106.777 438.212 106.777C438.212 106.777 449.845 93.4957 456.267 94.6353C462.689 95.775 466.522 123.141 466.522 123.141L467.539 126.928L467.525 126.932Z"
          fill="black"
        />
        <path
          d="M466.943 119.711C466.323 123.426 464.599 126.063 466.865 126.441C469.13 126.82 472.214 124.628 473.294 120.94C474.373 117.252 473.185 114.831 470.919 114.453C468.654 114.074 467.555 116.001 466.937 119.71L466.943 119.711Z"
          fill="#C67764"
        />
        <path
          d="M467.951 120.598C468.098 121.587 468.678 122.906 469.193 121.194C469.634 119.913 469.533 118.35 470.178 117.184C470.435 116.755 471.032 117.028 471.402 117.377C472.693 118.561 472.284 120.604 471.03 121.703C472.484 120.713 472.983 118.434 471.599 117.164C471.235 116.816 470.566 116.422 470.093 116.819C469.031 117.363 469.282 124.754 467.942 120.609L467.951 120.598Z"
          fill="black"
        />
        <path
          d="M438.673 112.136C437.703 115.775 438.183 118.889 435.964 118.297C433.744 117.706 431.842 114.435 432.382 110.631C432.907 106.902 435.005 105.113 437.225 105.704C439.444 106.296 439.649 108.504 438.68 112.137L438.673 112.136Z"
          fill="#C67764"
        />
        <path
          d="M437.395 112.528C434.469 115.751 437.748 109.136 437.003 108.187C436.736 107.631 435.963 107.72 435.489 107.88C433.703 108.464 433.215 110.752 434.131 112.248C433.443 110.729 433.921 108.701 435.58 108.155C436.062 107.99 436.724 107.989 436.774 108.486C436.885 109.821 436.147 111.202 436.015 112.544C435.777 114.309 436.848 113.36 437.392 112.514L437.395 112.528Z"
          fill="black"
        />
        <path
          d="M434.573 141.589L458.356 147.29C466.826 149.121 466.575 131.087 468.165 122.369L470.426 103.422C471.111 99.6486 468.722 96.778 463.46 95.4565L452.777 93.6119C447.648 93.6502 443.311 97.0862 440.472 102.059L434.447 114.304L426.113 131.255C424.795 135.921 425.538 138.521 434.573 141.589V141.589Z"
          fill="#C67764"
        />
        <path
          d="M468.982 97.8663C463.819 97.174 458.233 96.6505 453.866 93.5857C453.255 93.1411 452.723 92.6094 452.245 92C452.579 92.6899 453.086 93.3054 453.636 93.856C457.77 97.4507 463.716 98.0967 468.989 97.8679L468.982 97.8663Z"
          fill="#802626"
        />
        <path
          d="M461.84 100.102C458.165 97.9975 454.918 95.2939 452.244 92.0072C454.076 95.8856 457.727 98.9221 461.84 100.102Z"
          fill="#802626"
        />
        <path
          d="M463.143 114.391L459.36 117.875L457.228 117.394L457.234 112.274C459.805 111.997 462.469 112.868 463.143 114.391Z"
          fill="#AD5441"
        />
        <path
          d="M448.451 111.922L447.249 116.055L443.564 115.082L443.259 111.612C444.754 109.942 446.476 109.987 448.451 111.922Z"
          fill="#AD5441"
        />
        <path
          d="M458.099 117.7C457.625 117.598 457.389 116.827 457.573 115.98C457.756 115.132 458.289 114.528 458.763 114.631C459.237 114.733 459.473 115.503 459.289 116.351C459.106 117.199 458.573 117.803 458.099 117.7Z"
          fill="black"
        />
        <path
          d="M460.193 115.963C460.193 115.963 459.743 114.554 457.291 114.312"
          stroke="black"
          strokeWidth="0.320458"
          strokeMiterlimit="10"
        />
        <path
          d="M444.604 113.286C444.698 112.424 445.165 111.768 445.647 111.82C446.129 111.872 446.444 112.614 446.35 113.476C446.256 114.338 445.789 114.995 445.307 114.942C444.825 114.89 444.51 114.148 444.604 113.286Z"
          fill="black"
        />
        <path
          d="M447.12 112.1C447.12 112.1 445.954 111.218 443.802 112.464"
          stroke="black"
          strokeWidth="0.320458"
          strokeMiterlimit="10"
        />
        <path
          d="M446.436 114.87C446.436 114.87 445.882 115.248 444.43 114.803"
          stroke="black"
          strokeWidth="0.320458"
          strokeMiterlimit="10"
        />
        <path
          d="M465.564 110.41C464.312 107.739 461.781 105.467 458.815 104.989C461.542 106.117 463.745 108.121 465.564 110.41Z"
          fill="black"
        />
        <path
          d="M458.13 111.346L462.051 112.679C463.922 113.215 464.317 112.933 464.909 111.927C465.5 110.92 464.765 109.955 463.943 109.266C463.051 108.509 460.571 106.969 458.992 106.477C457.992 106.162 457.514 106.157 457.378 107.361C457.327 107.782 457.404 108.212 457.313 108.632C457.313 108.632 457.143 110.753 458.13 111.346Z"
          fill="black"
        />
        <path
          d="M441.655 103.954C444.258 102.622 447.092 101.707 450.041 101.807C447.143 101.017 443.893 102.038 441.655 103.954Z"
          fill="black"
        />
        <path
          d="M448.039 107.879L443.917 107.473C441.992 107.188 441.749 106.768 441.626 105.607C441.503 104.446 442.682 104.117 443.605 103.582C446.057 102.158 447.725 102.237 449.366 102.441C450.407 102.568 451.259 103.028 450.37 104.56C450.159 104.928 449.995 105.325 449.904 105.745C449.904 105.745 449.183 107.746 448.039 107.879Z"
          fill="black"
        />
        <path
          d="M457.074 128.233C457.074 128.233 455.054 133.874 452.11 133.238C449.166 132.601 441.094 129.931 441.094 129.931C439.781 128.906 439.374 125.362 440.709 123.585C440.873 123.372 441.417 127.162 444.803 126.969C448.189 126.777 454.926 131.007 457.08 128.234L457.074 128.233Z"
          fill="black"
        />
        <path
          d="M452.269 128.013C451.834 129.145 449.479 129.331 447.641 128.704C445.796 128.076 444.235 126.564 444.671 125.426C445.107 124.287 445.711 123.559 447.555 124.187C449.4 124.816 452.705 126.875 452.269 128.013V128.013Z"
          fill="#AD5441"
        />
        <path
          d="M451.37 112.278C449.285 115.768 447.368 119.354 445.488 122.954C445.099 123.814 444.291 124.911 444.363 125.91C444.377 127.061 445.193 128.05 446.224 128.464C447.967 129.352 450.435 130.095 452.08 128.648C450.304 129.824 448.127 128.973 446.456 128.028C446.006 127.774 445.632 127.535 445.372 127.158C444.974 126.606 444.868 125.882 445.059 125.241C445.191 124.811 445.849 123.681 446.053 123.253C447.911 119.635 449.72 116 451.363 112.283L451.37 112.278Z"
          fill="black"
        />
        <path
          d="M450.012 134.751C447.957 135.671 445.813 135.581 444.26 133.816C445.259 136.143 448.299 136.367 450.012 134.751Z"
          fill="black"
        />
        <path
          d="M467.742 125.175C467.177 126.24 467.005 127.462 466.69 128.614C465.873 132.089 465.282 135.64 464.519 139.108C463.906 142.188 462.384 146.043 458.963 146.641C455.499 146.678 452.018 145.67 448.635 144.912C441.75 143.089 434.746 141.397 428.159 138.655C432.351 140.951 436.977 142.359 441.48 143.916C446.038 145.367 450.623 146.726 455.381 147.584C458.084 148.096 460.566 148.233 462.599 146.076C464.43 144.223 465.291 141.727 465.736 139.364C466.763 134.675 466.859 129.863 467.741 125.182L467.742 125.175Z"
          fill="black"
        />
        <path
          d="M434.573 141.589C428.053 137.229 430.148 129.059 431.555 122.976C431.862 121.646 433.572 117.347 433.484 116.272L426.119 131.257C424.802 135.922 425.544 138.522 434.579 141.591L434.573 141.589Z"
          fill="#AD6858"
        />
        <path
          d="M302.258 124.6L433.196 146.077L415.465 281.539L274.039 263.027L302.258 124.6Z"
          fill="#FFCD9F"
        />
        <rect
          x="346.646"
          y="53.6057"
          width="85.2535"
          height="78.3223"
          transform="rotate(9.05519 346.646 53.6057)"
          fill="#F5BE8A"
        />
        <path
          d="M393.419 62.1292L386.44 96.2322L381.901 92.729L376.369 93.8504L382.529 60.1394L393.419 62.1292Z"
          fill="#CF9865"
        />
        <path
          d="M386.871 54.2741L346.656 53.6047L384.969 59.941L386.871 54.2741Z"
          fill="#CF9865"
        />
        <path
          d="M383.098 132.448L336.004 124.599L346.211 53.9597L429.406 67.3027L418.417 139.512"
          stroke="#0E1725"
          strokeWidth="1.6327"
        />
        <path
          d="M277.14 141.867L274 263.524L295.977 265.879L302.256 124.599L277.14 141.867Z"
          fill="#CF9865"
        />
        <path
          d="M325.323 131.186L340.993 134.265L338.017 172.983L331.223 168.041L322.694 171.553L325.323 131.186Z"
          fill="#CF9865"
        />
        <rect
          x="369.622"
          y="174.001"
          width="47.0932"
          height="6.27909"
          transform="rotate(7.84941 369.622 174.001)"
          fill="#CF9865"
        />
        <rect
          x="368.261"
          y="192.884"
          width="47.0932"
          height="6.27909"
          transform="rotate(7.84941 368.261 192.884)"
          fill="#CF9865"
        />
        <path
          d="M303.041 125.384L434.117 147.361L421.559 238.408"
          stroke="#0E1725"
          strokeWidth="1.6327"
        />
        <path
          d="M383.088 45.3659L338.453 40.2655C335.73 39.9544 333.264 41.893 332.924 44.6124L328.727 78.1531"
          stroke="#0E1725"
          strokeWidth="2"
        />
        <path
          d="M423.506 225.5C406.151 241.448 393.506 256 354.327 261.17C355.827 273.996 352.334 279.633 346.164 288.926C430.591 306.415 433.513 277.497 464.534 238.313C481.621 207.758 499.682 188.757 480.006 161C472.437 150.322 457.336 153.371 451.506 159C432.209 182.272 442.006 208.5 423.506 225.5Z"
          fill="#FFF3C4"
        />
        <path
          d="M354.327 261.169C398.006 256.5 406.842 239.745 431.006 219.5M346.164 289.742C363.035 294.368 405.864 297.427 427.506 284.5C463.5 263 483.286 204.524 489 195"
          stroke="#1C1C1C"
          strokeWidth="1.6327"
        />
        <path
          d="M454.5 245.5C428.1 279.5 374.5 285.667 351 284.5L345 289.5C420.6 312.3 462.5 254 474 222C470 227.167 460.5 239.1 454.5 245.5Z"
          fill="#FFDF99"
        />
        <path
          d="M436.5 164.5C447.334 152.667 473 137 489 169"
          stroke="#802626"
        />
        <path
          d="M323.903 245.374C331.857 255.044 334.747 254.935 328.469 262.247C314.201 266.746 308.622 261.896 294.227 254.935C288.24 257.047 288.147 259.413 290.232 265.059C310.206 287.556 315.914 286.993 342.738 289.805C364.197 292.055 360.049 274.245 354.722 265.059C349.015 248.749 347.588 251.996 339.883 247.062C328.469 239.751 323.903 241.438 323.903 245.374Z"
          fill="#C67764"
          stroke="#802626"
        />
      </g>
      <defs>
        <clipPath id="clip0_1284_23673">
          <rect width="503" height="273" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  inventoryManagement: (
    <svg
      width="49"
      height="49"
      viewBox="0 0 49 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="9.03418"
        y="10.8778"
        width="39.7899"
        height="26.0165"
        rx="1.49219"
        fill="white"
      />
      <path
        d="M43.0855 36.5117H9.41709C8.30092 36.5117 7.23046 36.0683 6.4412 35.279C5.65195 34.4898 5.20855 33.4193 5.20855 32.3031V13.3647C5.20855 12.2485 4.76515 11.178 3.97589 10.3888C3.18664 9.59953 2.11618 9.15613 1 9.15613"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.1226 48C37.4469 48 39.3312 46.1157 39.3312 43.7914C39.3312 41.4671 37.4469 39.5829 35.1226 39.5829C32.7983 39.5829 30.9141 41.4671 30.9141 43.7914C30.9141 46.1157 32.7983 48 35.1226 48Z"
        fill="white"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.0142 48C18.3385 48 20.2228 46.1157 20.2228 43.7914C20.2228 41.4671 18.3385 39.5829 16.0142 39.5829C13.6899 39.5829 11.8057 41.4671 11.8057 43.7914C11.8057 46.1157 13.6899 48 16.0142 48Z"
        fill="white"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="10.5645"
        y="16.9993"
        width="15.3038"
        height="12.243"
        rx="1"
        fill="#D9D9D9"
      />
      <rect
        x="10.5645"
        y="30.7727"
        width="32.138"
        height="3.06076"
        rx="1"
        fill="#D9D9D9"
      />
      <rect
        x="28.9297"
        y="16.9994"
        width="13.7734"
        height="12.243"
        rx="1"
        fill="#D9D9D9"
      />
      <rect
        x="20.2451"
        y="0.25"
        width="14.5143"
        height="14.5143"
        rx="0.75"
        fill="#D92D20"
        stroke="black"
        strokeWidth="0.5"
      />
      <rect x="29.5508" width="2.72987" height="8.1896" fill="white" />
    </svg>
  ),
  clock: (
    <svg
      width="54"
      height="49"
      viewBox="0 0 54 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="27.7105" cy="24.8143" r="9.72272" fill="white" />
      <circle cx="27.7126" cy="24.8141" r="14.2101" fill="white" />
      <circle cx="27.7105" cy="24.8143" r="9.72272" fill="#D9D9D9" />
      <path
        d="M9.5147 24.8147C9.5147 24.5386 9.29084 24.3147 9.0147 24.3147C8.73856 24.3147 8.5147 24.5386 8.5147 24.8147H9.5147ZM16.1934 9.45554C15.9726 9.62139 15.9281 9.93482 16.0939 10.1556C16.2598 10.3764 16.5732 10.421 16.794 10.2551L16.1934 9.45554ZM6.34225 27.5491C6.20018 27.7859 6.27696 28.093 6.51375 28.2351C6.75054 28.3772 7.05767 28.3004 7.19974 28.0636L6.34225 27.5491ZM9.0147 24.0668L9.36825 23.7133C9.25938 23.6044 9.10642 23.5518 8.95361 23.5706C8.80079 23.5894 8.66517 23.6776 8.58595 23.8096L9.0147 24.0668ZM11.6528 27.412C11.848 27.6072 12.1646 27.6072 12.3599 27.412C12.5551 27.2167 12.5551 26.9001 12.3599 26.7049L11.6528 27.412ZM45.9098 24.8147C45.9098 34.865 37.7625 43.0123 27.7122 43.0123V44.0123C38.3147 44.0123 46.9098 35.4172 46.9098 24.8147H45.9098ZM27.7122 43.0123C17.662 43.0123 9.5147 34.865 9.5147 24.8147H8.5147C8.5147 35.4172 17.1097 44.0123 27.7122 44.0123V43.0123ZM27.7122 6.61719C37.7625 6.61719 45.9098 14.7645 45.9098 24.8147H46.9098C46.9098 14.2122 38.3147 5.61719 27.7122 5.61719V6.61719ZM16.794 10.2551C19.8354 7.97067 23.615 6.61719 27.7122 6.61719V5.61719C23.391 5.61719 19.402 7.04549 16.1934 9.45554L16.794 10.2551ZM7.19974 28.0636L9.44345 24.3241L8.58595 23.8096L6.34225 27.5491L7.19974 28.0636ZM8.66115 24.4204L11.6528 27.412L12.3599 26.7049L9.36825 23.7133L8.66115 24.4204Z"
        fill="black"
      />
      <path
        d="M16.2189 5.59126C15.0823 4.21464 13.4454 3.34591 11.6683 3.17619C9.89118 3.00647 8.11943 3.54965 6.74281 4.68625C5.36619 5.82285 4.49746 7.45976 4.32774 9.23687C4.15801 11.014 4.7012 12.7857 5.8378 14.1624L11.0284 9.87681L16.2189 5.59126Z"
        fill="#D92D20"
      />
      <path
        opacity="0.9"
        d="M47.8686 14.2265C49.0833 12.9183 49.7286 11.1811 49.6625 9.3971C49.5964 7.61312 48.8243 5.92847 47.5161 4.71376C46.2079 3.49904 44.4707 2.85376 42.6867 2.91987C40.9028 2.98598 39.2181 3.75807 38.0034 5.06628L42.936 9.64637L47.8686 14.2265Z"
        fill="#D92D20"
      />
      <rect
        x="17.3257"
        y="18.8367"
        width="11.575"
        height="1.79496"
        transform="rotate(32.6071 17.3257 18.8367)"
        fill="black"
      />
      <rect
        x="26.9634"
        y="25.0798"
        width="13.3148"
        height="1.79496"
        transform="rotate(-33.8367 26.9634 25.0798)"
        fill="black"
      />
      <circle cx="27.1682" cy="25.5616" r="1.4958" fill="black" />
      <path
        d="M13.5024 48.0001L16.494 43.5127"
        stroke="black"
        strokeLinecap="round"
      />
      <path
        d="M41.9214 48.0001L38.9298 43.5127"
        stroke="black"
        strokeLinecap="round"
      />
      <path
        d="M5.58168 0.765066C3.70126 1.73403 0.145718 4.99399 0.966889 10.2822"
        stroke="black"
      />
      <path
        d="M51.6422 10.457C52.1897 8.41367 52.1682 3.5899 47.7023 0.641251"
        stroke="black"
      />
    </svg>
  ),
  automatedPaymentReminder: (
    <svg
      width="580"
      height="339"
      viewBox="0 0 580 339"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="-0.429688"
        y="130.736"
        width="69.3862"
        height="86.1346"
        rx="6.58953"
        fill="#D3DCEB"
      />
      <rect
        x="-10"
        y="121.165"
        width="72.9751"
        height="87.3309"
        rx="6.58953"
        fill="white"
      />
      <rect
        x="-10"
        y="121.165"
        width="72.9751"
        height="20.3373"
        fill="#D3DCEB"
      />
      <rect
        x="-0.429688"
        y="116.38"
        width="5.98157"
        height="14.3558"
        fill="#D3DCEB"
      />
      <rect
        x="16.3594"
        y="116.38"
        width="5.98157"
        height="14.3558"
        fill="#D3DCEB"
      />
      <rect
        x="32.832"
        y="116.38"
        width="5.98157"
        height="14.3558"
        fill="#D3DCEB"
      />
      <rect
        x="47.4238"
        y="116.38"
        width="5.98157"
        height="14.3558"
        fill="#D3DCEB"
      />
      <rect
        x="0.765625"
        y="184.57"
        width="9.57051"
        height="9.57051"
        rx="1.64738"
        fill="#D3DCEB"
      />
      <rect
        x="15.1211"
        y="184.57"
        width="9.57051"
        height="9.57051"
        rx="1.64738"
        fill="#D9D9D9"
      />
      <rect
        x="15.1211"
        y="167.822"
        width="9.57051"
        height="9.57051"
        rx="1.64738"
        fill="#D9D9D9"
      />
      <rect
        x="29.4785"
        y="184.571"
        width="9.57051"
        height="9.57051"
        rx="1.64738"
        fill="#D9D9D9"
      />
      <rect
        x="29.4785"
        y="167.822"
        width="9.57051"
        height="9.57051"
        rx="1.64738"
        fill="#D9D9D9"
      />
      <rect
        x="43.832"
        y="184.571"
        width="9.57051"
        height="9.57051"
        rx="1.64738"
        fill="#D9D9D9"
      />
      <rect
        x="43.832"
        y="167.822"
        width="9.57051"
        height="9.57051"
        rx="1.64738"
        fill="#D9D9D9"
      />
      <path
        d="M243.81 26.7698L234.074 28.2825C233.625 28.3521 233.32 28.7714 233.389 29.2175C233.458 29.6636 233.877 29.9703 234.325 29.9006L244.061 28.388C244.51 28.3183 244.816 27.899 244.746 27.453C244.677 27.0069 244.258 26.7001 243.81 26.7698Z"
        fill="white"
        stroke="#375A8D"
        strokeWidth="1.64738"
      />
      <path
        d="M252.256 29.8705C256.751 31.3556 260.695 34.1597 263.572 37.9165C263.985 37.2607 264.286 36.5382 264.461 35.7783L264.461 35.7782C264.874 33.981 264.556 32.0939 263.578 30.5308C262.599 28.9682 261.041 27.8568 259.243 27.4404C257.791 27.1112 256.272 27.2543 254.907 27.8487C253.868 28.301 252.96 28.9968 252.256 29.8705Z"
        fill="white"
        stroke="#375A8D"
        strokeWidth="1.64738"
      />
      <path
        d="M216.184 44.9835C217.746 40.5144 220.617 36.6191 224.422 33.807C223.774 33.3827 223.057 33.0691 222.3 32.8817L222.3 32.8816C220.51 32.4382 218.618 32.7234 217.038 33.6748C215.459 34.6259 214.321 36.1653 213.874 37.9556C213.52 39.4016 213.637 40.9232 214.208 42.2983C214.642 43.3448 215.322 44.2646 216.184 44.9835Z"
        fill="white"
        stroke="#375A8D"
        strokeWidth="1.64738"
      />
      <path
        d="M219.119 59.4019C220.041 65.3389 223.287 70.666 228.141 74.2113C232.996 77.7565 239.062 79.2295 245.005 78.3061C247.947 77.849 250.771 76.8173 253.314 75.2699C255.857 73.7225 258.07 71.6897 259.827 69.2877C261.584 66.8857 262.85 64.1616 263.553 61.2709C264.256 58.3803 264.382 55.3798 263.924 52.4408C263.409 49.0704 262.131 45.8622 260.186 43.0606C257.163 38.6832 252.695 35.5072 247.564 34.088C244.468 33.2351 241.225 33.0506 238.051 33.5467C232.11 34.4698 226.779 37.7118 223.228 42.5602C219.678 47.4086 218.2 53.4664 219.119 59.4019Z"
        fill="#375A8D"
      />
      <path
        d="M263.753 50.482L263.752 50.4795C263.256 47.2332 262.025 44.143 260.152 41.4445L260.151 41.443C257.238 37.2248 252.932 34.1641 247.988 32.7963C245.004 31.9745 241.88 31.7967 238.821 32.2748L238.821 32.2749C233.095 33.1644 227.957 36.2889 224.536 40.9611C221.115 45.6333 219.69 51.4707 220.576 57.1901C221.465 62.9109 224.592 68.044 229.27 71.4603C233.948 74.8767 239.794 76.2963 245.522 75.4065C248.357 74.9659 251.078 73.9717 253.529 72.4805C255.98 70.9893 258.112 69.0303 259.805 66.7157C261.498 64.401 262.718 61.7759 263.396 58.9905C264.073 56.2051 264.194 53.3139 263.753 50.482Z"
        fill="white"
        stroke="#375A8D"
        strokeWidth="1.64738"
      />
      <path
        d="M259.81 50.7718C258.355 41.4097 249.579 35.0005 240.207 36.4565C230.836 37.9125 224.418 46.6824 225.872 56.0445C226.595 60.6963 229.125 64.6191 232.638 67.2102"
        stroke="#375A8D"
        strokeWidth="0.5"
      />
      <path
        d="M242.56 43.5454L244.904 52.3414C244.899 52.3761 244.881 52.4075 244.853 52.4297L243.924 55.2612C243.914 55.2956 243.896 55.3268 243.87 55.3516C243.844 55.3765 243.812 55.394 243.777 55.4026C243.742 55.4112 243.706 55.4104 243.672 55.4005C243.637 55.3905 243.606 55.3716 243.581 55.3458L242.077 53.8766C242.056 53.8582 242.039 53.8359 242.027 53.8108C242.016 53.7858 242.009 53.7586 242.008 53.7309L242.07 43.5574C242.069 43.4925 242.093 43.4296 242.138 43.3826C242.183 43.3356 242.244 43.3083 242.309 43.3067C242.374 43.3051 242.437 43.3294 242.484 43.3742C242.531 43.419 242.558 43.4805 242.56 43.5454Z"
        fill="#375A8D"
      />
      <path
        d="M235.492 56.0602L242.588 54.0575C242.621 54.0481 242.658 54.0561 242.693 54.0802L243.82 54.9623C243.844 54.982 243.865 55.0095 243.88 55.042C243.896 55.0744 243.906 55.1103 243.909 55.1461C243.911 55.1818 243.907 55.2159 243.896 55.2446C243.886 55.2734 243.869 55.2958 243.847 55.3092L242.736 55.9986L242.69 56.0114L235.588 56.4505C235.553 56.4577 235.514 56.444 235.48 56.4125C235.446 56.3809 235.42 56.3342 235.407 56.2825C235.394 56.2307 235.396 56.1782 235.412 56.1365C235.428 56.0948 235.457 56.0674 235.492 56.0602Z"
        fill="#375A8D"
      />
      <path
        d="M242.5 248C238.358 248 235 244.642 235 240.5C235 236.358 238.358 233 242.5 233L351.5 233C355.642 233 359 236.358 359 240.5C359 244.642 355.642 248 351.5 248L242.5 248Z"
        fill="#D3DCEB"
      />
      <rect
        x="473.553"
        y="115.265"
        width="106.125"
        height="6.5308"
        rx="3.2654"
        fill="#DDE2EB"
      />
      <rect
        x="473.553"
        y="129.96"
        width="48.981"
        height="6.5308"
        rx="3.2654"
        fill="#DDE2EB"
      />
      <rect
        x="436"
        y="112"
        width="27.7559"
        height="27.7559"
        rx="4.8981"
        fill="#DDE2EB"
      />
      <path
        d="M310.742 66.2803C310.742 63.827 312.731 61.8381 315.184 61.8381H413.446C415.899 61.8381 417.888 63.827 417.888 66.2803V167.89V167.91V167.931V167.951V167.972V167.992V168.013V168.033V168.054V168.074V168.095V168.115V168.136V168.156V168.176V168.197V168.217V168.237V168.258V168.278V168.298V168.319V168.339V168.359V168.38V168.4V168.42V168.44V168.461V168.481V168.501V168.521V168.541V168.562V168.582V168.602V168.622V168.642V168.662V168.682V168.702V168.723V168.743V168.763V168.783V168.803V168.823V168.843V168.863V168.883V168.903V168.923V168.943V168.963V168.983V169.003V169.023V169.043V169.062V169.082V169.102V169.122V169.142V169.162V169.182V169.201V169.221V169.241V169.261V169.281V169.3V169.32V169.34V169.36V169.379V169.399V169.419V169.439V169.458V169.478V169.498V169.517V169.537V169.557V169.576V169.596V169.616V169.635V169.655V169.674V169.694V169.713V169.733V169.752V169.772V169.792V169.811V169.831V169.85V169.869V169.889V169.908V169.928V169.947V169.967V169.986V170.005V170.025V170.044V170.064V170.083V170.102V170.122V170.141V170.16V170.18V170.199V170.218V170.237V170.257V170.276V170.295V170.314V170.334V170.353V170.372V170.391V170.41V170.43V170.449V170.468V170.487V170.506V170.525V170.544V170.563V170.582V170.602V170.621V170.64V170.659V170.678V170.697V170.716V170.735V170.754V170.773V170.792V170.811V170.83V170.849V170.867V170.886V170.905V170.924V170.943V170.962V170.981V171V171.019V171.037V171.056V171.075V171.094V171.113V171.131V171.15V171.169V171.188V171.206V171.225V171.244V171.263V171.281V171.3V171.319V171.337V171.356V171.375V171.393V171.412V171.43V171.449V171.468V171.486V171.505V171.523V171.542V171.56V171.579V171.598V171.616V171.635V171.653V171.672V171.69V171.708V171.727V171.745V171.764V171.782V171.801V171.819V171.837V171.856V171.874V171.892V171.911V171.929V171.947V171.966V171.984V172.002V172.021V172.039V172.057V172.076V172.094V172.112V172.13V172.148V172.167V172.185V172.203V172.221V172.239V172.258V172.276V172.294V172.312V172.33V172.348V172.366V172.384V172.402V172.42V172.439V172.457V172.475V172.493V172.511V172.529V172.547V172.565V172.583V172.601V172.618V172.636V172.654V172.672V172.69V172.708V172.726V172.744V172.762V172.78V172.797V172.815V172.833V172.851V172.869V172.887V172.904V172.922V172.94V172.958V172.975V172.993V173.011V173.029V173.046V173.064V173.082V173.099V173.117V173.135V173.152V173.17V173.188V173.205V173.223V173.241V173.258V173.276V173.293V173.311V173.328V173.346V173.363V173.381V173.399V173.416V173.434V173.451V173.468V173.486V173.503V173.521V173.538V173.556V173.573V173.59V173.608V173.625V173.643V173.66V173.677V173.695V173.712V173.729V173.747V173.764V173.781V173.799V173.816V173.833V173.85V173.868V173.885V173.902V173.919V173.936V173.954V173.971V173.988V174.005V174.022V174.04V174.057V174.074V174.091V174.108V174.125V174.142V174.159V174.176V174.193V174.21V174.227V174.245V174.262V174.279V174.296V174.313V174.33V174.346V174.363V174.38V174.397V174.414V174.431V174.448V174.465V174.482V174.499V174.516V174.533V174.549V174.566V174.583V174.6V174.617V174.634V174.65V174.667V174.684V174.701V174.717V174.734V174.751V174.768V174.784V174.801V174.818V174.834V174.851V174.868V174.884V174.901V174.918V174.934V174.951V174.968V174.984V175.001V175.017V175.034V175.051V175.067V175.084V175.1V175.117V175.133V175.15V175.166V175.183V175.199V175.216V175.232V175.249V175.265V175.281V175.298V175.314V175.331V175.347V175.363V175.38V175.396V175.413V175.429V175.445V175.462V175.478V175.494V175.51V175.527V175.543V175.559V175.576V175.592V175.608V175.624V175.641V175.657V175.673V175.689V175.705V175.721V175.738V175.754V175.77V175.786V175.802V175.818V175.834V175.851V175.867V175.883V175.899V175.915V175.931V175.947V175.963V175.979V175.995V176.011V176.027V176.043V176.059V176.075V176.091V176.107V176.123V176.139V176.155V176.171V176.186V176.202V176.218V176.234V176.25V176.266V176.282V176.297V176.313V176.329V176.345V176.361V176.376V176.392V176.408V176.424V176.44V176.455V176.471V176.487V176.502V176.518V176.534V176.55V176.565V176.581V176.597V176.612V176.628V176.643V176.659V176.675V176.69V176.706V176.721V176.737V176.753V176.768V176.784V176.799V176.815V176.83V176.846V176.861V176.877V176.892V176.908V176.923V176.939V176.954V176.97V176.985V177V177.016V177.031V177.047C417.888 185.869 410.736 193.016 401.914 193.016H333.305C320.844 193.016 310.742 182.914 310.742 170.453V66.2803Z"
        fill="#8CBFBB"
        stroke="#0E1725"
      />
      <path
        d="M328.422 116.381C328.422 114.561 329.897 113.086 331.717 113.086H394.317C396.137 113.086 397.612 114.561 397.612 116.381C397.612 118.201 396.137 119.676 394.317 119.676H331.717C329.897 119.676 328.422 118.201 328.422 116.381Z"
        fill="#F5F5F5"
      />
      <path
        d="M328.422 134.502C328.422 132.682 329.897 131.207 331.717 131.207H394.317C396.137 131.207 397.612 132.682 397.612 134.502C397.612 136.322 396.137 137.797 394.317 137.797H331.717C329.897 137.797 328.422 136.322 328.422 134.502Z"
        fill="#F5F5F5"
      />
      <path
        d="M381.996 162.275H279V167.159C279 181.716 290.801 193.517 305.358 193.517H399.162C389.353 191.519 381.996 179.967 381.996 162.275Z"
        fill="#375A8D"
      />
      <path
        d="M434.968 71.2221C434.968 84.0399 424.577 94.4308 411.759 94.4308C398.941 94.4308 388.55 84.0399 388.55 71.2221C388.55 58.4043 398.941 48.0134 411.759 48.0134C424.577 48.0134 434.968 58.4043 434.968 71.2221Z"
        fill="#FFF3C4"
        stroke="#375A8D"
        strokeWidth="1.64738"
      />
      <path
        d="M402.146 72.8238L409.158 78.4314L423.776 64.012"
        stroke="#375A8D"
        strokeWidth="3.29476"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M430.559 157.565V184.747C430.559 196.574 420.971 206.162 409.143 206.162H376.195"
        stroke="#6FB9B1"
        strokeWidth="2"
      />
      <path
        d="M201.865 39.037C201.112 35.5494 201.535 27.8929 209.255 25.1688"
        stroke="#CDE1FF"
        strokeWidth="2.40565"
      />
      <path
        d="M194.071 41.2186C192.962 36.0849 193.586 24.815 204.949 20.8051"
        stroke="#CDE1FF"
        strokeWidth="2.40565"
      />
      <path
        d="M261.664 20.7095C264.702 20.5308 271.099 21.8888 272.385 28.7505"
        stroke="#CDE1FF"
        strokeWidth="2.05164"
      />
      <path
        d="M260.844 13.8555C265.316 13.5925 274.732 15.5915 276.626 25.6916"
        stroke="#CDE1FF"
        strokeWidth="2.05164"
      />
      <path
        d="M203.095 194.948C209.597 190.771 205.146 193.722 213.868 186.232C238.739 164.9 173.854 99.2776 158.555 90.7685C111.045 64.3532 184.745 159.111 168.846 181.574C167.302 183.756 166.733 184.338 166.883 186.357C171.928 204.138 184.383 201.4 203.095 194.948V194.948Z"
        fill="#C67764"
      />
      <path
        d="M268.917 124.711C264.278 130.201 251.53 126.362 245.747 132.264C239.282 138.847 232.567 154.021 225.965 167.038C221.864 175.128 217.8 182.381 213.867 186.232C210.554 189.477 206.959 192.391 203.089 194.948C194.523 194.86 188.271 192.09 184.657 187.389C179.637 180.874 179.699 170.639 185.72 158.698C187.089 157.666 190.009 153.04 191.241 151.846C197.055 146.206 216.712 122.017 226.797 114.995C238.044 107.168 234.037 91.9189 238.169 93.5757C247.279 97.2207 243.371 107.199 243.371 107.199C248.623 107.368 257.782 105.073 263.934 100.159C263.934 100.159 261.346 80.7088 270.856 81.1089C273.563 81.2215 271.981 94.6573 272.112 99.1901C272.3 105.617 276.801 115.358 268.911 124.711H268.917Z"
        fill="#C67764"
      />
      <path
        d="M233.706 116.583C232.33 114.182 230.773 113.576 233.868 105.467C236.963 97.3578 235.031 91.6871 238.17 93.5815C241.314 95.4759 245.803 97.8767 243.371 107.199C243.371 107.199 245.184 108.543 253.1 105.823"
        stroke="black"
        strokeWidth="0.347157"
        strokeMiterlimit="10"
      />
      <path
        d="M249.117 130.132C249.117 130.132 243.477 129.313 223.239 171.852C210.279 199.093 188.728 199.155 188.728 199.155"
        stroke="#FFF3C4"
        strokeWidth="0.347157"
        strokeMiterlimit="10"
      />
      <path
        d="M191.142 154.002C201.439 137.184 232.518 109.575 232.518 109.575"
        stroke="#573828"
        strokeWidth="0.347157"
        strokeMiterlimit="10"
      />
      <path
        d="M256.852 90.7745C256.852 90.7745 258.596 92.0437 263.729 93.4755C268.862 94.9072 275.727 98.3459 275.727 99.7151C275.727 101.084 273.039 117.878 273.039 117.878C273.039 117.878 261.997 123.398 264.398 117.565C266.799 111.732 267.03 102.804 266.743 102.116C266.455 101.428 253.413 102.772 256.846 90.7745H256.852Z"
        fill="#C67764"
      />
      <path
        d="M256.533 90.2619C256.533 90.2619 274.92 96.339 275.414 99.2024C275.908 102.066 272.87 118.29 272.401 119.647C271.932 121.004 268.374 128.487 257.133 128.888"
        stroke="#FFF3C4"
        strokeWidth="0.347157"
        strokeMiterlimit="10"
      />
      <path
        d="M268.191 105.83C268.191 105.83 258.432 102.572 261.245 99.4838C261.245 99.4838 270.58 100.759 273.293 101.366C276.006 101.972 274.287 98.1083 274.975 104.285"
        fill="#C67764"
      />
      <path
        d="M273.044 117.878C273.001 115.589 276.596 104.454 274.501 102.166C272.407 99.8777 260.54 98.8461 260.54 98.8461C260.54 98.8461 259.609 104.742 266.004 105.079"
        stroke="#FFF3C4"
        strokeWidth="0.347157"
        strokeMiterlimit="10"
      />
      <path
        d="M237.425 129.169C238.337 128.938 248.166 129.782 251.942 129.169C255.718 128.556 263.083 128.8 266.003 126.756"
        stroke="#FFF3C4"
        strokeWidth="0.347157"
        strokeMiterlimit="10"
      />
      <path
        d="M244.753 120.16C244.753 120.16 249.298 114.226 256.851 115.896"
        stroke="black"
        strokeWidth="0.347157"
        strokeMiterlimit="10"
      />
      <path
        d="M224.953 167.038C220.852 175.128 217.801 182.381 213.868 186.232C210.554 189.477 200.238 197.824 188.728 199.155C180.163 199.068 190.31 192.716 186.703 188.02C185.19 181.862 185.89 177.698 191.142 181.862C198.1 187.383 211.974 177.761 224.953 167.044V167.038Z"
        fill="#AD6858"
      />
      <path
        d="M75.2266 201.55C75.1203 203.175 75.114 204.788 75.2078 206.408C61.9471 218.774 49.4365 219.687 37.7638 207.533C37.2136 206.977 36.6822 206.383 36.1445 205.764C35.8507 201.394 36.007 196.998 36.5947 192.628C37.5387 185.651 39.1831 174.034 41.315 161.674C45.0225 140.291 50.1743 116.677 55.6011 111.007C82.204 83.2346 76.352 184.838 75.2203 201.55H75.2266Z"
        fill="#C67764"
      />
      <path
        d="M37.7641 207.533C37.2139 206.977 36.6825 206.383 36.1448 205.764C35.8509 201.393 36.0072 196.998 36.5949 192.628C37.539 185.651 39.1833 174.034 41.3153 161.674L48.449 166.838C48.449 166.838 36.2698 193.284 37.7641 207.533Z"
        fill="#965B4C"
      />
      <path
        d="M175.517 273.512C175.517 286.954 162.919 303.297 136.666 313.325C99.6409 327.462 76.9331 288.761 75.8203 275.356C74.251 256.387 85.8799 238.6 114.765 238.6C143.65 238.6 175.51 260.076 175.51 273.512H175.517Z"
        fill="#C67764"
      />
      <path
        d="M179.631 252.617C175.398 310.931 153.028 379.523 134.559 428.383C134.559 428.383 129.126 436.405 110.495 429.878C109.694 429.596 108.863 429.29 108.013 428.952C104.53 427.577 118.291 404.613 120.961 388.488C124.424 367.563 123.055 346.249 117.197 326.048C115.184 319.084 112.633 312.244 109.563 305.598C96.4586 277.257 86.5365 244.027 114.421 247.766L179.637 252.617H179.631Z"
        fill="#D16D6D"
      />
      <path
        d="M108.013 428.959C108.013 428.959 123.687 438.343 134.559 428.383C134.559 428.383 172.641 325.061 170.365 307.211"
        stroke="#573828"
        strokeWidth="0.347157"
        strokeMiterlimit="10"
      />
      <path
        d="M182.125 262.652H182.137C182.137 262.652 182.125 262.652 182.113 262.664L182.125 262.652V262.652Z"
        fill="black"
      />
      <path
        d="M182.15 262.639C182.15 262.639 182.15 262.639 182.138 262.651C182.138 262.651 182.138 262.639 182.15 262.639Z"
        fill="black"
      />
      <path
        d="M100.74 245.196C72.8618 241.457 75.2752 286.316 79.5016 305.604C85.6162 333.47 80.5895 364.224 75.9316 392.371C73.262 408.495 56.5813 422.631 59.1509 425.357C72.5555 439.593 82.4964 432.397 82.4964 432.397C117.783 371.72 139.835 313.225 136.627 260.132L100.74 245.202V245.196Z"
        fill="#D16D6D"
      />
      <path
        d="M76.7777 291.649C84.1052 326.642 88.3629 374.365 73.9017 407.758C71.5321 412.853 68.6499 417.748 64.9111 421.919C68.3248 417.486 71.0132 412.559 73.0827 407.401C86.0058 374.828 81.8607 326.086 76.7839 291.649H76.7777Z"
        fill="#573828"
      />
      <path
        d="M85.2612 86.1605L124.362 80.3648C124.362 80.3648 124.231 82.5656 125.087 84.1974C125.944 85.8292 105.699 93.7506 105.699 93.7506L86.4491 92.8941L85.2612 86.1605V86.1605Z"
        fill="#8E4747"
      />
      <path
        d="M113.765 100.797L92.9517 99.7215L94.1896 85.748L95.2962 73.3188L108.695 80.8776L109.657 84.6539L113.765 100.797Z"
        fill="#C67764"
      />
      <path
        d="M109.656 84.6539C109.275 86.0669 108.112 85.2729 97.5397 88.2426C96.0205 88.6678 94.3699 88.1801 93.9885 88.0363L95.2952 73.3188L108.694 80.8776L109.656 84.6601V84.6539Z"
        fill="#602F2F"
      />
      <path
        d="M167.683 114.277C180.837 139.523 195.861 205.608 179.631 252.611C179.631 252.611 79.1153 283.115 76.7394 261.427C68.843 189.458 65.0605 163.318 62.0719 116.234C61.9031 113.533 61.1091 94.7075 81.2972 94.1323C84.0732 94.051 100.698 96.2205 121.173 87.0549C133.653 81.4717 160.606 100.697 167.683 114.27V114.277Z"
        fill="#C67764"
      />
      <path
        d="M180.28 163.543C183.819 173.903 200.112 226.146 182.149 262.639C182.149 262.639 182.149 262.639 182.137 262.639C182.137 262.639 182.137 262.639 182.124 262.639L182.112 262.652C182.112 262.652 182.099 262.652 182.093 262.664C181.993 262.727 181.893 262.783 181.793 262.839C180.605 263.552 176.466 266.003 170.439 269.266C170.414 269.285 170.383 269.298 170.358 269.31C142.942 284.147 76.7386 315.632 70.4802 277.482C70.4802 277.482 67.7355 238.587 69.7924 218.187C70.0988 215.136 69.6987 207.846 69.1485 200.499C68.4107 190.683 67.3916 180.768 67.3916 180.768L37.4814 158.46C37.4814 154.34 54.3497 103.485 54.3497 103.485C54.3497 103.485 58.8137 98.4395 66.36 95.6761C73.9189 92.9064 84.5162 90.5056 84.5162 90.5056L85.2602 86.1728L89.2866 89.3552L102.41 92.3562L103.585 100.453L109.125 103.71L110.35 96.6764C110.35 96.6764 111.207 87.7296 114.739 86.1666C118.278 84.5973 124.361 80.3708 124.361 80.3708L125.086 84.2034L152.183 85.4351C163.756 88.3048 179.786 106.849 195.604 124.648L183.981 151.633L179.636 161.724C179.636 161.724 179.874 162.361 180.28 163.549V163.543Z"
        fill="#FFF3C4"
      />
      <g clipPath="url(#clip0_1586_23305)">
        <path
          d="M139.67 224.472L138.938 224.588C142.743 210.895 133.044 203.696 132.946 203.622L133.587 203.253C133.688 203.326 143.518 210.615 139.666 224.472H139.67Z"
          fill="#F5DCA4"
        />
        <path
          d="M142.834 227.72L142.099 227.816C145.385 212.438 135.245 203.806 135.144 203.719L135.78 203.329C135.885 203.416 146.164 212.155 142.837 227.72H142.834Z"
          fill="#F5DCA4"
        />
        <path
          d="M146.288 225.038L145.554 225.181C147.586 210.126 136.647 202.493 136.535 202.42L137.142 202C137.253 202.077 148.344 209.803 146.285 225.038H146.288Z"
          fill="#F5DCA4"
        />
        <path
          d="M131.959 237.541L131.194 237.525C137.617 224.278 129.088 215.183 129 215.093L129.721 214.833C129.809 214.923 138.46 224.135 131.959 237.538V237.541Z"
          fill="#F5DCA4"
        />
        <path
          d="M134.577 241.423L133.809 241.386C140.017 226.331 131.305 215.696 131.214 215.593L131.935 215.31C132.026 215.416 140.859 226.184 134.577 241.423Z"
          fill="#F5DCA4"
        />
        <path
          d="M138.591 239.32L137.816 239.334C142.689 224.378 132.973 214.62 132.875 214.523L133.573 214.207C133.674 214.304 143.521 224.188 138.591 239.324V239.32Z"
          fill="#F5DCA4"
        />
        <path
          d="M140.29 249.668L139.666 249.828C141.847 237.641 132.842 232.171 132.751 232.118L133.277 231.744C133.368 231.798 142.497 237.338 140.29 249.672V249.668Z"
          fill="#F5DCA4"
        />
        <path
          d="M143.303 252.234L142.673 252.377C144.263 238.771 134.76 232.091 134.665 232.024L135.184 231.634C135.282 231.701 144.917 238.464 143.306 252.234H143.303Z"
          fill="#F5DCA4"
        />
        <path
          d="M146.08 249.628L145.453 249.812C145.985 236.585 135.868 230.838 135.764 230.782L136.256 230.368C136.36 230.425 146.615 236.242 146.076 249.628H146.08Z"
          fill="#F5DCA4"
        />
        <path
          d="M137.3 257.957L136.65 257.947C142.045 246.643 134.743 238.951 134.668 238.874L135.282 238.647C135.356 238.724 142.763 246.517 137.304 257.957H137.3Z"
          fill="#F5DCA4"
        />
        <path
          d="M139.548 261.249L138.894 261.222C144.101 248.379 136.63 239.377 136.556 239.287L137.166 239.044C137.243 239.134 144.816 248.252 139.548 261.249Z"
          fill="#F5DCA4"
        />
        <path
          d="M142.952 259.44L142.295 259.453C146.366 246.703 138.049 238.448 137.964 238.368L138.557 238.094C138.642 238.178 147.074 246.537 142.955 259.44H142.952Z"
          fill="#F5DCA4"
        />
        <path
          d="M116.372 283.063L116.348 282.31C130.027 287.964 138.759 279.099 138.847 279.009L139.147 279.708C139.059 279.798 130.216 288.79 116.375 283.067L116.372 283.063Z"
          fill="#F5DCA4"
        />
        <path
          d="M112.594 285.839V285.082C128.083 290.433 138.358 281.311 138.459 281.218L138.78 281.911C138.675 282.004 128.272 291.256 112.594 285.839Z"
          fill="#F5DCA4"
        />
        <path
          d="M97.237 283.05L97.1292 282.307C111.27 286.375 118.886 276.66 118.96 276.56L119.334 277.216C119.257 277.316 111.546 287.168 97.237 283.05Z"
          fill="#F5DCA4"
        />
        <path
          d="M93.8198 286.208L93.7322 285.462C109.629 289.03 118.738 278.889 118.829 278.786L119.223 279.435C119.132 279.539 109.908 289.82 93.8198 286.208Z"
          fill="#F5DCA4"
        />
        <path
          d="M96.5496 289.75L96.4114 289.004C111.991 291.299 120.076 280.328 120.153 280.218L120.581 280.841C120.5 280.954 112.318 292.072 96.5496 289.75Z"
          fill="#F5DCA4"
        />
        <path
          d="M86.3483 259.392L86.6853 258.733C95.7575 269.927 107.465 266.352 107.58 266.315L107.505 267.055C107.388 267.092 95.5283 270.72 86.345 259.392H86.3483Z"
          fill="#F5DCA4"
        />
        <path
          d="M81.7854 260.029L82.1426 259.376C92.9167 271.15 106.07 268.068 106.201 268.035L106.147 268.781C106.013 268.814 92.6909 271.942 81.7854 260.029Z"
          fill="#F5DCA4"
        />
        <path
          d="M81.9573 264.41L82.2741 263.73C93.5233 274.298 106.323 269.977 106.451 269.934L106.437 270.673C106.309 270.72 93.3413 275.104 81.9573 264.41Z"
          fill="#F5DCA4"
        />
        <path
          d="M80.8215 244.723L81.3944 244.35C83.4839 257.373 94.477 259.789 94.5882 259.812L94.1905 260.368C94.0793 260.345 82.9379 257.903 80.8215 244.723Z"
          fill="#F5DCA4"
        />
        <path
          d="M76.8853 243.177L77.4716 242.818C80.653 257.07 92.5762 260.532 92.6941 260.565L92.31 261.138C92.1886 261.105 80.107 257.607 76.8853 243.181V243.177Z"
          fill="#F5DCA4"
        />
        <path
          d="M75.0049 246.756L75.5711 246.356C79.6859 259.859 91.8989 262.171 92.0203 262.191L91.6698 262.777C91.5451 262.754 79.1703 260.422 75.0049 246.756Z"
          fill="#F5DCA4"
        />
        <path
          d="M71.7593 230.564L72.3693 230.364C71.0179 242.634 80.3462 247.489 80.4406 247.535L79.9418 247.942C79.8475 247.895 70.3911 242.981 71.7593 230.564Z"
          fill="#F5DCA4"
        />
        <path
          d="M68.5882 228.209L69.205 228.025C68.5343 241.672 78.4423 247.695 78.54 247.752L78.048 248.175C77.9469 248.115 67.9041 242.018 68.5849 228.209H68.5882Z"
          fill="#F5DCA4"
        />
        <path
          d="M66 230.984L66.61 230.761C66.9672 243.957 77.4211 249.011 77.5289 249.061L77.0672 249.504C76.9594 249.454 66.364 244.337 66.0034 230.984H66Z"
          fill="#F5DCA4"
        />
        <path
          d="M78.3074 215.129L78.8904 214.819C79.7363 227.522 90.0891 230.807 90.1935 230.837L89.7588 231.337C89.6543 231.304 79.16 227.985 78.3074 215.129Z"
          fill="#F5DCA4"
        />
        <path
          d="M74.6609 213.297L75.2574 213C77.0435 226.979 88.195 231.35 88.3062 231.39L87.885 231.907C87.7704 231.863 76.4672 227.442 74.6643 213.297H74.6609Z"
          fill="#F5DCA4"
        />
        <path
          d="M72.5344 216.571L73.1141 216.235C75.864 229.578 87.3963 232.866 87.5143 232.896L87.1234 233.429C87.0054 233.396 75.3181 230.071 72.5344 216.568V216.571Z"
          fill="#F5DCA4"
        />
        <path
          d="M110.75 279.173L111.06 278.593C118.956 288.678 129.413 285.673 129.517 285.643L129.44 286.299C129.335 286.332 118.74 289.381 110.75 279.176V279.173Z"
          fill="#F5DCA4"
        />
        <path
          d="M106.682 279.669L107.009 279.093C116.408 289.717 128.146 287.172 128.264 287.145L128.206 287.808C128.088 287.835 116.199 290.42 106.685 279.669H106.682Z"
          fill="#F5DCA4"
        />
        <path
          d="M106.729 263.914L106.867 263.294C116.826 270.71 125.807 265.277 125.894 265.22L125.992 265.85C125.901 265.906 116.805 271.417 106.729 263.911V263.914Z"
          fill="#F5DCA4"
        />
        <path
          d="M103.066 265.4L103.221 264.78C114.723 272.32 125.012 266.996 125.113 266.939L125.227 267.572C125.123 267.629 114.703 273.029 103.062 265.4H103.066Z"
          fill="#F5DCA4"
        />
        <path
          d="M104.151 269.015L104.269 268.382C115.906 274.818 125.635 268.535 125.733 268.472L125.881 269.091C125.783 269.158 115.929 275.531 104.151 269.015Z"
          fill="#F5DCA4"
        />
        <path
          d="M87.4963 261.535L87.7322 260.836C98.331 270.57 109.354 265.36 109.462 265.307L109.499 266.046C109.388 266.099 98.2232 271.387 87.4963 261.535Z"
          fill="#F5DCA4"
        />
        <path
          d="M83.0884 262.821L83.3445 262.125C95.7092 272.186 108.232 267.256 108.357 267.202L108.414 267.945C108.286 267.995 95.6047 273.003 83.0917 262.818L83.0884 262.821Z"
          fill="#F5DCA4"
        />
        <path
          d="M83.9038 267.119L84.1161 266.403C96.7706 275.208 108.761 269.101 108.883 269.038L108.98 269.771C108.859 269.834 96.7134 276.028 83.9072 267.116L83.9038 267.119Z"
          fill="#F5DCA4"
        />
        <path
          d="M85.8618 228.692L86.5392 228.343C87.3547 242.988 99.2443 246.896 99.3622 246.933L98.8567 247.503C98.7354 247.466 86.6875 243.511 85.8618 228.689V228.692Z"
          fill="#F5DCA4"
        />
        <path
          d="M81.6831 226.54L82.3705 226.207C84.2544 242.335 97.0505 247.503 97.1785 247.553L96.6865 248.142C96.5551 248.092 83.5871 242.865 81.6797 226.54H81.6831Z"
          fill="#F5DCA4"
        />
        <path
          d="M79.1892 230.288L79.8598 229.908C82.8626 245.314 96.1102 249.242 96.245 249.278L95.7901 249.888C95.6553 249.848 82.229 245.877 79.1892 230.288Z"
          fill="#F5DCA4"
        />
        <path
          d="M88.3354 216.982L89.033 216.729C87.931 230.968 98.9005 236.238 99.0117 236.292L98.4489 236.778C98.3377 236.725 87.2166 231.391 88.332 216.982H88.3354Z"
          fill="#F5DCA4"
        />
        <path
          d="M84.5778 214.377L85.2855 214.14C85.0226 229.945 96.7066 236.548 96.8245 236.612L96.2718 237.118C96.1539 237.051 84.3115 230.372 84.5744 214.373L84.5778 214.377Z"
          fill="#F5DCA4"
        />
        <path
          d="M81.6897 217.678L82.3873 217.398C83.2972 232.647 95.581 238.107 95.7024 238.161L95.1834 238.69C95.0587 238.637 82.6097 233.11 81.6897 217.678Z"
          fill="#F5DCA4"
        />
        <path
          d="M82.303 206.791L82.9062 206.324C86.3875 220.607 98.8128 222.332 98.9375 222.346L98.5432 222.999C98.4152 222.982 85.8247 221.243 82.303 206.787V206.791Z"
          fill="#F5DCA4"
        />
        <path
          d="M77.7939 205.415L78.4107 204.961C83.2164 220.513 96.7639 223.319 96.9021 223.345L96.5247 224.015C96.3865 223.988 82.6569 221.156 77.7939 205.415Z"
          fill="#F5DCA4"
        />
        <path
          d="M76.0247 209.552L76.6178 209.059C82.3907 223.698 96.1607 225.201 96.2989 225.214L95.9619 225.897C95.8203 225.884 81.8683 224.371 76.0247 209.556V209.552Z"
          fill="#F5DCA4"
        />
        <path
          d="M85.0024 195.05L85.4877 194.597C89.6969 206.711 100.623 207.2 100.734 207.204L100.447 207.803C100.336 207.8 89.2622 207.31 85.0024 195.05Z"
          fill="#F5DCA4"
        />
        <path
          d="M80.9753 194.22L81.4741 193.777C86.9369 206.887 98.9309 208.223 99.0489 208.233L98.7759 208.843C98.6546 208.829 86.5022 207.483 80.9719 194.217L80.9753 194.22Z"
          fill="#F5DCA4"
        />
        <path
          d="M79.7788 197.955L80.2506 197.479C86.4785 209.716 98.5533 209.906 98.6747 209.906L98.4388 210.525C98.3174 210.525 86.0808 210.342 79.7788 197.955Z"
          fill="#F5DCA4"
        />
        <path
          d="M120.782 284.786L120.776 284.14C132.392 289.217 140.029 281.775 140.103 281.701L140.346 282.304C140.268 282.381 132.537 289.927 120.779 284.786H120.782Z"
          fill="#F5DCA4"
        />
        <path
          d="M110.591 273.042L110.834 272.33C121.621 282.311 132.894 277.03 133.005 276.977L133.039 277.733C132.925 277.79 121.507 283.144 110.588 273.046L110.591 273.042Z"
          fill="#F5DCA4"
        />
        <path
          d="M106.085 274.335L106.348 273.625C118.935 283.947 131.738 278.956 131.866 278.903L131.924 279.662C131.796 279.716 118.824 284.78 106.085 274.335Z"
          fill="#F5DCA4"
        />
        <path
          d="M106.901 278.729L107.12 278C120.007 287.038 132.274 280.848 132.396 280.785L132.493 281.535C132.369 281.598 119.943 287.878 106.901 278.733V278.729Z"
          fill="#F5DCA4"
        />
        <path
          d="M101.253 265.073L101.624 264.56C107.835 275.155 118.181 273.619 118.282 273.602L118.123 274.215C118.019 274.232 107.538 275.798 101.253 265.073Z"
          fill="#F5DCA4"
        />
        <path
          d="M97.3166 265.033L97.7008 264.527C105.273 275.828 116.775 274.888 116.89 274.878L116.748 275.501C116.63 275.511 104.98 276.471 97.3132 265.033H97.3166Z"
          fill="#F5DCA4"
        />
        <path
          d="M96.8955 268.755L97.2493 268.222C105.378 278.566 116.742 276.534 116.856 276.514L116.748 277.137C116.634 277.16 105.122 279.223 96.8921 268.755H96.8955Z"
          fill="#F5DCA4"
        />
        <path
          d="M86.2495 260.429L86.3135 259.706C98.7254 266.609 108.06 259.113 108.151 259.036L108.357 259.736C108.263 259.813 98.8096 267.415 86.2461 260.429H86.2495Z"
          fill="#F5DCA4"
        />
        <path
          d="M82.3301 262.661L82.411 261.938C96.5887 268.751 107.423 261.182 107.531 261.102L107.76 261.802C107.653 261.878 96.6797 269.558 82.3301 262.661Z"
          fill="#F5DCA4"
        />
        <path
          d="M84.1128 266.593L84.1499 265.86C98.3142 271.407 108.364 262.831 108.465 262.745L108.728 263.424C108.627 263.514 98.4456 272.206 84.1128 266.593Z"
          fill="#F5DCA4"
        />
        <path
          d="M82.8726 243.578L83.0377 242.972C92.5581 250.741 101.684 245.76 101.775 245.707L101.843 246.333C101.752 246.386 92.5075 251.44 82.8726 243.575V243.578Z"
          fill="#F5DCA4"
        />
        <path
          d="M79.1824 244.891L79.3644 244.284C90.4046 252.247 100.821 247.426 100.926 247.376L101.014 248.006C100.909 248.056 90.3575 252.946 79.1824 244.891Z"
          fill="#F5DCA4"
        />
        <path
          d="M80.0957 248.512L80.2406 247.892C91.4662 254.769 101.371 248.975 101.469 248.915L101.586 249.535C101.485 249.595 91.4528 255.472 80.0957 248.512Z"
          fill="#F5DCA4"
        />
        <path
          d="M77.3559 223.635L77.976 223.209C80.6282 237.504 92.8076 239.877 92.9289 239.9L92.5043 240.523C92.3796 240.5 80.0385 238.104 77.3525 223.635H77.3559Z"
          fill="#F5DCA4"
        />
        <path
          d="M72.9782 222.033L73.6118 221.619C77.5008 237.241 90.7316 240.739 90.8631 240.773L90.4519 241.412C90.3171 241.379 76.9111 237.841 72.9749 222.029L72.9782 222.033Z"
          fill="#F5DCA4"
        />
        <path
          d="M71 226.024L71.6133 225.567C76.51 240.34 90.0307 242.565 90.1655 242.585L89.7948 243.241C89.6566 243.221 75.9573 240.973 71 226.024V226.024Z"
          fill="#F5DCA4"
        />
        <path
          d="M163.983 224.385L163.242 224.548C166.285 210.272 155.888 203.479 155.784 203.412L156.417 202.993C156.525 203.059 167.063 209.936 163.983 224.385Z"
          fill="#F5DCA4"
        />
        <path
          d="M167.434 227.523L166.686 227.666C169.092 211.691 158.153 203.459 158.042 203.379L158.668 202.939C158.78 203.022 169.87 211.355 167.434 227.523Z"
          fill="#F5DCA4"
        />
        <path
          d="M170.811 224.558L170.066 224.751C171.208 209.186 159.508 202.03 159.39 201.96L159.986 201.49C160.107 201.56 171.963 208.806 170.807 224.558H170.811Z"
          fill="#F5DCA4"
        />
        <path
          d="M163.114 239.054L162.514 239.074C166.976 228.449 159.922 221.689 159.848 221.623L160.401 221.39C160.475 221.456 167.626 228.303 163.11 239.054H163.114Z"
          fill="#F5DCA4"
        />
        <path
          d="M165.325 241.982H164.721C168.941 229.955 161.678 221.999 161.604 221.923L162.153 221.673C162.227 221.753 169.591 229.809 165.321 241.985L165.325 241.982Z"
          fill="#F5DCA4"
        />
        <path
          d="M168.374 240.173L167.768 240.216C170.946 228.319 162.939 221.09 162.858 221.016L163.39 220.74C163.471 220.813 171.593 228.136 168.374 240.173Z"
          fill="#F5DCA4"
        />
        <path
          d="M155.154 255.162L154.48 255.132C160.451 243.595 153.138 235.379 153.064 235.296L153.708 235.082C153.782 235.166 161.2 243.485 155.154 255.162Z"
          fill="#F5DCA4"
        />
        <path
          d="M157.375 258.647L156.697 258.597C162.524 245.457 155.083 235.879 155.009 235.785L155.649 235.552C155.727 235.649 163.269 245.347 157.375 258.647Z"
          fill="#F5DCA4"
        />
        <path
          d="M160.964 256.881L160.279 256.874C164.927 243.794 156.583 234.962 156.498 234.876L157.122 234.613C157.206 234.703 165.668 243.641 160.964 256.881Z"
          fill="#F5DCA4"
        />
        <path
          d="M145.68 266.746L145.097 266.679C150.982 257.068 145.172 249.515 145.111 249.442L145.68 249.295C145.741 249.372 151.635 257.018 145.68 266.746Z"
          fill="#F5DCA4"
        />
        <path
          d="M147.382 269.894L146.799 269.811C152.656 258.803 146.823 250.068 146.762 249.981L147.332 249.818C147.392 249.905 153.31 258.753 147.379 269.894H147.382Z"
          fill="#F5DCA4"
        />
        <path
          d="M150.597 268.588L150.008 268.542C154.844 257.514 148.178 249.368 148.11 249.288L148.666 249.098C148.734 249.182 155.491 257.427 150.597 268.588Z"
          fill="#F5DCA4"
        />
        <path
          d="M132.945 277.827L132.463 277.477C142.56 271.873 141.238 262.298 141.222 262.202L141.801 262.355C141.815 262.451 143.159 272.153 132.945 277.827Z"
          fill="#F5DCA4"
        />
        <path
          d="M132.857 281.461L132.385 281.098C143.163 274.245 142.425 263.607 142.415 263.501L143.001 263.641C143.011 263.747 143.766 274.525 132.857 281.461Z"
          fill="#F5DCA4"
        />
        <path
          d="M136.369 281.898L135.87 281.565C145.751 274.185 143.975 263.661 143.958 263.554L144.548 263.661C144.568 263.767 146.371 274.432 136.372 281.898H136.369Z"
          fill="#F5DCA4"
        />
        <path
          d="M118.966 290.23L118.359 289.777C131.304 282.831 129.797 270.627 129.78 270.504L130.515 270.71C130.532 270.834 132.065 283.197 118.966 290.23Z"
          fill="#F5DCA4"
        />
        <path
          d="M175.381 220.783C175.192 220.777 175.007 220.77 174.818 220.763C177.002 214.167 176.87 206.964 176.54 200.081C176.729 200.077 176.914 200.071 177.103 200.067C178.447 205.924 177.029 215.189 175.381 220.783Z"
          fill="#F5DCA4"
        />
        <path
          d="M177.433 221.606C177.244 221.596 177.059 221.583 176.87 221.573C178.865 215.806 180.857 205.121 178.788 199.058C178.976 199.051 179.162 199.041 179.35 199.035C181.447 205.158 179.418 215.759 177.433 221.606Z"
          fill="#F5DCA4"
        />
        <path
          d="M179.903 222.132C179.718 222.103 179.533 222.069 179.347 222.039C182.074 215.663 183.877 206.807 180.918 200.114C181.103 200.097 181.285 200.081 181.47 200.067C184.476 206.727 182.704 215.802 179.903 222.132Z"
          fill="#F5DCA4"
        />
        <path
          d="M150.628 190.902C150.452 190.945 150.277 190.992 150.098 191.035C150.318 184.316 148.215 177.649 146.017 171.336C146.189 171.282 146.364 171.226 146.536 171.172C149.394 176.26 150.624 185.258 150.628 190.902Z"
          fill="#F5DCA4"
        />
        <path
          d="M152.761 191.119C152.582 191.159 152.407 191.199 152.228 191.239C152.498 185.338 151.416 174.864 147.824 169.783C147.996 169.727 148.167 169.667 148.339 169.61C151.972 174.744 153 185.149 152.757 191.119H152.761Z"
          fill="#F5DCA4"
        />
        <path
          d="M155.201 190.942C155.019 190.962 154.837 190.982 154.658 191.005C155.443 184.342 154.685 175.62 150.092 170.19C150.26 170.126 150.425 170.06 150.594 169.996C155.221 175.384 156.067 184.299 155.201 190.942Z"
          fill="#F5DCA4"
        />
        <path
          d="M128.001 185.665C127.866 185.795 127.732 185.921 127.593 186.051C124.314 179.885 118.969 174.941 113.726 170.366C113.854 170.23 113.982 170.093 114.106 169.956C119.313 173.095 125.076 180.584 127.998 185.668L128.001 185.665Z"
          fill="#F5DCA4"
        />
        <path
          d="M130.037 184.782C129.898 184.909 129.757 185.032 129.619 185.159C126.812 179.705 120.419 170.816 114.551 168.051C114.676 167.911 114.801 167.771 114.929 167.634C120.857 170.426 127.165 179.282 130.037 184.782Z"
          fill="#F5DCA4"
        />
        <path
          d="M132.146 183.389C131.995 183.499 131.839 183.609 131.688 183.719C128.948 177.316 123.755 169.843 116.809 167.271C116.927 167.128 117.045 166.985 117.163 166.845C124.119 169.36 129.494 176.966 132.15 183.389H132.146Z"
          fill="#F5DCA4"
        />
      </g>
      <path
        d="M179.632 161.724C179.632 161.724 179.869 162.361 180.276 163.549L178.719 160.761L162.832 128.1C163.332 128.75 177.2 146.956 183.983 151.639L179.638 161.73L179.632 161.724Z"
        fill="#F9D074"
      />
      <path
        d="M170.365 269.323C142.95 284.159 76.7459 315.645 70.4875 277.495C70.4875 277.495 67.7428 238.6 69.7998 218.199C70.1061 215.148 69.706 207.858 69.1558 200.512C70.2812 192.309 71.0064 187.108 71.0064 187.108C71.0064 187.108 69.6622 266.166 88.3561 277.501C105.074 287.636 137.204 286.298 170.372 269.329L170.365 269.323Z"
        fill="#573828"
      />
      <path
        d="M132.446 324.604C132.446 324.604 130.858 412.203 110.495 429.878C109.694 429.596 108.863 429.29 108.012 428.952C104.53 427.577 118.291 404.613 120.961 388.488C124.424 367.563 122.824 363.561 121.917 349.431C130.383 332.494 132.446 324.604 132.446 324.604Z"
        fill="#B74E4E"
      />
      <path
        d="M110.981 52.1742C110.981 56.1693 109.725 59.2329 112 59.2329C114.276 59.2329 116.927 56.4007 117.39 52.3555C117.84 48.3917 116.289 45.9846 114.014 45.9846C111.738 45.9846 110.981 48.1854 110.981 52.1805V52.1742Z"
        fill="#C67764"
      />
      <path
        d="M110.982 52.1741C110.982 53.5558 110.832 54.9375 110.738 56.313C110.738 57.2133 110.475 58.57 111.451 59.0077C113.114 59.3953 114.621 57.9886 115.508 56.7069C117.365 54.156 118.447 47.3162 114.552 46.1846C111.226 45.5093 110.976 49.8421 110.982 52.1741ZM110.982 52.1741C111.069 50.1922 110.882 47.7288 112.532 46.2971C113.758 45.4593 115.552 45.8219 116.471 46.9536C118.647 49.817 117.884 54.2248 115.927 57.007C114.902 58.3512 113.158 59.7829 111.351 59.239C110.257 58.7201 110.594 57.2571 110.644 56.3068C110.801 54.9313 110.969 53.5621 110.976 52.1741H110.982Z"
        fill="black"
      />
      <path
        d="M111.302 53.312C111.302 53.312 111.839 56.4255 112.608 54.0247C113.377 51.6239 113.371 48.3665 114.997 49.1606C116.622 49.9546 117.379 52.8431 114.834 54.7812"
        fill="#C67764"
      />
      <path
        d="M111.302 53.312C112.246 57.2946 112.84 52.3617 113.152 51.1488C113.452 49.5983 114.09 47.9477 115.747 49.5482C117.279 51.105 116.56 53.6997 114.834 54.7875C115.841 53.9622 116.541 52.6868 116.341 51.4114C116.253 50.7862 115.991 50.1797 115.547 49.7421C115.141 49.3107 114.428 48.9355 114.078 49.4482C113.24 50.7862 113.271 52.6055 112.69 54.081C112.002 56.038 111.433 54.4437 111.302 53.312V53.312Z"
        fill="black"
      />
      <path
        d="M82.9236 62.3649C82.9236 62.3649 78.2782 49.1167 77.4092 43.5273C76.5401 37.9379 80.6728 34.0553 83.9239 32.6361C84.299 32.4735 83.8864 31.5232 85.1431 30.6479C86.0871 29.9914 88.2629 29.5975 90.6825 29.2787C92.1454 29.0849 94.3337 28.5097 101.167 29.9414C107.026 31.1731 110.846 38.1004 111.027 43.421C111.208 48.7415 113.897 57.6258 113.897 57.6258C112.296 57.6196 107.995 38.9445 103.406 34.9556C100.748 32.6486 87.4814 33.3363 84.2303 36.9688C80.9791 40.6013 84.9868 58.4824 83.605 61.0958C82.2233 63.7091 82.9298 62.3712 82.9298 62.3712L82.9236 62.3649Z"
        fill="black"
      />
      <path
        d="M113.977 81.4465H113.952L112.908 81.459L92.6947 81.7403C80.5343 81.1401 84.123 70.7616 82.6162 63.6592C82.5287 63.2528 82.5412 62.8277 82.4974 62.4213L82.4724 61.0583V61.0458L82.4412 59.1577V59.1452L82.4287 58.1761L82.3161 50.9174L82.1911 42.8396C81.816 39.7636 82.4849 37.1377 85.711 35.7684C85.8611 35.6997 86.0174 35.6434 86.18 35.5871C86.1925 35.5871 86.2112 35.5746 86.2237 35.5746C86.7489 35.3871 87.3303 35.2245 87.9743 35.0995L101.173 34.7744C102.223 34.8431 103.123 35.0807 103.923 35.4621C105.418 36.1811 106.556 37.394 107.556 38.9133C108.563 40.4575 109.444 42.3019 110.426 44.2713L111.445 47.2411L111.595 47.6787L113.089 52.0552L113.889 54.3873L115.021 57.6822L115.215 58.2574L115.521 59.6203L118.822 74.3628C120.304 78.3892 117.472 81.0901 113.971 81.4402L113.977 81.4465Z"
        fill="#C67764"
      />
      <path
        d="M102.053 75.6162C99.9406 76.3932 97.8073 76.1567 96.379 74.2894C97.2158 76.6796 100.233 77.1116 102.053 75.6162Z"
        fill="black"
      />
      <path
        d="M104.376 71.8633C104.226 72.707 103.649 73.4415 102.766 73.9157C101.883 74.3899 100.76 74.5675 99.6286 74.412C98.4973 74.2565 97.4437 73.7797 96.685 73.0798C95.9263 72.3799 95.5201 71.5103 95.5503 70.6501L99.9819 71.0794L104.376 71.8633Z"
        fill="#F0F2F4"
      />
      <path
        d="M84.8047 35.2245C84.8047 35.2245 100.441 45.3967 108.663 38.0755C103.067 35.1244 98.5594 29.2349 84.8047 35.2245Z"
        fill="black"
      />
      <path
        d="M98.5732 65.8349C98.9421 66.9228 101.168 67.1791 102.937 66.6477C104.707 66.1162 106.238 64.7408 105.869 63.6467C105.501 62.5525 104.95 61.846 103.181 62.3712C101.412 62.8964 98.2043 64.7408 98.5732 65.8286V65.8349Z"
        fill="#AD5441"
      />
      <path
        d="M99.9784 50.9488C101.841 54.3312 103.505 57.8011 105.174 61.2773L105.774 62.5903C107.25 65.6413 103.936 66.998 101.454 67.2856C100.479 67.3606 99.4157 67.1356 98.7217 66.4416C100.36 67.617 102.46 66.8917 104.074 66.0539C104.911 65.6726 105.53 65.0098 105.568 64.0845C105.593 63.6281 105.468 63.2592 105.249 62.8403C103.386 58.9265 101.585 54.9752 99.9784 50.9488V50.9488Z"
        fill="black"
      />
      <path
        d="M83.7795 56.6129C83.7795 60.608 85.0362 63.6715 82.7604 63.6715C80.4847 63.6715 77.8338 60.8393 77.3711 56.7942C76.9209 52.8303 78.4715 50.4233 80.7472 50.4233C83.023 50.4233 83.7795 52.624 83.7795 56.6191V56.6129Z"
        fill="#C67764"
      />
      <path
        d="M83.7794 56.6128C83.7794 57.9945 83.9544 59.37 84.1108 60.7454C84.1608 61.702 84.4984 63.1525 83.4043 63.6777C81.5974 64.2279 79.8531 62.7899 78.8277 61.4519C76.877 58.6697 76.1143 54.262 78.2838 51.3985C79.2028 50.2669 80.9972 49.9043 82.2226 50.742C83.8794 52.1675 83.6856 54.6371 83.7731 56.619L83.7794 56.6128ZM83.7794 56.6128C83.7856 54.2807 83.5356 49.948 80.2094 50.6233C76.3143 51.7549 77.396 58.5885 79.2529 61.1456C80.1469 62.4335 81.6537 63.834 83.3105 63.4464C84.2858 63.0087 84.0232 61.6458 84.0232 60.7517C83.9232 59.3762 83.7731 57.9945 83.7794 56.6128Z"
        fill="black"
      />
      <path
        d="M83.4559 57.7507C83.4559 57.7507 82.9182 60.8643 82.1492 58.4634C81.3802 56.0626 81.3864 52.8053 79.7609 53.5993C78.1416 54.3933 77.3788 57.2818 79.9235 59.2199"
        fill="#C67764"
      />
      <path
        d="M83.4559 57.7508C83.3246 58.8699 82.7556 60.483 82.0679 58.5198C81.4864 57.0443 81.5115 55.2249 80.6799 53.887C80.3298 53.3743 79.6233 53.7494 79.2107 54.1808C78.7668 54.6185 78.5042 55.2249 78.4166 55.8502C78.2166 57.1256 78.9231 58.401 79.9234 59.2263C78.1978 58.1447 77.4788 55.5501 79.0106 53.987C80.6737 52.3865 81.3051 54.037 81.6052 55.5876C81.9178 56.8005 82.5118 61.7272 83.4559 57.7508V57.7508Z"
        fill="black"
      />
      <path
        d="M89 51.154L91.7009 55.9056L94.0705 55.8056L95.5147 50.7601C93.2765 49.7285 91.0945 49.641 89 51.1603V51.154Z"
        fill="#AD5441"
      />
      <path
        d="M102.793 49.7794L103.425 53.9933L107.17 53.5181L107.926 50.1545C106.551 48.9228 104.875 48.679 102.793 49.7731V49.7794Z"
        fill="#AD5441"
      />
      <path
        d="M100.947 44.1775C103.742 43.346 107.081 43.7274 109.4 45.5843C106.768 44.3088 103.836 43.9837 100.947 44.1775Z"
        fill="black"
      />
      <path
        d="M85.543 45.8468C87.9876 44.2525 91.3012 43.6835 94.0521 44.8027C91.1699 44.3275 88.2626 44.8402 85.543 45.8468V45.8468Z"
        fill="black"
      />
      <path
        d="M92.8014 55.5624C93.2814 55.5624 93.6705 54.8682 93.6705 54.0119C93.6705 53.1556 93.2814 52.4614 92.8014 52.4614C92.3215 52.4614 91.9324 53.1556 91.9324 54.0119C91.9324 54.8682 92.3215 55.5624 92.8014 55.5624Z"
        fill="black"
      />
      <path
        d="M91.1326 53.4493C91.1326 53.4493 91.8578 52.1801 94.2836 52.4615"
        stroke="black"
        strokeWidth="0.175368"
        strokeMiterlimit="10"
      />
      <path
        d="M91.7131 55.5189C91.7131 55.5189 92.2571 55.9003 93.7013 55.4564"
        stroke="black"
        strokeWidth="0.175368"
        strokeMiterlimit="10"
      />
      <path
        d="M105.991 52.0859C106.057 51.2321 105.723 50.5099 105.244 50.4727C104.766 50.4356 104.324 51.0976 104.258 51.9513C104.191 52.8051 104.526 53.5273 105.004 53.5645C105.483 53.6016 105.924 52.9396 105.991 52.0859Z"
        fill="black"
      />
      <path
        d="M106.857 50.5859C106.857 50.5859 105.6 49.8669 103.643 51.3611"
        stroke="black"
        strokeWidth="0.175368"
        strokeMiterlimit="10"
      />
      <path
        d="M103.987 53.3806C103.987 53.3806 104.537 53.7557 105.975 53.2993"
        stroke="black"
        strokeWidth="0.175368"
        strokeMiterlimit="10"
      />
      <path
        d="M85.7373 46.7159C85.7373 46.7159 89.0822 43.9525 93.2211 45.9407C93.2211 45.9407 94.7716 47.7288 93.5087 48.0101C92.2458 48.2915 89.0884 48.3227 88.2131 48.9292C87.3378 49.5356 83.8429 48.379 85.7373 46.7222V46.7159Z"
        fill="black"
      />
      <path
        d="M102.086 44.9341C102.086 44.9341 106.15 42.9209 109.463 46.3971C109.463 46.3971 110.376 48.8542 109.088 48.7667C107.794 48.6792 104.774 47.7413 103.749 48.1415C102.73 48.5416 99.7539 46.1783 102.086 44.9341V44.9341Z"
        fill="black"
      />
      <path
        d="M102.281 39.0229C94.7811 39.0229 87.2811 35.0229 87.2811 35.0229L89.7262 34.862C89.7262 34.862 98.0961 37.9693 102.281 39.0229Z"
        fill="#999999"
      />
      <path
        d="M105.781 35.0229C101.781 37.0229 90.9782 35.6215 87.281 35.0229L87.281 34.8621C87.596 34.1954 88.4261 32.9621 89.2261 33.3621C90.0261 33.7621 100.596 34.6359 105.781 35.0229Z"
        fill="#999999"
      />
      <path
        d="M67.061 431.741C67.061 431.741 77.6897 435.823 82.4975 432.391C87.3054 428.959 130.883 329.262 130.883 329.262"
        stroke="#B74E4E"
        strokeWidth="0.347157"
        strokeMiterlimit="10"
      />
      <path
        d="M81.2963 94.1382C81.2963 94.1382 63.4215 102.51 58.8887 102.998C54.3559 103.485 42.3831 152.965 42.3831 152.965"
        stroke="black"
        strokeWidth="0.347157"
        strokeMiterlimit="10"
      />
      <path
        d="M159.048 123.548C163.681 128.769 191.147 172.021 190.265 214.892"
        stroke="#602F2F"
        strokeWidth="0.347157"
        strokeMiterlimit="10"
      />
      <path
        d="M85.1607 86.1668C88.5994 90.0994 97.2773 91.3373 102.317 92.0313L102.56 92.0626L102.598 92.3127L103.892 100.403L103.667 100.072L109.225 103.279C112.114 105.617 114.258 108.512 116.378 111.488C119.435 115.933 121.954 120.697 124.224 125.574C142.518 166.851 145.431 222.738 144.618 267.616C143.318 220.9 140.655 164.012 120.548 121.404C117.472 115.245 113.677 108.681 108.687 104.173L103.192 100.859L102.998 100.741L102.973 100.528L101.929 92.4065L102.217 92.6878C97.0898 91.8 88.5118 90.337 85.1482 86.1606L85.1607 86.1668Z"
        fill="#602F2F"
      />
      <path
        d="M63.9973 217.106C67.3984 213.992 70.512 210.572 73.3067 206.883C81.9847 195.43 97.64 162.131 106.455 150.052C111.326 143.381 116.496 138.122 120.923 132.464C122.267 130.745 125.656 126.694 123.649 123.568C123.393 123.167 124.574 122.605 124.618 121.192C124.693 118.603 123.668 119.341 122.924 117.103C121.723 113.495 120.473 109.119 120.623 106.687C120.917 101.804 127.857 95.1453 123.849 95.1078C111.77 94.9953 114.364 107.118 114.364 107.118C109.038 112.895 107.431 115.652 102.404 116.346C102.404 116.346 103.342 103.811 94.2451 101.766C90.1187 100.841 96.5459 116.084 88.8495 127.363C80.5904 139.473 51.1366 165.663 46.2162 172.09C45.1784 173.447 44.6282 183.538 43.4403 184.77C35.8252 206.421 44.4844 220.263 64.0035 217.106H63.9973Z"
        fill="#C67764"
      />
      <path
        d="M85.2612 132.145C85.2612 132.145 89.075 129.632 91.4321 122.067C93.8579 114.295 92.2261 102.504 93.5078 101.797C94.7895 101.091 103.292 104.192 102.392 116.334C102.392 116.334 106.506 118.115 114.352 107.105C114.352 107.105 112.821 96.0392 122.43 95.0951C122.43 95.0951 126.963 94.3573 123.781 99.1777C120.598 103.998 119.492 107.137 122.449 115.233C122.449 115.233 123.23 117.384 121.517 119.097C119.804 120.81 119.46 121.442 119.46 121.442"
        stroke="black"
        strokeWidth="0.347157"
        strokeMiterlimit="10"
      />
      <path
        d="M106.456 150.051C105.224 149.776 103.111 148.494 100.635 146.738C100.335 143.393 97.5281 140.773 94.1019 140.773C93.7456 140.773 93.3955 140.811 93.0516 140.867C87.681 136.465 82.8794 132.151 82.8794 132.151L79.0593 136.959C79.0593 139.648 82.9607 143.186 87.606 146.45C87.5685 146.744 87.5372 147.038 87.5372 147.344C87.5372 150.97 90.4757 153.909 94.1019 153.909C95.4774 153.909 96.7529 153.484 97.8095 152.758C100.773 154.409 102.88 155.459 102.88 155.459L106.456 150.058V150.051Z"
        fill="#573828"
      />
      <path
        d="M94.1021 151.627C96.4743 151.627 98.3973 149.704 98.3973 147.332C98.3973 144.959 96.4743 143.036 94.1021 143.036C91.7299 143.036 89.8069 144.959 89.8069 147.332C89.8069 149.704 91.7299 151.627 94.1021 151.627Z"
        fill="#AA6039"
      />
      <path
        d="M43.9358 212.697C43.9358 212.697 56.5151 220.438 63.9989 217.099C71.4827 213.76 99.2046 161.668 99.2046 161.668C99.2046 161.668 108.852 145.962 114.329 140.767C119.805 135.571 124.463 127.994 124.363 126.293C124.263 124.592 123.65 123.561 123.65 123.561C123.65 123.561 125.213 120.885 124.363 119.672C123.513 118.459 123.006 117.384 123.006 117.384"
        stroke="#573828"
        strokeWidth="0.347157"
        strokeMiterlimit="10"
      />
      <path
        d="M113.977 81.4465H113.952C113.896 81.4465 113.846 81.4465 113.79 81.4465L105.856 81.5591C114.008 78.9332 115.009 77.9391 115.678 76.5699C116.934 73.994 117.597 74.2628 117.053 71.4494C116.466 68.4046 115.284 60.4081 115.059 58.2699L115.528 59.6391L118.829 74.3816C120.311 78.408 117.478 81.1089 113.977 81.459V81.4465Z"
        fill="#E0996B"
      />
      <path
        d="M82.7551 63.6654C83.2365 67.3292 83.8117 71.0054 84.8433 74.5441C85.3622 76.2197 85.9874 77.989 87.0878 79.3395C87.5442 79.8772 88.0756 80.3086 88.7509 80.4836C89.6574 80.6774 90.8453 80.8713 91.7769 80.9838C99.1169 81.7653 106.588 81.5527 113.984 81.4465C106.576 82.3343 99.1106 82.8344 91.6456 82.1467C90.664 82.0342 89.4386 81.8466 88.482 81.6528C87.5567 81.4465 86.7439 80.8212 86.175 80.1085C84.9058 78.508 84.3118 76.6511 83.8304 74.8255C82.9301 71.1492 82.6675 67.3917 82.7613 63.6654H82.7551Z"
        fill="black"
      />
      <path
        d="M133.671 135.828C135.014 135.828 136.103 134.739 136.103 133.395C136.103 132.052 135.014 130.963 133.671 130.963C132.328 130.963 131.239 132.052 131.239 133.395C131.239 134.739 132.328 135.828 133.671 135.828Z"
        fill="#F9D074"
      />
      <path
        d="M145.569 168.407C146.912 168.407 148.001 167.318 148.001 165.975C148.001 164.632 146.912 163.543 145.569 163.543C144.226 163.543 143.137 164.632 143.137 165.975C143.137 167.318 144.226 168.407 145.569 168.407Z"
        fill="#F9D074"
      />
      <path
        d="M150.184 204.013C151.527 204.013 152.616 202.924 152.616 201.581C152.616 200.238 151.527 199.149 150.184 199.149C148.84 199.149 147.751 200.238 147.751 201.581C147.751 202.924 148.84 204.013 150.184 204.013Z"
        fill="#F9D074"
      />
      <path
        d="M152.616 244.977C153.959 244.977 155.048 243.888 155.048 242.545C155.048 241.202 153.959 240.113 152.616 240.113C151.273 240.113 150.184 241.202 150.184 242.545C150.184 243.888 151.273 244.977 152.616 244.977Z"
        fill="#F9D074"
      />
      <defs>
        <clipPath id="clip0_1586_23305">
          <rect
            width="123"
            height="140"
            fill="white"
            transform="translate(71 163)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  attendance: (
    <svg
      width="62"
      height="49"
      viewBox="0 0 62 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.13672 9.30139C1.13672 6.53997 3.37529 4.30139 6.13672 4.30139H40.1555C42.9169 4.30139 45.1555 6.53997 45.1555 9.30139V15.3061H1.13672V9.30139Z"
        fill="#DC343B"
      />
      <path
        d="M44.5144 22.4589V8.42785C44.5144 6.0474 42.5846 4.11768 40.2042 4.11768H5.31017C2.92973 4.11768 1 6.0474 1 8.42785V38.599C1 40.9795 2.92973 42.9092 5.31017 42.9092H18.1948"
        stroke="#375A8D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.6445 1V7.60281"
        stroke="#375A8D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.84082 1V7.60281"
        stroke="#375A8D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.5488 1V7.60281"
        stroke="#375A8D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.4531 1V7.60281"
        stroke="#375A8D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.1377 15.3062H44.056"
        stroke="#375A8D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="6.64062"
        y="19.7079"
        width="3.30141"
        height="3.30141"
        fill="#D3DCEB"
      />
      <rect
        x="6.64062"
        y="26.3107"
        width="3.30141"
        height="3.30141"
        fill="#DC343B"
      />
      <rect
        x="6.50293"
        y="32.9136"
        width="3.30141"
        height="3.30141"
        fill="#DC343B"
      />
      <rect
        x="12.1426"
        y="19.7079"
        width="3.30141"
        height="3.30141"
        fill="#DC343B"
      />
      <rect
        x="12.1426"
        y="26.3108"
        width="3.30141"
        height="3.30141"
        fill="#D3DCEB"
      />
      <rect
        x="12.0049"
        y="32.9136"
        width="3.30141"
        height="3.30141"
        fill="#DC343B"
      />
      <rect
        x="18.6084"
        y="19.7079"
        width="3.30141"
        height="3.30141"
        fill="#DC343B"
      />
      <rect
        x="18.6084"
        y="26.3108"
        width="3.30141"
        height="3.30141"
        fill="#DC343B"
      />
      <rect
        x="17.5078"
        y="32.9136"
        width="3.30141"
        height="3.30141"
        fill="#DC343B"
      />
      <rect
        x="24.1104"
        y="19.7079"
        width="3.30141"
        height="3.30141"
        fill="#DC343B"
      />
      <rect
        x="29.6123"
        y="19.7079"
        width="3.30141"
        height="3.30141"
        fill="#DC343B"
      />
      <path
        d="M25.3467 43.9183V29.5117C25.3467 28.9594 25.7944 28.5117 26.3467 28.5117H55.0593"
        stroke="#375A8D"
        strokeWidth="1.5"
      />
      <path
        d="M27.3597 29.6122H57.4474C57.9516 29.6122 58.3604 30.0424 58.3604 30.573V46.2588C58.3604 46.7895 57.9516 47.2197 57.4474 47.2197H27.3597C26.8555 47.2197 26.4468 46.7895 26.4468 46.2588V30.573C26.4468 30.0424 26.8555 29.6122 27.3597 29.6122Z"
        fill="#D3DCEB"
      />
      <g clipPath="url(#clip0_1284_24596)">
        <path
          d="M30.2577 32.2904H59.9203C60.4174 32.2904 60.8203 32.6791 60.8203 33.1585V47.3298C60.8203 47.8092 60.4174 48.1978 59.9203 48.1978H52.5046H45.089H30.2577C29.7606 48.1978 29.3576 47.8092 29.3576 47.3298V33.1585C29.3576 32.6791 29.7606 32.2904 30.2577 32.2904Z"
          fill="white"
          stroke="#375A8D"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
        <path
          d="M32.3042 42.3315V38.1566C33.9585 38.1566 35.2974 36.8271 35.2974 35.175H54.8807C54.8807 36.8221 56.2273 38.1566 57.874 38.1566V42.3315C56.2216 42.3315 54.8807 43.6611 54.8807 45.3131H35.2974C35.2974 43.6677 33.9585 42.3315 32.3042 42.3315Z"
          stroke="#375A8D"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M45.089 42.5483C43.7814 42.5483 42.7214 41.5167 42.7214 40.2442C42.7214 38.9716 43.7814 37.9401 45.089 37.9401C46.3965 37.9401 47.4565 38.9716 47.4565 40.2442C47.4565 41.5167 46.3965 42.5483 45.089 42.5483Z"
          fill="#375A8D"
        />
      </g>
      <defs>
        <clipPath id="clip0_1284_24596">
          <rect
            width="33.1461"
            height="17.5112"
            fill="white"
            transform="matrix(-1 0 0 1 61.6621 31.4885)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  backup: (
    <svg
      width="56"
      height="49"
      viewBox="0 0 56 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.2146 13.524C19.514 14.5197 19.0632 15.6524 18.8964 16.8364C16.7523 16.3297 14.1904 17.0873 12.5303 18.5992C10.9643 20.0253 10.659 21.7273 11.3471 23.8053H16.4681H36.3381H36.9565C42.1002 24.2144 43.0936 21.1252 42.4768 19.2108C42.1421 18.1718 41.4613 17.2618 40.5351 16.6151C39.6088 15.9684 38.4862 15.6193 37.333 15.6194H35.1952C34.8322 14.4749 34.1974 13.4233 33.3388 12.544C32.4803 11.6647 31.4204 10.981 30.2396 10.5445C29.0587 10.108 27.7879 9.93021 26.5232 10.0246C25.2586 10.1191 24.0334 10.4832 22.9404 11.0895C21.8474 11.6958 20.9153 12.5283 20.2146 13.524Z"
        fill="#D3DCEB"
      />
      <path
        d="M18.6765 23.7407H12.832C8.72075 23.0324 7.10487 20.3604 7 17.6316C7.12629 10.9652 13.3282 10.7926 13.3282 10.7926C12.8817 4.38269 18.6765 1.81849 18.6765 1.81849C27.464 -1.38704 30.8389 5.85719 30.8389 5.85719C33.6411 4.25783 36.698 4.24534 38.3534 5.27942C41.8997 7.49287 40.7721 11.1127 40.7721 11.1127C46.6944 10.9209 47.4589 16.1764 47.4589 16.1764C48.2178 21.8814 43.2563 23.7407 43.2563 23.7407H36.1675"
        stroke="#375A8D"
        strokeWidth="1.60174"
        strokeMiterlimit="10"
      />
      <rect
        x="19.7461"
        y="28.5457"
        width="18.7407"
        height="20.3704"
        rx="0.88"
        fill="#D3DCEB"
      />
      <mask id="path-4-inside-1_1284_24625" fill="white">
        <rect x="18.0703" y="26" width="18.7407" height="20.3704" rx="0.88" />
      </mask>
      <rect
        x="18.0703"
        y="26"
        width="18.7407"
        height="20.3704"
        rx="0.88"
        fill="white"
        stroke="#375A8D"
        strokeWidth="2.64"
        mask="url(#path-4-inside-1_1284_24625)"
      />
      <rect
        x="21.3281"
        y="38.2219"
        width="12.2222"
        height="1.62963"
        fill="#D3DCEB"
      />
      <rect
        x="22.9609"
        y="34.9626"
        width="8.96296"
        height="1.62963"
        fill="#DC343B"
      />
      <rect
        x="20.5137"
        y="41.4814"
        width="13.8519"
        height="1.62963"
        fill="#D3DCEB"
      />
      <rect
        x="1.26367"
        y="30.735"
        width="14.137"
        height="15.3663"
        rx="0.88"
        fill="#D3DCEB"
      />
      <mask id="path-9-inside-2_1284_24625" fill="white">
        <rect y="28.8147" width="14.137" height="15.3663" rx="0.88" />
      </mask>
      <rect
        y="28.8147"
        width="14.137"
        height="15.3663"
        rx="0.88"
        fill="white"
        stroke="#375A8D"
        strokeWidth="2.64"
        mask="url(#path-9-inside-2_1284_24625)"
      />
      <rect x="2.73633" y="36.8147" width="8" height="1" fill="#D3DCEB" />
      <rect x="2.73633" y="34.8147" width="8" height="1" fill="#DC343B" />
      <rect x="2.73633" y="38.8147" width="8" height="1" fill="#D3DCEB" />
      <rect
        width="14.137"
        height="15.3663"
        rx="0.88"
        transform="matrix(-1 0 0 1 53.873 30.735)"
        fill="#D3DCEB"
      />
      <mask id="path-14-inside-3_1284_24625" fill="white">
        <rect
          width="14.137"
          height="15.3663"
          rx="0.88"
          transform="matrix(-1 0 0 1 55.1367 28.8147)"
        />
      </mask>
      <rect
        width="14.137"
        height="15.3663"
        rx="0.88"
        transform="matrix(-1 0 0 1 55.1367 28.8147)"
        fill="white"
        stroke="#375A8D"
        strokeWidth="2.64"
        mask="url(#path-14-inside-3_1284_24625)"
      />
      <rect
        width="8"
        height="1"
        transform="matrix(-1 0 0 1 52.4004 36.8147)"
        fill="#D3DCEB"
      />
      <rect
        width="8"
        height="1"
        transform="matrix(-1 0 0 1 52.4004 34.8147)"
        fill="#DC343B"
      />
      <rect
        width="8"
        height="1"
        transform="matrix(-1 0 0 1 52.4004 38.8147)"
        fill="#D3DCEB"
      />
      <rect
        x="25.668"
        y="21.2964"
        width="3.25926"
        height="11.4074"
        rx="0.667097"
        fill="#DC343B"
      />
      <path
        d="M31.6388 23.7406H23.6566C23.1238 23.7406 22.806 23.1467 23.1016 22.7034L26.7856 17.1773C27.0382 16.7985 27.5877 16.7784 27.8673 17.1378L32.1654 22.6639C32.5062 23.1021 32.1939 23.7406 31.6388 23.7406Z"
        fill="#DC343B"
      />
      <line x1="14" y1="37.5" x2="19" y2="37.5" stroke="#375A8D" />
      <line x1="37" y1="37.5" x2="42" y2="37.5" stroke="#375A8D" />
    </svg>
  ),
  businessReports: (
    <svg
      width="50"
      height="53"
      viewBox="0 0 50 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="5" y="9" width="27" height="32" rx="2" fill="#D3DCEB" />
      <rect x="10" y="8" width="31" height="37" rx="3" fill="white" />
      <path
        d="M5 38H3C1.89543 38 1 37.1046 1 36V3C1 1.89543 1.89543 1 3 1H30C31.1046 1 32 1.89543 32 3V6.55"
        stroke="#375A8D"
        strokeWidth="1.5"
      />
      <path
        d="M23 45H12C10.8954 45 10 44.1046 10 43V10C10 8.89543 10.8954 8 12 8H39C40.1046 8 41 8.89543 41 10V26.5"
        stroke="#375A8D"
        strokeWidth="1.5"
      />
      <circle cx="37" cy="40" r="10.25" fill="white" />
      <circle cx="37" cy="40" r="10.25" fill="white" />
      <circle cx="37" cy="40" r="10.25" stroke="#375A8D" strokeWidth="1.5" />
      <path
        d="M46 40C46 41.1819 45.7672 42.3522 45.3149 43.4442C44.8626 44.5361 44.1997 45.5282 43.364 46.364C42.5282 47.1997 41.5361 47.8626 40.4442 48.3149C39.3522 48.7672 38.1819 49 37 49V40H46Z"
        fill="#DC343B"
      />
      <path
        d="M42.206 32.6586C43.3976 33.5037 44.3656 34.6262 45.0264 35.9292C45.6871 37.2321 46.0208 38.6763 45.9985 40.137L36.9996 39.9998L42.206 32.6586Z"
        fill="#D3DCEB"
      />
      <rect x="15" y="19" width="3" height="8" fill="#DC343B" />
      <rect x="20" y="17" width="3" height="10" fill="#DC343B" />
      <rect
        x="25"
        y="31"
        width="2"
        height="10"
        transform="rotate(90 25 31)"
        fill="#D3DCEB"
      />
      <rect
        x="25"
        y="35"
        width="2"
        height="10"
        transform="rotate(90 25 35)"
        fill="#D3DCEB"
      />
      <rect
        x="25"
        y="39"
        width="2"
        height="10"
        transform="rotate(90 25 39)"
        fill="#D3DCEB"
      />
      <rect x="25" y="14" width="3" height="13" fill="#DC343B" />
    </svg>
  ),
  retailers: (
    <svg
      width="92"
      height="86"
      viewBox="0 0 92 86"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="16.2507"
        y="19.25"
        width="58.5"
        height="52.5"
        rx="4.75"
        stroke="#375A8D"
        strokeWidth="1.5"
      />
      <rect x="17.0007" y="19" width="57" height="52" rx="4" fill="white" />
      <path
        d="M46.6103 37.3392H43.7868C42.9879 37.3392 42.2218 37.0174 41.6569 36.4446C41.092 35.8718 40.7747 35.0949 40.7747 34.2849V15.8718H49.6225V34.2849C49.6225 34.686 49.5446 35.0832 49.3932 35.4537C49.2418 35.8243 49.0199 36.161 48.7402 36.4446C48.4605 36.7282 48.1285 36.9532 47.763 37.1067C47.3976 37.2602 47.0059 37.3392 46.6103 37.3392V37.3392Z"
        fill="#D3DCEB"
      />
      <path
        d="M64.3074 37.3392H61.4758C60.677 37.3387 59.9111 37.0168 59.3464 36.4441C58.7816 35.8714 58.4641 35.0948 58.4636 34.2849V15.8718H67.3131V34.2849C67.3127 35.0937 66.996 35.8693 66.4327 36.4418C65.8693 37.0143 65.105 37.337 64.3074 37.3392V37.3392Z"
        fill="#D3DCEB"
      />
      <mask id="path-5-inside-1_1284_24733" fill="white">
        <path d="M49.6244 17.643V15.8718H58.4723V34.2849C58.4723 35.0949 58.1549 35.8718 57.59 36.4446C57.0251 37.0174 56.259 37.3392 55.4601 37.3392H52.635C51.8361 37.3392 51.0699 37.0174 50.5051 36.4446C49.9402 35.8718 49.6228 35.0949 49.6228 34.2849V22.7406" />
      </mask>
      <path
        d="M49.6244 17.643V15.8718H58.4723V34.2849C58.4723 35.0949 58.1549 35.8718 57.59 36.4446C57.0251 37.0174 56.259 37.3392 55.4601 37.3392H52.635C51.8361 37.3392 51.0699 37.0174 50.5051 36.4446C49.9402 35.8718 49.6228 35.0949 49.6228 34.2849V22.7406"
        fill="white"
      />
      <path
        d="M49.6244 15.8718V14.3718H48.1244V15.8718H49.6244ZM58.4723 15.8718H59.9723V14.3718H58.4723V15.8718ZM55.4601 37.3392L55.4601 38.8392L55.4601 37.3392ZM52.635 37.3392V38.8392V37.3392ZM51.1244 17.643V15.8718H48.1244V17.643H51.1244ZM49.6244 17.3718H58.4723V14.3718H49.6244V17.3718ZM56.9723 15.8718V34.2849H59.9723V15.8718H56.9723ZM56.9723 34.2849C56.9723 34.7038 56.808 35.1014 56.522 35.3913L58.658 37.4979C59.5018 36.6422 59.9723 35.4861 59.9723 34.2849H56.9723ZM56.522 35.3913C56.2368 35.6806 55.8544 35.8392 55.4601 35.8392L55.4601 38.8392C56.6636 38.8392 57.8135 38.3542 58.658 37.4979L56.522 35.3913ZM55.4601 35.8392H52.635V38.8392H55.4601V35.8392ZM52.635 35.8392C52.2407 35.8392 51.8583 35.6806 51.5731 35.3913L49.4371 37.4979C50.2816 38.3542 51.4315 38.8392 52.635 38.8392L52.635 35.8392ZM51.5731 35.3913C51.2871 35.1014 51.1228 34.7038 51.1228 34.2849H48.1228C48.1228 35.4861 48.5932 36.6422 49.4371 37.4979L51.5731 35.3913ZM51.1228 34.2849V22.7406H48.1228V34.2849H51.1228Z"
        fill="#375A8D"
        mask="url(#path-5-inside-1_1284_24733)"
      />
      <mask id="path-7-inside-2_1284_24733" fill="white">
        <path d="M31.9265 17.643V15.8718H40.7743V34.2849C40.7743 35.0949 40.457 35.8718 39.8921 36.4446C39.3272 37.0174 38.561 37.3392 37.7622 37.3392H34.9387C34.1398 37.3392 33.3737 37.0174 32.8088 36.4446C32.2439 35.8718 31.9265 35.0949 31.9265 34.2849V23.0276" />
      </mask>
      <path
        d="M31.9265 17.643V15.8718H40.7743V34.2849C40.7743 35.0949 40.457 35.8718 39.8921 36.4446C39.3272 37.0174 38.561 37.3392 37.7622 37.3392H34.9387C34.1398 37.3392 33.3737 37.0174 32.8088 36.4446C32.2439 35.8718 31.9265 35.0949 31.9265 34.2849V23.0276"
        fill="white"
      />
      <path
        d="M31.9265 15.8718V14.3718H30.4265V15.8718H31.9265ZM40.7743 15.8718H42.2743V14.3718H40.7743V15.8718ZM37.7622 37.3392L37.7622 38.8392L37.7622 37.3392ZM34.9387 37.3392V38.8392V37.3392ZM33.4265 17.643V15.8718H30.4265V17.643H33.4265ZM31.9265 17.3718H40.7743V14.3718H31.9265V17.3718ZM39.2743 15.8718V34.2849H42.2743V15.8718H39.2743ZM39.2743 34.2849C39.2743 34.7038 39.11 35.1014 38.8241 35.3913L40.9601 37.4979C41.804 36.6422 42.2743 35.4861 42.2743 34.2849H39.2743ZM38.8241 35.3913C38.5389 35.6805 38.1565 35.8392 37.7622 35.8392L37.7622 38.8392C38.9656 38.8392 40.1156 38.3542 40.9601 37.4979L38.8241 35.3913ZM37.7622 35.8392H34.9387V38.8392H37.7622V35.8392ZM34.9387 35.8392C34.5444 35.8392 34.162 35.6806 33.8768 35.3913L31.7408 37.4979C32.5853 38.3542 33.7352 38.8392 34.9387 38.8392L34.9387 35.8392ZM33.8768 35.3913C33.5908 35.1014 33.4265 34.7038 33.4265 34.2849H30.4265C30.4265 35.4861 30.8969 36.6422 31.7408 37.4979L33.8768 35.3913ZM33.4265 34.2849V23.0276H30.4265V34.2849H33.4265Z"
        fill="#375A8D"
        mask="url(#path-7-inside-2_1284_24733)"
      />
      <path
        d="M29.0234 37.3392H26.1999C25.401 37.3392 24.6349 37.0174 24.07 36.4446C23.5051 35.8718 23.1877 35.0949 23.1877 34.2849V15.8718H32.0356V34.2849C32.0356 35.0949 31.7182 35.8718 31.1533 36.4446C30.5884 37.0174 29.8223 37.3392 29.0234 37.3392V37.3392Z"
        fill="#D3DCEB"
      />
      <mask id="path-10-inside-3_1284_24733" fill="white">
        <path d="M15.3616 18.245L15.9244 15.8718H23.0807V34.2849C23.0807 35.0949 22.7634 35.8718 22.1985 36.4446C21.6336 37.0174 20.8674 37.3392 20.0685 37.3392H17.2353C15.5731 37.3392 11.5867 35.69 11.5867 34.0078L14.2231 23.0276" />
      </mask>
      <path
        d="M15.3616 18.245L15.9244 15.8718H23.0807V34.2849C23.0807 35.0949 22.7634 35.8718 22.1985 36.4446C21.6336 37.0174 20.8674 37.3392 20.0685 37.3392H17.2353C15.5731 37.3392 11.5867 35.69 11.5867 34.0078L14.2231 23.0276"
        fill="white"
      />
      <path
        d="M15.9244 15.8718V14.3718H14.7385L14.4648 15.5257L15.9244 15.8718ZM23.0807 15.8718H24.5807V14.3718H23.0807V15.8718ZM23.0807 34.2849H24.5807H23.0807ZM20.0685 37.3392L20.0685 38.8392L20.0685 37.3392ZM11.5867 34.0078L10.1281 33.6576L10.0867 33.8303V34.0078H11.5867ZM16.8212 18.5911L17.3839 16.2179L14.4648 15.5257L13.9021 17.8989L16.8212 18.5911ZM15.9244 17.3718H23.0807V14.3718H15.9244V17.3718ZM21.5807 15.8718V34.2849H24.5807V15.8718H21.5807ZM21.5807 34.2849C21.5807 34.7038 21.4164 35.1014 21.1305 35.3913L23.2665 37.4979C24.1103 36.6422 24.5807 35.4861 24.5807 34.2849L21.5807 34.2849ZM21.1305 35.3913C20.8452 35.6806 20.4628 35.8392 20.0685 35.8392L20.0685 38.8392C21.272 38.8392 22.4219 38.3542 23.2665 37.4979L21.1305 35.3913ZM20.0685 35.8392H17.2353V38.8392H20.0685V35.8392ZM17.2353 35.8392C16.7376 35.8392 15.5706 35.5374 14.4764 34.9718C13.9506 34.7 13.5406 34.4164 13.2847 34.166C12.9988 33.8862 13.0867 33.833 13.0867 34.0078H10.0867C10.0867 35.0237 10.6728 35.8075 11.1864 36.3101C11.7298 36.8419 12.4203 37.2861 13.0989 37.6368C14.4134 38.3163 16.0708 38.8392 17.2353 38.8392V35.8392ZM13.0452 34.358L15.6817 23.3778L12.7646 22.6774L10.1281 33.6576L13.0452 34.358Z"
        fill="#375A8D"
        mask="url(#path-10-inside-3_1284_24733)"
      />
      <mask id="path-12-inside-4_1284_24733" fill="white">
        <path d="M75.0694 18.3732L74.5067 16H67.3503V34.4131C67.3503 35.2231 67.6677 36 68.2326 36.5728C68.7975 37.1456 69.5636 37.4673 70.3625 37.4673H73.186C74.8498 37.4673 78.8346 35.8182 78.8346 34.136L76.1982 23.1558" />
      </mask>
      <path
        d="M75.0694 18.3732L74.5067 16H67.3503V34.4131C67.3503 35.2231 67.6677 36 68.2326 36.5728C68.7975 37.1456 69.5636 37.4673 70.3625 37.4673H73.186C74.8498 37.4673 78.8346 35.8182 78.8346 34.136L76.1982 23.1558"
        fill="white"
      />
      <path
        d="M74.5067 16L75.9662 15.6539L75.6926 14.5H74.5067V16ZM67.3503 16V14.5H65.8503V16H67.3503ZM67.3503 34.4131H68.8503H67.3503ZM70.3625 37.4673V38.9673V37.4673ZM78.8346 34.136H80.3346V33.9584L80.2932 33.7858L78.8346 34.136ZM76.5289 18.0271L75.9662 15.6539L73.0471 16.3461L73.6099 18.7193L76.5289 18.0271ZM74.5067 14.5H67.3503V17.5H74.5067V14.5ZM65.8503 16V34.4131H68.8503V16H65.8503ZM65.8503 34.4131C65.8503 35.6143 66.3208 36.7704 67.1646 37.626L69.3006 35.5195C69.0146 35.2296 68.8503 34.8319 68.8503 34.4131L65.8503 34.4131ZM67.1646 37.626C68.0091 38.4824 69.159 38.9673 70.3625 38.9673L70.3625 35.9673C69.9682 35.9673 69.5858 35.8087 69.3006 35.5195L67.1646 37.626ZM70.3625 38.9673H73.186V35.9673H70.3625V38.9673ZM73.186 38.9673C74.3513 38.9673 76.0086 38.4446 77.3231 37.7649C78.0016 37.4142 78.692 36.97 79.2353 36.4381C79.7488 35.9354 80.3346 35.1517 80.3346 34.136H77.3346C77.3346 33.9614 77.4223 34.0147 77.1367 34.2943C76.8809 34.5447 76.4711 34.8282 75.9454 35.1C74.8516 35.6655 73.6846 35.9673 73.186 35.9673V38.9673ZM80.2932 33.7858L77.6567 22.8056L74.7396 23.506L77.3761 34.4862L80.2932 33.7858Z"
        fill="#375A8D"
        mask="url(#path-12-inside-4_1284_24733)"
      />
      <path
        d="M27.1843 46.0001H36.7551C37.0443 45.999 37.3307 46.0576 37.5982 46.1726C37.8656 46.2877 38.1087 46.4568 38.3135 46.6704C38.5183 46.8839 38.6809 47.1377 38.7917 47.4172C38.9026 47.6966 38.9597 47.9962 38.9597 48.2988V65.7144C38.9597 66.8189 38.0643 67.7144 36.9597 67.7144H27.0005C25.896 67.7144 25.0005 66.8189 25.0005 65.7144V48.2988C25.0005 47.6915 25.2302 47.1088 25.6393 46.6781C26.0485 46.2474 26.6039 46.0036 27.1843 46.0001Z"
        fill="#DC343B"
      />
      <path
        d="M66.5183 8.30945H24.1772V12.9173H66.5183V8.30945Z"
        fill="white"
        stroke="#375A8D"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <rect x="45.0007" y="46" width="23" height="14" rx="1" fill="#D3DCEB" />
      <path
        d="M69.5007 52L69.5007 61C69.5007 61.5523 69.053 62 68.5007 62L49.0007 62"
        stroke="#375A8D"
        strokeWidth="1.5"
      />
      <circle cx="6.55102" cy="48.0817" r="1.55102" fill="#FFE000" />
      <circle cx="83.5" cy="6.5" r="4" stroke="#FFE000" />
      <path
        d="M11.9125 79.94C11.0799 81.2721 12.0376 83 13.6085 83H78C79.6481 83 80.5889 81.1185 79.6 79.8V79.8C79.2223 79.2964 78.6295 79 78 79H13.6085C12.9189 79 12.278 79.3552 11.9125 79.94V79.94Z"
        fill="#D3DCEB"
      />
    </svg>
  ),
  wholesalers: (
    <svg
      width="150"
      height="86"
      viewBox="0 0 150 86"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="34.75"
        y="45.75"
        width="33.5"
        height="22.5"
        rx="1.25"
        fill="white"
        stroke="#375A8D"
        strokeWidth="1.5"
      />
      <rect
        x="67.75"
        y="45.75"
        width="28.5"
        height="22.5"
        fill="white"
        stroke="#375A8D"
        strokeWidth="1.5"
      />
      <rect
        x="96.75"
        y="32.75"
        width="24.5"
        height="35.5"
        rx="1.25"
        fill="white"
        stroke="#375A8D"
        strokeWidth="1.5"
      />
      <path
        d="M42 29.75H56C56.6904 29.75 57.25 30.3096 57.25 31V44C57.25 44.6904 56.6904 45.25 56 45.25H42C41.3096 45.25 40.75 44.6904 40.75 44V31C40.75 30.3096 41.3096 29.75 42 29.75Z"
        fill="white"
        stroke="#375A8D"
        strokeWidth="1.5"
      />
      <path
        d="M62 12.75H92C92.6904 12.75 93.25 13.3096 93.25 14V41C93.25 41.6904 92.6904 42.25 92 42.25H62C61.3096 42.25 60.75 41.6904 60.75 41V14C60.75 13.3096 61.3096 12.75 62 12.75Z"
        fill="#DC343B"
        stroke="#375A8D"
        strokeWidth="1.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 22H24V26V29V68.8182L136.351 68.8182V75L24 75H18.0137H18V29H8V22Z"
        fill="#D3DCEB"
      />
      <rect x="68" y="20" width="21" height="4" fill="white" />
      <rect
        x="60"
        y="52"
        width="16"
        height="3"
        transform="rotate(-180 60 52)"
        fill="#D3DCEB"
      />
      <rect
        x="91"
        y="64"
        width="16"
        height="4"
        transform="rotate(-180 91 64)"
        fill="#D3DCEB"
      />
      <rect
        x="55"
        y="35"
        width="9"
        height="3"
        transform="rotate(-180 55 35)"
        fill="#D3DCEB"
      />
      <rect
        x="115"
        y="40"
        width="13"
        height="3"
        transform="rotate(-180 115 40)"
        fill="#D3DCEB"
      />
      <circle cx="139" cy="26" r="5.25" stroke="#FFE000" strokeWidth="1.5" />
      <circle cx="2.5" cy="57.5" r="1.75" stroke="#FFE000" strokeWidth="1.5" />
      <rect x="39" y="74" width="24" height="7" fill="#D3DCEB" />
      <rect x="102" y="74" width="24" height="7" fill="#D3DCEB" />
      <path
        d="M56 20V9C56 8.44772 56.4477 8 57 8H76"
        stroke="#375A8D"
        strokeWidth="1.5"
      />
    </svg>
  ),
  manufacturers: (
    <svg
      width="156"
      height="86"
      viewBox="0 0 156 86"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="5.00049"
        y="59.2803"
        width="140.382"
        height="20.3312"
        rx="10.1656"
        fill="#D3DCEB"
      />
      <circle
        cx="41.7903"
        cy="69.9299"
        r="6.05096"
        fill="white"
        stroke="#375A8D"
        strokeWidth="1.45223"
      />
      <circle
        cx="19.5227"
        cy="69.9299"
        r="6.05096"
        fill="white"
        stroke="#375A8D"
        strokeWidth="1.45223"
      />
      <circle
        cx="64.0578"
        cy="69.9299"
        r="6.05096"
        fill="white"
        stroke="#375A8D"
        strokeWidth="1.45223"
      />
      <circle
        cx="86.3254"
        cy="69.9299"
        r="6.05096"
        fill="white"
        stroke="#375A8D"
        strokeWidth="1.45223"
      />
      <circle
        cx="108.593"
        cy="69.9299"
        r="6.05096"
        fill="white"
        stroke="#375A8D"
        strokeWidth="1.45223"
      />
      <circle
        cx="130.861"
        cy="69.9299"
        r="6.05096"
        fill="white"
        stroke="#375A8D"
        strokeWidth="1.45223"
      />
      <path
        d="M137.153 53.9554C144.031 56.1944 147.803 58.3121 149.739 66.5414"
        stroke="#375A8D"
        strokeWidth="0.968153"
      />
      <path
        d="M88.9869 20.6177C88.9869 19.9141 89.5572 19.3438 90.2607 19.3438H124.019C124.722 19.3438 125.293 19.9141 125.293 20.6177V54.3756C125.293 55.0792 124.722 55.6495 124.019 55.6495H90.2607C89.5572 55.6495 88.9869 55.0792 88.9869 54.3756V20.6177Z"
        fill="#DC343B"
        stroke="#375A8D"
        strokeWidth="1.45223"
      />
      <rect
        x="97.9424"
        y="27.3311"
        width="20.3312"
        height="4.84076"
        fill="white"
      />
      <path
        d="M6.93701 83H40.3383M96.9752 82.0319H130.377"
        stroke="#375A8D"
        strokeWidth="0.968153"
      />
      <rect
        x="5"
        y="27.9122"
        width="38.7261"
        height="12.0051"
        rx="1.93631"
        fill="#D3DCEB"
      />
      <rect
        x="29.2046"
        y="7"
        width="22.2675"
        height="11.6178"
        rx="1.93631"
        transform="rotate(90 29.2046 7)"
        fill="#D3DCEB"
      />
      <rect
        x="8.87305"
        y="34.1083"
        width="17.4268"
        height="1.93631"
        fill="white"
      />
      <rect
        x="31.1406"
        y="32.172"
        width="9.68153"
        height="3.87261"
        rx="0.968153"
        fill="white"
      />
      <rect
        x="62.8472"
        y="32.8982"
        width="22.7516"
        height="22.7516"
        rx="1.27389"
        fill="white"
        stroke="#375A8D"
        strokeWidth="1.45223"
      />
      <rect
        x="71.5606"
        y="38.7072"
        width="12.1019"
        height="1.45223"
        rx="0.726115"
        fill="#D3DCEB"
        stroke="#375A8D"
        strokeWidth="1.45223"
      />
      <rect
        x="36.9497"
        y="33.1401"
        width="2.90446"
        height="1.93631"
        fill="#FFE000"
      />
      <rect
        x="32.1094"
        y="33.1401"
        width="2.90446"
        height="1.93631"
        fill="#FFE000"
      />
    </svg>
  ),
  googlePlayBadge: (
    <svg
      width="163"
      height="48"
      viewBox="0 0 163 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M156.633 0H6.14547C2.821 0 0.125977 2.68629 0.125977 6V42C0.125977 45.3137 2.821 48 6.14547 48H156.633C159.957 48 162.653 45.3137 162.653 42V6C162.653 2.68629 159.957 0 156.633 0Z"
        fill="#141414"
      />
      <path
        d="M156.633 0.959992C157.973 0.96316 159.257 1.49518 160.205 2.43968C161.153 3.38418 161.686 4.66428 161.689 6V42C161.689 43.3367 161.157 44.6186 160.208 45.5638C159.26 46.509 157.974 47.04 156.633 47.04H6.14547C4.80541 47.0368 3.52115 46.5048 2.57359 45.5603C1.62602 44.6158 1.09228 43.3357 1.0891 42V6C1.09228 4.66428 1.62602 3.38418 2.57359 2.43968C3.52115 1.49518 4.80541 0.96316 6.14547 0.959992H156.633ZM156.633 0H6.14547C4.549 0 3.01792 0.632137 1.88904 1.75735C0.760171 2.88258 0.125977 4.4087 0.125977 6V42C0.125977 43.5913 0.760171 45.1174 1.88904 46.2426C2.448 46.7998 3.11159 47.2418 3.84191 47.5433C4.57223 47.8448 5.35498 48 6.14547 48H156.633C158.229 48 159.761 47.3678 160.889 46.2426C162.018 45.1174 162.653 43.5913 162.653 42V6C162.653 4.4087 162.018 2.88258 160.889 1.75735C159.761 0.632137 158.229 0 156.633 0Z"
        fill="#A6A6A6"
      />
      <path
        d="M57.2511 12.2998C57.271 12.7388 57.2025 13.1775 57.0495 13.5897C56.8965 14.002 56.6621 14.3794 56.3601 14.6998C56.0165 15.0536 55.6021 15.3315 55.1437 15.5155C54.6853 15.6995 54.1933 15.7854 53.6996 15.7678C53.186 15.7967 52.6719 15.7208 52.1888 15.5448C51.7057 15.3688 51.2636 15.0964 50.8897 14.7443C50.5159 14.3921 50.2181 13.9676 50.0146 13.4967C49.811 13.0258 49.7061 12.5185 49.7061 12.0058C49.7061 11.4931 49.811 10.9857 50.0146 10.5148C50.2181 10.044 50.5159 9.61949 50.8897 9.26725C51.2636 8.91509 51.7057 8.64269 52.1888 8.46669C52.6719 8.29069 53.186 8.21485 53.6996 8.24381C54.2089 8.23861 54.7135 8.34085 55.1804 8.54381C55.6178 8.71557 56.0064 8.99165 56.3121 9.34781L55.686 9.98381C55.4384 9.68861 55.1232 9.45717 54.7669 9.30893C54.4108 9.16061 54.0241 9.09989 53.6393 9.13181C53.2639 9.12829 52.8916 9.20069 52.5449 9.34453C52.1983 9.48829 51.8845 9.70061 51.6223 9.96861C51.3602 10.2366 51.1553 10.5548 51.0198 10.9038C50.8844 11.2529 50.8213 11.6257 50.8343 11.9998C50.8264 12.5592 50.9849 13.1083 51.2897 13.578C51.5946 14.0476 52.0322 14.4168 52.5473 14.6388C53.0625 14.8609 53.6321 14.926 54.1842 14.8257C54.7364 14.7256 55.2464 14.4646 55.6499 14.0758C56.0222 13.6768 56.2361 13.1564 56.2518 12.6118H53.6393V11.7478H57.1427C57.1965 11.9279 57.2327 12.1128 57.2511 12.2998Z"
        fill="white"
        stroke="white"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M62.7649 9.25201H59.4782V11.532H62.4398V12.396H59.4782V14.688H62.7649V15.564H58.5513V8.36401H62.7649V9.25201Z"
        fill="white"
        stroke="white"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M66.6778 15.6H65.7507V9.25201H63.7402V8.36401H68.7003V9.25201H66.6778V15.6Z"
        fill="white"
        stroke="white"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M72.2876 15.5999V8.3999H73.2146V15.5999H72.2876Z"
        fill="white"
        stroke="white"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M77.332 15.6H76.405V9.25201H74.3945V8.36401H79.3545V9.25201H77.332V15.6Z"
        fill="white"
        stroke="white"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M88.7448 14.6759C88.3976 15.0227 87.984 15.2979 87.5296 15.4857C87.0752 15.6734 86.588 15.77 86.096 15.77C85.6048 15.77 85.1176 15.6734 84.6632 15.4857C84.2088 15.2979 83.7952 15.0227 83.448 14.6759C82.7664 13.9527 82.3872 12.9979 82.3872 12.0059C82.3872 11.0138 82.7664 10.0591 83.448 9.33586C83.7952 8.98906 84.2088 8.71386 84.6632 8.5261C85.1176 8.33834 85.6048 8.2417 86.096 8.2417C86.588 8.2417 87.0752 8.33834 87.5296 8.5261C87.984 8.71386 88.3976 8.98906 88.7448 9.33586C89.432 10.0563 89.8144 11.0121 89.8144 12.0059C89.8144 12.9997 89.432 13.9555 88.7448 14.6759ZM84.1344 14.0519C84.388 14.3129 84.6936 14.519 85.0312 14.6573C85.3688 14.7956 85.7312 14.8632 86.096 14.8559C86.4616 14.8654 86.8248 14.7988 87.1624 14.6603C87.5008 14.5219 87.8056 14.3147 88.0584 14.0519C88.5768 13.486 88.8632 12.7478 88.8632 11.9819C88.8632 11.216 88.5768 10.4778 88.0584 9.91186C87.8096 9.65946 87.5112 9.4601 87.1816 9.32602C86.8528 9.19194 86.5 9.12594 86.1448 9.13186C85.78 9.12458 85.4168 9.19218 85.0792 9.3305C84.7416 9.46882 84.4368 9.6749 84.1824 9.93586C83.6696 10.5043 83.3856 11.2415 83.3856 12.0059C83.3856 12.7702 83.6696 13.5075 84.1824 14.0759L84.1344 14.0519Z"
        fill="white"
        stroke="white"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M91.1167 15.5999V8.3999H92.2487L95.7759 14.0519V12.6599V8.3999H96.7151V15.5999H95.7759L92.0439 9.7319V11.1239V15.5999H91.1167Z"
        fill="white"
        stroke="white"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M82.1598 26.0519C81.1502 26.0637 80.1662 26.3723 79.3321 26.9391C78.4977 27.5059 77.8497 28.3055 77.4694 29.2379C77.089 30.1701 76.9932 31.1936 77.194 32.1799C77.3948 33.1663 77.8832 34.0716 78.598 34.7824C79.3128 35.4932 80.2222 35.9779 81.2118 36.1758C82.2022 36.3736 83.2286 36.2757 84.163 35.8944C85.0974 35.5131 85.8982 34.8655 86.4646 34.0324C87.0318 33.1995 87.339 32.2183 87.3486 31.2119C87.3654 30.5287 87.2422 29.8493 86.987 29.2151C86.7318 28.5807 86.3502 28.0047 85.8646 27.5221C85.3798 27.0395 84.8006 26.6603 84.1638 26.4075C83.527 26.1547 82.8454 26.0338 82.1598 26.0519ZM82.1598 34.2599C81.535 34.3057 80.9102 34.1627 80.3686 33.8497C79.8261 33.5367 79.3911 33.0681 79.12 32.5051C78.8488 31.9419 78.7542 31.3105 78.8484 30.693C78.9426 30.0755 79.2213 29.5007 79.6481 29.0434C80.075 28.586 80.6302 28.2675 81.2406 28.1293C81.8518 27.9911 82.491 28.0395 83.0734 28.2684C83.6566 28.4974 84.1574 28.896 84.5094 29.4125C84.8614 29.929 85.0502 30.5393 85.0494 31.1639C85.075 31.5614 85.0206 31.96 84.8878 32.3359C84.755 32.7116 84.5478 33.0568 84.2774 33.3506C84.0078 33.6443 83.6806 33.8806 83.3166 34.0451C82.9526 34.2096 82.559 34.299 82.1598 34.3079V34.2599ZM70.9515 26.0519C69.9376 26.0543 68.9473 26.356 68.1055 26.9192C67.2637 27.4823 66.6082 28.2815 66.2219 29.2159C65.8356 30.1502 65.7356 31.1776 65.9349 32.1685C66.1342 33.1593 66.6236 34.0691 67.3413 34.7828C68.059 35.4965 68.9729 35.9822 69.9674 36.1785C70.9619 36.3747 71.9925 36.2728 72.9289 35.8855C73.8653 35.4983 74.6657 34.8431 75.2286 34.0027C75.7917 33.1623 76.0921 32.1744 76.0921 31.1639C76.1036 30.4883 75.9784 29.8175 75.7239 29.1914C75.4695 28.5652 75.091 27.9966 74.6112 27.5195C74.1314 27.0423 73.56 26.6664 72.9312 26.4143C72.3024 26.1621 71.6291 26.0388 70.9515 26.0519ZM70.9515 34.2599C70.3265 34.3057 69.7023 34.1627 69.16 33.8497C68.6178 33.5367 68.1828 33.0681 67.9116 32.5051C67.6405 31.9419 67.5459 31.3105 67.64 30.693C67.7343 30.0755 68.0129 29.5007 68.4397 29.0434C68.8665 28.586 69.4216 28.2675 70.0327 28.1293C70.6437 27.9911 71.2824 28.0395 71.8655 28.2684C72.4484 28.4974 72.9488 28.896 73.3012 29.4125C73.6535 29.929 73.8416 30.5393 73.8408 31.1639C73.8669 31.5614 73.812 31.96 73.6795 32.3359C73.5469 32.7116 73.3393 33.0568 73.0694 33.3506C72.7994 33.6443 72.4726 33.8806 72.1087 34.0451C71.7447 34.2096 71.351 34.299 70.9515 34.3079V34.2599ZM57.6123 27.6719V29.8319H62.8131C62.7342 30.8535 62.3098 31.818 61.6093 32.5679C61.0876 33.0943 60.4618 33.507 59.7717 33.7797C59.0816 34.0523 58.3421 34.1791 57.6002 34.1519C56.1117 34.0842 54.7066 33.4471 53.6772 32.3731C52.6479 31.2992 52.0735 29.8711 52.0735 28.3859C52.0735 26.9006 52.6479 25.4724 53.6772 24.3985C54.7066 23.3246 56.1117 22.6875 57.6002 22.6199C59.0578 22.6037 60.4633 23.1597 61.5129 24.1679L63.0419 22.6439C62.3269 21.9363 61.4772 21.3785 60.5426 21.0034C59.608 20.6283 58.6076 20.4435 57.6002 20.4599C56.53 20.4183 55.4623 20.5926 54.4612 20.9722C53.4601 21.3519 52.5462 21.929 51.7743 22.6691C51.0024 23.4091 50.3882 24.297 49.9687 25.2793C49.5492 26.2616 49.333 27.3183 49.333 28.3859C49.333 29.4535 49.5492 30.5101 49.9687 31.4924C50.3882 32.4747 51.0024 33.3626 51.7743 34.1027C52.5462 34.8427 53.4601 35.4199 54.4612 35.7995C55.4623 36.1791 56.53 36.3534 57.6002 36.3119C58.6307 36.3583 59.6592 36.1842 60.6165 35.8012C61.5739 35.4183 62.4378 34.8355 63.1502 34.0919C64.4115 32.7106 65.0849 30.8947 65.0283 29.0279C65.0355 28.5729 64.9952 28.1184 64.9079 27.6719H57.6123ZM112.161 29.3519C111.857 28.4277 111.279 27.6174 110.503 27.028C109.727 26.4387 108.789 26.0983 107.815 26.0519C107.155 26.0505 106.502 26.1842 105.897 26.4447C105.291 26.7051 104.745 27.0869 104.294 27.5662C103.842 28.0455 103.495 28.6122 103.272 29.231C103.049 29.8499 102.957 30.5078 102.999 31.1639C102.986 31.8341 103.109 32.5001 103.359 33.1223C103.609 33.7446 103.982 34.3103 104.456 34.786C104.93 35.2617 105.495 35.6377 106.117 35.8915C106.74 36.1454 107.407 36.272 108.08 36.2639C108.924 36.2683 109.755 36.0646 110.501 35.6709C111.246 35.2773 111.883 34.706 112.353 34.0079L110.608 32.8079C110.345 33.2417 109.974 33.6003 109.531 33.8485C109.088 34.0967 108.588 34.226 108.08 34.2239C107.558 34.242 107.044 34.1043 106.602 33.8284C106.16 33.5526 105.811 33.1511 105.6 32.6759L112.45 29.8439L112.161 29.3519ZM105.178 31.0559C105.154 30.6875 105.203 30.3181 105.322 29.9687C105.442 29.6194 105.629 29.2971 105.875 29.0204C106.12 28.7438 106.417 28.5182 106.75 28.3567C107.083 28.1953 107.445 28.1012 107.815 28.0799C108.203 28.0543 108.59 28.1431 108.929 28.3351C109.267 28.5271 109.541 28.8139 109.717 29.1599L105.178 31.0559ZM99.6046 35.9999H101.856V20.9999H99.6046V35.9999ZM95.9206 27.2519H95.8478C95.5086 26.8737 95.0934 26.5714 94.6286 26.3646C94.1638 26.1578 93.6606 26.0512 93.151 26.0519C91.8358 26.1155 90.595 26.6811 89.6862 27.6318C88.7782 28.5823 88.271 29.8449 88.271 31.1579C88.271 32.4707 88.7782 33.7334 89.6862 34.6839C90.595 35.6346 91.8358 36.2003 93.151 36.2639C93.6614 36.2724 94.167 36.1694 94.6334 35.962C95.099 35.7547 95.5142 35.4482 95.8478 35.0639H95.9206V35.8079C95.9758 36.1905 95.9462 36.5807 95.8318 36.9504C95.7182 37.3201 95.5238 37.66 95.2622 37.9458C95.0014 38.2315 94.6798 38.4559 94.3206 38.603C93.9622 38.7499 93.575 38.8159 93.1878 38.7959C92.6262 38.7827 92.0814 38.6035 91.6222 38.2807C91.1638 37.9581 90.8118 37.5067 90.611 36.9839L88.6486 37.7999C89.0206 38.6936 89.651 39.457 90.459 39.9933C91.267 40.5295 92.2166 40.8144 93.1878 40.8119C95.8238 40.8119 98.003 39.2639 98.003 35.4959V26.4119H95.9206V27.2519ZM93.3678 34.3079C92.5918 34.2396 91.8686 33.8839 91.3422 33.3108C90.8158 32.7378 90.5238 31.9889 90.5238 31.2119C90.5238 30.4348 90.8158 29.6859 91.3422 29.1128C91.8686 28.5398 92.5918 28.1841 93.3678 28.1159C94.1254 28.21 94.8222 28.5766 95.327 29.1467C95.8318 29.7169 96.111 30.4513 96.111 31.2119C96.111 31.9724 95.8318 32.7068 95.327 33.277C94.8222 33.8471 94.1254 34.2137 93.3678 34.3079ZM122.695 20.9999H117.313V35.9999H119.553V30.3239H122.695C123.329 30.3559 123.963 30.2591 124.559 30.0393C125.154 29.8195 125.699 29.4813 126.159 29.0452C126.619 28.6091 126.985 28.0843 127.236 27.5027C127.486 26.9211 127.616 26.2948 127.616 25.6619C127.616 25.0289 127.486 24.4026 127.236 23.821C126.985 23.2393 126.619 22.7145 126.159 22.2784C125.699 21.8424 125.154 21.5042 124.559 21.2843C123.963 21.0646 123.329 20.9678 122.695 20.9999ZM122.695 28.1999H119.553V23.0879H122.755C123.109 23.0638 123.465 23.1124 123.799 23.2309C124.133 23.3493 124.439 23.535 124.698 23.7763C124.957 24.0178 125.165 24.3097 125.305 24.634C125.447 24.9584 125.52 25.3083 125.52 25.6619C125.52 26.0155 125.447 26.3653 125.305 26.6897C125.165 27.014 124.957 27.3059 124.698 27.5473C124.439 27.7887 124.133 27.9744 123.799 28.0928C123.465 28.2113 123.109 28.2599 122.755 28.2359L122.695 28.1999ZM136.636 26.0519C135.816 26.0056 134.999 26.199 134.287 26.6083C133.575 27.0175 132.998 27.6248 132.627 28.3559L134.625 29.1839C134.821 28.8208 135.12 28.5229 135.483 28.3267C135.847 28.1306 136.261 28.0447 136.673 28.0799C136.958 28.0449 137.249 28.0675 137.525 28.1463C137.803 28.2251 138.061 28.3586 138.285 28.5387C138.51 28.7188 138.697 28.942 138.833 29.1951C138.969 29.4481 139.053 29.7259 139.08 30.0119V30.1679C138.347 29.7968 137.53 29.6191 136.709 29.6519C134.553 29.6519 132.374 30.8519 132.374 33.0359C132.396 33.499 132.51 33.9531 132.71 34.3715C132.911 34.7899 133.193 35.1639 133.541 35.4716C133.889 35.7793 134.295 36.0143 134.736 36.1627C135.177 36.3111 135.643 36.37 136.106 36.3359C136.672 36.3695 137.236 36.2515 137.74 35.994C138.244 35.7365 138.669 35.349 138.972 34.8719H139.044V36.0719H141.223V30.2279C141.211 27.5639 139.213 26.0519 136.636 26.0519ZM136.359 34.2719C135.625 34.2719 134.601 33.9119 134.601 32.9999C134.601 31.7999 135.877 31.4039 137.009 31.4039C137.724 31.3814 138.431 31.5514 139.056 31.8959C138.979 32.5556 138.662 33.1645 138.165 33.6068C137.669 34.0492 137.025 34.2944 136.359 34.2959V34.2719ZM149.109 26.4119L146.533 32.9159H146.448L143.775 26.4119H141.368L145.377 35.4959L143.101 40.5479H145.437L151.613 26.4119H149.109ZM128.871 36.0119H131.122V20.9999H128.871V36.0119Z"
        fill="white"
      />
      <path
        d="M12.7068 9.04811C12.3114 9.52051 12.1132 10.1262 12.153 10.7401V37.2721C12.1132 37.886 12.3114 38.4917 12.7068 38.9641L12.791 39.0481L27.6953 24.1801V23.8321L12.779 8.96411L12.7068 9.04811Z"
        fill="url(#paint0_linear_1344_25385)"
      />
      <path
        d="M32.6675 29.1358L27.6953 24.1798V23.8318L32.6675 18.8518H32.7879L38.6749 22.1878C40.3604 23.1358 40.3604 24.6958 38.6749 25.6558L32.7879 29.0758L32.6675 29.1358Z"
        fill="url(#paint1_linear_1344_25385)"
      />
      <path
        d="M32.7881 29.076L27.6956 24L12.707 38.964C13.0506 39.265 13.4888 39.437 13.9461 39.4501C14.4033 39.4633 14.8507 39.3168 15.2111 39.036L32.8001 29.076"
        fill="url(#paint2_linear_1344_25385)"
      />
      <path
        d="M32.7879 18.9359L15.1989 8.97587C14.8395 8.69291 14.3915 8.54499 13.9337 8.55819C13.4759 8.57131 13.0372 8.74475 12.6948 9.04795L27.6954 23.9999L32.7879 18.9359Z"
        fill="url(#paint3_linear_1344_25385)"
      />
      <path
        opacity="0.2"
        d="M32.6677 28.968L15.1991 38.856C14.8507 39.1132 14.4287 39.252 13.9952 39.252C13.5617 39.252 13.1397 39.1132 12.7913 38.856L12.707 38.952L12.7913 39.036C13.1397 39.2932 13.5617 39.432 13.9952 39.432C14.4287 39.432 14.8507 39.2932 15.1991 39.036L32.7881 29.076L32.6677 28.968Z"
        fill="#141414"
      />
      <path
        opacity="0.12"
        d="M12.7068 38.784C12.3144 38.3146 12.1163 37.7138 12.153 37.104V37.272C12.1132 37.8859 12.3114 38.4916 12.7068 38.964L12.791 38.868L12.7068 38.784Z"
        fill="#141414"
      />
      <path
        opacity="0.12"
        d="M38.6748 25.56L32.6553 28.968L32.7757 29.076L38.6628 25.74C38.9991 25.581 39.2874 25.3364 39.4988 25.0309C39.7102 24.7254 39.837 24.3699 39.8666 24C39.7994 24.333 39.6572 24.6464 39.4507 24.9166C39.2442 25.1869 38.979 25.4068 38.6748 25.56Z"
        fill="#141414"
      />
      <path
        opacity="0.25"
        d="M15.1985 9.15623L38.6745 22.4522C38.9795 22.6027 39.2463 22.8202 39.4549 23.0884C39.6634 23.3565 39.8082 23.6682 39.8785 24.0002C39.8468 23.6324 39.7189 23.2794 39.5077 22.9762C39.2965 22.673 39.0092 22.4302 38.6745 22.2722L15.1985 8.97615C13.513 8.02815 12.1406 8.82023 12.1406 10.7402V10.9082C12.1406 8.98823 13.513 8.19623 15.1985 9.15623Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1344_25385"
          x1="26.371"
          y1="10.4521"
          x2="6.23516"
          y2="30.6654"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF" />
          <stop offset="0.01" stopColor="#00A1FF" />
          <stop offset="0.26" stopColor="#00BEFF" />
          <stop offset="0.51" stopColor="#00D2FF" />
          <stop offset="0.76" stopColor="#00DFFF" />
          <stop offset="1" stopColor="#00E3FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1344_25385"
          x1="40.866"
          y1="23.9998"
          x2="11.7316"
          y2="23.9998"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE000" />
          <stop offset="0.41" stopColor="#FFBD00" />
          <stop offset="0.78" stopColor="#FFA500" />
          <stop offset="1" stopColor="#FF9C00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1344_25385"
          x1="30.0191"
          y1="26.76"
          x2="2.70723"
          y2="54.1606"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF3A44" />
          <stop offset="1" stopColor="#C31162" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1344_25385"
          x1="8.9145"
          y1="0.215906"
          x2="21.1065"
          y2="12.4475"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#32A071" />
          <stop offset="0.07" stopColor="#2DA771" />
          <stop offset="0.48" stopColor="#15CF74" />
          <stop offset="0.8" stopColor="#06E775" />
          <stop offset="1" stopColor="#00F076" />
        </linearGradient>
      </defs>
    </svg>
  ),
  appStoreBadge: (
    <svg
      width="164"
      height="48"
      viewBox="0 0 164 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1344_25358)">
        <path
          d="M154.526 0.47998H7.99998C3.8468 0.47998 0.47998 3.8468 0.47998 7.99998V40C0.47998 44.1532 3.8468 47.52 7.99998 47.52H154.526C158.68 47.52 162.046 44.1532 162.046 40V7.99998C162.046 3.8468 158.68 0.47998 154.526 0.47998Z"
          fill="#141414"
        />
        <path
          d="M40.0022 23.9601C40.0126 22.9579 40.2762 21.9749 40.7679 21.1036C41.2597 20.2323 41.9635 19.5016 42.8131 18.9801C42.2734 18.2049 41.5618 17.5671 40.7348 17.1173C39.9078 16.6673 38.9882 16.4177 38.0488 16.3881C36.0598 16.1721 34.1183 17.5881 33.094 17.5881C32.0697 17.5881 30.4855 16.3881 28.7942 16.3881C27.7014 16.4239 26.6365 16.7445 25.7034 17.3187C24.7702 17.8929 24.0009 18.7009 23.4702 19.6641C21.219 23.7321 22.8866 29.6001 25.09 32.8881C26.1977 34.4841 27.4722 36.2601 29.1754 36.1881C30.8786 36.1161 31.4384 35.1321 33.4394 35.1321C35.4404 35.1321 35.9883 36.1881 37.7154 36.1521C39.4424 36.1161 40.6096 34.5561 41.6697 32.9481C42.4611 31.8146 43.0719 30.5635 43.4801 29.2401C42.4487 28.8029 41.5685 28.0685 40.9498 27.1293C40.331 26.1899 40.0014 25.0874 40.0022 23.9601Z"
          fill="white"
        />
        <path
          d="M36.703 14.252C37.6655 13.0812 38.1395 11.5798 38.0251 10.064C36.5487 10.2244 35.1851 10.9349 34.2018 12.056C33.238 13.1663 32.7498 14.616 32.844 16.088C33.583 16.0953 34.3142 15.9339 34.9826 15.616C35.6509 15.298 36.2391 14.8316 36.703 14.252Z"
          fill="white"
        />
        <path
          d="M60.882 32.1681H55.2482L53.8904 36.2001H51.5083L56.8442 21.2961H59.3336L64.6696 36.2001H62.2874L60.882 32.1681ZM55.8318 30.3081H60.2983L58.1425 23.7681H58.0829L55.8318 30.3081Z"
          fill="white"
        />
        <path
          d="M76.1989 30.7999C76.1989 34.1719 74.4003 36.3439 71.6967 36.3439C71.0068 36.3733 70.3227 36.2067 69.7224 35.8629C69.1222 35.5191 68.6299 35.0122 68.3021 34.3999V39.7759H66.0391V25.3759H68.183V27.1999C68.5311 26.5965 69.0351 26.0994 69.6411 25.7613C70.2471 25.4233 70.9328 25.2569 71.6252 25.2799C74.4003 25.2199 76.1989 27.3919 76.1989 30.7999ZM73.9239 30.7999C73.9239 28.6039 72.7329 27.1999 71.0773 27.1999C69.4217 27.1999 68.2426 28.6759 68.2426 30.7999C68.2426 32.9239 69.4336 34.4599 71.0773 34.4599C72.721 34.4599 73.9239 32.9839 73.9239 30.7999Z"
          fill="white"
        />
        <path
          d="M88.0616 30.7998C88.0616 34.1718 86.2752 36.3438 83.572 36.3438C82.8816 36.3746 82.1968 36.2085 81.596 35.8646C80.996 35.5207 80.504 35.013 80.1768 34.3998V39.7758H77.9141V25.3758H80.0576V27.1998C80.4048 26.5983 80.9072 26.1023 81.5112 25.7644C82.1144 25.4264 82.7976 25.259 83.488 25.2798C86.2632 25.2198 88.0616 27.3918 88.0616 30.7998ZM85.7872 30.7998C85.7872 28.6038 84.6672 27.1998 82.94 27.1998C81.2136 27.1998 80.1176 28.6758 80.1176 30.7998C80.1176 32.9238 81.2488 34.3998 82.94 34.3998C84.632 34.3998 85.7872 32.9838 85.7872 30.7998Z"
          fill="white"
        />
        <path
          d="M95.9112 32C96.0776 33.476 97.4952 34.4 99.484 34.4C101.474 34.4 102.688 33.428 102.688 32.096C102.688 30.764 101.878 30.248 99.9607 29.768L98.0432 29.3C95.3272 28.64 94.0768 27.368 94.0768 25.292C94.0768 22.712 96.2919 20.948 99.4487 20.948C102.605 20.948 104.725 22.712 104.797 25.292H102.522C102.39 23.804 101.164 22.892 99.3888 22.892C97.6144 22.892 96.3872 23.792 96.3872 25.124C96.3872 26.168 97.1616 26.792 99.0672 27.272L100.699 27.668C103.736 28.388 104.999 29.624 104.999 31.796C104.999 34.592 102.783 36.332 99.2815 36.332C96.0063 36.332 93.7911 34.628 93.6479 31.94L95.9112 32Z"
          fill="white"
        />
        <path
          d="M109.775 22.7603V25.3283H111.823V27.0923H109.775V33.0923C109.775 34.0163 110.18 34.4483 111.085 34.4483C111.327 34.4631 111.57 34.4631 111.812 34.4483V36.2003C111.419 36.2748 111.02 36.311 110.621 36.3083C108.429 36.3083 107.583 35.4803 107.583 33.3683V27.0923H105.975V25.3283H107.548V22.7603H109.775Z"
          fill="white"
        />
        <path
          d="M113.002 30.7999C113.002 27.3799 115.004 25.2319 118.124 25.2319C121.245 25.2319 123.234 27.3799 123.234 30.7999C123.234 34.2199 121.269 36.3319 118.124 36.3319C114.98 36.3319 113.002 34.1959 113.002 30.7999ZM120.983 30.7999C120.983 28.4599 119.911 27.0679 118.124 27.0679C116.338 27.0679 115.314 28.3999 115.314 30.7999C115.314 33.1999 116.374 34.5319 118.172 34.5319C119.97 34.5319 120.983 33.1159 120.983 30.7999Z"
          fill="white"
        />
        <path
          d="M125.068 25.3277H127.224V27.1997C127.369 26.6231 127.705 26.114 128.178 25.7578C128.651 25.4017 129.231 25.2201 129.821 25.2437C130.077 25.2396 130.333 25.2677 130.583 25.3277V27.4157C130.273 27.2857 129.942 27.2126 129.606 27.1997C129.273 27.1752 128.94 27.2258 128.629 27.3479C128.318 27.47 128.038 27.6605 127.81 27.9054C127.582 28.1504 127.411 28.4437 127.309 28.7638C127.208 29.0839 127.179 29.4228 127.224 29.7557V36.1997H125.068V25.3277Z"
          fill="white"
        />
        <path
          d="M140.778 33.008C140.481 34.976 138.575 36.332 136.145 36.332C133.001 36.332 131.059 34.208 131.059 30.812C131.059 27.416 133.013 25.196 136.049 25.196C139.087 25.196 140.909 27.26 140.909 30.56V31.316H133.286V31.46C133.253 31.8599 133.303 32.2624 133.435 32.6409C133.567 33.0195 133.777 33.3655 134.053 33.656C134.327 33.9464 134.66 34.1748 135.029 34.3258C135.398 34.4768 135.795 34.5472 136.193 34.532C136.715 34.5812 137.239 34.4595 137.688 34.185C138.136 33.9105 138.485 33.4978 138.682 33.008H140.778ZM133.298 29.756H138.694C138.713 29.3971 138.66 29.0378 138.535 28.7009C138.41 28.3641 138.217 28.0569 137.969 27.7988C137.721 27.5406 137.422 27.3371 137.092 27.201C136.761 27.0649 136.406 26.9992 136.049 27.008C135.69 27.0064 135.333 27.0763 135.001 27.2136C134.668 27.3508 134.365 27.5528 134.109 27.808C133.853 28.0632 133.65 28.3665 133.512 28.7008C133.373 29.035 133.3 29.3936 133.298 29.756Z"
          fill="white"
        />
        <path
          d="M55.5581 10.0757C56.0254 10.0425 56.4942 10.1149 56.9302 10.2877C57.3661 10.4605 57.7582 10.7292 58.0778 11.0743C58.3975 11.4193 58.6366 11.832 58.7776 12.282C58.9187 12.7321 58.9581 13.2083 58.8931 13.6757C58.8931 15.9557 57.702 17.2757 55.5581 17.2757H52.9854V10.0757H55.5581ZM54.0931 16.2197H55.4271C55.7614 16.2469 56.0975 16.1976 56.4103 16.0756C56.7231 15.9536 57.0046 15.762 57.2336 15.5152C57.4626 15.2683 57.6334 14.9724 57.733 14.6498C57.8327 14.3271 57.8587 13.986 57.8092 13.6517C57.8564 13.3179 57.8287 12.9776 57.7282 12.656C57.6277 12.3344 57.4569 12.0395 57.2283 11.7932C56.9998 11.5468 56.7194 11.3552 56.4077 11.2324C56.0959 11.1096 55.7609 11.0588 55.4271 11.0837H54.0931V16.2197Z"
          fill="white"
        />
        <path
          d="M60.1437 14.5279C60.1198 14.1783 60.1677 13.8275 60.2841 13.4974C60.4005 13.1671 60.583 12.8646 60.8204 12.6085C61.0577 12.3524 61.3449 12.1482 61.6638 12.0086C61.9828 11.869 62.3269 11.7969 62.6747 11.7969C63.0225 11.7969 63.3665 11.869 63.6856 12.0086C64.0045 12.1482 64.2917 12.3524 64.529 12.6085C64.7664 12.8646 64.9489 13.1671 65.0653 13.4974C65.1817 13.8275 65.2295 14.1783 65.2057 14.5279C65.2295 14.8775 65.1817 15.2282 65.0653 15.5585C64.9489 15.8886 64.7664 16.1912 64.529 16.4474C64.2917 16.7034 64.0045 16.9077 63.6856 17.0473C63.3665 17.1869 63.0225 17.259 62.6747 17.259C62.3269 17.259 61.9828 17.1869 61.6638 17.0473C61.3449 16.9077 61.0577 16.7034 60.8204 16.4474C60.583 16.1912 60.4005 15.8886 60.2841 15.5585C60.1677 15.2282 60.1198 14.8775 60.1437 14.5279ZM64.1099 14.5279C64.1099 13.3279 63.5977 12.6799 62.6806 12.6799C61.7635 12.6799 61.2394 13.3639 61.2394 14.5279C61.2394 15.6919 61.7159 16.3999 62.6806 16.3999C63.6454 16.3999 64.098 15.7039 64.098 14.5279H64.1099Z"
          fill="white"
        />
        <path
          d="M71.9231 17.2401H70.8273L69.7196 13.2561H69.6362L68.5286 17.2401H67.4447L65.9678 11.8281H67.0397L68.0045 15.9561H68.0759L69.1836 11.8281H70.196L71.3037 15.9561H71.3871L72.3399 11.8281H73.4L71.9231 17.2401Z"
          fill="white"
        />
        <path
          d="M74.6383 11.8281H75.6626V12.6921H75.746C75.8777 12.3831 76.1029 12.1239 76.3896 11.9515C76.6761 11.7791 77.0095 11.7023 77.342 11.7321C77.6028 11.7112 77.8649 11.7498 78.1089 11.8452C78.3528 11.9404 78.5722 12.09 78.7508 12.2826C78.9293 12.4752 79.0625 12.706 79.1403 12.9576C79.2181 13.2093 79.2385 13.4754 79.2001 13.7361V17.2401H78.1401V14.0001C78.1401 13.1241 77.7589 12.6921 76.9489 12.6921C76.7697 12.6757 76.589 12.7004 76.4206 12.7645C76.2522 12.8285 76.1004 12.9302 75.9766 13.0619C75.8528 13.1936 75.7602 13.3518 75.7058 13.5247C75.6514 13.6976 75.6367 13.8806 75.6626 14.0601V17.2401H74.6025L74.6383 11.8281Z"
          fill="white"
        />
        <path
          d="M80.8799 9.72827H81.9631V17.2403H80.9031L80.8799 9.72827Z"
          fill="white"
        />
        <path
          d="M83.4167 14.5279C83.3927 14.1783 83.4407 13.8275 83.5575 13.4974C83.6735 13.1671 83.8559 12.8646 84.0935 12.6085C84.3311 12.3524 84.6183 12.1482 84.9367 12.0086C85.2559 11.869 85.5999 11.7969 85.9479 11.7969C86.2959 11.7969 86.6399 11.869 86.9583 12.0086C87.2775 12.1482 87.5647 12.3524 87.8023 12.6085C88.0391 12.8646 88.2223 13.1671 88.3383 13.4974C88.4551 13.8275 88.5023 14.1783 88.4791 14.5279C88.5023 14.8775 88.4551 15.2282 88.3383 15.5585C88.2223 15.8886 88.0391 16.1912 87.8023 16.4474C87.5647 16.7034 87.2775 16.9077 86.9583 17.0473C86.6399 17.1869 86.2959 17.259 85.9479 17.259C85.5999 17.259 85.2559 17.1869 84.9367 17.0473C84.6183 16.9077 84.3311 16.7034 84.0935 16.4474C83.8559 16.1912 83.6735 15.8886 83.5575 15.5585C83.4407 15.2282 83.3927 14.8775 83.4167 14.5279ZM87.3831 14.5279C87.3831 13.3279 86.8591 12.6799 85.9415 12.6799C85.0247 12.6799 84.5127 13.3639 84.5127 14.5279C84.5127 15.6919 85.0247 16.3999 85.9415 16.3999C86.8591 16.3999 87.3831 15.7039 87.3831 14.5279Z"
          fill="white"
        />
        <path
          d="M89.5864 15.704C89.5864 14.732 90.3008 14.18 91.5872 14.096L93.0408 14V13.532C93.0408 12.968 92.6592 12.644 91.9328 12.644C91.2064 12.644 90.932 12.86 90.8248 13.244H89.7888C89.908 12.308 90.7656 11.72 91.98 11.72C93.1952 11.72 94.0888 12.392 94.0888 13.532V17.24H93.064V16.472H92.9808C92.8136 16.7468 92.576 16.971 92.2936 17.121C92.0104 17.2709 91.692 17.3411 91.3728 17.324C91.148 17.3475 90.92 17.3231 90.7048 17.2525C90.4888 17.1817 90.2912 17.0664 90.1224 16.9137C89.9544 16.761 89.8192 16.5745 89.7272 16.3661C89.6344 16.1577 89.5864 15.9322 89.5864 15.704ZM93.0408 15.2V14.744L91.7304 14.828C90.992 14.828 90.6464 15.14 90.6464 15.608C90.6464 16.076 91.0752 16.376 91.6472 16.376C91.8152 16.3941 91.9864 16.3778 92.1488 16.3281C92.3112 16.2783 92.4616 16.1961 92.592 16.0863C92.7216 15.9765 92.8288 15.8415 92.9056 15.6892C92.9824 15.5369 93.0288 15.3705 93.0408 15.2Z"
          fill="white"
        />
        <path
          d="M95.4824 14.5283C95.4824 12.8243 96.352 11.7443 97.7096 11.7443C98.0448 11.7297 98.3768 11.8111 98.6672 11.9788C98.9584 12.1467 99.196 12.394 99.3536 12.6923H99.4248V9.72827H100.485V17.2403H99.4728V16.4003H99.3888C99.22 16.6955 98.9744 16.9387 98.6784 17.1036C98.3824 17.2686 98.048 17.349 97.7096 17.3363C96.34 17.3243 95.4824 16.2443 95.4824 14.5283ZM96.5784 14.5283C96.5784 15.7283 97.1144 16.3643 98.0072 16.3643C98.9008 16.3643 99.4488 15.6683 99.4488 14.5403C99.4488 13.4123 98.8888 12.7043 98.0072 12.7043C97.1264 12.7043 96.5784 13.4003 96.5784 14.5283Z"
          fill="white"
        />
        <path
          d="M104.868 14.5279C104.844 14.1783 104.892 13.8275 105.008 13.4974C105.125 13.1671 105.307 12.8646 105.544 12.6085C105.781 12.3524 106.069 12.1482 106.388 12.0086C106.707 11.869 107.051 11.7969 107.398 11.7969C107.746 11.7969 108.09 11.869 108.409 12.0086C108.729 12.1482 109.016 12.3524 109.253 12.6085C109.49 12.8646 109.673 13.1671 109.789 13.4974C109.905 13.8275 109.953 14.1783 109.929 14.5279C109.953 14.8775 109.905 15.2282 109.789 15.5585C109.673 15.8886 109.49 16.1912 109.253 16.4474C109.016 16.7034 108.729 16.9077 108.409 17.0473C108.09 17.1869 107.746 17.259 107.398 17.259C107.051 17.259 106.707 17.1869 106.388 17.0473C106.069 16.9077 105.781 16.7034 105.544 16.4474C105.307 16.1912 105.125 15.8886 105.008 15.5585C104.892 15.2282 104.844 14.8775 104.868 14.5279ZM108.833 14.5279C108.833 13.3279 108.309 12.6799 107.405 12.6799C106.499 12.6799 105.963 13.3639 105.963 14.5279C105.963 15.6919 106.476 16.3999 107.405 16.3999C108.333 16.3999 108.833 15.7039 108.833 14.5279Z"
          fill="white"
        />
        <path
          d="M111.347 11.8283H112.36V12.6923H112.443C112.58 12.3845 112.808 12.127 113.096 11.9551C113.384 11.7832 113.718 11.7053 114.051 11.7323C114.311 11.7133 114.571 11.7533 114.814 11.8495C115.057 11.9456 115.274 12.0955 115.451 12.2878C115.629 12.4802 115.761 12.7103 115.838 12.961C115.915 13.2117 115.935 13.4767 115.897 13.7363V17.2403H114.849V14.0003C114.849 13.1243 114.468 12.6923 113.658 12.6923C113.48 12.6778 113.3 12.704 113.134 12.7689C112.966 12.8338 112.816 12.9357 112.694 13.0672C112.571 13.1986 112.48 13.3561 112.426 13.528C112.373 13.7 112.358 13.8819 112.383 14.0603V17.2403H111.323L111.347 11.8283Z"
          fill="white"
        />
        <path
          d="M121.888 10.4839V11.8639H123.079V12.7999H121.888V15.5839C121.888 16.1479 122.114 16.3999 122.638 16.3999H123.044V17.2879C122.853 17.3012 122.662 17.3012 122.472 17.2879C121.281 17.2879 120.828 16.8799 120.828 15.8359V12.7999H119.97V11.9119H120.828V10.4839H121.888Z"
          fill="white"
        />
        <path
          d="M124.485 9.72827H125.545V12.7043H125.628C125.764 12.3973 125.99 12.1396 126.275 11.9659C126.56 11.7921 126.891 11.7106 127.224 11.7323C127.484 11.7174 127.744 11.7607 127.986 11.859C128.226 11.9574 128.443 12.1084 128.62 12.3011C128.796 12.4938 128.928 12.7236 129.006 12.9738C129.084 13.224 129.106 13.4884 129.07 13.7483V17.2403H128.01V14.0003C128.01 13.1363 127.618 12.7043 126.819 12.7043C126.638 12.6898 126.454 12.7152 126.283 12.7789C126.112 12.8425 125.957 12.9428 125.827 13.0728C125.698 13.2029 125.598 13.3596 125.535 13.5321C125.472 13.7047 125.447 13.8889 125.462 14.0723V17.2403H124.485V9.72827Z"
          fill="white"
        />
        <path
          d="M135.276 15.7763C135.132 16.2816 134.811 16.7176 134.374 17.0042C133.936 17.2908 133.411 17.4087 132.894 17.3363C132.539 17.3553 132.183 17.2938 131.855 17.1563C131.526 17.0188 131.231 16.8088 130.994 16.5417C130.756 16.2747 130.581 15.9573 130.481 15.613C130.381 15.2687 130.359 14.9063 130.416 14.5523C130.371 14.1983 130.4 13.8386 130.504 13.4973C130.608 13.156 130.783 12.8411 131.018 12.5739C131.253 12.3066 131.542 12.0931 131.865 11.9479C132.189 11.8027 132.539 11.7292 132.894 11.7323C134.383 11.7323 135.276 12.7523 135.276 14.4563V14.8283H131.5V14.8883C131.487 15.0883 131.515 15.2891 131.584 15.4771C131.653 15.6653 131.761 15.8365 131.901 15.9795C132.04 16.1224 132.209 16.2339 132.395 16.3063C132.58 16.3789 132.779 16.4109 132.977 16.4003C133.232 16.4292 133.491 16.3821 133.719 16.2648C133.947 16.1475 134.137 15.9651 134.263 15.7403L135.276 15.7763ZM131.56 14.0003H134.263C134.277 13.8185 134.252 13.636 134.191 13.4644C134.131 13.2928 134.035 13.1359 133.911 13.0037C133.787 12.8715 133.636 12.767 133.469 12.6968C133.302 12.6267 133.123 12.5924 132.942 12.5963C132.759 12.5946 132.577 12.6299 132.408 12.7C132.239 12.7702 132.086 12.8737 131.957 13.0046C131.828 13.1354 131.727 13.2909 131.659 13.4619C131.591 13.633 131.557 13.8159 131.56 14.0003Z"
          fill="white"
        />
        <path
          d="M154.526 0.47998H7.99998C3.8468 0.47998 0.47998 3.8468 0.47998 7.99998V40C0.47998 44.1532 3.8468 47.52 7.99998 47.52H154.526C158.68 47.52 162.046 44.1532 162.046 40V7.99998C162.046 3.8468 158.68 0.47998 154.526 0.47998Z"
          stroke="#A6A6A6"
          strokeWidth="1.2"
        />
      </g>
      <defs>
        <clipPath id="clip0_1344_25358">
          <rect width="163.2" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  tricycle: (
    <svg
      width="512"
      height="226"
      viewBox="0 0 512 226"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M239.703 147.939L239.68 154.075L257.087 154.14L257.109 148.003L239.703 147.939Z"
        fill="#EDC7CB"
      />
      <path
        d="M247.579 152.879L222.375 164.04C221.844 164.275 221.479 164.744 221.27 165.288C220.93 166.176 220.186 166.906 219.139 167.166C217.866 167.482 216.472 166.895 215.798 165.764C214.827 164.138 215.515 162.083 217.185 161.343C218.04 160.964 218.971 161.011 219.75 161.389C220.265 161.638 220.849 161.706 221.372 161.474L246.474 150.359C247.16 150.055 247.961 150.367 248.263 151.056L248.274 151.082C248.577 151.771 248.265 152.576 247.58 152.878L247.579 152.879Z"
        fill="#FFE4E0"
      />
      <path
        d="M380.789 160.021H399.185C406.303 160.021 412.509 154.937 413.939 147.932L422.554 105.779L417.828 104.803L409.214 146.956C408.24 151.718 404.023 155.173 399.185 155.173H380.789C375.951 155.173 371.732 151.718 370.76 146.956L362.145 104.803L357.42 105.779L366.034 147.932C367.465 154.937 373.671 160.021 380.789 160.021Z"
        fill="#F4D1D4"
      />
      <path
        d="M316.968 147.403H283.072V156.704H316.968V147.403Z"
        fill="#F4D1D4"
      />
      <path
        d="M243.337 72.9396L237.486 76.2419L287.493 165.658L293.343 162.355L243.337 72.9396Z"
        fill="#F4D1D4"
      />
      <path
        d="M389.948 160.276H201.783V167.401H389.948V160.276Z"
        fill="#F4D1D4"
      />
      <path
        d="M446.232 129.009H341.504V138.311H446.232V129.009Z"
        fill="#F4D1D4"
      />
      <path
        d="M348.476 89.7491H430.095V108.06H348.476C345.546 108.06 343.17 105.673 343.17 102.729V95.0804C343.17 92.1364 345.546 89.7491 348.476 89.7491V89.7491Z"
        fill="#F4D1D4"
      />
      <path
        d="M498.896 89.2357L492.316 111.799L281.285 111.794L277.9 89.2427L498.896 89.2357Z"
        fill="#F4D1D4"
      />
      <path
        d="M493.951 113.147L486.451 135.711H286.835L281.322 113.16L493.951 113.147Z"
        fill="#F4D1D4"
      />
      <path
        d="M341.504 138.311L316.967 156.704V147.403L341.504 129.009V138.311Z"
        fill="#F4D1D4"
      />
      <path
        d="M243.354 70.5983H110.609V76.0826H243.354V70.5983Z"
        fill="#F4D1D4"
      />
      <path
        d="M238.084 82.8575H123.37V88.3419H238.084V82.8575Z"
        fill="#F4D1D4"
      />
      <path
        d="M111.173 71.5239L222.139 162.562L218.285 166.989L107.319 75.9515L111.173 71.5239Z"
        fill="#F4D1D4"
      />
      <path
        d="M109.374 84.1014L205.555 163.009L201.7 167.438L105.52 88.5302L109.374 84.1014Z"
        fill="#F4D1D4"
      />
      <path
        d="M244.538 52.1525L226.344 124.39L231.156 125.613L249.35 53.3758L244.538 52.1525Z"
        fill="#FFE4E0"
      />
      <path
        d="M112.092 46.267L99.8789 93.8153L105.357 95.2355L117.57 47.6872L112.092 46.267Z"
        fill="#FFE4E0"
      />
      <path
        d="M105.595 64.738L98.6465 91.7896L107.411 94.0619L114.36 67.0104L105.595 64.738Z"
        fill="#F4D1D4"
      />
      <path
        d="M240.495 62.7184L214.708 165.102L221.528 166.836L247.315 64.4522L240.495 62.7184Z"
        fill="#F4D1D4"
      />
      <path
        d="M203.506 164.308C203.506 172.644 210.233 179.402 218.53 179.402C226.827 179.402 233.553 172.644 233.553 164.308C233.553 155.973 226.827 149.215 218.53 149.215C210.233 149.215 203.506 155.973 203.506 164.308V164.308ZM228.054 165.715C225.777 166.459 223.333 165.207 222.593 162.92C221.853 160.632 223.099 158.177 225.375 157.433C227.652 156.69 230.097 157.941 230.837 160.229C231.577 162.516 230.331 164.972 228.054 165.715ZM221.041 167.719C222.977 166.305 225.688 166.736 227.095 168.681C228.502 170.627 228.073 173.35 226.135 174.763C224.199 176.177 221.489 175.746 220.082 173.799C218.674 171.854 219.104 169.131 221.04 167.717L221.041 167.719ZM218.53 159.954C216.136 159.954 214.195 158.004 214.195 155.599C214.195 153.195 216.135 151.245 218.53 151.245C220.924 151.245 222.864 153.195 222.864 155.599C222.864 158.004 220.924 159.954 218.53 159.954ZM209.965 168.681C211.372 166.736 214.082 166.305 216.019 167.719C217.955 169.133 218.384 171.855 216.977 173.8C215.569 175.746 212.86 176.177 210.923 174.764C208.987 173.35 208.558 170.628 209.964 168.683L209.965 168.681ZM206.223 160.229C206.963 157.942 209.407 156.69 211.684 157.433C213.961 158.177 215.207 160.632 214.467 162.92C213.727 165.206 211.282 166.459 209.006 165.715C206.729 164.972 205.483 162.516 206.223 160.229Z"
        fill="#EDBDC1"
      />
      <path
        d="M200.792 164.308C200.792 154.482 208.749 146.488 218.53 146.488C225.944 146.488 358.838 154.981 390.982 158.992C394.26 159.402 396.065 161.29 396.065 164.308C396.065 167.704 393.437 169.036 391.233 169.557C359.126 177.13 228.595 182.13 218.53 182.13C208.464 182.13 200.792 174.136 200.792 164.31V164.308ZM202.664 164.308C202.664 173.099 209.78 180.249 218.53 180.249C228.577 180.249 358.826 175.268 390.804 167.726C394.193 166.927 394.193 165.024 394.193 164.308C394.193 163.593 394.193 161.289 390.752 160.859C358.646 156.852 225.934 148.369 218.531 148.369C209.781 148.369 202.666 155.519 202.666 164.308H202.664Z"
        fill="#FFD8D8"
      />
      <path
        d="M188.147 176.21L214.527 164.353C215.057 164.115 215.419 163.644 215.625 163.099C215.961 162.208 216.7 161.475 217.746 161.209C218.962 160.901 220.302 161.409 221.006 162.453C222.114 164.093 221.448 166.25 219.733 167.022C218.849 167.418 217.88 167.359 217.082 166.946C216.579 166.687 215.974 166.72 215.458 166.952L189.267 178.725L188.147 176.211V176.21Z"
        fill="#FFE4E0"
      />
      <path
        d="M196.106 175.206L178.7 175.264L178.72 181.4L196.127 181.342L196.106 175.206Z"
        fill="#EDC7CB"
      />
      <path
        d="M377.626 153.602H402.347C403.42 153.602 404.291 154.478 404.291 155.555V160.186C404.291 161.264 403.42 162.139 402.347 162.139H377.626C376.553 162.139 375.682 161.264 375.682 160.186V155.555C375.682 154.478 376.553 153.602 377.626 153.602V153.602Z"
        fill="#EDBDC1"
      />
      <path
        d="M340.616 164.308C340.616 191.645 362.674 213.806 389.885 213.806C417.095 213.806 439.154 191.645 439.154 164.308C439.154 136.971 417.095 114.81 389.885 114.81C362.674 114.81 340.616 136.971 340.616 164.308ZM344.402 164.308C344.402 139.072 364.765 118.614 389.885 118.614C415.004 118.614 435.368 139.072 435.368 164.308C435.368 189.544 415.004 210.003 389.885 210.003C364.765 210.003 344.402 189.544 344.402 164.308Z"
        fill="#DFA6AC"
      />
      <path
        d="M381.695 164.308C381.695 168.853 385.362 172.537 389.885 172.537C394.409 172.537 398.076 168.853 398.076 164.308C398.076 159.764 394.409 156.079 389.885 156.079C385.362 156.079 381.695 159.764 381.695 164.308Z"
        fill="#EDC5C5"
      />
      <path
        d="M445.339 149.626L449.937 148.158C441.597 121.771 417.463 104.044 389.885 104.044C362.306 104.044 339.659 120.8 330.649 145.743L335.185 147.396C343.504 124.365 365.486 108.891 389.885 108.891C414.284 108.891 437.638 125.262 445.34 149.627L445.339 149.626Z"
        fill="#FFE4E0"
      />
      <path
        d="M384.641 164.308C384.641 167.218 386.988 169.577 389.885 169.577C392.782 169.577 395.129 167.218 395.129 164.308C395.129 161.399 392.782 159.04 389.885 159.04C386.988 159.04 384.641 161.399 384.641 164.308Z"
        fill="#EDBDC1"
      />
      <path
        d="M337.437 164.308C337.437 193.408 360.918 217 389.885 217C418.851 217 442.332 193.408 442.332 164.308C442.332 135.208 418.85 111.617 389.885 111.617C360.919 111.617 337.437 135.208 337.437 164.308ZM342.599 164.308C342.599 138.072 363.77 116.803 389.885 116.803C415.999 116.803 437.17 138.072 437.17 164.308C437.17 190.545 415.999 211.814 389.885 211.814C363.77 211.814 342.599 190.545 342.599 164.308Z"
        fill="#EDC7CB"
      />
      <path
        d="M23.1783 164.308C23.1783 191.645 45.2369 213.806 72.4472 213.806C99.6575 213.806 121.716 191.645 121.716 164.308C121.716 136.971 99.6575 114.81 72.4472 114.81C45.2369 114.81 23.1783 136.971 23.1783 164.308ZM26.9643 164.308C26.9643 139.072 47.3278 118.614 72.4472 118.614C97.5666 118.614 117.93 139.072 117.93 164.308C117.93 189.544 97.5666 210.003 72.4472 210.003C47.3278 210.003 26.9643 189.544 26.9643 164.308Z"
        fill="#DFA6AC"
      />
      <path
        d="M65.9496 164.309C65.9496 167.914 68.8592 170.837 72.4476 170.837C76.0361 170.837 78.9457 167.914 78.9457 164.309C78.9457 160.704 76.0361 157.78 72.4476 157.78C68.8592 157.78 65.9496 160.704 65.9496 164.309Z"
        fill="#DFA6AC"
      />
      <path
        d="M128.241 164.997H131.53C131.53 132.191 104.965 105.501 72.3112 105.501C62.4521 105.501 52.6912 107.985 44.0825 112.684L45.6528 115.587C53.7811 111.152 62.9994 108.806 72.3112 108.806C103.152 108.806 128.241 134.013 128.241 164.997Z"
        fill="#FFE4E0"
      />
      <path
        d="M20 164.308C20 193.408 43.481 217 72.4475 217C101.414 217 124.895 193.408 124.895 164.308C124.895 135.208 101.414 111.617 72.4475 111.617C43.481 111.617 20 135.208 20 164.308ZM25.1622 164.308C25.1622 138.072 46.3328 116.803 72.4475 116.803C98.5621 116.803 119.733 138.072 119.733 164.308C119.733 190.545 98.5621 211.814 72.4475 211.814C46.3328 211.814 25.1622 190.546 25.1622 164.308Z"
        fill="#EDC7CB"
      />
      <path
        d="M70.5372 105.538V162.471H74.5148V105.538C74.5148 104.446 73.6339 103.56 72.5462 103.56H72.507C71.4193 103.56 70.5372 104.446 70.5372 105.538V105.538Z"
        fill="#F4D1D4"
      />
      <path
        d="M71.2267 168.228C71.3006 168.228 71.3745 168.226 71.4484 168.221C87.1335 167.172 90.5292 153.81 92.1595 147.389L104.153 100.701C104.608 98.9331 103.551 97.1305 101.791 96.6746C100.027 96.2164 98.2373 97.2813 97.7847 99.0479L85.785 145.754C83.7575 153.732 81.1019 160.949 71.0108 161.626C69.1981 161.746 67.8264 163.322 67.9476 165.143C68.0631 166.888 69.5087 168.227 71.2267 168.227V168.228Z"
        fill="#F4D1D4"
      />
      <path
        d="M108.099 95.7393L106.258 102.906L95.4055 100.091L97.2471 92.9252C97.4457 92.1503 98.2331 91.6852 99.0032 91.8847L107.063 93.975C107.835 94.1745 108.298 94.9656 108.099 95.7393Z"
        fill="#DFA6AC"
      />
      <path
        d="M110.06 47.668H116.639C120.563 47.668 123.715 45.7355 126.498 44.0292C128.989 42.5015 131.344 41.0585 134 41.0585H150.814C152.327 41.0585 153.555 39.8255 153.555 38.3048C153.555 36.7841 152.327 35.551 150.814 35.551H134C129.803 35.551 126.53 37.5578 123.642 39.3279C121.164 40.8474 119.023 42.1605 116.64 42.1605H110.061C108.547 42.1605 107.32 43.3936 107.32 44.9143C107.32 46.435 108.547 47.668 110.061 47.668H110.06Z"
        fill="#FFE4E0"
      />
      <path
        d="M140.412 41.6095H157.225C159.043 41.6095 160.515 40.1294 160.515 38.3047C160.515 36.4801 159.043 35 157.225 35H140.412C138.595 35 137.853 36.4801 137.853 38.3047C137.853 40.1294 138.595 41.6095 140.412 41.6095Z"
        fill="#EDC7CB"
      />
      <path
        d="M111.156 51.8917H120.294C122.667 51.8917 124.851 51.2177 127.162 50.5055C130.078 49.6065 133.382 48.5869 138.021 48.5869C145.428 48.5869 150.945 49.8188 151 49.8316C151.881 50.0311 152.765 49.4743 152.966 48.5834C153.166 47.6926 152.611 46.8087 151.724 46.6068C151.486 46.5535 145.79 45.281 138.021 45.281C132.889 45.281 129.177 46.4259 126.196 47.3457C124.038 48.0116 122.174 48.5857 120.294 48.5857H111.156C110.249 48.5857 109.512 49.3258 109.512 50.2375C109.512 51.1493 110.249 51.8905 111.156 51.8905V51.8917Z"
        fill="#EEEEEF"
      />
      <path
        d="M117.013 41.4261H115.35C115.052 41.4261 114.811 41.6687 114.811 41.9679V52.0839C114.811 52.3831 115.052 52.6256 115.35 52.6256H117.013C117.311 52.6256 117.552 52.3831 117.552 52.0839V41.9679C117.552 41.6687 117.311 41.4261 117.013 41.4261Z"
        fill="#DFA6AC"
      />
      <path
        d="M63.8904 165.354C68.3968 165.689 73.0279 163.197 73.2392 160.323L72.0349 160.233C71.8883 162.225 68.0643 164.48 63.977 164.176C56.6661 163.632 53.2843 157.322 53.7231 151.369C54.1688 145.324 56.3198 130.987 66.6545 128.409C76.3289 125.995 87.3726 115.745 91.2705 105.56C93.0012 101.04 96.6255 91.125 99.8249 82.3754C103.059 73.5295 107.27 62.1757 107.635 61.4009C108.533 59.4869 110.214 58.9963 110.725 59.0345L111.796 59.1146L111.882 57.9361L110.812 57.856C109.915 57.7887 107.69 58.4464 106.537 60.9044C106.152 61.7268 102.072 72.7187 98.6888 81.974C95.4917 90.719 91.8674 100.632 90.1413 105.142C86.3646 115.011 75.6915 124.935 66.3509 127.265C55.2587 130.031 52.983 144.981 52.5188 151.28C52.0374 157.818 55.7887 164.752 63.8904 165.355V165.354Z"
        fill="#C47B7B"
      />
      <path
        d="M107.941 51.7951H110.633V49.0414H107.941C107.358 49.0414 106.886 49.5158 106.886 50.1016V50.7349C106.886 51.3207 107.358 51.7951 107.941 51.7951V51.7951Z"
        fill="#AF9292"
      />
      <path
        d="M216.011 45.2658L263.596 40.8591C265.262 40.8591 269.677 47.0812 269.677 48.9371V50.2235C269.677 53.4912 267.301 56.1394 264.369 56.1394H248.461C247.207 56.1394 242.531 54.9295 238.143 54.0862C235.232 53.5271 232.225 53.7058 229.406 54.6198C221.644 57.1346 207.185 51.3452 216.011 45.267V45.2658Z"
        fill="#EDC5C5"
      />
      <path
        d="M499.366 64.8007L495.104 87.3655H277.9L272.464 62.1177L499.366 64.8007Z"
        fill="#F4D1D4"
      />
    </svg>
  ),
  kbLogoWithName: (
    <svg
      width="58"
      height="64"
      viewBox="0 0 58 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.1319 6.14923V44.3228L41.3772 44.6209C41.4712 44.6288 41.5659 44.6173 41.6553 44.5873C41.7448 44.5572 41.8271 44.5091 41.8973 44.446C41.9674 44.3829 42.0239 44.3061 42.0632 44.2203C42.1026 44.1346 42.1239 44.0416 42.126 43.9473V6.44838C42.1282 6.37898 42.1161 6.30986 42.0905 6.2453C42.0649 6.18074 42.0264 6.12211 41.9773 6.07303C41.9282 6.02394 41.8695 5.98545 41.8049 5.95992C41.7404 5.93439 41.6712 5.92236 41.6018 5.92458C40.7284 5.9867 40.1147 6.04883 39.501 6.11095C39.3787 6.12334 39.2563 6.13572 39.1319 6.14811V6.14923ZM39.1319 3.15396L43.7726 2.70505C43.9463 2.68093 44.123 2.69358 44.2914 2.74218C44.4598 2.79077 44.6162 2.87423 44.7502 2.98713C44.8843 3.10003 44.9932 3.23985 45.0697 3.39753C45.1463 3.55521 45.1889 3.72722 45.1947 3.90241V46.7172C45.1947 48.1392 44.4462 48.9625 42.8744 48.7382L39.2067 47.9898C39.2067 48.1044 39.2073 48.2187 39.2078 48.3324V48.3328C39.216 50.149 39.2234 51.7892 37.1112 51.5077C36.3624 51.4332 9.86544 48.1392 9.26676 48.0647C8.88341 47.9811 8.53752 47.7754 8.28104 47.4785C8.02456 47.1816 7.87134 46.8094 7.84438 46.418V6.22411C7.84438 6.16438 7.8442 6.10465 7.84401 6.04502C7.84049 4.9093 7.83707 3.81034 9.117 3.45461C9.6408 3.37973 36.4372 0.0111719 36.8113 0.0111719C37.7098 -0.0633372 38.3085 0.234699 38.6826 0.909751C39.055 1.43335 39.1318 2.18179 39.1319 3.15396ZM49.1112 62.0262V63.9351H47.5513V55.2921H49.1112V60.1724L51.0197 57.4562H52.7815L50.7258 60.1724L53.0382 63.9351H51.1296L49.661 61.3292L49.1112 62.0262ZM1.61498 61.53V63.934H0V55.2909H1.61498V59.3103L4.07378 55.2909H5.9272L3.41289 58.9046L6.23939 63.934H4.36772L2.4588 60.2268L1.61498 61.53ZM45.1104 60.0614C45.1104 59.1624 44.7069 58.7038 44.0091 58.7038C43.2566 58.7038 42.8896 59.1624 42.8896 60.0614V61.2729C42.8896 62.1718 43.2566 62.6308 44.0091 62.6308C44.7066 62.6308 45.1104 62.1722 45.1104 61.2729V60.0614ZM41.3849 61.2729V60.0614C41.3849 59.1077 41.5869 58.465 42.101 58.0064C42.3573 57.772 42.6588 57.5925 42.987 57.4789C43.3152 57.3653 43.6632 57.3201 44.0095 57.3459C44.3557 57.3217 44.7033 57.3678 45.0312 57.4813C45.3592 57.5948 45.6609 57.7734 45.9181 58.0064C46.4139 58.465 46.6158 59.1077 46.6158 60.0614V61.2729C46.6158 62.227 46.4139 62.8879 45.9181 63.3282C45.6609 63.5612 45.3592 63.7399 45.0312 63.8534C44.7033 63.9669 44.3557 64.0129 44.0095 63.9888C43.6632 64.0146 43.3152 63.9693 42.987 63.8557C42.6588 63.7421 42.3573 63.5626 42.101 63.3282C41.5869 62.8879 41.3849 62.227 41.3849 61.2729ZM39.0174 60.0614C39.0174 59.1624 38.6691 58.7038 37.9717 58.7038C37.2191 58.7038 36.8518 59.1624 36.8518 60.0614V61.2729C36.8518 62.1718 37.2191 62.6308 37.9717 62.6308C38.6687 62.6308 39.0174 62.1722 39.0174 61.2729V60.0614ZM35.292 61.2729V60.0614C35.264 59.6881 35.3131 59.313 35.4363 58.9594C35.5595 58.6059 35.7541 58.2815 36.008 58.0064C36.5525 57.5407 37.2563 57.3039 37.9717 57.3459C38.3179 57.3217 38.6654 57.3678 38.9934 57.4813C39.3214 57.5948 39.623 57.7734 39.8802 58.0064C40.1273 58.2853 40.3163 58.6107 40.4361 58.9636C40.5558 59.3165 40.604 59.6897 40.5776 60.0614V61.2729C40.6057 61.6448 40.5584 62.0185 40.4385 62.3717C40.3187 62.7249 40.1288 63.0502 39.8802 63.3282C39.623 63.5612 39.3214 63.7398 38.9934 63.8533C38.6654 63.9669 38.3179 64.0129 37.9717 63.9888C37.2563 64.0307 36.5525 63.794 36.008 63.3282C35.549 62.8879 35.292 62.227 35.292 61.2729ZM32.9077 60.0614C32.9335 59.6894 32.8298 59.3199 32.6141 59.0156C32.523 58.9069 32.4071 58.8218 32.2761 58.7675C32.145 58.7132 32.0028 58.6914 31.8616 58.7038C31.7169 58.6935 31.572 58.72 31.4403 58.7809C31.3087 58.8418 31.1947 58.9352 31.109 59.0522C30.8896 59.3414 30.7792 59.6988 30.7972 60.0614V61.2729C30.7761 61.6359 30.8869 61.9943 31.109 62.2821C31.2033 62.4037 31.3268 62.4993 31.468 62.5602C31.6093 62.6212 31.7636 62.6453 31.9167 62.6305C32.559 62.6305 32.9077 62.1719 32.9077 61.2725V60.0614ZM30.7599 63.9359H29.2355V55.2928H30.7953V58.0642C30.9672 57.8386 31.1895 57.6563 31.4445 57.5321C31.6994 57.4078 31.9799 57.3449 32.2635 57.3485C32.5646 57.3342 32.8652 57.3859 33.1442 57.5C33.4231 57.6141 33.6738 57.7878 33.8785 58.009C34.3103 58.5895 34.5187 59.306 34.4657 60.0275V61.3314C34.5191 62.0473 34.3104 62.7582 33.8785 63.3316C33.6815 63.5476 33.4401 63.7184 33.1708 63.8324C32.9016 63.9464 32.6109 64.0009 32.3187 63.9921C32.0255 64.0081 31.7325 63.9569 31.4621 63.8424C31.1917 63.7279 30.9511 63.5532 30.7585 63.3316L30.7599 63.9359ZM26.6493 61.6235V61.128H25.4944C24.8517 61.128 24.5399 61.4216 24.5399 61.9357C24.5399 62.4863 24.8521 62.743 25.4944 62.743C25.8979 62.743 26.2097 62.6882 26.3568 62.4863C26.5643 62.2484 26.6698 61.9385 26.6508 61.6235H26.6493ZM28.1737 59.6598V63.9362H26.6478V63.3856C26.4667 63.5803 26.2481 63.7364 26.0051 63.8446C25.7303 63.9503 25.4371 64.0001 25.1427 63.991C24.8628 64.017 24.5805 63.9865 24.3125 63.9014C24.0446 63.8163 23.7965 63.6783 23.5829 63.4955C23.2101 63.0774 23.0129 62.5316 23.0322 61.9718C23.0212 61.7087 23.0699 61.4466 23.1748 61.2051C23.2797 60.9635 23.4379 60.7489 23.6376 60.5774C24.0953 60.2144 24.6701 60.0315 25.2534 60.0633H26.6478V59.5674C26.6685 59.4244 26.6558 59.2785 26.6108 59.1412C26.5658 59.0039 26.4897 58.8788 26.3884 58.7758C26.2871 58.6728 26.1633 58.5945 26.0268 58.5472C25.8903 58.4999 25.7447 58.4848 25.6013 58.503C25.3459 58.5032 25.0988 58.5941 24.9043 58.7597C24.8251 58.8283 24.7613 58.9128 24.717 59.0078C24.6727 59.1027 24.6489 59.206 24.6472 59.3107V59.3655H23.1786V59.3107C23.1754 59.0353 23.2329 58.7626 23.3471 58.512C23.4612 58.2614 23.6293 58.039 23.8392 57.8608C24.3542 57.5008 24.9732 57.3203 25.6009 57.347C26.2809 57.311 26.9531 57.5048 27.5095 57.8973C27.744 58.1231 27.925 58.3985 28.0394 58.7033C28.1537 59.0082 28.1985 59.3347 28.1704 59.659L28.1737 59.6598ZM21.2351 61.9334C21.2351 62.3738 21.437 62.6305 21.896 62.6305H22.3527V63.9344H21.6371C21.122 63.9429 20.6209 63.7672 20.224 63.4389C20.0404 63.2535 19.8968 63.0324 19.802 62.7893C19.7073 62.5462 19.6635 62.2862 19.6734 62.0254V58.5023H18.7744V57.4014H19.6741V56.153L21.2351 55.5838V57.4007H22.5017V58.5015H21.2351V61.9334ZM16.6472 61.6212V61.1257H15.5262C14.8839 61.1257 14.5352 61.4193 14.5352 61.9334C14.5352 62.484 14.8288 62.7407 15.4893 62.7407C15.6488 62.7602 15.8106 62.7476 15.9652 62.7035C16.1197 62.6594 16.2638 62.5848 16.389 62.484C16.5605 62.2293 16.6501 61.9283 16.6457 61.6212H16.6472ZM18.2059 59.659V63.934H16.6822V63.3834C16.475 63.5715 16.2399 63.7263 15.9852 63.8423C15.7105 63.9497 15.4167 63.9995 15.122 63.9888C14.5638 64.0258 14.0125 63.8486 13.5804 63.4933C13.3894 63.2896 13.2407 63.0501 13.1431 62.7885C13.0454 62.5269 13.0007 62.2486 13.0115 61.9696C13.0005 61.7064 13.0493 61.4442 13.1543 61.2027C13.2593 60.9611 13.4177 60.7466 13.6176 60.5751C14.1005 60.2207 14.6888 60.0395 15.2874 60.061H16.6457V59.5674C16.6658 59.4229 16.6522 59.2757 16.6058 59.1373C16.5594 58.999 16.4815 58.8733 16.3783 58.7701C16.2751 58.667 16.1494 58.5892 16.011 58.5428C15.8727 58.4965 15.7255 58.4828 15.581 58.503C15.342 58.5031 15.1122 58.595 14.9391 58.7597C14.8471 58.8202 14.7709 58.9018 14.7166 58.9976C14.6624 59.0934 14.6318 59.2007 14.6272 59.3107V59.3655H13.2134V59.3107C13.198 59.0335 13.2501 58.7568 13.3653 58.5042C13.4805 58.2516 13.6553 58.0308 13.8747 57.8608C14.3821 57.4854 15.0068 57.3032 15.6365 57.347C16.2997 57.307 16.9559 57.5018 17.4899 57.8973C17.7327 58.1192 17.923 58.3925 18.0469 58.6973C18.1708 59.002 18.2251 59.3306 18.2059 59.659ZM8.44188 55.2898V58.0061C8.61695 57.764 8.86945 57.5891 9.15754 57.5102C9.40543 57.3977 9.67512 57.3413 9.94733 57.3452C10.2357 57.327 10.5246 57.3718 10.7939 57.4764C11.0633 57.581 11.3066 57.7429 11.5072 57.9509C11.9003 58.4304 12.1027 59.0381 12.0757 59.6575V63.934H10.5158V59.8595C10.5225 59.7051 10.4983 59.551 10.4448 59.406C10.3912 59.2611 10.3094 59.1283 10.204 59.0153C10.1207 58.9119 10.014 58.8298 9.89279 58.7756C9.77157 58.7214 9.63922 58.6966 9.50661 58.7035C9.3664 58.7003 9.22707 58.7265 9.09751 58.7801C8.96794 58.8338 8.85098 58.9139 8.75407 59.0153C8.64866 59.1282 8.5668 59.2611 8.51326 59.406C8.45973 59.5509 8.43558 59.7051 8.44225 59.8595V63.9336H6.88203V55.2906L8.44188 55.2898ZM56.8016 52.2513C56.4703 52.0568 56.0957 51.9596 55.678 51.9596C55.253 51.9596 54.8749 52.0568 54.5436 52.2513C54.2123 52.4386 53.953 52.7015 53.7657 53.04C53.5784 53.3713 53.4848 53.7458 53.4848 54.1636C53.4848 54.5813 53.5784 54.9595 53.7657 55.298C53.953 55.6365 54.2123 55.903 54.5436 56.0975C54.8749 56.2847 55.253 56.3784 55.678 56.3784C56.0957 56.3784 56.4703 56.2847 56.8016 56.0975C57.1329 55.903 57.3922 55.6365 57.5795 55.298C57.7667 54.9595 57.8604 54.5813 57.8604 54.1636C57.8604 53.7458 57.7667 53.3713 57.5795 53.04C57.3922 52.7015 57.1329 52.4386 56.8016 52.2513ZM56.9312 55.4492C56.6143 55.7806 56.1966 55.9462 55.678 55.9462C55.1522 55.9462 54.7308 55.7806 54.4139 55.4492C54.1042 55.1179 53.9494 54.6894 53.9494 54.1636C53.9494 53.6378 54.1042 53.2092 54.4139 52.8779C54.7308 52.5466 55.1522 52.381 55.678 52.381C56.1966 52.381 56.6143 52.5466 56.9312 52.8779C57.2553 53.2092 57.4174 53.6378 57.4174 54.1636C57.4174 54.6894 57.2553 55.1179 56.9312 55.4492ZM56.5099 54.1528C56.6035 54.0303 56.6503 53.8827 56.6503 53.7098C56.6503 53.4865 56.5747 53.3101 56.4234 53.1804C56.2794 53.0508 56.0849 52.986 55.84 52.986H54.8029V55.3088H55.3647V54.4445H55.5483L56.0669 55.3088L56.7476 55.298L56.1425 54.4013C56.301 54.3508 56.4234 54.268 56.5099 54.1528ZM55.8076 53.9799H55.3647V53.4937H55.8076C55.8869 53.4937 55.9517 53.5154 56.0021 53.5586C56.0597 53.5946 56.0885 53.6522 56.0885 53.7314C56.0885 53.8107 56.0597 53.8719 56.0021 53.9151C55.9517 53.9583 55.8869 53.9799 55.8076 53.9799Z"
        fill="#DC343B"
      />
    </svg>
  ),
  googlePlayIocn: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1284_24699"
        maskUnits="userSpaceOnUse"
        x="5"
        y="2"
        width="19"
        height="20"
      >
        <path
          d="M22.5363 10.8003C23.4879 11.324 23.4879 12.676 22.5363 13.1997L7.3172 21.5744C6.39039 22.0844 5.25 21.4226 5.25 20.3747L5.25 3.6253C5.25 2.57743 6.39039 1.91561 7.3172 2.42561L22.5363 10.8003Z"
          fill="#C4C4C4"
        />
      </mask>
      <g mask="url(#mask0_1284_24699)">
        <path
          d="M5.72604 21.4099L15.2192 11.8633L5.88239 2.474C5.5099 2.71279 5.25 3.12505 5.25 3.6253V20.3747C5.25 20.8015 5.43917 21.1642 5.72604 21.4099Z"
          fill="url(#paint0_linear_1284_24699)"
        />
        <path
          d="M22.5363 10.8003C23.4879 11.324 23.4879 12.676 22.5363 13.1997L18.6968 15.3125L15.2192 11.8633L18.5195 8.58997L22.5363 10.8003Z"
          fill="url(#paint1_linear_1284_24699)"
        />
        <path
          d="M18.6969 15.3125L15.2193 11.8633L5.72607 21.4099C6.14354 21.7673 6.76792 21.8767 7.31726 21.5744L18.6969 15.3125Z"
          fill="url(#paint2_linear_1284_24699)"
        />
        <path
          d="M5.88232 2.47399L15.2191 11.8633L18.5194 8.58996L7.31711 2.42561C6.83277 2.15909 6.29009 2.2126 5.88232 2.47399Z"
          fill="url(#paint3_linear_1284_24699)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1284_24699"
          x1="11.7577"
          y1="8.15536"
          x2="5.30329"
          y2="14.6628"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00C3FF" />
          <stop offset="1" stopColor="#1BE2FA" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1284_24699"
          x1="15.2192"
          y1="11.8633"
          x2="23.8039"
          y2="11.8633"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFCE00" />
          <stop offset="1" stopColor="#FFEA00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1284_24699"
          x1="5.52699"
          y1="22.5752"
          x2="16.9463"
          y2="13.4201"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DE2453" />
          <stop offset="1" stopColor="#FE3944" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1284_24699"
          x1="6.08068"
          y1="1.42603"
          x2="16.948"
          y2="10.3024"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#11D574" />
          <stop offset="1" stopColor="#01F176" />
        </linearGradient>
      </defs>
    </svg>
  ),
  appleIcon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.5 12C22.5 17.796 17.8012 22.5 12 22.5C6.19875 22.5 1.5 17.796 1.5 12C1.5 6.19875 6.19875 1.5 12 1.5C17.8012 1.5 22.5 6.19875 22.5 12Z"
        fill="#283544"
      />
      <path
        d="M16.9216 9.34304C16.8643 9.37646 15.5003 10.0819 15.5003 11.6459C15.5646 13.4296 17.2216 14.0551 17.25 14.0551C17.2216 14.0885 16.9998 14.9072 16.343 15.7654C15.8217 16.5047 15.2432 17.25 14.3646 17.25C13.5289 17.25 13.2289 16.7573 12.2646 16.7573C11.229 16.7573 10.936 17.25 10.1431 17.25C9.26458 17.25 8.64315 16.4647 8.09345 15.7324C7.37932 14.7739 6.77233 13.2698 6.7509 11.8256C6.73646 11.0603 6.89392 10.308 7.29361 9.66904C7.85774 8.77699 8.86489 8.17143 9.96473 8.15146C10.8074 8.12498 11.5574 8.6906 12.0717 8.6906C12.5646 8.6906 13.486 8.15146 14.5286 8.15146C14.9786 8.1519 16.1786 8.27822 16.9216 9.34304ZM12.0005 7.99866C11.8505 7.29978 12.2646 6.60089 12.6503 6.15508C13.1432 5.61594 13.9216 5.25 14.5929 5.25C14.6357 5.94889 14.3641 6.63432 13.8787 7.13352C13.4432 7.67266 12.6932 8.07853 12.0005 7.99866Z"
        fill="white"
      />
    </svg>
  ),
  arrowTopRight: (
    <svg
      width="16"
      height="18"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 7L7 17"
        stroke="#737373"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 7H17V16"
        stroke="#737373"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  baLogoWithName: (
    <svg
      width="67"
      height="64"
      viewBox="0 0 67 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.8868 22.5105C48.1549 21.5226 49.1806 20.2581 49.8857 18.8135C50.5909 17.3689 50.9568 15.7823 50.9557 14.1748V10.5728C50.9555 7.76885 49.8417 5.07979 47.859 3.09707C45.8764 1.11434 43.1874 0.000349449 40.3834 0.000112302H39.7601C39.7016 0.000112302 39.6448 0.000112301 39.5862 0.00324216C39.5659 0.000680885 39.5454 -0.000365291 39.5249 0.000112302H13.9576C12.3573 0.000112302 10.2943 1.63569 10.2943 3.65132V43.5432C10.2943 45.5553 12.3573 47.1913 13.9576 47.1913H40.3825C41.7707 47.1914 43.1453 46.9181 44.4278 46.387C45.7104 45.8558 46.8757 45.0773 47.8574 44.0957C48.839 43.1142 49.6177 41.949 50.149 40.6665C50.6803 39.384 50.9538 38.0095 50.9539 36.6213V33.0219C50.9552 31.4142 50.5894 29.8273 49.8842 28.3824C49.1791 26.9374 48.1533 25.6727 46.885 24.6844C46.7197 24.5556 46.5859 24.3907 46.4939 24.2023C46.4019 24.014 46.3541 23.8071 46.3541 23.5975C46.3541 23.3879 46.4019 23.181 46.4939 22.9926C46.5859 22.8043 46.7197 22.6394 46.885 22.5105H46.8868ZM21.6847 36.9285C21.6847 37.6381 21.4028 38.3186 20.9011 38.8204C20.3993 39.3222 19.7188 39.604 19.0091 39.604C18.2995 39.604 17.619 39.3222 17.1172 38.8204C16.6155 38.3186 16.3336 37.6381 16.3336 36.9285V27.1602C16.3336 26.4506 16.6155 25.77 17.1172 25.2682C17.619 24.7665 18.2995 24.4846 19.0091 24.4846C19.7188 24.4846 20.3993 24.7665 20.9011 25.2682C21.4028 25.77 21.6847 26.4506 21.6847 27.1602V36.9285ZM30.9098 36.9285C30.9098 37.6381 30.6279 38.3186 30.1261 38.8204C29.6243 39.3222 28.9438 39.604 28.2342 39.604C27.5246 39.604 26.844 39.3222 26.3423 38.8204C25.8405 38.3186 25.5586 37.6381 25.5586 36.9285V19.5846C25.5586 18.8749 25.8405 18.1944 26.3423 17.6926C26.844 17.1909 27.5246 16.909 28.2342 16.909C28.9438 16.909 29.6243 17.1909 30.1261 17.6926C30.6279 18.1944 30.9098 18.8749 30.9098 19.5846V36.9285ZM40.1335 36.9285C40.1335 37.6381 39.8516 38.3186 39.3498 38.8204C38.8481 39.3222 38.1675 39.604 37.4579 39.604C36.7483 39.604 36.0677 39.3222 35.566 38.8204C35.0642 38.3186 34.7823 37.6381 34.7823 36.9285V12.0456C34.7823 11.336 35.0642 10.6555 35.566 10.1537C36.0677 9.65192 36.7483 9.37003 37.4579 9.37003C38.1675 9.37003 38.8481 9.65192 39.3498 10.1537C39.8516 10.6555 40.1335 11.336 40.1335 12.0456V36.9285ZM7.44159 59.2256C7.4631 59.5906 7.40641 59.9559 7.27533 60.2972C7.14424 60.6385 6.94178 60.9478 6.68148 61.2046C6.09433 61.7028 5.33752 61.9553 4.56882 61.9092H0.812988V52.5563H4.41859C5.18973 52.5094 5.95074 52.751 6.5536 53.2341C6.81467 53.4787 7.01865 53.7777 7.15103 54.11C7.28341 54.4423 7.34094 54.7997 7.31953 55.1568C7.32248 55.5601 7.21418 55.9565 7.00654 56.3023C6.80234 56.6467 6.50043 56.9226 6.13912 57.0951C6.53971 57.2642 6.87816 57.5531 7.10804 57.9222C7.33807 58.3164 7.45315 58.7671 7.44025 59.2234L7.44159 59.2256ZM2.58851 56.3788H4.28311C4.61838 56.4024 4.95018 56.2983 5.21179 56.0872C5.32071 55.9815 5.40554 55.8535 5.46048 55.712C5.51543 55.5705 5.53918 55.4188 5.53014 55.2672C5.54111 55.1084 5.51842 54.949 5.46356 54.7995C5.4087 54.65 5.32291 54.5138 5.21179 54.3998C4.95211 54.1846 4.61951 54.0778 4.28311 54.1016H2.58851V56.3788ZM5.66562 59.1035C5.6749 58.9448 5.65143 58.7859 5.59666 58.6367C5.54189 58.4875 5.457 58.3511 5.34726 58.2361C5.08264 58.0093 4.73884 57.8967 4.39132 57.9231H2.58851V60.3631H4.38997C4.5636 60.3764 4.73811 60.3538 4.90259 60.2967C5.06708 60.2395 5.218 60.149 5.34592 60.0309C5.57059 59.7755 5.68505 59.4417 5.66428 59.1022L5.66562 59.1035ZM10.3286 53.8986H8.62062V52.5572H10.3286V53.8986ZM10.3152 61.9097H8.64789V54.8608H10.3152V61.9097ZM16.401 60.4986H13.2832L16.401 56.2693V54.8595H11.4536V56.2693H14.5714L11.4536 60.4986V61.9084H16.401V60.4986ZM21.6614 60.0931L21.0918 61.9093H19.2201L22.5414 52.5564H23.9918L27.3265 61.9093H25.4423L24.8727 60.0931H21.6614ZM23.2608 55.0236L22.1358 58.6158H24.3996L23.2608 55.0236ZM29.4946 55.4979V54.8608H27.8546V61.9084H29.5371V57.5167C29.5264 57.3496 29.549 57.182 29.6037 57.0238C29.6583 56.8655 29.7439 56.7196 29.8554 56.5947C29.9599 56.4879 30.0853 56.4039 30.2238 56.3479C30.3623 56.292 30.5109 56.2653 30.6603 56.2697C30.8091 56.2629 30.9577 56.2885 31.0958 56.3446C31.2339 56.4007 31.3582 56.486 31.4602 56.5947C31.6732 56.853 31.7798 57.1826 31.7584 57.5167V61.9084H33.4391V57.3133C33.4774 56.6418 33.2648 55.98 32.8427 55.4564C32.63 55.2262 32.369 55.0461 32.0783 54.9289C31.7877 54.8117 31.4748 54.7603 31.1619 54.7785C30.8479 54.7781 30.5369 54.8402 30.2471 54.9614C29.9584 55.08 29.7009 55.2636 29.4946 55.4979ZM39.959 57.2735V61.9093H38.3324V61.2994C38.1276 61.5215 37.8812 61.7013 37.6071 61.8283C37.3074 61.9459 36.9868 62.0011 36.6651 61.9906C36.3603 62.01 36.0547 61.9685 35.7661 61.8687C35.4775 61.7689 35.2116 61.6128 34.9839 61.4094C34.7788 61.196 34.6201 60.9425 34.5174 60.665C34.4148 60.3874 34.3705 60.0916 34.3874 59.7962C34.3741 59.5147 34.4245 59.2338 34.5349 58.9744C34.6452 58.7151 34.8126 58.484 35.0246 58.2983C35.5302 57.9056 36.1615 57.7104 36.8005 57.7492H38.2917V57.1935C38.3135 57.0406 38.2994 56.8849 38.2506 56.7384C38.2018 56.592 38.1196 56.4589 38.0104 56.3498C37.9013 56.2406 37.7682 56.1584 37.6218 56.1096C37.4753 56.0607 37.3195 56.0467 37.1667 56.0685C36.8954 56.0538 36.628 56.1382 36.4142 56.3059C36.3231 56.383 36.2507 56.4799 36.2025 56.5891C36.1544 56.6983 36.1316 56.8171 36.1361 56.9364V56.9771H34.5774V56.923C34.5651 56.6253 34.6224 56.3288 34.7447 56.0571C34.867 55.7855 35.051 55.5461 35.2821 55.358C35.8277 54.9498 36.4992 54.746 37.1797 54.7821C37.9205 54.7326 38.6537 54.957 39.24 55.4126C39.4895 55.6512 39.6832 55.942 39.8074 56.2641C39.9316 56.5863 39.9832 56.9318 39.9586 57.2762L39.959 57.2735ZM38.2912 59.4045V58.9028H37.071C36.3664 58.9028 36.0139 59.1875 36.0136 59.7568C36.0136 60.3443 36.3564 60.6381 37.042 60.6381C37.2136 60.6544 37.3867 60.6358 37.5509 60.5834C37.7151 60.531 37.8671 60.4459 37.9975 60.3332C38.2112 60.073 38.3157 59.7401 38.289 59.4045H38.2912ZM41.1519 52.5564V59.7676V59.768C41.1211 60.0568 41.1554 60.3488 41.2521 60.6227C41.3489 60.8965 41.5057 61.1453 41.711 61.3506C41.9164 61.556 42.1651 61.7128 42.439 61.8095C42.7128 61.9063 43.0049 61.9405 43.2937 61.9097H44.0663V60.4592H43.4971C43.4041 60.4681 43.3103 60.4563 43.2225 60.4247C43.1346 60.3931 43.0548 60.3424 42.9887 60.2764C42.8679 60.0947 42.8128 59.8771 42.8327 59.6598V52.5564H41.1519ZM47.7798 62.5196C47.6463 62.9679 47.3733 63.362 47.0004 63.6445C46.5975 63.8974 46.1266 64.0205 45.6515 63.9973H45.0702V62.4923H45.5987C45.8096 62.5079 46.0202 62.4583 46.2019 62.3501C46.362 62.2093 46.4735 62.0215 46.5207 61.8136L46.5475 61.7188L44.1621 54.8599H45.9381L47.3206 59.2923L48.7304 54.8599H50.4518L47.7798 62.5196ZM50.6539 59.7676V59.8217L50.6575 59.8212C50.6467 60.1235 50.7073 60.424 50.8345 60.6984C50.9617 60.9728 51.1518 61.2133 51.3894 61.4005C51.9475 61.816 52.6328 62.0245 53.3277 61.9902C54.0562 62.0235 54.7755 61.8163 55.3746 61.4005C55.6328 61.2071 55.8395 60.9534 55.9766 60.6615C56.1137 60.3696 56.1771 60.0485 56.1611 59.7264C56.1751 59.4717 56.1352 59.2168 56.0441 58.9785C55.953 58.7403 55.8126 58.5239 55.6322 58.3435C55.1836 57.9678 54.6295 57.7405 54.0462 57.6929L53.2195 57.5708C52.9736 57.5522 52.7372 57.4679 52.535 57.3267C52.465 57.2669 52.4097 57.1918 52.3732 57.1072C52.3368 57.0226 52.3202 56.9309 52.3248 56.8389C52.322 56.7332 52.3453 56.6285 52.3925 56.5339C52.4398 56.4393 52.5096 56.3578 52.5958 56.2965C52.8293 56.1463 53.1048 56.075 53.3818 56.0931C53.6645 56.0775 53.9453 56.1485 54.1866 56.2965C54.2799 56.3586 54.3556 56.4436 54.4067 56.5433C54.4577 56.6431 54.4823 56.7542 54.4782 56.8662V56.9069H56.0364V56.8255C56.0401 56.449 55.9238 56.0811 55.7042 55.7752C55.4657 55.4497 55.142 55.1965 54.7688 55.0433C54.3291 54.8597 53.856 54.7697 53.3796 54.779C52.7 54.7507 52.0317 54.9592 51.4887 55.3688C51.2485 55.557 51.0563 55.7994 50.9279 56.0763C50.7995 56.3531 50.7385 56.6565 50.75 56.9614C50.7339 57.2099 50.7703 57.4591 50.8567 57.6926C50.9431 57.9262 51.0777 58.1389 51.2517 58.3171C51.6964 58.6818 52.2383 58.908 52.8104 58.9676L53.5557 59.0897C53.8301 59.113 54.0949 59.2013 54.3284 59.3473C54.4046 59.4059 54.4654 59.4823 54.5056 59.5696C54.5458 59.657 54.5641 59.7529 54.5591 59.8489C54.565 59.9663 54.5391 60.0832 54.484 60.187C54.4288 60.2908 54.3466 60.3778 54.2461 60.4387C53.9808 60.5835 53.6804 60.6515 53.3787 60.635C53.0843 60.6487 52.7929 60.5706 52.5448 60.4114C52.4438 60.3441 52.3615 60.2522 52.3059 60.1443C52.2502 60.0364 52.2228 59.9162 52.2264 59.7948V59.7676H50.6539ZM59.3016 59.7676C59.3016 60.2466 59.532 60.4861 59.9928 60.4861H60.5218V61.9093H59.7219C59.4439 61.9239 59.1658 61.8829 58.9039 61.7886C58.642 61.6943 58.4016 61.5487 58.1967 61.3602C58.0056 61.165 57.8569 60.9323 57.7601 60.6769C57.6633 60.4214 57.6205 60.1486 57.6343 59.8758V56.0394H56.6582V54.8599H57.6343V53.4774L59.3016 52.8962V54.8635H60.6573V56.043H59.3016V59.7676ZM64.8724 49.9062C64.461 49.6648 63.996 49.5441 63.4773 49.5441C62.9497 49.5441 62.4802 49.6648 62.0689 49.9062C61.6575 50.1387 61.3356 50.4651 61.1031 50.8854C60.8706 51.2968 60.7543 51.7618 60.7543 52.2804C60.7543 52.7991 60.8706 53.2686 61.1031 53.6889C61.3356 54.1092 61.6575 54.4401 62.0689 54.6815C62.4802 54.914 62.9497 55.0303 63.4773 55.0303C63.996 55.0303 64.461 54.914 64.8724 54.6815C65.2837 54.4401 65.6056 54.1092 65.8381 53.6889C66.0706 53.2686 66.1869 52.7991 66.1869 52.2804C66.1869 51.7618 66.0706 51.2968 65.8381 50.8854C65.6056 50.4651 65.2837 50.1387 64.8724 49.9062ZM65.0333 53.8767C64.6399 54.288 64.1212 54.4937 63.4773 54.4937C62.8245 54.4937 62.3014 54.288 61.9079 53.8767C61.5234 53.4653 61.3311 52.9333 61.3311 52.2804C61.3311 51.6277 61.5234 51.0956 61.9079 50.6842C62.3014 50.2729 62.8245 50.0672 63.4773 50.0672C64.1212 50.0672 64.6399 50.2729 65.0333 50.6842C65.4357 51.0956 65.6369 51.6277 65.6369 52.2804C65.6369 52.9333 65.4357 53.4653 65.0333 53.8767ZM64.5102 52.267C64.6264 52.115 64.6846 51.9317 64.6846 51.7171C64.6846 51.4399 64.5907 51.2208 64.4029 51.0598C64.224 50.8988 63.9826 50.8184 63.6785 50.8184H62.3908V53.7023H63.0883V52.6292H63.3164L63.9602 53.7023L64.8053 53.6889L64.0541 52.5756C64.2509 52.513 64.4029 52.4101 64.5102 52.267ZM63.6383 52.0524H63.0883V51.4488H63.6383C63.7367 51.4488 63.8171 51.4756 63.8797 51.5293C63.9513 51.574 63.987 51.6455 63.987 51.7439C63.987 51.8423 63.9513 51.9183 63.8797 51.9719C63.8171 52.0256 63.7367 52.0524 63.6383 52.0524Z"
        fill="#0094FF"
      />
    </svg>
  ),
  deskTopIcon: (
    <svg
      width="30"
      height="26"
      viewBox="0 0 30 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.75"
        y="0.75"
        width="28.5"
        height="19.5"
        rx="1.25"
        stroke="#375A8D"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <rect x="3" y="5.5" width="16" height="12" rx="1" fill="#D3DCEB" />
      <rect x="3" y="2.5" width="16" height="2" rx="1" fill="#DC343B" />
      <rect x="20" y="2.5" width="7" height="5" rx="1" fill="#D3DCEB" />
      <rect x="20" y="9" width="7" height="9" rx="1" fill="#D3DCEB" />
      <rect
        x="7.5"
        y="24.5"
        width="15"
        height="1"
        rx="0.5"
        stroke="#375A8D"
        strokeLinejoin="round"
      />
    </svg>
  ),
  kbCircle: (
    <svg
      width="71"
      height="134"
      viewBox="0 0 71 134"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M56.2233 134C65.6933 114.335 70.9999 92.2872 70.9999 69C70.9999 44.1205 64.9428 20.6558 54.2227 0L0.375484 0C16.4434 18.4683 26.172 42.5981 26.172 69.0001C26.172 93.5358 17.7703 116.109 3.68678 134H56.2233Z"
        fill="#FEF6F7"
      />
    </svg>
  ),
  checkRed: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0ZM13.22 6.97L8.75 11.44L6.78 9.47C6.63783 9.33752 6.44978 9.2654 6.25548 9.26882C6.06118 9.27225 5.87579 9.35097 5.73838 9.48838C5.60097 9.62579 5.52225 9.81118 5.51883 10.0055C5.5154 10.1998 5.58752 10.3878 5.72 10.53L8.22 13.03C8.36063 13.1705 8.55125 13.2493 8.75 13.2493C8.94875 13.2493 9.13937 13.1705 9.28 13.03L14.28 8.03C14.3537 7.96134 14.4128 7.87854 14.4538 7.78654C14.4948 7.69454 14.5168 7.59522 14.5186 7.49452C14.5204 7.39382 14.5018 7.29379 14.4641 7.2004C14.4264 7.10701 14.3703 7.02218 14.299 6.95096C14.2278 6.87974 14.143 6.8236 14.0496 6.78588C13.9562 6.74816 13.8562 6.72963 13.7555 6.73141C13.6548 6.73318 13.5555 6.75523 13.4635 6.79622C13.3715 6.83721 13.2887 6.89631 13.22 6.97Z"
        fill="#D92D20"
      />
    </svg>
  ),
  playStore: (
    <svg
      width="164"
      height="49"
      viewBox="0 0 164 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1248_23964)">
        <path
          d="M156.833 0.153687H6.34566C3.02119 0.153687 0.326172 2.83997 0.326172 6.15369V42.1537C0.326172 45.4674 3.02119 48.1537 6.34566 48.1537H156.833C160.158 48.1537 162.853 45.4674 162.853 42.1537V6.15369C162.853 2.83997 160.158 0.153687 156.833 0.153687Z"
          fill="#141414"
        />
        <path
          d="M57.4513 12.4536C57.4712 12.8927 57.4027 13.3313 57.2497 13.7435C57.0967 14.1558 56.8623 14.5332 56.5603 14.8536C56.2167 15.2074 55.8023 15.4853 55.3439 15.6693C54.8855 15.8533 54.3935 15.9392 53.8998 15.9216C53.3862 15.9505 52.8721 15.8747 52.389 15.6987C51.9058 15.5227 51.4638 15.2503 51.0899 14.8981C50.7161 14.5459 50.4183 14.1214 50.2148 13.6505C50.0112 13.1796 49.9062 12.6723 49.9062 12.1596C49.9062 11.6469 50.0112 11.1395 50.2148 10.6687C50.4183 10.1978 50.7161 9.7733 51.0899 9.42106C51.4638 9.0689 51.9058 8.7965 52.389 8.6205C52.8721 8.4445 53.3862 8.36866 53.8998 8.39762C54.4091 8.39242 54.9137 8.49466 55.3806 8.69762C55.818 8.86938 56.2066 9.14546 56.5122 9.50162L55.8862 10.1376C55.6386 9.84242 55.3234 9.61098 54.9671 9.46274C54.611 9.31442 54.2242 9.2537 53.8395 9.28562C53.4641 9.2821 53.0918 9.3545 52.7451 9.49834C52.3985 9.6421 52.0846 9.85442 51.8225 10.1224C51.5604 10.3904 51.3555 10.7086 51.22 11.0576C51.0846 11.4067 51.0214 11.7795 51.0345 12.1536C51.0266 12.713 51.185 13.2621 51.4899 13.7318C51.7948 14.2015 52.2324 14.5707 52.7475 14.7927C53.2627 15.0147 53.8322 15.0798 54.3844 14.9795C54.9366 14.8794 55.4466 14.6184 55.8501 14.2296C56.2224 13.8306 56.4363 13.3103 56.452 12.7656H53.8395V11.9016H57.3429C57.3966 12.0817 57.4329 12.2666 57.4513 12.4536Z"
          fill="white"
          stroke="white"
          strokeWidth="0.2"
          strokeMiterlimit="10"
        />
        <path
          d="M62.9652 9.40582H59.6785V11.6858H62.6401V12.5498H59.6785V14.8418H62.9652V15.7178H58.7516V8.51782H62.9652V9.40582Z"
          fill="white"
          stroke="white"
          strokeWidth="0.2"
          strokeMiterlimit="10"
        />
        <path
          d="M66.8778 15.7538H65.9507V9.40582H63.9402V8.51782H68.9003V9.40582H66.8778V15.7538Z"
          fill="white"
          stroke="white"
          strokeWidth="0.2"
          strokeMiterlimit="10"
        />
        <path
          d="M72.4879 15.7537V8.55371H73.4149V15.7537H72.4879Z"
          fill="white"
          stroke="white"
          strokeWidth="0.2"
          strokeMiterlimit="10"
        />
        <path
          d="M77.5321 15.7538H76.605V9.40582H74.5945V8.51782H79.5545V9.40582H77.5321V15.7538Z"
          fill="white"
          stroke="white"
          strokeWidth="0.2"
          strokeMiterlimit="10"
        />
        <path
          d="M88.9448 14.8297C88.5976 15.1765 88.184 15.4517 87.7296 15.6395C87.2752 15.8272 86.788 15.9238 86.296 15.9238C85.8048 15.9238 85.3176 15.8272 84.8632 15.6395C84.4088 15.4517 83.9952 15.1765 83.648 14.8297C82.9664 14.1065 82.5872 13.1517 82.5872 12.1597C82.5872 11.1676 82.9664 10.2129 83.648 9.48967C83.9952 9.14287 84.4088 8.86767 84.8632 8.67991C85.3176 8.49215 85.8048 8.39551 86.296 8.39551C86.788 8.39551 87.2752 8.49215 87.7296 8.67991C88.184 8.86767 88.5976 9.14287 88.9448 9.48967C89.632 10.2101 90.0144 11.1659 90.0144 12.1597C90.0144 13.1535 89.632 14.1093 88.9448 14.8297ZM84.3344 14.2057C84.588 14.4667 84.8936 14.6728 85.2312 14.8111C85.5688 14.9494 85.9312 15.017 86.296 15.0097C86.6616 15.0192 87.0248 14.9526 87.3624 14.8141C87.7008 14.6757 88.0056 14.4685 88.2584 14.2057C88.7768 13.6398 89.0632 12.9016 89.0632 12.1357C89.0632 11.3698 88.7768 10.6316 88.2584 10.0657C88.0096 9.81327 87.7112 9.61391 87.3816 9.47983C87.0528 9.34575 86.7 9.27975 86.3448 9.28567C85.98 9.27839 85.6168 9.34599 85.2792 9.48431C84.9416 9.62263 84.6368 9.82871 84.3824 10.0897C83.8696 10.6581 83.5856 11.3953 83.5856 12.1597C83.5856 12.924 83.8696 13.6613 84.3824 14.2297L84.3344 14.2057Z"
          fill="white"
          stroke="white"
          strokeWidth="0.2"
          strokeMiterlimit="10"
        />
        <path
          d="M91.3168 15.7537V8.55371H92.4488L95.976 14.2057V12.8137V8.55371H96.9152V15.7537H95.976L92.244 9.88571V11.2777V15.7537H91.3168Z"
          fill="white"
          stroke="white"
          strokeWidth="0.2"
          strokeMiterlimit="10"
        />
        <path
          d="M82.36 26.2057C81.3504 26.2175 80.3664 26.5261 79.5323 27.0929C78.6979 27.6597 78.0499 28.4593 77.6696 29.3917C77.2892 30.3239 77.1934 31.3474 77.3942 32.3337C77.595 33.3201 78.0834 34.2254 78.7982 34.9362C79.513 35.647 80.4224 36.1317 81.412 36.3296C82.4024 36.5274 83.4288 36.4295 84.3632 36.0482C85.2976 35.6669 86.0984 35.0193 86.6648 34.1862C87.232 33.3533 87.5392 32.3721 87.5488 31.3657C87.5656 30.6825 87.4424 30.0031 87.1872 29.3689C86.932 28.7345 86.5504 28.1585 86.0648 27.6759C85.58 27.1933 85.0008 26.8141 84.364 26.5613C83.7272 26.3085 83.0456 26.1876 82.36 26.2057ZM82.36 34.4137C81.7352 34.4595 81.1104 34.3165 80.5688 34.0035C80.0263 33.6905 79.5913 33.2219 79.3202 32.6589C79.049 32.0957 78.9544 31.4643 79.0486 30.8468C79.1428 30.2293 79.4214 29.6545 79.8482 29.1972C80.2752 28.7398 80.8304 28.4213 81.4408 28.2831C82.052 28.1449 82.6912 28.1933 83.2736 28.4222C83.8568 28.6512 84.3576 29.0498 84.7096 29.5663C85.0616 30.0828 85.2504 30.6931 85.2496 31.3177C85.2752 31.7152 85.2208 32.1138 85.088 32.4897C84.9552 32.8654 84.748 33.2106 84.4776 33.5044C84.208 33.7981 83.8808 34.0344 83.5168 34.1989C83.1528 34.3634 82.7592 34.4528 82.36 34.4617V34.4137ZM71.1517 26.2057C70.1378 26.2081 69.1474 26.5098 68.3057 27.073C67.4638 27.6361 66.8084 28.4353 66.4221 29.3697C66.0358 30.304 65.9358 31.3314 66.1351 32.3223C66.3344 33.3131 66.8238 34.2229 67.5415 34.9366C68.2592 35.6503 69.173 36.136 70.1676 36.3323C71.1621 36.5285 72.1927 36.4266 73.1291 36.0393C74.0655 35.6521 74.8658 34.9969 75.4288 34.1565C75.9918 33.3161 76.2923 32.3282 76.2923 31.3177C76.3038 30.6421 76.1786 29.9713 75.9241 29.3452C75.6697 28.719 75.2912 28.1504 74.8114 27.6733C74.3316 27.1961 73.7602 26.8202 73.1314 26.5681C72.5026 26.3159 71.8293 26.1926 71.1517 26.2057ZM71.1517 34.4137C70.5267 34.4595 69.9025 34.3165 69.3602 34.0035C68.818 33.6905 68.383 33.2219 68.1118 32.6589C67.8407 32.0957 67.7461 31.4643 67.8402 30.8468C67.9345 30.2293 68.2131 29.6545 68.6399 29.1972C69.0667 28.7398 69.6218 28.4213 70.2329 28.2831C70.8439 28.1449 71.4826 28.1933 72.0657 28.4222C72.6486 28.6512 73.149 29.0498 73.5014 29.5663C73.8537 30.0828 74.0418 30.6931 74.041 31.3177C74.0671 31.7152 74.0122 32.1138 73.8797 32.4897C73.747 32.8654 73.5395 33.2106 73.2696 33.5044C72.9996 33.7981 72.6728 34.0344 72.3089 34.1989C71.9449 34.3634 71.5512 34.4528 71.1517 34.4617V34.4137ZM57.8125 27.8257V29.9857H63.0133C62.9344 31.0073 62.51 31.9718 61.8094 32.7217C61.2878 33.2481 60.662 33.6608 59.9719 33.9335C59.2818 34.2061 58.5423 34.3329 57.8004 34.3057C56.3119 34.238 54.9068 33.6009 53.8774 32.5269C52.8481 31.453 52.2737 30.0249 52.2737 28.5397C52.2737 27.0544 52.8481 25.6262 53.8774 24.5523C54.9068 23.4784 56.3119 22.8413 57.8004 22.7737C59.258 22.7575 60.6634 23.3135 61.7131 24.3217L63.2421 22.7977C62.5271 22.0901 61.6774 21.5323 60.7428 21.1572C59.8082 20.7821 58.8078 20.5973 57.8004 20.6137C56.7302 20.5721 55.6625 20.7464 54.6614 21.126C53.6603 21.5057 52.7464 22.0828 51.9745 22.8229C51.2026 23.5629 50.5884 24.4508 50.1689 25.4331C49.7494 26.4154 49.5332 27.4721 49.5332 28.5397C49.5332 29.6073 49.7494 30.6639 50.1689 31.6462C50.5884 32.6285 51.2026 33.5164 51.9745 34.2565C52.7464 34.9965 53.6603 35.5737 54.6614 35.9533C55.6625 36.3329 56.7302 36.5072 57.8004 36.4657C58.8309 36.5121 59.8594 36.338 60.8167 35.955C61.7741 35.5721 62.638 34.9893 63.3504 34.2457C64.6117 32.8644 65.2851 31.0485 65.2285 29.1817C65.2357 28.7267 65.1954 28.2722 65.1081 27.8257H57.8125ZM112.361 29.5057C112.058 28.5815 111.479 27.7712 110.703 27.1818C109.927 26.5925 108.99 26.2521 108.015 26.2057C107.355 26.2043 106.702 26.338 106.097 26.5985C105.491 26.8589 104.946 27.2407 104.494 27.72C104.042 28.1993 103.695 28.766 103.472 29.3848C103.25 30.0037 103.157 30.6616 103.199 31.3177C103.186 31.9879 103.309 32.6539 103.559 33.2761C103.81 33.8984 104.182 34.4641 104.656 34.9398C105.13 35.4155 105.695 35.7915 106.318 36.0453C106.94 36.2992 107.607 36.4258 108.28 36.4177C109.124 36.4221 109.955 36.2184 110.701 35.8247C111.446 35.4311 112.083 34.8598 112.554 34.1617L110.808 32.9617C110.546 33.3955 110.174 33.7541 109.731 34.0023C109.288 34.2505 108.788 34.3798 108.28 34.3777C107.758 34.3958 107.244 34.2581 106.802 33.9822C106.36 33.7064 106.011 33.3049 105.8 32.8297L112.65 29.9977L112.361 29.5057ZM105.378 31.2097C105.354 30.8413 105.403 30.4719 105.522 30.1225C105.642 29.7732 105.83 29.4509 106.075 29.1742C106.32 28.8976 106.618 28.672 106.95 28.5105C107.283 28.3491 107.646 28.255 108.015 28.2337C108.403 28.2081 108.79 28.2969 109.129 28.4889C109.467 28.6809 109.741 28.9677 109.918 29.3137L105.378 31.2097ZM99.8048 36.1537H102.056V21.1537H99.8048V36.1537ZM96.1208 27.4057H96.048C95.7088 27.0275 95.2936 26.7252 94.8288 26.5184C94.364 26.3116 93.8608 26.205 93.3512 26.2057C92.036 26.2693 90.7952 26.8349 89.8864 27.7856C88.9784 28.7361 88.4712 29.9987 88.4712 31.3117C88.4712 32.6245 88.9784 33.8872 89.8864 34.8377C90.7952 35.7884 92.036 36.3541 93.3512 36.4177C93.8616 36.4262 94.3672 36.3232 94.8336 36.1158C95.2992 35.9085 95.7144 35.602 96.048 35.2177H96.1208V35.9617C96.176 36.3443 96.1464 36.7345 96.032 37.1042C95.9184 37.4739 95.724 37.8138 95.4624 38.0996C95.2016 38.3853 94.88 38.6097 94.5208 38.7568C94.1624 38.9037 93.7752 38.9697 93.388 38.9497C92.8264 38.9365 92.2816 38.7573 91.8224 38.4345C91.364 38.1119 91.012 37.6605 90.8112 37.1377L88.8488 37.9537C89.2208 38.8474 89.8512 39.6108 90.6592 40.1471C91.4672 40.6833 92.4168 40.9682 93.388 40.9657C96.024 40.9657 98.2032 39.4177 98.2032 35.6497V26.5657H96.1208V27.4057ZM93.568 34.4617C92.792 34.3934 92.0688 34.0377 91.5424 33.4646C91.016 32.8916 90.724 32.1427 90.724 31.3657C90.724 30.5886 91.016 29.8398 91.5424 29.2666C92.0688 28.6936 92.792 28.3379 93.568 28.2697C94.3256 28.3638 95.0224 28.7304 95.5272 29.3005C96.032 29.8707 96.3112 30.6051 96.3112 31.3657C96.3112 32.1262 96.032 32.8606 95.5272 33.4308C95.0224 34.0009 94.3256 34.3675 93.568 34.4617ZM122.895 21.1537H117.514V36.1537H119.753V30.4777H122.895C123.53 30.5097 124.163 30.4129 124.759 30.1931C125.354 29.9733 125.899 29.6351 126.359 29.199C126.819 28.7629 127.186 28.2382 127.436 27.6565C127.686 27.0749 127.816 26.4486 127.816 25.8157C127.816 25.1827 127.686 24.5564 127.436 23.9748C127.186 23.3931 126.819 22.8683 126.359 22.4322C125.899 21.9962 125.354 21.658 124.759 21.4381C124.163 21.2184 123.53 21.1216 122.895 21.1537ZM122.895 28.3537H119.753V23.2417H122.955C123.31 23.2176 123.665 23.2662 123.999 23.3847C124.333 23.5031 124.639 23.6888 124.898 23.9301C125.158 24.1716 125.365 24.4635 125.506 24.7878C125.647 25.1122 125.72 25.4621 125.72 25.8157C125.72 26.1693 125.647 26.5191 125.506 26.8435C125.365 27.1678 125.158 27.4597 124.898 27.7011C124.639 27.9425 124.333 28.1282 123.999 28.2466C123.665 28.3651 123.31 28.4137 122.955 28.3897L122.895 28.3537ZM136.836 26.2057C136.016 26.1594 135.199 26.3528 134.487 26.7621C133.775 27.1713 133.198 27.7786 132.827 28.5097L134.826 29.3377C135.022 28.9746 135.32 28.6767 135.683 28.4805C136.047 28.2844 136.461 28.1985 136.873 28.2337C137.158 28.1987 137.449 28.2213 137.726 28.3001C138.003 28.3789 138.262 28.5124 138.486 28.6925C138.71 28.8726 138.897 29.0958 139.033 29.3489C139.17 29.6019 139.254 29.8797 139.28 30.1657V30.3217C138.547 29.9506 137.73 29.7729 136.909 29.8057C134.754 29.8057 132.574 31.0057 132.574 33.1897C132.596 33.6528 132.71 34.1069 132.91 34.5253C133.111 34.9437 133.394 35.3177 133.742 35.6254C134.09 35.9331 134.495 36.1681 134.936 36.3165C135.377 36.4649 135.843 36.5238 136.306 36.4897C136.872 36.5233 137.436 36.4053 137.94 36.1478C138.444 35.8903 138.87 35.5028 139.172 35.0257H139.244V36.2257H141.423V30.3817C141.411 27.7177 139.413 26.2057 136.836 26.2057ZM136.559 34.4257C135.825 34.4257 134.802 34.0657 134.802 33.1537C134.802 31.9537 136.078 31.5577 137.21 31.5577C137.924 31.5352 138.631 31.7052 139.256 32.0497C139.179 32.7094 138.862 33.3183 138.366 33.7606C137.869 34.203 137.226 34.4482 136.559 34.4497V34.4257ZM149.309 26.5657L146.733 33.0697H146.648L143.975 26.5657H141.568L145.577 35.6497L143.302 40.7017H145.637L151.813 26.5657H149.309ZM129.071 36.1657H131.322V21.1537H129.071V36.1657Z"
          fill="white"
        />
        <path
          d="M12.9069 9.2018C12.5115 9.6742 12.3133 10.2799 12.353 10.8938V37.4258C12.3133 38.0397 12.5115 38.6454 12.9069 39.1178L12.9911 39.2018L27.8953 24.3338V23.9858L12.9791 9.1178L12.9069 9.2018Z"
          fill="url(#paint0_linear_1248_23964)"
        />
        <path
          d="M32.8675 29.2896L27.8953 24.3336V23.9856L32.8675 19.0056H32.9879L38.8749 22.3416C40.5603 23.2896 40.5603 24.8496 38.8749 25.8096L32.9879 29.2296L32.8675 29.2896Z"
          fill="url(#paint1_linear_1248_23964)"
        />
        <path
          d="M32.9881 29.2297L27.8956 24.1537L12.907 39.1177C13.2506 39.4187 13.6888 39.5906 14.1461 39.6038C14.6033 39.617 15.0507 39.4705 15.4111 39.1897L33.0001 29.2297"
          fill="url(#paint2_linear_1248_23964)"
        />
        <path
          d="M32.988 19.0896L15.399 9.12955C15.0396 8.84659 14.5917 8.69867 14.1338 8.71187C13.676 8.72499 13.2374 8.89843 12.895 9.20163L27.8955 24.1536L32.988 19.0896Z"
          fill="url(#paint3_linear_1248_23964)"
        />
        <path
          opacity="0.2"
          d="M32.8677 29.1217L15.3991 39.0097C15.0507 39.2669 14.6287 39.4057 14.1952 39.4057C13.7617 39.4057 13.3397 39.2669 12.9913 39.0097L12.907 39.1057L12.9913 39.1897C13.3397 39.4469 13.7617 39.5857 14.1952 39.5857C14.6287 39.5857 15.0507 39.4469 15.3991 39.1897L32.9881 29.2297L32.8677 29.1217Z"
          fill="#141414"
        />
        <path
          opacity="0.12"
          d="M12.9069 38.9376C12.5145 38.4682 12.3164 37.8674 12.353 37.2576V37.4256C12.3133 38.0395 12.5115 38.6452 12.9069 39.1176L12.9911 39.0216L12.9069 38.9376Z"
          fill="#141414"
        />
        <path
          opacity="0.12"
          d="M38.875 25.7137L32.8554 29.1217L32.9758 29.2297L38.863 25.8937C39.1993 25.7346 39.4876 25.4901 39.699 25.1846C39.9103 24.8791 40.0372 24.5236 40.0668 24.1537C39.9996 24.4866 39.8574 24.8001 39.6509 25.0703C39.4444 25.3406 39.1791 25.5605 38.875 25.7137Z"
          fill="#141414"
        />
        <path
          opacity="0.25"
          d="M15.3989 9.3098L38.875 22.6058C39.1799 22.7563 39.4467 22.9738 39.6553 23.242C39.8638 23.51 40.0086 23.8218 40.0789 24.1538C40.0472 23.786 39.9194 23.4329 39.7081 23.1297C39.4969 22.8265 39.2096 22.5838 38.875 22.4258L15.3989 9.12972C13.7134 8.18172 12.341 8.9738 12.341 10.8938V11.0618C12.341 9.1418 13.7134 8.3498 15.3989 9.3098Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1248_23964"
          x1="26.5711"
          y1="10.6058"
          x2="6.43523"
          y2="30.8191"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF" />
          <stop offset="0.01" stopColor="#00A1FF" />
          <stop offset="0.26" stopColor="#00BEFF" />
          <stop offset="0.51" stopColor="#00D2FF" />
          <stop offset="0.76" stopColor="#00DFFF" />
          <stop offset="1" stopColor="#00E3FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1248_23964"
          x1="41.066"
          y1="24.1536"
          x2="11.9316"
          y2="24.1536"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE000" />
          <stop offset="0.41" stopColor="#FFBD00" />
          <stop offset="0.78" stopColor="#FFA500" />
          <stop offset="1" stopColor="#FF9C00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1248_23964"
          x1="30.2191"
          y1="26.9137"
          x2="2.90724"
          y2="54.3142"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF3A44" />
          <stop offset="1" stopColor="#C31162" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1248_23964"
          x1="9.11464"
          y1="0.369593"
          x2="21.3066"
          y2="12.6012"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#32A071" />
          <stop offset="0.07" stopColor="#2DA771" />
          <stop offset="0.48" stopColor="#15CF74" />
          <stop offset="0.8" stopColor="#06E775" />
          <stop offset="1" stopColor="#00F076" />
        </linearGradient>
        <clipPath id="clip0_1248_23964">
          <rect
            width="163.2"
            height="48"
            fill="white"
            transform="translate(0.200012 0.153687)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  appStore: (
    <svg
      width="164"
      height="49"
      viewBox="0 0 164 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1248_23938)">
        <path
          d="M154.526 0.633667H7.99998C3.8468 0.633667 0.47998 4.00048 0.47998 8.15367V40.1537C0.47998 44.3068 3.8468 47.6737 7.99998 47.6737H154.526C158.68 47.6737 162.046 44.3068 162.046 40.1537V8.15367C162.046 4.00048 158.68 0.633667 154.526 0.633667Z"
          fill="#141414"
        />
        <path
          d="M40.0022 24.1137C40.0127 23.1115 40.2762 22.1284 40.768 21.2571C41.2597 20.3859 41.9636 19.6551 42.8132 19.1337C42.2734 18.3585 41.5618 17.7207 40.7349 17.2708C39.9079 16.8209 38.9883 16.5712 38.0489 16.5417C36.0598 16.3257 34.1184 17.7417 33.0941 17.7417C32.0697 17.7417 30.4856 16.5417 28.7943 16.5417C27.7015 16.5775 26.6365 16.8981 25.7034 17.4723C24.7703 18.0464 24.0009 18.8545 23.4702 19.8177C21.2191 23.8857 22.8866 29.7537 25.0901 33.0417C26.1977 34.6377 27.4722 36.4137 29.1754 36.3417C30.8787 36.2697 31.4385 35.2857 33.4395 35.2857C35.4405 35.2857 35.9884 36.3417 37.7154 36.3057C39.4425 36.2697 40.6097 34.7097 41.6697 33.1017C42.4612 31.9682 43.072 30.7171 43.4801 29.3937C42.4488 28.9564 41.5685 28.2221 40.9498 27.2828C40.3311 26.3435 40.0014 25.241 40.0022 24.1137Z"
          fill="white"
        />
        <path
          d="M36.703 14.4058C37.6655 13.235 38.1395 11.7336 38.0251 10.2178C36.5487 10.3783 35.1851 11.0887 34.2017 12.2098C33.2379 13.3201 32.7498 14.7698 32.8439 16.2418C33.583 16.2491 34.3141 16.0877 34.9825 15.7698C35.6508 15.4518 36.2391 14.9855 36.703 14.4058Z"
          fill="white"
        />
        <path
          d="M60.8819 32.3217H55.2482L53.8903 36.3537H51.5082L56.8442 21.4497H59.3335L64.6695 36.3537H62.2874L60.8819 32.3217ZM55.8318 30.4617H60.2982L58.1425 23.9217H58.0829L55.8318 30.4617Z"
          fill="white"
        />
        <path
          d="M76.1989 30.9535C76.1989 34.3255 74.4003 36.4975 71.6966 36.4975C71.0068 36.5269 70.3226 36.3602 69.7224 36.0165C69.1222 35.6727 68.6299 35.1657 68.3021 34.5535V39.9295H66.039V25.5295H68.183V27.3535C68.5311 26.7501 69.035 26.2529 69.641 25.9149C70.2471 25.5769 70.9328 25.4105 71.6252 25.4335C74.4003 25.3735 76.1989 27.5455 76.1989 30.9535ZM73.9239 30.9535C73.9239 28.7575 72.7329 27.3535 71.0773 27.3535C69.4217 27.3535 68.2426 28.8295 68.2426 30.9535C68.2426 33.0775 69.4336 34.6135 71.0773 34.6135C72.721 34.6135 73.9239 33.1375 73.9239 30.9535Z"
          fill="white"
        />
        <path
          d="M88.0616 30.9535C88.0616 34.3255 86.2752 36.4975 83.572 36.4975C82.8816 36.5283 82.1968 36.3622 81.596 36.0183C80.996 35.6744 80.504 35.1667 80.1768 34.5535V39.9295H77.9141V25.5295H80.0576V27.3535C80.4048 26.752 80.9072 26.256 81.5112 25.9181C82.1144 25.5801 82.7976 25.4127 83.488 25.4335C86.2632 25.3735 88.0616 27.5455 88.0616 30.9535ZM85.7872 30.9535C85.7872 28.7575 84.6672 27.3535 82.94 27.3535C81.2136 27.3535 80.1176 28.8295 80.1176 30.9535C80.1176 33.0775 81.2488 34.5535 82.94 34.5535C84.632 34.5535 85.7872 33.1375 85.7872 30.9535Z"
          fill="white"
        />
        <path
          d="M95.9112 32.1538C96.0776 33.6298 97.4952 34.5538 99.484 34.5538C101.474 34.5538 102.688 33.5818 102.688 32.2498C102.688 30.9178 101.878 30.4018 99.9608 29.9218L98.0432 29.4538C95.3272 28.7938 94.0768 27.5218 94.0768 25.4458C94.0768 22.8658 96.292 21.1018 99.4488 21.1018C102.605 21.1018 104.725 22.8658 104.797 25.4458H102.522C102.39 23.9578 101.164 23.0458 99.3888 23.0458C97.6144 23.0458 96.3872 23.9458 96.3872 25.2778C96.3872 26.3218 97.1616 26.9458 99.0672 27.4258L100.699 27.8218C103.736 28.5418 104.999 29.7778 104.999 31.9498C104.999 34.7458 102.783 36.4858 99.2816 36.4858C96.0064 36.4858 93.7912 34.7818 93.648 32.0938L95.9112 32.1538Z"
          fill="white"
        />
        <path
          d="M109.775 22.9138V25.4818H111.823V27.2458H109.775V33.2458C109.775 34.1698 110.18 34.6018 111.085 34.6018C111.327 34.6167 111.57 34.6167 111.812 34.6018V36.3538C111.419 36.4284 111.02 36.4645 110.621 36.4618C108.429 36.4618 107.583 35.6338 107.583 33.5218V27.2458H105.975V25.4818H107.548V22.9138H109.775Z"
          fill="white"
        />
        <path
          d="M113.002 30.9537C113.002 27.5337 115.004 25.3857 118.124 25.3857C121.245 25.3857 123.234 27.5337 123.234 30.9537C123.234 34.3737 121.269 36.4857 118.124 36.4857C114.98 36.4857 113.002 34.3497 113.002 30.9537ZM120.983 30.9537C120.983 28.6137 119.911 27.2217 118.124 27.2217C116.338 27.2217 115.314 28.5537 115.314 30.9537C115.314 33.3537 116.374 34.6857 118.172 34.6857C119.97 34.6857 120.983 33.2697 120.983 30.9537Z"
          fill="white"
        />
        <path
          d="M125.068 25.4815H127.224V27.3536C127.369 26.7769 127.706 26.2678 128.178 25.9116C128.651 25.5555 129.231 25.374 129.821 25.3976C130.078 25.3934 130.334 25.4215 130.583 25.4815V27.5695C130.273 27.4395 129.942 27.3664 129.606 27.3536C129.274 27.329 128.94 27.3796 128.629 27.5017C128.318 27.6238 128.038 27.8143 127.81 28.0592C127.582 28.3042 127.411 28.5975 127.31 28.9176C127.208 29.2377 127.179 29.5766 127.224 29.9096V36.3536H125.068V25.4815Z"
          fill="white"
        />
        <path
          d="M140.778 33.1617C140.481 35.1297 138.575 36.4857 136.146 36.4857C133.001 36.4857 131.059 34.3617 131.059 30.9657C131.059 27.5697 133.013 25.3497 136.05 25.3497C139.087 25.3497 140.91 27.4137 140.91 30.7137V31.4697H133.286V31.6137C133.253 32.0136 133.303 32.4161 133.435 32.7946C133.567 33.1732 133.778 33.5192 134.053 33.8097C134.327 34.1001 134.66 34.3285 135.03 34.4795C135.398 34.6305 135.795 34.7009 136.193 34.6857C136.715 34.7349 137.239 34.6132 137.688 34.3387C138.136 34.0642 138.485 33.6515 138.682 33.1617H140.778ZM133.298 29.9097H138.694C138.714 29.5508 138.66 29.1915 138.535 28.8546C138.41 28.5178 138.218 28.2106 137.97 27.9525C137.721 27.6943 137.422 27.4908 137.092 27.3547C136.762 27.2186 136.406 27.1529 136.05 27.1617C135.69 27.1601 135.334 27.23 135.001 27.3672C134.668 27.5044 134.365 27.7064 134.11 27.9616C133.854 28.2168 133.65 28.5202 133.512 28.8545C133.373 29.1887 133.3 29.5473 133.298 29.9097Z"
          fill="white"
        />
        <path
          d="M55.5578 10.2295C56.0252 10.1963 56.4939 10.2687 56.9299 10.4415C57.3658 10.6143 57.758 10.883 58.0776 11.2281C58.3973 11.5731 58.6363 11.9858 58.7773 12.4358C58.9185 12.8859 58.9579 13.3621 58.8929 13.8295C58.8929 16.1095 57.7018 17.4295 55.5578 17.4295H52.9851V10.2295H55.5578ZM54.0929 16.3735H55.4269C55.7612 16.4007 56.0973 16.3514 56.4101 16.2294C56.7229 16.1074 57.0043 15.9158 57.2333 15.669C57.4624 15.4221 57.6331 15.1262 57.7328 14.8036C57.8325 14.4809 57.8585 14.1398 57.8089 13.8055C57.8561 13.4717 57.8285 13.1314 57.728 12.8098C57.6274 12.4882 57.4566 12.1933 57.2281 11.947C56.9996 11.7006 56.7191 11.509 56.4074 11.3862C56.0957 11.2634 55.7606 11.2126 55.4269 11.2375H54.0929V16.3735Z"
          fill="white"
        />
        <path
          d="M60.1434 14.6816C60.1196 14.332 60.1674 13.9812 60.2838 13.651C60.4002 13.3208 60.5828 13.0183 60.8202 12.7622C61.0575 12.5061 61.3446 12.3018 61.6636 12.1622C61.9826 12.0226 62.3266 11.9506 62.6745 11.9506C63.0222 11.9506 63.3663 12.0226 63.6854 12.1622C64.0043 12.3018 64.2914 12.5061 64.5288 12.7622C64.7662 13.0183 64.9487 13.3208 65.0651 13.651C65.1815 13.9812 65.2293 14.332 65.2055 14.6816C65.2293 15.0312 65.1815 15.3819 65.0651 15.7122C64.9487 16.0423 64.7662 16.3449 64.5288 16.601C64.2914 16.8571 64.0043 17.0614 63.6854 17.201C63.3663 17.3406 63.0222 17.4126 62.6745 17.4126C62.3266 17.4126 61.9826 17.3406 61.6636 17.201C61.3446 17.0614 61.0575 16.8571 60.8202 16.601C60.5828 16.3449 60.4002 16.0423 60.2838 15.7122C60.1674 15.3819 60.1196 15.0312 60.1434 14.6816ZM64.1097 14.6816C64.1097 13.4816 63.5975 12.8336 62.6804 12.8336C61.7633 12.8336 61.2392 13.5176 61.2392 14.6816C61.2392 15.8456 61.7157 16.5536 62.6804 16.5536C63.6452 16.5536 64.0978 15.8576 64.0978 14.6816H64.1097Z"
          fill="white"
        />
        <path
          d="M71.9229 17.3938H70.8271L69.7194 13.4098H69.6361L68.5284 17.3938H67.4445L65.9676 11.9818H67.0395L68.0043 16.1098H68.0758L69.1834 11.9818H70.1958L71.3035 16.1098H71.387L72.3397 11.9818H73.3998L71.9229 17.3938Z"
          fill="white"
        />
        <path
          d="M74.6385 11.9818H75.6628V12.8458H75.7462C75.8778 12.5368 76.1031 12.2776 76.3898 12.1052C76.6763 11.9328 77.0097 11.856 77.3422 11.8858C77.603 11.8648 77.8651 11.9035 78.109 11.9988C78.353 12.0941 78.5724 12.2436 78.751 12.4363C78.9295 12.6289 79.0627 12.8596 79.1405 13.1113C79.2183 13.363 79.2387 13.6291 79.2002 13.8898V17.3938H78.1402V14.1538C78.1402 13.2778 77.759 12.8458 76.9491 12.8458C76.7698 12.8294 76.5892 12.8541 76.4208 12.9182C76.2524 12.9822 76.1006 13.0839 75.9768 13.2156C75.853 13.3472 75.7604 13.5055 75.706 13.6784C75.6516 13.8512 75.6369 14.0343 75.6628 14.2138V17.3938H74.6027L74.6385 11.9818Z"
          fill="white"
        />
        <path
          d="M80.88 9.88184H81.9632V17.3938H80.9032L80.88 9.88184Z"
          fill="white"
        />
        <path
          d="M83.4168 14.6816C83.3928 14.332 83.4408 13.9812 83.5576 13.651C83.6736 13.3208 83.856 13.0183 84.0936 12.7622C84.3312 12.5061 84.6184 12.3018 84.9368 12.1622C85.256 12.0226 85.6 11.9506 85.948 11.9506C86.296 11.9506 86.64 12.0226 86.9584 12.1622C87.2776 12.3018 87.5648 12.5061 87.8024 12.7622C88.0392 13.0183 88.2224 13.3208 88.3384 13.651C88.4552 13.9812 88.5024 14.332 88.4792 14.6816C88.5024 15.0312 88.4552 15.3819 88.3384 15.7122C88.2224 16.0423 88.0392 16.3449 87.8024 16.601C87.5648 16.8571 87.2776 17.0614 86.9584 17.201C86.64 17.3406 86.296 17.4126 85.948 17.4126C85.6 17.4126 85.256 17.3406 84.9368 17.201C84.6184 17.0614 84.3312 16.8571 84.0936 16.601C83.856 16.3449 83.6736 16.0423 83.5576 15.7122C83.4408 15.3819 83.3928 15.0312 83.4168 14.6816ZM87.3832 14.6816C87.3832 13.4816 86.8592 12.8336 85.9416 12.8336C85.0248 12.8336 84.5128 13.5176 84.5128 14.6816C84.5128 15.8456 85.0248 16.5536 85.9416 16.5536C86.8592 16.5536 87.3832 15.8576 87.3832 14.6816Z"
          fill="white"
        />
        <path
          d="M89.5864 15.8577C89.5864 14.8857 90.3008 14.3337 91.5872 14.2497L93.0408 14.1537V13.6857C93.0408 13.1217 92.6592 12.7977 91.9328 12.7977C91.2064 12.7977 90.932 13.0137 90.8248 13.3977H89.7888C89.908 12.4617 90.7656 11.8737 91.98 11.8737C93.1952 11.8737 94.0888 12.5457 94.0888 13.6857V17.3937H93.064V16.6257H92.9808C92.8136 16.9005 92.576 17.1247 92.2936 17.2747C92.0104 17.4246 91.692 17.4948 91.3728 17.4777C91.148 17.5012 90.92 17.4768 90.7048 17.4061C90.4888 17.3354 90.2912 17.2201 90.1224 17.0674C89.9544 16.9147 89.8192 16.7282 89.7272 16.5198C89.6344 16.3114 89.5864 16.0859 89.5864 15.8577ZM93.0408 15.3537V14.8977L91.7304 14.9817C90.992 14.9817 90.6464 15.2937 90.6464 15.7617C90.6464 16.2297 91.0752 16.5297 91.6472 16.5297C91.8152 16.5478 91.9864 16.5315 92.1488 16.4817C92.3112 16.432 92.4616 16.3497 92.592 16.24C92.7216 16.1302 92.8288 15.9952 92.9056 15.8429C92.9824 15.6906 93.0288 15.5242 93.0408 15.3537Z"
          fill="white"
        />
        <path
          d="M95.4824 14.6818C95.4824 12.9778 96.352 11.8978 97.7096 11.8978C98.0448 11.8833 98.3768 11.9646 98.6672 12.1324C98.9584 12.3002 99.196 12.5475 99.3536 12.8458H99.4248V9.88184H100.485V17.3938H99.4728V16.5538H99.3888C99.22 16.849 98.9744 17.0922 98.6784 17.2572C98.3824 17.4222 98.048 17.5026 97.7096 17.4898C96.34 17.4778 95.4824 16.3978 95.4824 14.6818ZM96.5784 14.6818C96.5784 15.8818 97.1144 16.5178 98.0072 16.5178C98.9008 16.5178 99.4488 15.8218 99.4488 14.6938C99.4488 13.5658 98.8888 12.8578 98.0072 12.8578C97.1264 12.8578 96.5784 13.5538 96.5784 14.6818Z"
          fill="white"
        />
        <path
          d="M104.868 14.6816C104.844 14.332 104.892 13.9812 105.008 13.651C105.125 13.3208 105.307 13.0183 105.544 12.7622C105.782 12.5061 106.069 12.3018 106.388 12.1622C106.707 12.0226 107.051 11.9506 107.398 11.9506C107.746 11.9506 108.09 12.0226 108.41 12.1622C108.729 12.3018 109.016 12.5061 109.253 12.7622C109.49 13.0183 109.673 13.3208 109.79 13.651C109.906 13.9812 109.954 14.332 109.93 14.6816C109.954 15.0312 109.906 15.3819 109.79 15.7122C109.673 16.0423 109.49 16.3449 109.253 16.601C109.016 16.8571 108.729 17.0614 108.41 17.201C108.09 17.3406 107.746 17.4126 107.398 17.4126C107.051 17.4126 106.707 17.3406 106.388 17.201C106.069 17.0614 105.782 16.8571 105.544 16.601C105.307 16.3449 105.125 16.0423 105.008 15.7122C104.892 15.3819 104.844 15.0312 104.868 14.6816ZM108.834 14.6816C108.834 13.4816 108.31 12.8336 107.405 12.8336C106.499 12.8336 105.963 13.5176 105.963 14.6816C105.963 15.8456 106.476 16.5536 107.405 16.5536C108.334 16.5536 108.834 15.8576 108.834 14.6816Z"
          fill="white"
        />
        <path
          d="M111.347 11.9818H112.36V12.8458H112.443C112.58 12.5381 112.808 12.2806 113.096 12.1086C113.384 11.9367 113.718 11.8589 114.051 11.8858C114.311 11.8669 114.571 11.9069 114.814 12.003C115.057 12.0992 115.274 12.249 115.451 12.4414C115.629 12.6338 115.761 12.8638 115.838 13.1146C115.915 13.3653 115.935 13.6302 115.897 13.8898V17.3938H114.849V14.1538C114.849 13.2778 114.468 12.8458 113.658 12.8458C113.48 12.8314 113.3 12.8576 113.134 12.9225C112.966 12.9874 112.816 13.0893 112.694 13.2207C112.571 13.3522 112.48 13.5097 112.426 13.6816C112.373 13.8535 112.358 14.0354 112.383 14.2138V17.3938H111.323L111.347 11.9818Z"
          fill="white"
        />
        <path
          d="M121.888 10.6377V12.0177H123.079V12.9537H121.888V15.7377C121.888 16.3017 122.114 16.5537 122.638 16.5537H123.044V17.4417C122.854 17.4551 122.662 17.4551 122.472 17.4417C121.281 17.4417 120.828 17.0337 120.828 15.9897V12.9537H119.97V12.0657H120.828V10.6377H121.888Z"
          fill="white"
        />
        <path
          d="M124.485 9.88184H125.545V12.8578H125.628C125.764 12.5509 125.99 12.2932 126.275 12.1194C126.56 11.9457 126.891 11.8642 127.224 11.8858C127.484 11.871 127.744 11.9142 127.986 12.0126C128.226 12.111 128.443 12.2619 128.62 12.4546C128.796 12.6474 128.928 12.8771 129.006 13.1274C129.084 13.3775 129.106 13.642 129.07 13.9018V17.3938H128.01V14.1538C128.01 13.2898 127.618 12.8578 126.819 12.8578C126.638 12.8434 126.454 12.8688 126.283 12.9325C126.112 12.9961 125.957 13.0964 125.827 13.2264C125.698 13.3565 125.598 13.5131 125.535 13.6857C125.472 13.8582 125.447 14.0425 125.462 14.2258V17.3938H124.485V9.88184Z"
          fill="white"
        />
        <path
          d="M135.276 15.9298C135.132 16.4352 134.811 16.8712 134.374 17.1578C133.936 17.4444 133.41 17.5622 132.894 17.4898C132.538 17.5089 132.183 17.4474 131.854 17.3098C131.526 17.1724 131.231 16.9624 130.994 16.6953C130.756 16.4282 130.581 16.1109 130.481 15.7666C130.381 15.4222 130.359 15.0598 130.416 14.7058C130.37 14.3519 130.4 13.9922 130.504 13.6509C130.608 13.3096 130.783 12.9947 131.018 12.7274C131.253 12.4602 131.542 12.2467 131.865 12.1015C132.189 11.9563 132.539 11.8828 132.894 11.8858C134.382 11.8858 135.276 12.9058 135.276 14.6098V14.9818H131.5V15.0418C131.486 15.2419 131.515 15.4426 131.584 15.6307C131.653 15.8189 131.761 15.9901 131.901 16.133C132.04 16.276 132.209 16.3874 132.394 16.4599C132.58 16.5325 132.778 16.5645 132.977 16.5538C133.232 16.5828 133.49 16.5357 133.718 16.4184C133.947 16.301 134.137 16.1186 134.263 15.8938L135.276 15.9298ZM131.56 14.1538H134.263C134.277 13.9721 134.252 13.7896 134.191 13.618C134.13 13.4464 134.035 13.2894 133.91 13.1573C133.786 13.0251 133.636 12.9206 133.469 12.8504C133.302 12.7802 133.122 12.746 132.942 12.7498C132.758 12.7482 132.577 12.7834 132.408 12.8536C132.239 12.9238 132.086 13.0273 131.957 13.1582C131.828 13.289 131.726 13.4445 131.658 13.6155C131.59 13.7866 131.557 13.9695 131.56 14.1538Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1248_23938">
          <rect
            width="163.2"
            height="48"
            fill="white"
            transform="translate(0 0.153687)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  fastMoney: (
    <svg
      width="59"
      height="44"
      viewBox="0 0 23 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5454 6.05787C11.1072 5.8731 10.5813 6.1503 10.4936 6.61227L7.86425 14.928C7.68898 15.39 7.95193 15.9444 8.39015 16.1292C8.47783 16.1292 8.56543 16.2216 8.6531 16.2216C9.00373 16.2216 9.35427 15.9444 9.44195 15.5749L12.0714 7.2591C12.2466 6.79704 11.9837 6.24265 11.5454 6.05787Z"
        fill="white"
      />
      <path
        d="M22.8913 14.0909C22.716 13.8182 22.453 13.6364 22.1024 13.6364H15.6165L21.1383 1.27273C21.226 1 21.226 0.636406 21.0506 0.363672C20.8753 0.0909375 20.6124 0 20.3495 0H10.7083C10.1824 0 9.83185 0.363672 9.83185 0.909063C9.83185 1.45445 10.1825 1.81813 10.7083 1.81813H18.9472L13.4254 14.1818C13.3377 14.4545 13.3377 14.8181 13.5131 15.0909C13.6883 15.3636 13.9513 15.4545 14.2142 15.4545H20.4372L8.07881 34.6363L10.7083 22C10.796 21.7273 10.7083 21.4545 10.533 21.2727C10.3577 21 10.0948 20.9091 9.83185 20.9091H2.20648L8.07888 1.1818C8.25416 0.727266 7.99121 0.181797 7.46538 0.0908594C7.02716 -0.0909375 6.50126 0.181797 6.41359 0.727187L0.278232 21.6362C0.190557 21.818 0.190557 22.0908 0.365907 22.3635C0.541181 22.5453 0.80413 22.7272 1.06708 22.7272H8.78005L5.44947 38.909C5.36179 39.3635 5.53714 39.7272 5.97536 39.909C6.06296 40 6.23824 40 6.32591 40C6.58886 40 6.85181 39.8182 7.02708 39.6363L22.8037 15.0909C22.9789 14.7273 23.0665 14.4545 22.8913 14.0909Z"
        fill="white"
      />
    </svg>
  ),
  manageSales: (
    <svg
      width="59"
      height="58"
      viewBox="0 0 59 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.24848 27.4087C1.93095 27.1019 1.41613 27.1019 1.0986 27.4087C0.781073 27.7154 0.781072 28.2127 1.0986 28.5194C1.41613 28.8262 1.93095 28.8262 2.24848 28.5194C2.566 28.2127 2.56601 27.7154 2.24848 27.4087Z"
        fill="white"
      />
      <path
        d="M7.06938 20.495C7.0693 20.7844 7.12825 21.071 7.24287 21.3384C7.35749 21.6058 7.52554 21.8488 7.73739 22.0535C7.94925 22.2581 8.20078 22.4205 8.4776 22.5312C8.75443 22.6419 9.05112 22.6989 9.35074 22.6988L27.2614 22.6988C27.6279 22.7012 27.9884 22.7891 28.3122 22.9551C28.636 23.1211 28.9134 23.3601 29.121 23.652C29.3285 23.9439 29.4599 24.2799 29.5041 24.6314C29.5483 24.9829 29.5039 25.3395 29.3746 25.6708L29.3576 25.7173C29.1983 26.1336 28.9095 26.4922 28.531 26.7437C28.1524 26.9953 27.7026 27.1277 27.2431 27.1226C26.7836 27.1175 20.7145 27.1226 20.7145 27.1226C20.2265 27.112 19.7475 27.2506 19.346 27.5187C18.9445 27.7868 18.641 28.1706 18.4788 28.6153C18.3631 28.9475 18.3309 29.3015 18.3847 29.6481C18.4386 29.9947 18.577 30.324 18.7886 30.6087C19.0001 30.8935 19.2788 31.1255 19.6014 31.2858C19.9241 31.446 20.2817 31.5297 20.6445 31.5302L27.2435 31.5302C27.703 31.5251 28.1528 31.6574 28.5314 31.909C28.91 32.1606 29.1987 32.5191 29.358 32.9355L29.3751 32.9819C29.5043 33.3133 29.5487 33.6699 29.5045 34.0214C29.4603 34.3729 29.3289 34.7089 29.1214 35.0008C28.9138 35.2926 28.6364 35.5317 28.3126 35.6977C27.9888 35.8637 27.6283 35.9516 27.2618 35.954L15.8741 35.954C15.3861 35.9434 14.9071 36.082 14.5056 36.3501C14.1041 36.6182 13.8005 37.002 13.6384 37.4467C13.5227 37.7789 13.4904 38.1329 13.5443 38.4795C13.5982 38.8261 13.7366 39.1554 13.9481 39.4401C14.1597 39.7249 14.4383 39.9569 14.761 40.1171C15.0837 40.2774 15.4412 40.3611 15.8041 40.3616C15.8041 40.3616 40.9047 40.3344 41.0772 40.2942C43.9967 40.0283 46.6981 38.6864 48.6204 36.547C50.5426 34.4077 51.5381 31.6353 51.4 28.8056C51.2619 25.976 50.0008 23.3064 47.8787 21.3512C45.7566 19.3961 42.9365 18.3056 40.004 18.3062L9.35073 18.2912C9.05112 18.2911 8.75443 18.3481 8.4776 18.4588C8.20078 18.5695 7.94925 18.7318 7.73739 18.9365C7.52554 19.1411 7.35749 19.3841 7.24287 19.6515C7.12825 19.9189 7.0693 20.2055 7.06938 20.495Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M36.9619 32.9998L43.0461 25.653"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.6659 30.7957C42.0359 30.7957 41.5251 31.2891 41.5251 31.8977C41.5251 32.5064 42.0359 32.9998 42.6659 32.9998C43.2959 32.9998 43.8067 32.5064 43.8067 31.8977C43.8067 31.2891 43.2959 30.7957 42.6659 30.7957Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.3422 25.6529C36.7122 25.6529 36.2014 26.1463 36.2014 26.7549C36.2014 27.3635 36.7122 27.8569 37.3422 27.8569C37.9722 27.8569 38.483 27.3635 38.483 26.7549C38.483 26.1463 37.9722 25.6529 37.3422 25.6529Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6633 27.7679L4.67217 27.7679"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.2663 30.3653L13.1152 30.3653"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  dataSecurity: (
    <svg
      width="59"
      height="37"
      viewBox="0 0 59 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M44.3971 6.76108C39.444 5.40391 34.4617 3.29067 29.9889 0.649883C29.7513 0.509609 29.4565 0.509609 29.219 0.649883C24.6172 3.36654 19.9042 5.36545 14.8104 6.76108C14.4813 6.85115 14.2532 7.15026 14.2532 7.49148V15.2291C14.2532 23.1971 17.9291 28.4713 21.0129 31.4927C24.3327 34.7457 28.1999 36.5447 29.604 36.5447C31.0079 36.5447 34.8751 34.7457 38.1949 31.4927C41.2786 28.4714 44.9543 23.1971 44.9543 15.2291V7.49141C44.9543 7.15026 44.7262 6.85115 44.3971 6.76108ZM43.4397 15.229C43.4397 22.6711 40.0112 27.5926 37.1349 30.4108C33.8702 33.6097 30.3797 35.03 29.604 35.03C28.8282 35.03 25.3375 33.6097 22.0727 30.4108C19.1965 27.5925 15.7678 22.6711 15.7678 15.229V8.06629C20.6389 6.68324 25.1753 4.7531 29.6041 2.17946C33.9223 4.68483 38.685 6.71095 43.4397 8.06601V15.229Z"
        fill="white"
      />
      <path
        d="M22.8916 7.98153C22.7383 7.59235 22.2986 7.40117 21.9094 7.55452C20.5566 8.08756 19.1681 8.5782 17.7824 9.01287C17.4666 9.11201 17.2518 9.40451 17.2518 9.7354V12.6598C17.2518 13.078 17.5909 13.417 18.009 13.417C18.4272 13.417 18.7663 13.078 18.7663 12.6598V10.2888C20.0093 9.88664 21.2511 9.44178 22.4646 8.96358C22.8538 8.81037 23.0449 8.37071 22.8916 7.98153Z"
        fill="white"
      />
      <path
        d="M24.3301 8.1252C24.4317 8.1252 24.5348 8.10474 24.6338 8.06157L24.6477 8.05553C25.0308 7.88762 25.2034 7.44163 25.0355 7.05864C24.8674 6.67551 24.4189 6.50219 24.0362 6.66995L24.024 6.67522C23.6406 6.84264 23.4675 7.28828 23.6349 7.67148C23.7592 7.95596 24.038 8.1252 24.3301 8.1252Z"
        fill="white"
      />
      <path
        d="M38.6264 24.963C38.2765 24.7343 37.8072 24.8326 37.5782 25.1827C36.9542 26.1378 36.2221 27.0525 35.402 27.9009C34.7275 28.5986 33.9967 29.2488 33.2298 29.8335C32.8973 30.087 32.8333 30.5622 33.0868 30.8948C33.2359 31.0902 33.4614 31.193 33.6895 31.193C33.8497 31.193 34.011 31.1425 34.1482 31.0378C34.9754 30.4071 35.7636 29.7058 36.4908 28.9536C37.3775 28.0365 38.1699 27.0465 38.8461 26.0111C39.075 25.661 38.9765 25.1917 38.6264 24.963Z"
        fill="white"
      />
      <path
        d="M31.4711 31.0211L31.4276 31.0467C31.0657 31.2563 30.942 31.7195 31.1516 32.0814C31.292 32.324 31.5462 32.4594 31.8077 32.4594C31.9363 32.4594 32.067 32.4266 32.1863 32.3573L32.2364 32.3278C32.5973 32.1165 32.7186 31.6526 32.5072 31.2917C32.2957 30.9309 31.8318 30.8099 31.4711 31.0211Z"
        fill="white"
      />
      <path
        d="M37.3543 13.0301L37.3542 13.03C37.1283 12.8042 36.8268 12.6794 36.5071 12.6794C36.1877 12.6794 35.8859 12.8042 35.66 13.0301L27.531 21.1591L27.5309 21.1591C27.4359 21.2542 27.307 21.3076 27.1724 21.3076C27.0378 21.3076 26.9089 21.2542 26.8136 21.159L23.548 17.8933L23.3712 18.0701L23.548 17.8933C23.3221 17.6674 23.0205 17.5427 22.7009 17.5427C22.3813 17.5427 22.0796 17.6676 21.8537 17.8934L21.8537 17.8935C21.3865 18.3606 21.3866 19.1204 21.8538 19.5876L21.8538 19.5876L26.3252 24.0589L26.3253 24.0589C26.5512 24.2848 26.853 24.4096 27.1724 24.4096C27.4919 24.4096 27.7937 24.2848 28.0196 24.0589L37.3542 14.7242C37.8214 14.257 37.8215 13.4973 37.3543 13.0301Z"
        fill="white"
        stroke="white"
        strokeWidth="0.5"
      />
    </svg>
  ),
  bizAnalystIcon: (
    <svg
      width="163"
      height="40"
      viewBox="0 0 163 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1284_25074"
        maskUnits="userSpaceOnUse"
        x="0"
        y="1"
        width="154"
        height="39"
      >
        <path d="M0 1.26758H153.492V39.1537H0V1.26758Z" fill="white" />
      </mask>
      <g mask="url(#mask0_1284_25074)">
        <path
          d="M111.166 36.0263C111.18 36.2655 111.145 36.5051 111.064 36.7291C110.983 36.953 110.857 37.1563 110.696 37.3252C110.332 37.6515 109.861 37.8167 109.384 37.7861H107.055V31.6546H109.291C109.77 31.624 110.242 31.7824 110.616 32.0988C110.778 32.2597 110.905 32.4561 110.987 32.6741C111.069 32.8921 111.104 33.1264 111.091 33.3604C111.093 33.6246 111.026 33.8844 110.897 34.1113C110.771 34.3368 110.584 34.5177 110.359 34.6309C110.608 34.742 110.818 34.9313 110.961 35.1727C111.103 35.4315 111.175 35.7269 111.166 36.0258M108.156 34.1599H109.207C109.415 34.1752 109.621 34.1069 109.783 33.9689C109.851 33.8995 109.904 33.8156 109.939 33.7229C109.973 33.6301 109.988 33.5307 109.983 33.4313C109.989 33.3271 109.975 33.2226 109.941 33.1247C109.906 33.0267 109.853 32.9374 109.783 32.8627C109.623 32.7216 109.416 32.6515 109.207 32.667H108.156V34.1599ZM110.065 35.9458C110.07 35.8417 110.056 35.7376 110.021 35.6398C109.987 35.542 109.934 35.4526 109.865 35.3772C109.784 35.3038 109.69 35.248 109.588 35.2129C109.487 35.1778 109.379 35.1641 109.273 35.1727H108.156V36.7721H109.273C109.38 36.7807 109.489 36.7658 109.591 36.7283C109.693 36.6908 109.786 36.6316 109.865 36.5542C110.006 36.3868 110.077 36.168 110.065 35.9454"
          fill="#0094FF"
        />
        <path
          d="M113.74 38.1856C113.657 38.4791 113.488 38.7375 113.256 38.923C113.007 39.0887 112.714 39.1693 112.419 39.1539H112.058V38.168H112.385C112.451 38.1795 112.518 38.1771 112.582 38.1609C112.647 38.1446 112.708 38.1149 112.761 38.0734C112.814 38.0319 112.859 37.9795 112.893 37.9194C112.927 37.8592 112.949 37.7926 112.957 37.7234L112.974 37.6614L111.494 33.1653H112.596L113.453 36.0708L114.328 33.1653H115.396L113.74 38.1856Z"
          fill="#0094FF"
        />
        <path
          d="M118.576 36.0706V37.7856H117.474V31.6545H118.576V34.5156L120.585 31.6545H121.906L120.047 34.1159L122.057 37.7856H120.779L119.341 35.0578L118.576 36.0706Z"
          fill="#0094FF"
        />
        <path
          d="M123.37 31.6545V33.5737C123.494 33.4232 123.649 33.3047 123.824 33.2271C124 33.1497 124.188 33.1103 124.379 33.1115C124.573 33.0996 124.767 33.1328 124.947 33.2088C125.127 33.2847 125.289 33.4016 125.421 33.551C125.685 33.8961 125.816 34.3315 125.791 34.7729V37.7848H124.748V34.9061C124.763 34.6858 124.697 34.4679 124.563 34.2973C124.5 34.2272 124.423 34.1722 124.337 34.136C124.252 34.0999 124.16 34.0834 124.067 34.0878C123.975 34.0849 123.882 34.1023 123.796 34.139C123.71 34.1757 123.632 34.2309 123.567 34.3011C123.498 34.3829 123.444 34.4785 123.41 34.5822C123.376 34.6859 123.361 34.7957 123.368 34.9053V37.784H122.325V31.6545H123.37Z"
          fill="#0094FF"
        />
        <path
          d="M129.836 34.7482V37.7869H128.827V37.3867C128.7 37.5323 128.547 37.6501 128.377 37.7333C128.191 37.8104 127.992 37.8466 127.793 37.8397C127.603 37.8521 127.414 37.8247 127.235 37.7591C127.056 37.6935 126.891 37.5909 126.75 37.4575C126.623 37.3173 126.524 37.151 126.461 36.9691C126.397 36.7872 126.37 36.5935 126.38 36.3999C126.372 36.2156 126.403 36.0317 126.471 35.8618C126.54 35.6919 126.644 35.5403 126.775 35.4182C127.088 35.161 127.48 35.0329 127.877 35.0582H128.802V34.6941C128.816 34.5943 128.807 34.4924 128.777 34.3965C128.747 34.3007 128.696 34.2136 128.628 34.142C128.561 34.0705 128.478 34.0164 128.387 33.9843C128.296 33.9521 128.199 33.9426 128.104 33.9566C127.936 33.947 127.77 34.0023 127.637 34.1121C127.581 34.1628 127.536 34.2263 127.506 34.2979C127.476 34.3694 127.462 34.4472 127.465 34.5252V34.5516H126.498V34.516C126.49 34.3209 126.526 34.1266 126.602 33.9485C126.678 33.7704 126.792 33.6133 126.936 33.4899C127.274 33.2225 127.691 33.0889 128.114 33.1127C128.573 33.0806 129.028 33.2277 129.391 33.5259C129.546 33.6828 129.666 33.8736 129.743 34.0847C129.82 34.2959 129.852 34.5222 129.837 34.7477M128.803 36.1427V35.8137H128.045C127.608 35.8137 127.389 36.0003 127.389 36.3735C127.389 36.7588 127.602 36.9512 128.027 36.951C128.134 36.9616 128.241 36.9494 128.343 36.915C128.445 36.8807 128.539 36.8249 128.62 36.7511C128.753 36.5802 128.817 36.3621 128.801 36.1422"
          fill="#0094FF"
        />
        <path
          d="M131.93 36.382C131.93 36.696 132.073 36.853 132.359 36.853H132.687V37.7857H132.191C132.019 37.7953 131.846 37.7683 131.683 37.7065C131.521 37.6447 131.372 37.5492 131.245 37.4258C131.126 37.2976 131.034 37.145 130.974 36.9776C130.914 36.8102 130.887 36.6315 130.896 36.4528V33.9387H130.291V33.1652H130.896V32.2589L131.93 31.8767V33.1648H132.771V33.9379H131.93V36.382Z"
          fill="#0094FF"
        />
        <path
          d="M136.546 34.7482V37.7869H135.537V37.3867C135.41 37.5323 135.257 37.65 135.087 37.7333C134.901 37.8104 134.702 37.8466 134.503 37.8397C134.313 37.8521 134.124 37.8247 133.945 37.7591C133.766 37.6935 133.601 37.5909 133.46 37.4575C133.333 37.3173 133.234 37.151 133.171 36.9691C133.107 36.7872 133.08 36.5935 133.09 36.3999C133.082 36.2156 133.113 36.0317 133.181 35.8618C133.25 35.6919 133.354 35.5403 133.485 35.4182C133.798 35.161 134.19 35.0329 134.587 35.0582H135.512V34.6941C135.526 34.5943 135.517 34.4924 135.487 34.3965C135.457 34.3007 135.406 34.2136 135.338 34.142C135.271 34.0705 135.188 34.0164 135.097 33.9843C135.006 33.9521 134.909 33.9426 134.814 33.9566C134.646 33.947 134.48 34.0023 134.347 34.1121C134.291 34.1628 134.246 34.2263 134.216 34.2979C134.186 34.3694 134.172 34.4472 134.175 34.5252V34.5516H133.208V34.516C133.2 34.3209 133.236 34.1266 133.312 33.9485C133.388 33.7704 133.503 33.6133 133.647 33.4899C133.985 33.2225 134.402 33.089 134.824 33.1127C135.284 33.0806 135.739 33.2277 136.102 33.5259C136.257 33.683 136.377 33.8739 136.453 34.0851C136.53 34.2963 136.562 34.5227 136.546 34.7482ZM135.512 36.1431V35.8142H134.754C134.317 35.8142 134.098 36.0008 134.098 36.374C134.098 36.7592 134.311 36.9516 134.736 36.9514C134.843 36.962 134.95 36.9498 135.052 36.9155C135.154 36.8811 135.248 36.8253 135.329 36.7515C135.462 36.5806 135.526 36.3625 135.51 36.1427"
          fill="#0094FF"
        />
        <path
          d="M138.304 37.7856H137.286V31.6545H138.329V33.6361C138.437 33.4699 138.582 33.3348 138.753 33.2432C138.923 33.1516 139.113 33.1065 139.304 33.1119C139.504 33.1047 139.703 33.1431 139.887 33.2244C140.071 33.3057 140.237 33.428 140.372 33.5829C140.675 33.9884 140.822 34.4991 140.783 35.0134V35.9286C140.821 36.4442 140.675 36.9561 140.372 37.3637C140.243 37.5173 140.083 37.6394 139.904 37.7215C139.726 37.8037 139.532 37.8439 139.337 37.8393C139.141 37.8498 138.946 37.8118 138.766 37.7285C138.586 37.6452 138.428 37.5188 138.303 37.3595L138.304 37.7856ZM139.741 35.0578C139.764 34.7948 139.697 34.5318 139.552 34.3157C139.485 34.2425 139.403 34.1847 139.313 34.1459C139.223 34.1071 139.127 34.0881 139.029 34.0902C138.932 34.0923 138.836 34.1154 138.748 34.158C138.66 34.2006 138.581 34.2619 138.516 34.3379C138.374 34.5472 138.306 34.8013 138.322 35.0574V35.8929C138.306 36.1499 138.377 36.4046 138.522 36.6124C138.589 36.6955 138.674 36.7611 138.769 36.8043C138.865 36.8474 138.969 36.8669 139.072 36.8613C139.521 36.8613 139.745 36.5384 139.745 35.8925L139.741 35.0578Z"
          fill="#0094FF"
        />
        <path
          d="M141.375 35.9022V35.0416C141.34 34.7855 141.362 34.5247 141.438 34.2788C141.515 34.0329 141.643 33.8086 141.814 33.6227C141.985 33.4369 142.194 33.2945 142.425 33.2064C142.657 33.1182 142.904 33.0867 143.149 33.1141C143.62 33.0866 144.082 33.2559 144.435 33.5851C144.605 33.7809 144.734 34.0113 144.815 34.262C144.896 34.5127 144.927 34.7782 144.906 35.042V35.9039C144.928 36.1692 144.897 36.4364 144.816 36.6887C144.735 36.941 144.605 37.1731 144.435 37.3705C144.082 37.6996 143.62 37.8688 143.149 37.8415C142.674 37.8693 142.207 37.7002 141.849 37.3705C141.678 37.1738 141.547 36.9419 141.466 36.6895C141.384 36.4371 141.353 36.1696 141.374 35.9039M143.872 35.0596C143.872 34.414 143.631 34.0911 143.149 34.0908C142.655 34.0908 142.409 34.4137 142.409 35.0596V35.8951C142.409 36.5407 142.655 36.8636 143.149 36.8639C143.631 36.8639 143.872 36.541 143.872 35.8951V35.0596Z"
          fill="#0094FF"
        />
        <path
          d="M145.495 35.9022V35.0416C145.461 34.7855 145.483 34.5247 145.559 34.2788C145.635 34.0329 145.764 33.8086 145.935 33.6227C146.106 33.4369 146.315 33.2945 146.546 33.2064C146.777 33.1182 147.025 33.0867 147.269 33.1141C147.741 33.0866 148.203 33.2559 148.556 33.5851C148.725 33.7809 148.855 34.0113 148.936 34.262C149.017 34.5127 149.048 34.7782 149.027 35.042V35.9039C149.048 36.1692 149.018 36.4364 148.937 36.6887C148.856 36.941 148.726 37.1731 148.556 37.3705C148.203 37.6996 147.741 37.8688 147.269 37.8415C146.794 37.8693 146.328 37.7002 145.97 37.3705C145.799 37.1738 145.668 36.9419 145.586 36.6895C145.504 36.4371 145.473 36.1696 145.495 35.9039M147.992 35.0596C147.992 34.414 147.751 34.0911 147.269 34.0908C146.776 34.0908 146.529 34.4137 146.529 35.0596V35.8951C146.529 36.5407 146.776 36.8636 147.269 36.8639C147.751 36.8639 147.992 36.541 147.992 35.8951V35.0596Z"
          fill="#0094FF"
        />
        <path
          d="M150.734 36.4188V37.7869H149.692V31.6545H150.734V35.0842L152.147 33.1651H153.383L151.886 35.0042L153.492 37.7852H152.231L151.197 35.8485L150.734 36.4188Z"
          fill="#0094FF"
        />
        <path
          d="M42.3908 19.4703C42.3908 21.3341 41.8625 22.7815 40.806 23.8126C39.7494 24.8437 38.2778 25.3592 36.3912 25.3592H28.5518V4.83643H36.0795C37.9849 4.83643 39.4707 5.33213 40.5368 6.32353C41.6029 7.31493 42.136 8.72284 42.136 10.5473C42.1432 11.4323 41.9179 12.3022 41.4849 13.0614C41.0587 13.8173 40.4282 14.4229 39.6737 14.8011C40.5101 15.1721 41.217 15.8058 41.6974 16.6155C42.1777 17.4807 42.4179 18.4699 42.3908 19.4711M32.2592 13.2223H35.7968C36.4966 13.2741 37.1891 13.0456 37.7352 12.5828C37.9628 12.3508 38.14 12.0699 38.2547 11.7593C38.3695 11.4487 38.4191 11.1158 38.4002 10.7832C38.4231 10.4346 38.3757 10.0849 38.2611 9.75694C38.1465 9.42897 37.9673 9.13013 37.7352 8.87997C37.1932 8.40794 36.499 8.17353 35.7968 8.22546H32.2592V13.2223ZM38.6833 19.2009C38.7027 18.8526 38.6537 18.504 38.5392 18.1765C38.4248 17.8491 38.2475 17.5499 38.0183 17.2977C37.4661 16.8013 36.7493 16.5553 36.0248 16.6134H32.2612V21.9685H36.0248C36.387 21.9974 36.7509 21.9476 37.0938 21.8222C37.4368 21.6968 37.7515 21.4984 38.0183 21.2394C38.4874 20.6794 38.7265 19.9469 38.6833 19.2021"
          fill="#0094FF"
        />
        <path
          d="M48.418 7.78088H44.8521V4.83643H48.418V7.78088ZM48.3896 25.3588H44.9087V9.89274H48.3896V25.3588Z"
          fill="#0094FF"
        />
        <path
          d="M54.5873 22.2661H61.0959V25.3593H50.7666V22.2661L57.2764 12.9864H50.7666V9.89282H61.0959V12.986L54.5873 22.2661Z"
          fill="#0094FF"
        />
        <path
          d="M72.0757 21.3739L70.8872 25.3592H66.98L73.9132 4.83643H76.9433L83.9053 25.3592H79.9718L78.7841 21.3739H72.0757ZM75.4151 10.2497L73.066 18.1315H77.7921L75.4151 10.2497Z"
          fill="#0094FF"
        />
        <path
          d="M88.4323 9.89272V11.291C88.8633 10.7785 89.4007 10.3771 90.0028 10.1177C90.6079 9.85184 91.2574 9.71538 91.9133 9.71631C93.4228 9.71631 94.5923 10.212 95.4218 11.2034C96.2514 12.1948 96.6665 13.5531 96.6673 15.2784V25.3592H93.1589V15.7217C93.2032 14.9892 92.9804 14.2664 92.5357 13.7004C92.3228 13.462 92.0633 13.2749 91.7751 13.152C91.4868 13.029 91.1767 12.9731 90.866 12.988C90.5537 12.9779 90.2428 13.0359 89.953 13.1586C89.6632 13.2812 89.4008 13.4657 89.1823 13.7004C88.9494 13.9743 88.7707 14.2942 88.6565 14.6415C88.5424 14.9887 88.495 15.3563 88.5173 15.723V25.3604H85.0088V9.89272H88.4323Z"
          fill="#0094FF"
        />
        <path
          d="M110.28 15.1871V25.3593H106.885V24.0209C106.458 24.5087 105.943 24.9031 105.37 25.1816C104.745 25.4398 104.075 25.5611 103.403 25.5382C101.894 25.5382 100.725 25.1119 99.895 24.2593C99.0654 23.4068 98.6504 22.227 98.6498 20.7199C98.6221 20.1022 98.7274 19.4859 98.9576 18.9168C99.1879 18.3477 99.5373 17.8406 99.9799 17.4331C100.867 16.63 102.103 16.2284 103.688 16.2284H106.801V15.0091C106.801 13.3634 106.018 12.5405 104.452 12.5402C103.885 12.5079 103.327 12.6928 102.881 13.0606C102.691 13.2298 102.54 13.4422 102.439 13.6817C102.339 13.9213 102.291 14.1817 102.301 14.4434V14.5322H99.0462V14.4128C99.02 13.7592 99.1395 13.1082 99.3949 12.5117C99.6504 11.9152 100.035 11.3896 100.518 10.9768C101.499 10.1343 102.82 9.71293 104.48 9.71265C106.347 9.71265 107.781 10.1736 108.781 11.0954C109.782 12.0173 110.282 13.3805 110.281 15.185M106.8 19.855V18.7559H104.253C102.782 18.7559 102.046 19.3806 102.046 20.6298C102.046 21.9187 102.763 22.5632 104.198 22.5632C105.123 22.5632 105.787 22.3397 106.192 21.8927C106.638 21.3219 106.856 20.5917 106.8 19.8554"
          fill="#0094FF"
        />
        <path
          d="M112.77 20.6599V4.83643H116.278V20.424C116.236 20.9009 116.351 21.3785 116.603 21.7774C116.741 21.9223 116.908 22.0334 117.091 22.1028C117.275 22.1722 117.471 22.1982 117.665 22.1788H118.856V25.3613H117.242C115.827 25.3613 114.728 24.9548 113.946 24.1419C113.163 23.329 112.772 22.1691 112.772 20.662"
          fill="#0094FF"
        />
        <path
          d="M126.608 26.6976C126.329 27.6814 125.759 28.5463 124.981 29.1665C124.139 29.7208 123.157 29.9906 122.165 29.9396H120.948V26.6377H122.052C122.492 26.6718 122.932 26.5629 123.311 26.3255C123.644 26.0176 123.877 25.6071 123.976 25.1523L124.033 24.9428L119.052 9.89282H122.76L125.646 19.6187L128.589 9.89282H132.183L126.608 26.6976Z"
          fill="#0094FF"
        />
        <path
          d="M132.607 20.7785V20.6595H135.89V20.719C135.882 20.9854 135.939 21.2496 136.055 21.4864C136.171 21.7233 136.343 21.925 136.555 22.0724C137.073 22.4216 137.681 22.593 138.295 22.5631C138.925 22.5994 139.553 22.4501 140.106 22.1319C140.316 21.9981 140.487 21.8072 140.601 21.5794C140.716 21.3517 140.77 21.0957 140.757 20.8384C140.768 20.6277 140.73 20.4175 140.646 20.2259C140.562 20.0342 140.435 19.8668 140.276 19.738C139.788 19.4175 139.235 19.2237 138.662 19.1728L137.107 18.905C135.635 18.6472 134.55 18.1712 133.852 17.477C133.154 16.7828 132.805 15.7911 132.805 14.502C132.781 13.8328 132.908 13.1673 133.176 12.5598C133.444 11.9524 133.846 11.4203 134.347 11.0073C135.481 10.109 136.876 9.65183 138.294 9.71382C139.289 9.69342 140.277 9.89092 141.195 10.2937C141.974 10.6299 142.65 11.1857 143.148 11.8998C143.607 12.571 143.85 13.3783 143.842 14.2045V14.3825H140.588V14.2937C140.596 14.0482 140.545 13.8044 140.438 13.5856C140.332 13.3669 140.174 13.1805 139.979 13.0442C139.474 12.7188 138.887 12.5632 138.295 12.5984C137.717 12.5581 137.141 12.7144 136.654 13.0442C136.474 13.1786 136.328 13.3574 136.229 13.5649C136.131 13.7724 136.082 14.0023 136.088 14.2342C136.078 14.436 136.113 14.6375 136.189 14.8231C136.265 15.0087 136.38 15.1735 136.526 15.3048C136.949 15.6144 137.442 15.7994 137.956 15.8403L139.682 16.1081C141.153 16.3262 142.257 16.8021 142.991 17.5357C143.368 17.9314 143.661 18.4062 143.851 18.929C144.041 19.4519 144.124 20.0109 144.095 20.5698C144.128 21.2765 143.996 21.981 143.71 22.6215C143.424 23.2619 142.992 23.8187 142.453 24.2429C141.361 25.1058 139.938 25.5373 138.183 25.5373C136.504 25.5373 135.155 25.1061 134.137 24.2438C133.641 23.8331 133.244 23.3052 132.978 22.7032C132.713 22.1011 132.586 21.4417 132.608 20.7785"
          fill="#0094FF"
        />
        <path
          d="M150.662 20.6594C150.662 21.7103 151.143 22.2358 152.106 22.2361H153.209V25.3591H151.54C150.959 25.3913 150.379 25.3013 149.832 25.0944C149.285 24.8875 148.783 24.568 148.356 24.1544C147.957 23.7261 147.646 23.2157 147.444 22.6551C147.242 22.0945 147.152 21.4961 147.181 20.8974V12.4801H145.144V9.89263H147.181V6.85893L150.662 5.58008V9.89263H153.493V12.4805H150.662V20.6594Z"
          fill="#0094FF"
        />
        <path
          d="M20.4078 14.462C21.1151 13.8828 21.6871 13.1415 22.0804 12.2946C22.4737 11.4478 22.6778 10.5177 22.6772 9.5754V7.46396C22.6772 5.82055 22.056 4.24446 20.9503 3.0824C19.8447 1.92033 18.345 1.26749 16.7813 1.26749H16.4333C16.4002 1.26749 16.3703 1.26749 16.3372 1.26749C16.3257 1.26663 16.3141 1.26663 16.3025 1.26749H2.04369C1.51547 1.30787 1.01859 1.54623 0.643507 1.93921C0.268423 2.33219 0.0400654 2.85365 0 3.40868L0 26.79C0.0405213 27.3447 0.269079 27.8656 0.644121 28.2582C1.01916 28.6507 1.51578 28.8888 2.04369 28.9291H16.7813C17.5556 28.9293 18.3223 28.7691 19.0376 28.4578C19.7529 28.1465 20.4029 27.6902 20.9504 27.1149C21.4979 26.5395 21.9322 25.8565 22.2285 25.1047C22.5248 24.3529 22.6773 23.5472 22.6772 22.7335V20.622C22.6778 19.6797 22.4737 18.7496 22.0804 17.9028C21.6871 17.0559 21.1151 16.3146 20.4078 15.7354C20.3157 15.6599 20.2412 15.5633 20.19 15.453C20.1387 15.3427 20.1121 15.2215 20.1121 15.0987C20.1121 14.9759 20.1387 14.8548 20.19 14.7444C20.2412 14.6341 20.3157 14.5375 20.4078 14.462ZM6.35196 22.9111C6.3552 23.1192 6.319 23.3258 6.24549 23.519C6.17198 23.7122 6.06262 23.8881 5.92378 24.0364C5.78494 24.1847 5.6194 24.3025 5.43681 24.3829C5.25422 24.4633 5.05823 24.5047 4.86025 24.5047C4.66228 24.5047 4.46629 24.4633 4.2837 24.3829C4.10111 24.3025 3.93557 24.1847 3.79673 24.0364C3.65789 23.8881 3.54853 23.7122 3.47502 23.519C3.4015 23.3258 3.36531 23.1192 3.36855 22.9111V17.1865C3.36531 16.9784 3.4015 16.7718 3.47502 16.5786C3.54853 16.3854 3.65789 16.2095 3.79673 16.0612C3.93557 15.9129 4.10111 15.7951 4.2837 15.7147C4.46629 15.6343 4.66228 15.5929 4.86025 15.5929C5.05823 15.5929 5.25422 15.6343 5.43681 15.7147C5.6194 15.7951 5.78494 15.9129 5.92378 16.0612C6.06262 16.2095 6.17198 16.3854 6.24549 16.5786C6.319 16.7718 6.3552 16.9784 6.35196 17.1865V22.9111ZM11.4951 22.9111C11.4951 23.3272 11.3378 23.7262 11.0579 24.0205C10.7779 24.3147 10.3983 24.4799 10.0024 24.4799C9.60649 24.4799 9.22682 24.3147 8.94688 24.0205C8.66695 23.7262 8.50968 23.3272 8.50968 22.9111V12.7461C8.50968 12.3301 8.66695 11.931 8.94688 11.6368C9.22682 11.3426 9.60649 11.1773 10.0024 11.1773C10.3983 11.1773 10.7779 11.3426 11.0579 11.6368C11.3378 11.931 11.4951 12.3301 11.4951 12.7461V22.9111ZM16.6382 22.9111C16.6382 23.327 16.481 23.7258 16.2012 24.0199C15.9215 24.3139 15.542 24.4791 15.1463 24.4791C14.7506 24.4791 14.3712 24.3139 14.0914 24.0199C13.8116 23.7258 13.6544 23.327 13.6544 22.9111V8.3263C13.6544 7.91045 13.8116 7.51163 14.0914 7.21758C14.3712 6.92353 14.7506 6.75833 15.1463 6.75833C15.542 6.75833 15.9215 6.92353 16.2012 7.21758C16.481 7.51163 16.6382 7.91045 16.6382 8.3263V22.9111Z"
          fill="#0094FF"
        />
      </g>
      <path
        d="M158.513 0C159.253 0 159.917 0.181016 160.504 0.54305C161.09 0.891674 161.55 1.38109 161.881 2.0113C162.213 2.62809 162.379 3.32534 162.379 4.10304C162.379 4.88075 162.213 5.5847 161.881 6.21491C161.55 6.84511 161.09 7.34123 160.504 7.70326C159.917 8.05189 159.253 8.2262 158.513 8.2262C157.761 8.2262 157.091 8.05189 156.504 7.70326C155.917 7.34123 155.458 6.84511 155.126 6.21491C154.794 5.5847 154.628 4.88075 154.628 4.10304C154.628 3.32534 154.794 2.62809 155.126 2.0113C155.458 1.38109 155.917 0.891674 156.504 0.54305C157.091 0.181016 157.761 0 158.513 0ZM158.513 7.42168C159.432 7.42168 160.172 7.11328 160.733 6.49649C161.307 5.87969 161.594 5.08187 161.594 4.10304C161.594 3.12421 161.307 2.3264 160.733 1.7096C160.172 1.0928 159.432 0.784405 158.513 0.784405C157.582 0.784405 156.836 1.0928 156.274 1.7096C155.726 2.3264 155.451 3.12421 155.451 4.10304C155.451 5.08187 155.726 5.87969 156.274 6.49649C156.836 7.11328 157.582 7.42168 158.513 7.42168ZM160.236 3.2583C160.236 3.58011 160.153 3.85498 159.987 4.08293C159.834 4.29747 159.617 4.45167 159.336 4.54553L160.408 6.21491L159.202 6.23502L158.284 4.62598H157.958V6.23502H156.963V1.91073H158.8C159.234 1.91073 159.579 2.03141 159.834 2.27276C160.102 2.51412 160.236 2.84263 160.236 3.2583ZM157.958 3.76112H158.743C158.883 3.76112 158.998 3.7209 159.087 3.64045C159.189 3.55999 159.24 3.44602 159.24 3.29852C159.24 3.15103 159.189 3.04376 159.087 2.97672C158.998 2.89627 158.883 2.85604 158.743 2.85604H157.958V3.76112Z"
        fill="#0094FF"
      />
    </svg>
  ),
  tick: (
    <svg
      width="16"
      height="12"
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 7L5 11L15 1"
        stroke="#D92D20"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  phoneFilled: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.98356 7.37767C7.56356 8.58569 8.35422 9.71789 9.35553 10.7192C10.3568 11.7205 11.4891 12.5112 12.6971 13.0912C12.801 13.1411 12.8529 13.166 12.9187 13.1852C13.1523 13.2533 13.4392 13.2044 13.637 13.0627C13.6927 13.0228 13.7403 12.9752 13.8356 12.8799C14.1269 12.5886 14.2726 12.4429 14.4191 12.3477C14.9715 11.9885 15.6837 11.9885 16.2361 12.3477C16.3825 12.4429 16.5282 12.5886 16.8196 12.8799L16.9819 13.0423C17.4248 13.4852 17.6462 13.7066 17.7665 13.9444C18.0058 14.4174 18.0058 14.976 17.7665 15.4489C17.6462 15.6867 17.4248 15.9082 16.9819 16.351L16.8506 16.4824C16.4092 16.9238 16.1886 17.1444 15.8885 17.313C15.5556 17.5 15.0385 17.6345 14.6567 17.6333C14.3126 17.6323 14.0774 17.5655 13.607 17.432C11.0792 16.7146 8.69387 15.3608 6.70388 13.3709C4.7139 11.3809 3.36017 8.99557 2.6427 6.46774C2.50919 5.99737 2.44244 5.76218 2.44141 5.41806C2.44028 5.03621 2.57475 4.51913 2.76176 4.18621C2.9303 3.88618 3.15098 3.66551 3.59233 3.22416L3.72369 3.09279C4.16656 2.64992 4.388 2.42849 4.62581 2.3082C5.09878 2.06898 5.65734 2.06898 6.1303 2.3082C6.36812 2.42849 6.58955 2.64992 7.03242 3.09279L7.19481 3.25518C7.48615 3.54652 7.63182 3.69219 7.72706 3.83867C8.08622 4.39108 8.08622 5.10323 7.72706 5.65564C7.63182 5.80212 7.48615 5.94779 7.19482 6.23913C7.09956 6.33439 7.05193 6.38202 7.01206 6.4377C6.87038 6.63556 6.82146 6.92244 6.88957 7.15607C6.90873 7.22181 6.93368 7.27376 6.98356 7.37767Z"
        fill="#DC343B"
      />
    </svg>
  ),
  khatabook_main: (
    <svg
      width="151"
      height="32"
      viewBox="0 0 197 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.2741 4.78493V34.3994L26.0162 34.6313C26.089 34.6374 26.1623 34.6286 26.2316 34.6054C26.3008 34.5821 26.3646 34.5449 26.419 34.4961C26.4734 34.4473 26.5172 34.3879 26.5478 34.3216C26.5783 34.2552 26.595 34.1833 26.5968 34.1102V5.0168C26.5985 4.96297 26.5891 4.90937 26.5693 4.85929C26.5494 4.80922 26.5196 4.76374 26.4815 4.72565C26.4434 4.68757 26.3979 4.65769 26.3478 4.63787C26.2978 4.61804 26.2442 4.60868 26.1903 4.61036C25.3775 4.66855 24.8546 4.72674 24.2741 4.78406M24.2741 2.46136L27.8747 2.11397C28.0095 2.09521 28.1466 2.10499 28.2773 2.14269C28.4081 2.18038 28.5294 2.24515 28.6334 2.33278C28.7375 2.42041 28.8219 2.52895 28.8813 2.65135C28.9407 2.77374 28.9737 2.90726 28.9781 3.04323V36.2588C28.9781 37.3622 28.3971 38.0014 27.1778 37.8268L24.3323 37.2463C24.3323 38.7556 24.4482 40.2077 22.7069 39.9754C22.1259 39.9168 1.56903 37.3618 1.1044 37.304C0.806872 37.2394 0.538384 37.0798 0.339322 36.8495C0.14026 36.6191 0.0213871 36.3303 0.000584481 36.0265V4.84311C0.000584481 3.91386 -0.0576023 2.98461 0.987156 2.69454C1.39403 2.63592 22.1833 0.0231528 22.4738 0.0231528C22.7582 -0.0299148 23.0521 0.00878584 23.3131 0.133667C23.5741 0.258548 23.7887 0.463147 23.9258 0.717922C24.2143 1.25043 24.3354 1.85762 24.2732 2.46005"
        fill="#DC343B"
      />
      <path
        d="M177.24 26.8576V32.3384H172.761V7.51782H177.24V21.5352L182.721 13.736H187.78L181.878 21.5352L188.517 32.3384H183.037L178.822 24.8553L177.24 26.8576ZM40.8582 25.435V32.3393H36.2206V7.51782H40.8582V19.0588L47.9197 7.51782H53.2425L46.0256 17.899L54.1405 32.3384H48.7638L43.2834 21.6941L40.8582 25.435ZM165.751 21.2191C165.751 18.6367 164.592 17.3197 162.589 17.3197C160.428 17.3197 159.376 18.6367 159.376 21.2191V24.6973C159.376 27.2792 160.43 28.5967 162.589 28.5967C164.592 28.5967 165.751 27.2792 165.751 24.6973V21.2191ZM155.053 24.6973V21.2191C155.053 18.4787 155.633 16.6345 157.108 15.317C158.373 13.9996 160.27 13.4199 162.589 13.4199C164.907 13.4199 166.752 13.9996 168.07 15.317C169.492 16.6345 170.072 18.4787 170.072 21.2191V24.6973C170.072 27.4373 169.492 29.3344 168.07 30.5993C166.752 31.9168 164.907 32.4965 162.589 32.4965C160.27 32.4965 158.373 31.9168 157.108 30.5993C155.632 29.3344 155.053 27.4373 155.053 24.6973ZM148.255 21.2191C148.255 18.6367 147.254 17.3197 145.252 17.3197C143.091 17.3197 142.038 18.6367 142.038 21.2191V24.6973C142.038 27.2792 143.092 28.5967 145.252 28.5967C147.254 28.5967 148.255 27.2792 148.255 24.6973V21.2191ZM137.558 24.6973V21.2191C137.558 18.4787 138.296 16.6345 139.613 15.317C141.036 13.9996 142.933 13.4199 145.252 13.4199C147.57 13.4199 149.415 13.9996 150.732 15.317C151.997 16.6345 152.735 18.4787 152.735 21.2191V24.6973C152.735 27.4373 151.997 29.3344 150.732 30.5993C149.415 31.9168 147.57 32.4965 145.252 32.4965C142.933 32.4965 141.035 31.9168 139.614 30.5993C138.297 29.3344 137.559 27.4373 137.559 24.6973M130.709 21.2191C130.709 19.9542 130.445 18.9003 129.866 18.2151C129.444 17.6358 128.706 17.3197 127.705 17.3197C127.289 17.2894 126.873 17.3654 126.495 17.5405C126.117 17.7157 125.79 17.9841 125.544 18.3206C124.914 19.1512 124.597 20.1776 124.649 21.2191V24.6973C124.588 25.7397 124.906 26.7689 125.544 27.5953C126.124 28.3335 126.809 28.5967 127.863 28.5967C129.708 28.5967 130.709 27.2792 130.709 24.6973V21.2191ZM124.543 32.3384H120.169V7.51782H124.648V15.4751C125.142 14.8272 125.78 14.3039 126.512 13.947C127.244 13.5902 128.05 13.4096 128.864 13.4199C130.708 13.4199 132.342 13.9996 133.501 15.317C134.608 16.6345 135.187 18.4787 135.187 21.114V24.8553C135.187 27.4373 134.608 29.3344 133.501 30.5993C132.936 31.2196 132.242 31.7103 131.469 32.0377C130.696 32.3652 129.861 32.5217 129.022 32.4965C127.125 32.4965 125.702 31.9168 124.543 30.5993V32.3384ZM112.739 25.6982V24.2756H109.419C107.575 24.2756 106.679 25.1189 106.679 26.5944C106.679 28.1755 107.575 28.9128 109.419 28.9128C110.578 28.9128 111.475 28.7547 111.894 28.1746C112.489 27.492 112.792 26.6032 112.737 25.6995M117.111 20.061V32.3384H112.739V30.7574C112.219 31.3166 111.591 31.7648 110.894 32.0749C110.105 32.3788 109.264 32.5221 108.419 32.4965C106.417 32.4965 104.941 32.0749 103.939 31.0735C102.87 29.8731 102.303 28.3066 102.358 26.6995C102.327 25.944 102.467 25.191 102.768 24.4974C103.069 23.8037 103.524 23.1874 104.097 22.6946C105.099 21.7988 106.68 21.2182 108.735 21.2182H112.74V19.7961C112.74 17.7939 111.739 16.7396 109.736 16.7396C109.002 16.7403 108.292 17.0019 107.734 17.4778C107.506 17.6744 107.323 17.917 107.196 18.1894C107.068 18.4619 107 18.7581 106.995 19.0588V19.2169H102.78V19.0588C102.77 18.268 102.935 17.4848 103.263 16.7652C103.591 16.0455 104.074 15.4071 104.677 14.8954C105.994 13.8941 107.733 13.419 109.736 13.419C112.16 13.419 113.899 13.9987 115.216 15C116.534 16.159 117.113 17.793 117.113 20.0588M97.1931 26.5944C97.1931 27.8589 97.7728 28.5967 99.0899 28.5967H100.407V32.3384H98.3504C96.8714 32.3636 95.4322 31.8589 94.2929 30.9155C93.7655 30.3834 93.353 29.7487 93.081 29.0507C92.809 28.3526 92.6832 27.6062 92.7114 26.8576V16.7396H90.1295V13.5779H92.7114V9.99467L97.1914 8.3611V13.5779H100.827V16.7396H97.1914L97.1931 26.5944ZM84.0208 25.6982V24.2756H80.8074C78.9628 24.2756 77.9619 25.1189 77.9619 26.5944C77.9619 28.1755 78.8048 28.9128 80.7019 28.9128C81.8613 28.9128 82.7042 28.7547 83.2843 28.1746C83.7771 27.4442 84.0347 26.5805 84.0225 25.6995M88.4977 20.0597V32.3384H84.1241V30.7574C83.5292 31.2982 82.8535 31.7427 82.1214 32.0749C81.3341 32.3838 80.4915 32.5273 79.6463 32.4965C77.8017 32.4965 76.3262 32.0749 75.2193 31.0735C74.6712 30.4888 74.2446 29.8011 73.9642 29.0503C73.6839 28.2994 73.5554 27.5004 73.5862 26.6995C73.5543 25.9441 73.694 25.1913 73.9949 24.4977C74.2957 23.804 74.7498 23.1876 75.3231 22.6946C76.7102 21.6773 78.3997 21.1572 80.1187 21.2182H84.0208V19.7961C84.0208 17.7939 83.0194 16.7396 80.9642 16.7396C80.2773 16.7396 79.6168 17.0039 79.1196 17.4778C78.8557 17.6515 78.6369 17.8854 78.4812 18.1603C78.3255 18.4352 78.2374 18.7432 78.2242 19.0588V19.2169H74.1637V19.0588C74.1637 17.3219 74.7434 15.8967 76.0609 14.8954C77.2198 13.8941 78.9589 13.419 81.1197 13.419C83.4384 13.419 85.2826 13.9987 86.442 15C87.759 16.159 88.4972 17.793 88.4972 20.0588M60.4629 7.51782V15.317C60.9658 14.6224 61.6909 14.1203 62.5181 13.8941C63.2291 13.5706 64.0029 13.4086 64.7839 13.4199C66.6811 13.4199 68.2621 13.9996 69.2639 15.1568C70.3173 16.3162 70.897 18.0549 70.897 20.0575V32.3384H66.4179V20.6394C66.4367 20.1961 66.3672 19.7535 66.2134 19.3373C66.0596 18.9211 65.8246 18.5396 65.5221 18.2151C65.2827 17.9183 64.9764 17.6824 64.6283 17.5268C64.2802 17.3712 63.9002 17.3002 63.5194 17.3197C63.1168 17.3108 62.7168 17.3858 62.3448 17.5399C61.9728 17.6941 61.637 17.924 61.3587 18.2151C61.0561 18.5396 60.8211 18.9211 60.6673 19.3373C60.5136 19.7535 60.444 20.1961 60.4629 20.6394V32.3384H55.9833V7.51782H60.4629Z"
        fill="#DC343B"
      />
      <path
        d="M191.836 2.59253C192.642 2.59253 193.365 2.78012 194.004 3.15529C194.643 3.51657 195.143 4.02375 195.505 4.67684C195.866 5.31602 196.047 6.03858 196.047 6.84451C196.047 7.65045 195.866 8.37995 195.505 9.03304C195.143 9.68612 194.643 10.2002 194.004 10.5754C193.365 10.9367 192.642 11.1173 191.836 11.1173C191.016 11.1173 190.287 10.9367 189.648 10.5754C189.009 10.2002 188.508 9.68612 188.147 9.03304C187.786 8.37995 187.605 7.65045 187.605 6.84451C187.605 6.03858 187.786 5.31602 188.147 4.67684C188.508 4.02375 189.009 3.51657 189.648 3.15529C190.287 2.78012 191.016 2.59253 191.836 2.59253ZM191.836 10.2836C192.837 10.2836 193.643 9.96403 194.254 9.32484C194.879 8.68565 195.192 7.85888 195.192 6.84451C195.192 5.83015 194.879 5.00338 194.254 4.36419C193.643 3.725 192.837 3.40541 191.836 3.40541C190.822 3.40541 190.009 3.725 189.398 4.36419C188.8 5.00338 188.501 5.83015 188.501 6.84451C188.501 7.85888 188.8 8.68565 189.398 9.32484C190.009 9.96403 190.822 10.2836 191.836 10.2836ZM193.712 5.96911C193.712 6.30259 193.622 6.58745 193.441 6.82367C193.274 7.046 193.038 7.20579 192.732 7.30306L193.9 9.03304L192.587 9.05388L191.586 7.38644H191.232V9.05388H190.148V4.57262H192.149C192.621 4.57262 192.997 4.69768 193.274 4.94779C193.566 5.19791 193.712 5.53835 193.712 5.96911ZM191.232 6.49018H192.086C192.239 6.49018 192.364 6.4485 192.462 6.36512C192.573 6.28175 192.628 6.16364 192.628 6.01079C192.628 5.85794 192.573 5.74678 192.462 5.6773C192.364 5.59393 192.239 5.55224 192.086 5.55224H191.232V6.49018Z"
        fill="#DC343B"
      />
    </svg>
  ),
  youtube: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="12" fill="white" />
      <path
        d="M23.1948 12.4023C23.1093 12.0853 22.9424 11.7963 22.7105 11.5639C22.4787 11.3315 22.19 11.1639 21.8733 11.0778C20.6988 10.7553 16 10.75 16 10.75C16 10.75 11.302 10.7448 10.1268 11.053C9.8102 11.1431 9.52212 11.3131 9.29018 11.5466C9.05824 11.7801 8.89022 12.0693 8.80225 12.3865C8.4925 13.561 8.4895 15.997 8.4895 15.997C8.4895 15.997 8.4865 18.445 8.794 19.6075C8.9665 20.2503 9.47275 20.758 10.1163 20.9313C11.3028 21.2538 15.9888 21.259 15.9888 21.259C15.9888 21.259 20.6875 21.2643 21.862 20.9568C22.1789 20.8708 22.4678 20.7035 22.7002 20.4716C22.9327 20.2397 23.1005 19.9512 23.1873 19.6345C23.4978 18.4608 23.5 16.0255 23.5 16.0255C23.5 16.0255 23.515 13.5768 23.1948 12.4023ZM14.497 18.2538L14.5008 13.7538L18.406 16.0075L14.497 18.2538Z"
        fill="#0E1725"
      />
    </svg>
  ),
  linkedin: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="12" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8204 6.66699C10.7863 6.66699 10.7524 6.66742 10.7185 6.66826H21.3532C21.3194 6.66742 21.2854 6.66699 21.2513 6.66699H10.8204ZM21.2809 25.3336H10.7908C10.8007 25.3336 10.8105 25.3337 10.8204 25.3337H21.2513C21.2612 25.3337 21.2711 25.3336 21.2809 25.3336ZM21.1592 22.5722C21.9132 22.5722 22.5246 21.961 22.5248 21.207L22.5256 17.6858C22.5256 15.287 22.0152 13.443 19.2474 13.443C18.728 13.4235 18.2132 13.547 17.7577 13.8004C17.3061 14.0516 16.9295 14.4211 16.6674 14.8702C16.6633 14.8774 16.6556 14.8819 16.6473 14.8819C16.6344 14.8819 16.624 14.8714 16.624 14.8586V14.2732C16.624 13.9371 16.3515 13.6646 16.0154 13.6646H15.3132C14.5892 13.6646 14.0023 14.2515 14.0023 14.9754V21.2065C14.0023 21.9606 14.6137 22.572 15.3678 22.572C16.1219 22.572 16.7332 21.9606 16.7332 21.2065V18.1655C16.7332 17.0035 16.9509 15.8782 18.3732 15.8782C19.7753 15.8782 19.7935 17.2078 19.7935 18.2407V21.2066C19.7935 21.9608 20.4049 22.5722 21.1592 22.5722ZM10.0405 12.1767C10.3011 12.353 10.6076 12.4471 10.921 12.447C11.1291 12.447 11.3352 12.4054 11.5274 12.3247C11.7197 12.244 11.8944 12.1257 12.0415 11.9767C12.1886 11.8276 12.3053 11.6506 12.385 11.4559C12.4646 11.2611 12.5055 11.0524 12.5055 10.8416C12.5054 10.5242 12.4124 10.2139 12.2382 9.94993C12.0641 9.686 11.8165 9.48032 11.5269 9.35888C11.2373 9.23745 10.9187 9.20572 10.6113 9.26771C10.3039 9.3297 10.0215 9.48262 9.79991 9.70714C9.57831 9.93166 9.42743 10.2177 9.36633 10.5291C9.30524 10.8404 9.33668 11.1631 9.45668 11.4564C9.57668 11.7497 9.77985 12.0003 10.0405 12.1767ZM10.9196 22.5722C11.6745 22.5722 12.2864 21.9603 12.2864 21.2054V15.0314C12.2864 14.2765 11.6745 13.6646 10.9196 13.6646C10.1647 13.6646 9.5527 14.2765 9.5527 15.0314V21.2054C9.5527 21.9603 10.1647 22.5722 10.9196 22.5722Z"
        fill="#0E1725"
      />
    </svg>
  ),
  instagram: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="12" fill="white" />
      <path
        d="M15.9992 12.5327C15.0795 12.5327 14.1974 12.8981 13.547 13.5485C12.8966 14.1988 12.5313 15.0809 12.5312 16.0007C12.5313 16.9205 12.8966 17.8026 13.547 18.453C14.1974 19.1033 15.0795 19.4687 15.9992 19.4687C16.919 19.4687 17.8011 19.1033 18.4515 18.453C19.1019 17.8026 19.4672 16.9205 19.4672 16.0007C19.4672 15.0809 19.1019 14.1988 18.4515 13.5485C17.8011 12.8981 16.919 12.5327 15.9992 12.5327ZM15.9992 18.253C15.4017 18.253 14.8287 18.0156 14.4061 17.5931C13.9836 17.1706 13.7462 16.5975 13.7462 16C13.7462 15.4024 13.9836 14.8294 14.4061 14.4069C14.8287 13.9843 15.4017 13.747 15.9992 13.747C16.5968 13.747 17.1698 13.9843 17.5924 14.4069C18.0149 14.8294 18.2523 15.4024 18.2523 16C18.2523 16.5975 18.0149 17.1706 17.5924 17.5931C17.1698 18.0156 16.5968 18.253 15.9992 18.253Z"
        fill="#0E1725"
      />
      <path
        d="M19.6044 13.2138C20.0509 13.2138 20.4129 12.8518 20.4129 12.4053C20.4129 11.9588 20.0509 11.5968 19.6044 11.5968C19.1579 11.5968 18.7959 11.9588 18.7959 12.4053C18.7959 12.8518 19.1579 13.2138 19.6044 13.2138Z"
        fill="#0E1725"
      />
      <path
        d="M22.3997 11.5833C22.2261 11.1349 21.9608 10.7277 21.6207 10.3878C21.2807 10.0479 20.8734 9.78274 20.425 9.60928C19.9002 9.4123 19.3458 9.30579 18.7855 9.29428C18.0632 9.26278 17.8345 9.25378 16.003 9.25378C14.1715 9.25378 13.9367 9.25378 13.2205 9.29428C12.6605 9.3052 12.1065 9.41174 11.5825 9.60928C11.1339 9.78254 10.7265 10.0476 10.3865 10.3876C10.0464 10.7275 9.78114 11.1348 9.60771 11.5833C9.41069 12.108 9.30443 12.6624 9.29346 13.2228C9.26121 13.9443 9.25146 14.173 9.25146 16.0053C9.25146 17.8368 9.25146 18.07 9.29346 18.7878C9.30471 19.3488 9.41046 19.9023 9.60771 20.428C9.78162 20.8764 10.0471 21.2835 10.3873 21.6234C10.7274 21.9633 11.1348 22.2285 11.5832 22.402C12.1063 22.6069 12.6605 22.7211 13.222 22.7395C13.9442 22.771 14.173 22.7808 16.0045 22.7808C17.836 22.7808 18.0707 22.7808 18.787 22.7395C19.3473 22.7281 19.9016 22.6219 20.4265 22.4253C20.8748 22.2514 21.2819 21.986 21.6219 21.646C21.962 21.306 22.2274 20.8989 22.4012 20.4505C22.5985 19.9255 22.7042 19.372 22.7155 18.811C22.7477 18.0895 22.7575 17.8608 22.7575 16.0285C22.7575 14.1963 22.7575 13.9638 22.7155 13.246C22.7067 12.6777 22.5999 12.1152 22.3997 11.5833ZM21.4862 18.7323C21.4814 19.1645 21.4025 19.5927 21.253 19.9983C21.1403 20.2899 20.9679 20.5548 20.7468 20.7758C20.5256 20.9968 20.2607 21.1691 19.969 21.2815C19.5679 21.4304 19.1442 21.5093 18.7165 21.5148C18.004 21.5478 17.803 21.556 15.976 21.556C14.1475 21.556 13.9607 21.556 13.2347 21.5148C12.8072 21.5096 12.3837 21.4306 11.983 21.2815C11.6902 21.1698 11.4242 20.9978 11.2021 20.7768C10.98 20.5557 10.8068 20.2905 10.6937 19.9983C10.5463 19.5971 10.4674 19.1739 10.4605 18.7465C10.4282 18.034 10.4207 17.833 10.4207 16.006C10.4207 14.1783 10.4207 13.9915 10.4605 13.2648C10.4653 12.8328 10.5442 12.4048 10.6937 11.9995C10.9225 11.4078 11.3912 10.942 11.983 10.7155C12.3839 10.5671 12.8072 10.4883 13.2347 10.4823C13.948 10.45 14.1482 10.441 15.976 10.441C17.8037 10.441 17.9912 10.441 18.7165 10.4823C19.1443 10.4874 19.568 10.5663 19.969 10.7155C20.2607 10.8282 20.5256 11.0007 20.7467 11.2218C20.9678 11.4429 21.1403 11.7078 21.253 11.9995C21.4004 12.4007 21.4792 12.8239 21.4862 13.2513C21.5185 13.9645 21.5267 14.1648 21.5267 15.9925C21.5267 17.8195 21.5267 18.016 21.4945 18.733H21.4862V18.7323Z"
        fill="#0E1725"
      />
    </svg>
  ),
  facebook: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="12" fill="white" />
      <path
        d="M18.4715 16.8547C19.0498 16.8547 19.542 16.4339 19.6319 15.8626L19.673 15.6016C19.7872 14.8763 19.2265 14.2204 18.4922 14.2204C17.832 14.2204 17.2968 13.6852 17.2968 13.025V12.5109C17.2968 11.7902 17.6591 11.0877 18.8208 11.0877C19.472 11.0877 20 10.5597 20 9.90848V9.87373C20 9.28013 19.5706 8.77294 18.9794 8.71972C18.6506 8.69013 18.2756 8.66699 17.9067 8.66699C15.7705 8.66699 14.3744 9.9286 14.3744 12.2126V13.0332C14.3744 13.6889 13.8429 14.2204 13.1872 14.2204C12.5315 14.2204 12 14.7519 12 15.4076V15.6675C12 16.3232 12.5315 16.8547 13.1872 16.8547C13.8429 16.8547 14.3744 17.3862 14.3744 18.0419V21.7562C14.3744 22.5998 14.992 23.3339 15.8356 23.3337C16.6793 23.3337 17.2968 22.5998 17.2968 21.7562V18.0294C17.2968 17.3806 17.8227 16.8547 18.4715 16.8547Z"
        fill="#0E1725"
      />
    </svg>
  ),
  twitter: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="12" fill="white" />
      <path
        d="M13.4028 22C18.6861 22 21.5754 17.3837 21.5754 13.3807C21.5754 13.3441 21.5752 13.3076 21.5748 13.2711C21.5728 13.0943 21.6521 12.9264 21.7873 12.8126C22.0686 12.5757 22.3283 12.3122 22.5632 12.0254C22.7012 11.8569 22.5181 11.6236 22.3102 11.6887C22.088 11.7583 21.9291 11.4293 22.0746 11.2475C22.1505 11.1526 22.221 11.0527 22.2856 10.9484C22.4312 10.713 22.1613 10.4844 21.9083 10.5967C21.6562 10.7085 21.3967 10.8014 21.1318 10.8744C20.9218 10.9323 20.7037 10.853 20.5406 10.7087C20.041 10.2665 19.396 10 18.693 10C17.1068 10 15.8205 11.3567 15.8205 13.029C15.8205 13.3788 15.5487 13.7015 15.2024 13.6519C13.6358 13.4277 12.2105 12.7359 11.0569 11.7136C10.4952 11.2158 9.5847 11.3266 9.58531 12.0772C9.58531 12.7917 9.81964 13.4492 10.2119 13.9675C10.3752 14.1832 10.2275 14.5157 9.97498 14.4187C9.8451 14.3689 9.71848 14.309 9.59617 14.2393C9.58101 14.2307 9.56225 14.2412 9.56225 14.2586C9.56225 15.443 10.2075 16.4695 11.1476 16.9672C11.3235 17.0604 11.3083 17.335 11.1092 17.3349C10.8638 17.3347 10.6608 17.5651 10.772 17.7839C10.9026 18.041 11.0675 18.2759 11.2601 18.4819C11.7881 19.0465 12.0276 20.2198 11.2879 20.4441C10.779 20.5984 10.2412 20.681 9.68515 20.681C9.51207 20.681 9.4335 20.9149 9.58455 20.9994C10.7242 21.6369 12.0227 21.9999 13.403 21.9999"
        fill="#0E1725"
      />
    </svg>
  ),
  phone: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.38028 7.85335L6.4788 8.28617L6.4788 8.28617L7.38028 7.85335ZM14.2365 14.7096L14.6693 13.8081L14.6693 13.8081L14.2365 14.7096ZM2.17124 6.76144L3.13324 6.48839H3.13324L2.17124 6.76144ZM15.3284 19.9186L15.6014 18.9566L15.3284 19.9186ZM19.3783 14.6509L18.6712 15.358L18.6712 15.358L19.3783 14.6509ZM19.1835 14.4561L19.8906 13.749L19.8906 13.7489L19.1835 14.4561ZM18.4833 13.8174L19.0284 12.979L18.4833 13.8174ZM16.3029 13.8174L16.848 14.6557L16.848 14.6557L16.3029 13.8174ZM20.3198 17.5389L19.4275 17.0875L20.3198 17.5389ZM20.3198 15.7335L19.4275 16.1848V16.1848L20.3198 15.7335ZM8.27247 3.60655L9.11085 3.06146L9.11085 3.06146L8.27247 3.60655ZM8.27247 5.78692L7.4341 5.24182L7.43409 5.24183L8.27247 5.78692ZM4.55098 1.76999L4.09963 0.877641L4.09963 0.877642L4.55098 1.76999ZM6.35636 1.76999L5.90502 2.66234L6.35636 1.76999ZM16.588 20.1601L16.591 19.1601L16.588 20.1601ZM18.0662 19.7757L17.5765 18.9039L17.5765 18.9039L18.0662 19.7757ZM1.9297 5.50182L2.92969 5.49884V5.49884L1.9297 5.50182ZM2.31411 4.0236L1.44226 3.53384L1.44226 3.53384L2.31411 4.0236ZM14.5024 14.8224L14.7823 13.8623H14.7823L14.5024 14.8224ZM15.3644 14.6754L15.9466 15.4884L15.9466 15.4884L15.3644 14.6754ZM7.26748 7.58743L6.30744 7.86728L6.30744 7.86728L7.26748 7.58743ZM7.41447 6.72538L6.60142 6.14319L6.60141 6.1432L7.41447 6.72538ZM10.9337 11.1561C9.81307 10.0354 8.92958 8.76981 8.28176 7.42053L6.4788 8.28617C7.22297 9.83613 8.23706 11.2878 9.51953 12.5703L10.9337 11.1561ZM14.6693 13.8081C13.32 13.1603 12.0544 12.2768 10.9337 11.1561L9.51953 12.5703C10.802 13.8528 12.2537 14.8669 13.8037 15.611L14.6693 13.8081ZM7.75177 14.3381C5.48744 12.0737 3.94884 9.36196 3.13324 6.48839L1.20923 7.03448C2.11557 10.2277 3.82592 13.2406 6.33755 15.7523L7.75177 14.3381ZM15.6014 18.9566C12.7279 18.141 10.0161 16.6024 7.75177 14.3381L6.33755 15.7523C8.84919 18.2639 11.8621 19.9743 15.0554 20.8806L15.6014 18.9566ZM4.0179 3.57624L4.17554 3.41861L2.76133 2.00439L2.60369 2.16203L4.0179 3.57624ZM6.7318 3.4186L6.92667 3.61347L8.34088 2.19926L8.14601 2.00439L6.7318 3.4186ZM19.9278 19.4861L20.0854 19.3285L18.6712 17.9143L18.5136 18.0719L19.9278 19.4861ZM20.0854 13.9438L19.8906 13.749L18.4764 15.1632L18.6712 15.358L20.0854 13.9438ZM19.8906 13.7489C19.5771 13.4354 19.3142 13.1648 19.0284 12.979L17.9382 14.6557C18.0039 14.6985 18.0907 14.7775 18.4764 15.1632L19.8906 13.7489ZM16.3098 15.1632C16.6955 14.7775 16.7823 14.6985 16.848 14.6557L15.7578 12.979C15.472 13.1648 15.2091 13.4354 14.8956 13.7489L16.3098 15.1632ZM19.0284 12.979C18.034 12.3325 16.7522 12.3325 15.7578 12.979L16.848 14.6557C17.1795 14.4402 17.6067 14.4402 17.9382 14.6557L19.0284 12.979ZM20.0854 19.3285C20.5613 18.8526 20.9775 18.4542 21.2122 17.9902L19.4275 17.0875C19.3735 17.1942 19.2582 17.3273 18.6712 17.9143L20.0854 19.3285ZM18.6712 15.358C19.2583 15.9451 19.3735 16.0781 19.4275 16.1848L21.2122 15.2821C20.9775 14.8181 20.5613 14.4197 20.0854 13.9438L18.6712 15.358ZM21.2122 17.9902C21.6428 17.1389 21.6428 16.1335 21.2122 15.2821L19.4275 16.1848C19.571 16.4686 19.571 16.8037 19.4275 17.0875L21.2122 17.9902ZM6.92667 3.61347C7.31238 3.99918 7.39136 4.08591 7.4341 4.15165L9.11085 3.06146C8.92502 2.77564 8.65439 2.51277 8.34088 2.19926L6.92667 3.61347ZM8.34088 7.19421C8.65439 6.88071 8.92502 6.61783 9.11085 6.332L7.43409 5.24183C7.39136 5.30756 7.31238 5.39429 6.92667 5.78L8.34088 7.19421ZM7.4341 4.15165C7.64959 4.48309 7.64959 4.91038 7.4341 5.24182L9.11085 6.33201C9.75734 5.33767 9.75734 4.0558 9.11085 3.06146L7.4341 4.15165ZM4.17554 3.41861C4.76256 2.83158 4.8956 2.71632 5.00232 2.66234L4.09963 0.877642C3.63559 1.11235 3.23719 1.52853 2.76133 2.00439L4.17554 3.41861ZM8.14601 2.00439C7.67015 1.52853 7.27175 1.11235 6.80771 0.877641L5.90502 2.66234C6.01174 2.71632 6.14478 2.83158 6.7318 3.4186L8.14601 2.00439ZM5.00232 2.66234C5.2861 2.5188 5.62124 2.5188 5.90502 2.66234L6.80771 0.877641C5.95637 0.447036 4.95097 0.447037 4.09963 0.877641L5.00232 2.66234ZM15.0554 20.8806C15.602 21.0358 16.0134 21.1584 16.585 21.1601L16.591 19.1601C16.3368 19.1594 16.1837 19.1219 15.6014 18.9566L15.0554 20.8806ZM18.5136 18.0719C17.9534 18.6321 17.7914 18.7831 17.5765 18.9039L18.556 20.6476C19.0612 20.3638 19.4288 19.9852 19.9278 19.4861L18.5136 18.0719ZM16.585 21.1601C17.2158 21.162 18.0061 20.9565 18.556 20.6476L17.5765 18.9039C17.3274 19.0438 16.8767 19.161 16.591 19.1601L16.585 21.1601ZM3.13324 6.48839C2.96798 5.90614 2.93045 5.75305 2.92969 5.49884L0.9297 5.50479C0.931401 6.07648 1.05408 6.48784 1.20923 7.03448L3.13324 6.48839ZM2.60369 2.16203C2.10466 2.66105 1.72604 3.02866 1.44226 3.53384L3.18597 4.51336C3.30668 4.29848 3.45769 4.13646 4.0179 3.57624L2.60369 2.16203ZM2.92969 5.49884C2.92884 5.21317 3.04606 4.76243 3.18597 4.51336L1.44226 3.53384C1.13333 4.08378 0.927823 4.87402 0.9297 5.50479L2.92969 5.49884ZM13.8037 15.611C13.9095 15.6618 14.0495 15.7319 14.2226 15.7824L14.7823 13.8623C14.7917 13.8651 14.7966 13.8676 14.7854 13.8627C14.7775 13.8593 14.7655 13.8539 14.7454 13.8444C14.725 13.8348 14.7014 13.8235 14.6693 13.8081L13.8037 15.611ZM14.8956 13.7489C14.8341 13.8105 14.8046 13.8398 14.7825 13.8605C14.7657 13.8762 14.7692 13.8717 14.7823 13.8623L15.9466 15.4884C16.0952 15.382 16.2167 15.2562 16.3098 15.1632L14.8956 13.7489ZM14.2226 15.7824C14.7976 15.95 15.4596 15.8371 15.9466 15.4884L14.7823 13.8623C14.7932 13.8545 14.7985 13.8527 14.7963 13.8536C14.7942 13.8544 14.7889 13.8562 14.7814 13.8575C14.7739 13.8588 14.7683 13.8588 14.7661 13.8587C14.7638 13.8586 14.7694 13.8585 14.7823 13.8623L14.2226 15.7824ZM8.28176 7.42053C8.26632 7.38839 8.25503 7.36485 8.24542 7.34443C8.23597 7.32435 8.23051 7.31229 8.22712 7.30448C8.22222 7.29321 8.22478 7.29815 8.22752 7.30757L6.30744 7.86728C6.35789 8.04034 6.428 8.18037 6.4788 8.28617L8.28176 7.42053ZM6.92667 5.78C6.83358 5.87309 6.70782 5.9946 6.60142 6.14319L8.22752 7.30757C8.21816 7.32065 8.21364 7.32412 8.22936 7.30733C8.25002 7.28525 8.27936 7.25574 8.34088 7.19421L6.92667 5.78ZM8.22752 7.30757C8.23128 7.32048 8.23119 7.32606 8.23109 7.32369C8.23099 7.32148 8.23107 7.3159 8.23235 7.3084C8.23363 7.30089 8.2354 7.2956 8.23623 7.29354C8.23711 7.29135 8.23535 7.29664 8.22752 7.30757L6.60141 6.1432C6.25271 6.63018 6.13981 7.29225 6.30744 7.86728L8.22752 7.30757Z"
        fill="#737373"
      />
    </svg>
  ),
  email: (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.66675 3.83325L8.47085 8.59612C9.02182 8.9818 9.29731 9.17465 9.59697 9.24934C9.86166 9.31532 10.1385 9.31532 10.4032 9.24934C10.7029 9.17465 10.9783 8.9818 11.5293 8.59612L18.3334 3.83325M5.66675 14.6666H14.3334C15.7335 14.6666 16.4336 14.6666 16.9684 14.3941C17.4388 14.1544 17.8212 13.772 18.0609 13.3016C18.3334 12.7668 18.3334 12.0667 18.3334 10.6666V5.33325C18.3334 3.93312 18.3334 3.23306 18.0609 2.69828C17.8212 2.22787 17.4388 1.84542 16.9684 1.60574C16.4336 1.33325 15.7335 1.33325 14.3334 1.33325H5.66675C4.26662 1.33325 3.56655 1.33325 3.03177 1.60574C2.56137 1.84542 2.17892 2.22787 1.93923 2.69828C1.66675 3.23306 1.66675 3.93312 1.66675 5.33325V10.6666C1.66675 12.0667 1.66675 12.7668 1.93923 13.3016C2.17892 13.772 2.56137 14.1544 3.03177 14.3941C3.56655 14.6666 4.26662 14.6666 5.66675 14.6666Z"
        stroke="#737373"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  markerPin: (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 22L11.7929 22.7071C12.1834 23.0976 12.8166 23.0976 13.2071 22.7071L12.5 22ZM14.5 10C14.5 11.1046 13.6046 12 12.5 12V14C14.7091 14 16.5 12.2091 16.5 10H14.5ZM12.5 12C11.3954 12 10.5 11.1046 10.5 10H8.5C8.5 12.2091 10.2909 14 12.5 14V12ZM10.5 10C10.5 8.89543 11.3954 8 12.5 8V6C10.2909 6 8.5 7.79086 8.5 10H10.5ZM12.5 8C13.6046 8 14.5 8.89543 14.5 10H16.5C16.5 7.79086 14.7091 6 12.5 6V8ZM19.5 10C19.5 11.8921 18.6468 13.678 17.2077 15.5467C15.7588 17.4281 13.8261 19.2597 11.7929 21.2929L13.2071 22.7071C15.1739 20.7403 17.2412 18.781 18.7923 16.767C20.3532 14.7402 21.5 12.5262 21.5 10H19.5ZM13.2071 21.2929C11.1739 19.2597 9.24122 17.4281 7.79228 15.5467C6.35317 13.678 5.5 11.8921 5.5 10H3.5C3.5 12.5262 4.64683 14.7402 6.20772 16.767C7.75878 18.781 9.82611 20.7403 11.7929 22.7071L13.2071 21.2929ZM5.5 10C5.5 6.13401 8.63401 3 12.5 3V1C7.52944 1 3.5 5.02944 3.5 10H5.5ZM12.5 3C16.366 3 19.5 6.13401 19.5 10H21.5C21.5 5.02944 17.4706 1 12.5 1V3Z"
        fill="#737373"
      />
    </svg>
  ),
  leftBuilding: (
    <svg
      width="444"
      height="536"
      viewBox="0 0 444 536"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1284_22601)">
        <mask
          id="mask0_1284_22601"
          maskUnits="userSpaceOnUse"
          x="280"
          y="195"
          width="120"
          height="265"
        >
          <path d="M280 460L288 195L399.5 213V439L280 460Z" fill="black" />
        </mask>
        <g mask="url(#mask0_1284_22601)">
          <path
            d="M356.542 391.526L376.135 383.922L398.592 408.599L397.436 413.164L392.709 415.45L392.818 472.23L371.233 482.468L353.596 472.382L356.542 391.526Z"
            fill="#D1E7E9"
          />
          <path
            d="M395.355 362.829C395.332 363.615 395.127 364.355 394.781 365.006C393.948 366.575 392.296 367.636 390.413 367.636C390.367 367.636 390.318 367.636 390.271 367.636L382.663 366.083L382.7 364.762L382.713 364.335L373.272 364.071L370.061 478.404L361.752 478.17L370.982 355.033L373.519 355.106L373.301 362.842L382.743 363.107L382.759 362.479L395.349 362.832L395.355 362.829Z"
            fill="#D1E7E9"
          />
          <path
            d="M277.609 253.392L333.372 225.57L375.095 264.865L371.051 492.771L308.745 501.81L291.646 489.858L277.609 253.392Z"
            fill="#E3EFF0"
          />
          <path
            d="M371.127 361.508L320.69 329.983L321.744 324.935L371.861 358.505L371.127 361.508Z"
            fill="#D3E4EC"
          />
          <path
            d="M369.202 381.507L317.638 352.294L318.285 348.667L369.852 378.484L369.202 381.507Z"
            fill="#D3E4EC"
          />
          <path
            d="M323.551 344.898L318.89 342.196L321.946 337.036L326.508 339.87L323.551 344.898Z"
            fill="#D3E4EC"
          />
          <path
            d="M334.772 351.406L330.732 349.064L333.537 344.24L337.494 346.698L334.772 351.406Z"
            fill="#D3E4EC"
          />
          <path
            d="M344.564 357.081L341.03 355.033L343.623 350.504L347.085 352.658L344.564 357.081Z"
            fill="#D3E4EC"
          />
          <path
            d="M353.182 362.076L350.064 360.269L352.472 356.004L355.528 357.904L353.182 362.076Z"
            fill="#D3E4EC"
          />
          <path
            d="M360.827 366.506L358.052 364.901L360.302 360.87L363.02 362.559L360.827 366.506Z"
            fill="#D3E4EC"
          />
          <path
            d="M367.652 370.463L365.171 369.026L367.279 365.204L369.713 366.717L367.652 370.463Z"
            fill="#D3E4EC"
          />
          <path
            d="M331.545 267.775L340.19 272.284C342.556 264.34 346.358 259.239 356.341 266.345C362.158 271.627 365.7 279.945 364.074 286.958L370.665 291.488L372.442 269.235L332.364 233.521L331.545 267.775V267.775Z"
            fill="#D3E4EC"
          />
          <path
            d="M357.646 343.223L340.309 332.226L343.742 282.952C349.341 279.741 354.045 281.997 358.052 292.571L357.646 343.22V343.223Z"
            fill="#D3E4EC"
          />
          <path
            d="M366.03 350.504L361.782 347.822L364.246 294.834C366.483 293.893 367.844 295.026 368.56 297.672L366.03 350.504V350.504Z"
            fill="#D3E4EC"
          />
          <path
            d="M334.367 329.358L330.118 326.712L332.583 273.685C334.819 272.744 336.18 273.877 336.897 276.523L334.367 329.355V329.358Z"
            fill="#D3E4EC"
          />
          <path
            d="M365.171 387.308C365.171 387.308 376.01 402.022 385.256 404.02V408.863L340.312 398.695L319.266 387.685L321.281 366.506L365.174 387.308H365.171Z"
            fill="#D3E4EC"
          />
          <path
            d="M330.732 372.766C330.732 372.766 337.584 385.65 343.745 391.612L350.401 397.483L349.873 400.826L354.19 401.889L354.58 398.08C354.58 398.08 336.797 381.834 336.797 376.499L330.732 372.766V372.766Z"
            fill="#D1E7E9"
          />
          <path
            d="M341.67 378.458C341.67 378.458 348.218 389.009 354.098 394.708L360.457 400.317L359.978 403.109L364.104 404.126L364.451 400.892C364.451 400.892 347.088 386.608 347.088 381.51L341.67 378.461V378.458Z"
            fill="#D1E7E9"
          />
          <path
            d="M350.805 383.215C350.805 383.215 357.197 391.949 362.942 397.248L369.152 402.464L368.64 405.09L372.667 406.035L373.05 402.996C373.05 402.996 357.706 390.611 357.706 385.874L350.805 383.218V383.215Z"
            fill="#D1E7E9"
          />
          <path
            d="M359.176 386.122C359.176 386.122 365.132 394.258 370.484 399.194L376.268 404.053L375.756 406.653L379.509 407.535L379.902 404.552C379.902 404.552 365.608 393.016 365.608 388.603L359.179 386.129L359.176 386.122Z"
            fill="#D1E7E9"
          />
          <path
            d="M322.101 480.998C326.174 467.368 342.496 397.701 342.496 397.701L339.688 396.631L318.972 482.825L322.101 480.998Z"
            fill="#D3E4EC"
          />
          <path
            d="M364.956 484.873C368.775 472.091 384.077 406.782 384.077 406.782L381.444 405.778L362.023 486.584L364.956 484.873Z"
            fill="#D3E4EC"
          />
          <path
            d="M321.278 366.506L319.263 387.685L339.632 398.632L346.275 400.046C346.275 400.046 321.651 375.049 321.278 366.506Z"
            fill="#D1E7E9"
          />
          <path
            d="M340.765 196.559L339.721 222.386L371.015 251.496L372.875 230.952L340.765 196.559Z"
            fill="#D1E7E9"
          />
          <path
            d="M343.863 203.371L343.037 223.37L369.591 247.234L371.064 231.328L343.863 203.371Z"
            fill="#FFFDF3"
          />
          <path
            d="M347.752 238.675L346.163 237.172V227.476H347.752V238.675Z"
            fill="#D1E7E9"
          />
          <path
            d="M366.826 256.042L365.241 254.535V244.843H366.826V256.042Z"
            fill="#D1E7E9"
          />
          <path
            d="M338.112 223.856L369.396 252.213L371.015 251.496L339.721 222.385L338.112 223.856Z"
            fill="#D1E7E9"
          />
          <path
            d="M340.524 223.132L338.113 223.856L338.403 197.712L340.765 196.559L340.524 223.132Z"
            fill="#D1E7E9"
          />
          <path
            d="M322.441 280.675L310.882 279.84L310.294 243.273L322.92 237.605L322.441 280.675Z"
            fill="#D1E7E9"
          />
          <path
            d="M320.891 278.627L312.699 277.53L311.661 244.846L321.407 241.466L320.891 278.627Z"
            fill="#D3E4EC"
          />
          <path
            d="M393.912 340.349L375.095 338.982L376.4 299.766L397.195 296.423L393.912 340.349Z"
            fill="#D1E7E9"
          />
          <path
            d="M391.735 335.229L376.876 334.148L377.906 303.182L394.034 300.536L391.735 335.229Z"
            fill="#D3E4EC"
          />
          <path
            d="M376.882 305.458H373.43V307.381H376.882V305.458Z"
            fill="#D1E7E9"
          />
          <path
            d="M376.096 325.216H372.644V327.139H376.096V325.216Z"
            fill="#D1E7E9"
          />
          <path
            d="M343.746 413.947L360.996 420.884L357.974 476.631L339.474 478.897L343.746 413.947Z"
            fill="#D3E4EC"
          />
          <path
            d="M394.783 365.006C393.951 366.575 392.299 367.636 390.416 367.636C390.37 367.636 390.32 367.636 390.274 367.636L382.666 366.083L382.703 364.762L394.783 365.009V365.006Z"
            fill="#FFFDF3"
          />
          <path
            d="M299.072 280.925C300.757 279.488 300.142 276.001 297.698 273.138C295.255 270.275 291.909 269.12 290.224 270.558C288.539 271.996 289.154 275.482 291.598 278.345C294.041 281.208 297.388 282.363 299.072 280.925Z"
            fill="#D3E4EC"
          />
          <path
            d="M298.986 280.576L298.263 279.73L305.59 274.184L305.303 274.927L298.986 280.576Z"
            fill="#D3E4EC"
          />
          <path
            d="M305.221 274.001L304.646 273.271L303.159 274.443L303.734 275.172L305.221 274.001Z"
            fill="#D3E4EC"
          />
          <path
            d="M305.088 274.613L304.799 274.247L304.161 274.75L304.449 275.116L305.088 274.613Z"
            fill="#D3E4EC"
          />
          <path
            d="M293.479 284.431L294.9 280.411L294.642 280.186L292.941 284.088L293.479 284.431Z"
            fill="#D3E4EC"
          />
          <path
            d="M290.46 281.944L294.441 280.414L294.444 280.077L290.371 281.313L290.46 281.944Z"
            fill="#D3E4EC"
          />
          <path
            d="M348.7 217.695L349.615 217.318C349.979 218.094 350.441 218.844 350.834 219.244C351.254 219.67 351.442 219.68 351.465 219.389C351.489 219.079 351.231 218.705 350.798 218.025L350.151 216.984C349.579 216.082 349.094 214.913 349.156 213.912C349.232 212.719 350.154 212.683 351.343 213.988C351.948 214.649 352.579 215.656 353.005 216.766L352.245 217.126C351.918 216.436 351.624 215.947 351.234 215.527C350.887 215.157 350.663 215.081 350.643 215.382C350.62 215.706 350.92 216.142 351.386 216.888L351.997 217.87C352.612 218.857 352.926 219.779 352.856 220.658C352.774 221.725 351.991 221.966 350.699 220.691C350.028 220.027 349.259 218.943 348.7 217.695V217.695Z"
            fill="#D1E7E9"
          />
          <path
            d="M354.663 219.287L353.372 217.9L353.484 216.466L357.227 220.569L357.101 221.9L355.905 220.618L355.486 225.303L354.257 224.087L354.663 219.287V219.287Z"
            fill="#D1E7E9"
          />
          <path
            d="M357.877 221.282L360.56 224.226L360.424 225.468L358.875 223.806L358.782 224.708L360.11 226.109L359.978 227.334L358.654 225.966L358.551 226.974L360.153 228.596L360.021 229.795L357.309 227.109L357.877 221.282V221.282Z"
            fill="#D1E7E9"
          />
          <path
            d="M361.379 225.121L363.764 227.737L363.622 228.893L362.241 227.413L362.142 228.253L363.325 229.501L363.186 230.644L362.007 229.425L361.898 230.363L363.325 231.81L363.186 232.93L360.768 230.535L361.376 225.121H361.379Z"
            fill="#D1E7E9"
          />
          <path
            d="M364.495 228.537L365.39 229.518L364.888 233.389L366.11 234.628L365.968 235.679L363.857 233.588L364.495 228.533V228.537Z"
            fill="#D1E7E9"
          />
          <path
            d="M348.195 221.124L347.227 220.152L347.313 219.237L350.181 222.141L350.081 223.017L349.147 222.078L348.823 225.124L347.888 224.216L348.199 221.124H348.195Z"
            fill="#D1E7E9"
          />
          <path
            d="M350.699 222.663L352 223.981C352.727 224.718 353.305 225.616 353.176 226.551C353.054 227.447 352.4 227.215 351.68 226.508L351.297 226.132L351.141 227.384L350.246 226.515L350.695 222.666L350.699 222.663ZM351.72 225.659C352.07 226.01 352.278 226.019 352.321 225.696C352.364 225.372 352.192 225.078 351.838 224.724L351.515 224.401L351.399 225.342L351.723 225.663L351.72 225.659ZM351.554 226.089L352.238 226.023L353.024 229.204L352.06 228.266L351.558 226.089H351.554Z"
            fill="#D1E7E9"
          />
          <path
            d="M354.501 226.512L355.525 227.549L355.925 232.025L355.063 231.186L354.964 229.121C354.937 228.702 354.924 228.186 354.898 227.744L354.878 227.724C354.756 228.024 354.614 228.381 354.485 228.649L353.87 230.03L353.001 229.184L354.498 226.512H354.501ZM353.917 228.371L355.466 229.904L355.357 230.624L353.811 229.111L353.917 228.375V228.371Z"
            fill="#D1E7E9"
          />
          <path
            d="M356.731 228.771L357.636 229.69C358.554 230.618 359.086 231.731 358.872 232.927C358.66 234.106 357.963 234.007 357.104 233.178L356.169 232.27L356.731 228.774V228.771ZM357.134 232.369C357.567 232.792 357.937 232.927 358.075 232.134C358.214 231.335 357.904 230.823 357.464 230.387L357.418 230.34L357.088 232.322L357.134 232.369Z"
            fill="#D1E7E9"
          />
          <path
            d="M359.698 231.77L361.544 233.64L361.399 234.367L360.322 233.287L360.223 233.805L361.144 234.724L361.002 235.441L360.084 234.535L359.975 235.117L361.085 236.207L360.946 236.907L359.086 235.1L359.694 231.774L359.698 231.77Z"
            fill="#D1E7E9"
          />
          <path
            d="M362.126 234.232L363.163 235.279C363.741 235.867 364.184 236.594 364.012 237.37C363.847 238.113 363.295 237.942 362.72 237.377L362.413 237.076L362.195 238.117L361.478 237.42L362.126 234.228V234.232ZM362.806 236.676C363.087 236.954 363.265 236.957 363.325 236.69C363.384 236.419 363.252 236.184 362.971 235.9L362.714 235.639L362.552 236.419L362.809 236.673L362.806 236.676ZM362.634 237.036L363.229 236.964L363.698 239.583L362.925 238.83L362.638 237.04L362.634 237.036Z"
            fill="#D1E7E9"
          />
          <path
            d="M363.919 239.336L364.431 239.17C364.573 239.521 364.775 239.864 364.963 240.049C365.164 240.247 365.27 240.254 365.3 240.122C365.333 239.98 365.214 239.808 365.022 239.494L364.738 239.022C364.49 238.615 364.309 238.097 364.408 237.654C364.527 237.126 365.026 237.096 365.591 237.671C365.881 237.965 366.172 238.42 366.34 238.929L365.888 239.094C365.749 238.781 365.617 238.556 365.429 238.364C365.263 238.199 365.145 238.166 365.112 238.302C365.078 238.447 365.214 238.645 365.419 238.982L365.693 239.431C365.974 239.891 366.089 240.32 365.99 240.726C365.871 241.222 365.415 241.314 364.788 240.706C364.467 240.396 364.127 239.897 363.912 239.336H363.919Z"
            fill="#D1E7E9"
          />
          <path
            d="M302.491 241.156L301.147 241.777L302.016 220.645L302.861 220.186L302.491 241.156Z"
            fill="#D9EEE8"
          />
          <path
            d="M301.82 231.48L302.058 230.33L321.288 221.028L321.876 222.016L301.82 231.48Z"
            fill="#D9EEE8"
          />
          <path
            d="M303.053 220.879L302.015 220.661L322.936 205.148L322.867 206.873L303.053 220.879Z"
            fill="#D9EEE8"
          />
          <path
            d="M302.848 221.253L302.613 220.536L321.423 221.378L319.567 222.468L302.848 221.253Z"
            fill="#D9EEE8"
          />
          <path
            d="M303.684 229.696L302.376 230.426L319.583 207.996L320.274 208.587L303.684 229.696Z"
            fill="#D9EEE8"
          />
          <path
            d="M322.55 231.279L319.54 232.534L319.927 207.642L323.151 205.016L322.55 231.279Z"
            fill="#D9EEE8"
          />
          <path
            d="M407.277 285.677L373.529 290.279L373.43 289.301L407.271 284.64L407.277 285.677Z"
            fill="#D9EEE8"
          />
          <path
            d="M380.102 293.648L373.535 290.325L373.945 289.433L380.529 292.766L380.102 293.648Z"
            fill="#D9EEE8"
          />
          <path
            d="M379.594 292.802L386.657 287.685L387.162 288.508L380.099 293.598L379.594 292.802Z"
            fill="#D9EEE8"
          />
          <path
            d="M393.435 291.881L386.795 288.495L387.255 287.58L393.911 290.979L393.435 291.881Z"
            fill="#D9EEE8"
          />
          <path
            d="M392.947 291.019L400.429 285.769L400.918 286.612L393.439 291.831L392.947 291.019Z"
            fill="#D9EEE8"
          />
          <path
            d="M403.194 291.399L373.81 295.211L373.714 294.256L403.174 290.398L403.194 291.399Z"
            fill="#D9EEE8"
          />
          <path
            d="M387.602 293.139L386.809 293.242L386.436 287.507L387.238 287.398L387.602 293.139Z"
            fill="#D9EEE8"
          />
          <path
            d="M387.602 307.83H382.663V324.347H387.602V307.83Z"
            fill="#D1E7E9"
          />
        </g>
        <path
          d="M298.967 198.073L288.55 454.968L221.532 470.953L216.44 469.915L127.669 451.799L143.371 212.949L238.319 144.335L240.816 142.534L298.967 198.073Z"
          fill="#D8EBE9"
        />
        <path
          d="M244.045 182.442L241.926 229.952L284.422 250.069L287.67 218.245L244.045 182.442Z"
          fill="#EBFBEA"
        />
        <path
          d="M238.127 270.336L233.982 315.864L276.576 321.994L279.825 290.174L238.127 270.336Z"
          fill="#EBFBEA"
        />
        <path
          d="M308.416 283.049L286.435 281.83L291.48 216.629L312.569 208.155L308.416 283.049Z"
          fill="#AAD2D0"
        />
        <path
          d="M304.448 278.755L289.51 277.925L293.808 219.024L309.36 214.545L304.448 278.755Z"
          fill="#FAFBDB"
        />
        <path
          d="M291.933 224.282H288.484V225.41H291.933V224.282Z"
          fill="#A3D9D4"
        />
        <path
          d="M287.67 271.948H284.221V273.077H287.67V271.948Z"
          fill="#A3D9D4"
        />
        <path
          d="M302.381 365.698H268.323L271.807 334.373L313.631 330.402L302.381 365.698Z"
          fill="#EBFBEA"
        />
        <path
          d="M299.931 361.773H272.248L274.721 339.564L306.769 335.632L299.931 361.773Z"
          fill="#BDCFE4"
        />
        <path
          d="M271.347 345.435H267.132V347.425H271.347V345.435Z"
          fill="#A4D3B4"
        />
        <path
          d="M269.888 356.504H265.672V358.494H269.888V356.504Z"
          fill="#A4D3B4"
        />
        <path
          d="M305.778 322.698H287.922L289.121 291.689L307.367 300.505L305.778 322.698Z"
          fill="#EBFBEA"
        />
        <path
          d="M287.934 322.698L280.38 322.592L281.799 293.085L289.133 291.689L287.934 322.698Z"
          fill="#BDCFE4"
        />
        <path
          d="M299.211 318.778L290.458 318.282L291.473 298.185L300.843 301.964L299.211 318.778Z"
          fill="#BDCFE4"
        />
        <path
          d="M283.938 302.255L283.258 302.227L283.388 294.477L284.048 294.111L283.938 302.255Z"
          fill="#BDCFE4"
        />
        <path
          d="M285.436 302.078L284.756 302.05L284.882 294.3L285.542 293.934L285.436 302.078Z"
          fill="#BDCFE4"
        />
        <path
          d="M287.076 301.944L286.396 301.916L286.526 294.17L287.186 293.804L287.076 301.944Z"
          fill="#BDCFE4"
        />
        <path
          d="M283.545 312.596L282.865 312.565L282.99 304.818L283.651 304.453L283.545 312.596Z"
          fill="#BDCFE4"
        />
        <path
          d="M285.043 312.42L284.363 312.392L284.489 304.641L285.15 304.276L285.043 312.42Z"
          fill="#BDCFE4"
        />
        <path
          d="M286.682 312.286L286.002 312.258L286.128 304.508L286.789 304.142L286.682 312.286Z"
          fill="#BDCFE4"
        />
        <path
          d="M283.151 321.365L282.471 321.345L282.597 315.046L283.258 314.751L283.151 321.365Z"
          fill="#BDCFE4"
        />
        <path
          d="M284.646 321.224L283.966 321.2L284.096 314.905L284.756 314.606L284.646 321.224Z"
          fill="#BDCFE4"
        />
        <path
          d="M286.29 321.114L285.61 321.094L285.735 314.794L286.396 314.496L286.29 321.114Z"
          fill="#BDCFE4"
        />
        <path
          d="M238.319 144.335L216.44 469.915L127.669 451.799L143.371 212.949L238.319 144.335Z"
          fill="#BDCFE4"
        />
        <path
          d="M293.167 266.007H293.482L293.545 266.565C293.557 266.699 293.572 266.832 293.584 266.962H293.592C293.616 266.829 293.635 266.695 293.659 266.565L293.773 266.007H294.036L294.146 266.569C294.166 266.699 294.19 266.836 294.209 266.97H294.217C294.233 266.836 294.245 266.699 294.261 266.569L294.331 266.007H294.634L294.422 267.289L294.025 267.281L293.938 266.777C293.922 266.679 293.907 266.573 293.895 266.479H293.887C293.875 266.573 293.859 266.679 293.844 266.777L293.753 267.277L293.372 267.269L293.171 266.003L293.167 266.007Z"
          fill="#D8EBE9"
        />
        <path
          d="M294.772 266.007H295.094L295.086 266.491H295.448L295.456 266.007H295.782L295.759 267.313H295.436L295.444 266.794H295.082L295.074 267.301H294.756L294.772 266.007V266.007Z"
          fill="#D8EBE9"
        />
        <path
          d="M295.983 266.656C295.99 266.223 296.23 265.98 296.58 265.98C296.93 265.98 297.162 266.227 297.15 266.664C297.139 267.1 296.895 267.352 296.545 267.344C296.195 267.336 295.975 267.085 295.983 266.652V266.656ZM296.804 266.664C296.812 266.424 296.722 266.282 296.568 266.282C296.415 266.282 296.321 266.42 296.317 266.66C296.313 266.9 296.399 267.049 296.549 267.049C296.698 267.049 296.796 266.904 296.804 266.664Z"
          fill="#D8EBE9"
        />
        <path
          d="M297.387 266.007H297.729L297.693 267.049L298.185 267.057L298.173 267.352L297.343 267.34L297.383 266.011L297.387 266.007Z"
          fill="#D8EBE9"
        />
        <path
          d="M298.441 266.007H299.302L299.29 266.31H298.779L298.771 266.522H299.207L299.196 266.825H298.763L298.755 267.061L299.282 267.069L299.27 267.368L298.397 267.352L298.448 266.003L298.441 266.007Z"
          fill="#D8EBE9"
        />
        <path
          d="M299.436 267.202L299.652 266.958C299.742 267.037 299.86 267.092 299.962 267.096C300.073 267.096 300.12 267.061 300.124 267.002C300.124 266.935 300.057 266.915 299.947 266.868L299.782 266.793C299.64 266.734 299.518 266.608 299.526 266.412C299.538 266.176 299.754 265.983 300.053 265.983C300.21 265.983 300.379 266.042 300.501 266.168L300.305 266.396C300.214 266.329 300.135 266.294 300.033 266.294C299.947 266.294 299.888 266.325 299.884 266.388C299.884 266.455 299.959 266.479 300.08 266.526L300.246 266.593C300.415 266.663 300.505 266.781 300.493 266.974C300.482 267.206 300.277 267.411 299.935 267.403C299.766 267.403 299.573 267.336 299.436 267.202V267.202Z"
          fill="#D8EBE9"
        />
        <path
          d="M301.008 266.007H301.46L301.806 267.411L301.413 267.403L301.295 266.727C301.267 266.593 301.244 266.424 301.216 266.282H301.208C301.169 266.424 301.126 266.593 301.083 266.723L300.886 267.391L300.512 267.383L301.012 266.003L301.008 266.007ZM300.843 266.817L301.527 266.825L301.511 267.108L300.827 267.1L300.843 266.817Z"
          fill="#D8EBE9"
        />
        <path
          d="M301.995 266.007H302.377L302.302 267.108L302.849 267.116L302.825 267.427L301.901 267.411L301.991 266.007H301.995Z"
          fill="#D8EBE9"
        />
        <path
          d="M303.17 266.007H304.134L304.11 266.33H303.54L303.524 266.554H304.012L303.988 266.876H303.505L303.485 267.124L304.075 267.132L304.051 267.446L303.076 267.431L303.178 266.007H303.17Z"
          fill="#D8EBE9"
        />
        <path
          d="M293.187 269.629C293.187 269.192 293.871 269.243 293.875 269C293.875 268.944 293.847 268.913 293.788 268.913C293.725 268.913 293.674 268.952 293.674 269.039C293.674 269.232 293.993 269.511 294.303 269.672C294.429 269.739 294.551 269.79 294.649 269.802L294.555 270.073C294.394 270.042 294.225 269.971 294.067 269.876C293.682 269.644 293.36 269.279 293.36 269.027C293.36 268.838 293.521 268.681 293.784 268.689C294.02 268.697 294.174 268.827 294.174 269.015C294.174 269.369 293.552 269.412 293.552 269.633C293.552 269.711 293.623 269.77 293.741 269.778C293.835 269.782 293.938 269.739 294.036 269.668C294.15 269.578 294.248 269.456 294.299 269.29L294.657 269.306C294.587 269.499 294.472 269.676 294.303 269.833C294.158 269.967 293.953 270.045 293.694 270.03C293.36 270.01 293.198 269.825 293.198 269.633L293.187 269.629Z"
          fill="#D8EBE9"
        />
        <path
          d="M295.318 268.763L295.9 268.783C296.235 268.795 296.522 268.905 296.514 269.243C296.506 269.581 296.211 269.687 295.881 269.672L295.704 269.664L295.692 270.104L295.291 270.084L295.314 268.763H295.318ZM295.857 269.392C296.018 269.4 296.105 269.341 296.109 269.227C296.113 269.113 296.026 269.07 295.865 269.066H295.719L295.712 269.388L295.857 269.396V269.392ZM295.806 269.577L296.089 269.357L296.573 270.155L296.113 270.132L295.806 269.581V269.577Z"
          fill="#D8EBE9"
        />
        <path
          d="M296.816 268.819L297.854 268.858L297.842 269.161L297.229 269.137L297.221 269.35L297.744 269.373L297.732 269.676L297.209 269.652L297.201 269.892L297.838 269.924L297.827 270.223L296.777 270.168L296.82 268.823L296.816 268.819Z"
          fill="#D8EBE9"
        />
        <path
          d="M298.483 269.188L298.051 269.172L298.062 268.866L299.384 268.913L299.368 269.223L298.924 269.204L298.869 270.273L298.432 270.25L298.483 269.184V269.188Z"
          fill="#D8EBE9"
        />
        <path
          d="M299.821 268.929L300.371 268.948L300.808 270.38L300.328 270.356L300.175 269.668C300.139 269.534 300.108 269.361 300.076 269.216H300.064C300.017 269.357 299.966 269.523 299.919 269.656L299.687 270.321L299.235 270.297L299.825 268.929H299.821ZM299.628 269.739L300.462 269.778L300.442 270.065L299.608 270.026L299.624 269.743L299.628 269.739Z"
          fill="#D8EBE9"
        />
        <path
          d="M301.028 268.972L301.496 268.988L301.393 270.407L300.933 270.384L301.032 268.972H301.028Z"
          fill="#D8EBE9"
        />
        <path
          d="M301.877 269.004L302.353 269.019L302.263 270.14L302.947 270.175L302.919 270.494L301.767 270.435L301.877 269.008V269.004Z"
          fill="#D8EBE9"
        />
        <path
          d="M299.459 225.316C299.557 224.101 300.812 223.255 302.212 223.074C302.99 222.976 303.537 223.129 303.891 223.342L303.104 224.053C302.86 223.928 302.609 223.849 302.188 223.9C301.48 223.99 300.918 224.447 300.863 225.107C300.808 225.787 301.205 226.114 302.137 226.004C302.282 225.988 302.444 225.945 302.546 225.89L302.589 225.386L301.818 225.481L301.885 224.698L303.891 224.451L303.733 226.192C303.34 226.483 302.66 226.763 301.921 226.845C300.47 227.014 299.361 226.542 299.459 225.312V225.316Z"
          fill="#D8EBE9"
        />
        <path
          d="M300.544 228.827L302.2 228.642L303.47 232.048L302.019 232.193L301.578 230.53C301.48 230.204 301.39 229.783 301.295 229.441H301.264C301.122 229.818 300.957 230.259 300.804 230.613L300.076 232.39L298.7 232.528L300.544 228.823V228.827ZM299.931 230.947L302.451 230.683L302.388 231.411L299.876 231.67L299.935 230.947H299.931Z"
          fill="#D8EBE9"
        />
        <path
          d="M299.011 234.34L300.933 234.155C302.038 234.049 302.966 234.218 302.888 235.095C302.813 235.941 301.834 236.373 300.737 236.472L300.159 236.523L300.06 237.683L298.727 237.797L299.007 234.34H299.011ZM300.705 235.756C301.24 235.709 301.535 235.52 301.563 235.221C301.59 234.918 301.315 234.848 300.78 234.899L300.296 234.946L300.226 235.803L300.709 235.76L300.705 235.756ZM300.517 236.255L301.476 235.563L302.962 237.435L301.452 237.565L300.517 236.255Z"
          fill="#D8EBE9"
        />
        <path
          d="M298.023 239.657L299.439 239.543L300.08 240.88C300.158 241.06 300.217 241.265 300.292 241.458H300.324C300.434 241.249 300.528 241.033 300.638 240.84L301.491 239.381L302.935 239.267L302.624 242.696L301.409 242.783L301.495 241.78C301.527 241.434 301.68 240.895 301.775 240.549H301.743L301.252 241.403L300.536 242.57L299.828 242.622L299.305 241.548L298.975 240.766H298.943C298.979 241.104 299.042 241.619 299.014 241.965L298.932 242.96L297.76 243.042L298.031 239.664L298.023 239.657Z"
          fill="#D8EBE9"
        />
        <path
          d="M298.444 244.753L301.665 244.544L301.598 245.288L299.691 245.406L299.648 245.929L301.272 245.83L301.205 246.57L299.581 246.664L299.53 247.258L301.504 247.144L301.437 247.879L298.165 248.06L298.436 244.749L298.444 244.753Z"
          fill="#D8EBE9"
        />
        <path
          d="M297.598 249.825L298.92 249.759L299.883 251.166L300.288 251.878H300.319C300.288 251.528 300.225 251.041 300.26 250.639L300.343 249.692L301.597 249.629L301.306 252.904L299.973 252.959L299.014 251.552L298.609 250.848H298.577C298.605 251.217 298.672 251.682 298.64 252.083L298.562 253.018L297.339 253.07L297.598 249.833V249.825Z"
          fill="#D8EBE9"
        />
        <path
          d="M298.464 255.421L297.19 255.464L297.249 254.757L301.111 254.619L301.048 255.335L299.754 255.378L299.538 257.859L298.26 257.894L298.468 255.421H298.464Z"
          fill="#D8EBE9"
        />
        <path
          d="M296.695 262.31L297.453 261.74C297.776 261.913 298.189 262.031 298.543 262.023C298.924 262.02 299.093 261.933 299.105 261.795C299.117 261.646 298.877 261.603 298.484 261.504L297.902 261.351C297.398 261.225 296.978 260.95 297.013 260.502C297.056 259.971 297.827 259.515 298.873 259.495C299.424 259.483 300.021 259.605 300.442 259.884L299.754 260.419C299.439 260.278 299.164 260.203 298.81 260.211C298.499 260.219 298.303 260.293 298.291 260.431C298.279 260.58 298.547 260.628 298.971 260.73L299.541 260.867C300.127 261.013 300.446 261.276 300.411 261.709C300.363 262.24 299.64 262.716 298.448 262.731C297.847 262.739 297.174 262.605 296.687 262.31H296.695Z"
          fill="#D8EBE9"
        />
        <path
          d="M202 178.032L227.944 172.7L213.988 246.876"
          stroke="#FFF3C5"
          strokeWidth="0.45906"
          strokeMiterlimit="10"
        />
        <path
          d="M9.02188 211.56H51.6033V217.362H9.02188V211.56Z"
          fill="white"
        />
        <path
          d="M-12.9997 126.449L-0.132116 535.364L46.441 519.236L164.848 478.227L185.503 160.512L65.6814 96.4568L58.0635 92.3867L-12.9997 126.449Z"
          fill="#C3DEDB"
        />
        <path
          d="M223.526 178.189L207.229 266.808L179.108 258.825L189.612 182.168L223.526 178.189Z"
          fill="#9CC0BE"
        />
        <path
          d="M138.908 487.206C138.908 481.9 144.135 380.722 144.135 380.722L93.8884 365.465L91.947 503.469L138.908 487.206V487.206Z"
          fill="#83A2CC"
        />
        <path
          d="M217.484 184.296L203.528 258.472L182.947 255.059L191.54 189.629L217.484 184.296Z"
          fill="#EFFBDB"
        />
        <path
          d="M152.171 200.908L142.629 277.086L102.403 263.783L108.606 182.534L152.171 200.908Z"
          fill="#9CC0BE"
        />
        <path
          d="M155.697 200.076V203.162L152.171 204.921L104.967 185.981L105.298 179.935L109.668 178.189L155.697 200.076Z"
          fill="#9AAEC7"
        />
        <path
          d="M104.966 184.366L100.16 260.684L103.691 262.22L108.605 182.534L104.966 184.366Z"
          fill="#9AAEC7"
        />
        <path
          d="M149.176 202.118L139.538 277.974L142.968 279.732L152.919 200.516L149.176 202.118Z"
          fill="#9AAEC7"
        />
        <path
          d="M129.192 193.716L119.558 269.577L122.989 271.331L132.94 192.119L129.192 193.716Z"
          fill="#9AAEC7"
        />
        <path
          d="M103.073 223.761L126.283 234.121L127.576 230.795L103.317 220.083L103.073 223.761Z"
          fill="#9AAEC7"
        />
        <path
          d="M115.484 426.874H118.043V439.867H115.484V426.874Z"
          fill="#C7E0D0"
        />
        <path
          d="M174.968 193.547H188.053V196.55H174.968V193.547Z"
          fill="#9CC0BE"
        />
        <path
          d="M169.862 241.669H182.947V244.673H169.862V241.669Z"
          fill="#9CC0BE"
        />
        <path
          d="M146.133 392.502L90.2882 382.69L86.1572 376.274L86.2529 339.251L89.9922 338.468L148.871 356.803L146.133 392.502Z"
          fill="#9CC0BE"
        />
        <path
          d="M200.18 360.233L172.247 364.369L82.8227 340.71L62.8553 341.92L46.1309 335.077L79.4969 327.15L200.18 360.233Z"
          fill="#83A2CC"
        />
        <path
          d="M185.346 308.193L190.94 273.699C191.253 271.758 190.104 269.851 188.045 268.902L86.0445 221.981C82.2443 220.235 77.591 222.525 77.591 226.142V263.74C77.591 265.476 78.7314 267.078 80.564 267.91L176.975 311.723C180.484 313.316 184.815 311.488 185.35 308.188L185.346 308.193Z"
          stroke="#83A2CC"
          strokeWidth="2.53448"
          strokeMiterlimit="10"
        />
        <path
          d="M47.4894 243.023L73.4858 223.047C75.3271 221.341 77.5863 223.578 77.5863 227.104V263.778C77.5863 265.476 77.0334 267.035 76.1454 267.849L47.4894 294.028V243.028V243.023Z"
          stroke="#83A2CC"
          strokeWidth="0.802391"
          strokeMiterlimit="10"
        />
        <path
          d="M116.054 249.727L77.5905 233.037L47.6111 253.009L47.7853 262.103L77.5905 245.37L113.999 261.402"
          stroke="#83A2CC"
          strokeWidth="1.06085"
          strokeMiterlimit="10"
        />
        <path
          d="M114.9 255.055L77.5901 238.91L47.7849 257.266L47.6107 248.173L77.5901 227.104L116.497 243.781"
          stroke="#83A2CC"
          strokeWidth="1.06085"
          strokeMiterlimit="10"
        />
        <path
          d="M158.23 261.759L124.633 247.267"
          stroke="#83A2CC"
          strokeWidth="1.06085"
          strokeMiterlimit="10"
        />
        <path
          d="M156.872 267.818L123.275 253.327"
          stroke="#83A2CC"
          strokeWidth="1.06085"
          strokeMiterlimit="10"
        />
        <path
          d="M156.872 273.225L122.67 258.472"
          stroke="#83A2CC"
          strokeWidth="1.06085"
          strokeMiterlimit="10"
        />
        <path
          d="M155.705 278.94L121.416 263.979"
          stroke="#83A2CC"
          strokeWidth="1.06085"
          strokeMiterlimit="10"
        />
        <path
          d="M209.431 308.21L80.8204 252.274L46.1311 264.715V335.077L80.4199 329.614L200.181 360.233L209.431 308.21Z"
          fill="#A3C4D1"
        />
        <path
          d="M210.458 307.596L200.181 360.233L78.6786 329.892L84.2593 254.859L210.458 307.596Z"
          fill="#C3DEDB"
        />
        <path
          d="M202.384 310.852L196.107 353.895L89.3357 324.36L92.6875 265.981L202.384 310.852Z"
          fill="#819DC0"
        />
        <path
          d="M151 358.744C151 358.744 144.749 481.53 144.571 483.55C144.392 485.565 138.908 487.211 138.908 487.211L144.136 356.933L150.996 358.748L151 358.744Z"
          fill="#9CC0BE"
        />
        <path
          d="M94.3502 356.08C94.3502 356.08 92.0692 497.502 91.8907 499.517C91.7122 501.533 86.2274 503.178 86.2274 503.178L86.2535 364.369L94.3502 356.08V356.08Z"
          fill="#9CC0BE"
        />
        <path
          d="M147.104 381.933L89.6222 369.954L90.5798 367.568L147.722 380.375L147.104 381.933Z"
          fill="#83A2CC"
        />
        <path
          d="M147.104 376.344L89.7223 363.293L90.6801 360.934L147.722 374.798L147.104 376.344Z"
          fill="#83A2CC"
        />
        <path
          d="M147.104 370.824L89.8224 356.72L90.7758 354.387L147.722 369.296L147.104 370.824Z"
          fill="#83A2CC"
        />
        <path
          d="M147.108 365.37L89.9183 350.221L90.8716 347.919L147.722 363.855L147.108 365.37Z"
          fill="#83A2CC"
        />
        <path
          d="M147.722 361.8V363.855L90.8718 347.918L90.9066 345.28L147.722 361.8Z"
          fill="#C7E0D0"
        />
        <path
          d="M147.722 367.424V369.488L90.7715 354.613L90.8106 351.967L147.722 367.424Z"
          fill="#C7E0D0"
        />
        <path
          d="M147.722 372.622V374.685L90.6801 360.799L90.7192 358.148L147.722 372.622Z"
          fill="#C7E0D0"
        />
        <path
          d="M147.722 378.085V380.157L90.5842 367.315L90.6234 364.651L147.722 378.085Z"
          fill="#C7E0D0"
        />
        <path
          d="M-12.948 127.085L-0.080368 536L58.5288 512.677L65.7288 97.0924L58.111 93.0223L-12.948 127.085Z"
          fill="#9CC0BE"
        />
        <path
          d="M197.539 155.81L194.143 169.165L186.047 173.409L183.552 190.46L61.8807 133.788L-12.9959 155.81V108.245L65.4023 80.0543L197.539 155.81Z"
          fill="#9AAEC7"
        />
        <path
          d="M194.143 169.165L65.6985 96.7917L58.3549 103.839L186.047 173.409L194.143 169.165Z"
          fill="#7B92B3"
        />
        <path
          d="M165.183 162.64H176.261C176.261 162.64 175.517 176.957 169.949 177.679C164.382 178.402 163.772 178.15 163.772 178.15L165.183 162.64Z"
          fill="#7B92B3"
        />
        <path
          d="M181.093 165.056C181.093 165.056 180.488 176.335 175.856 178.15C171.224 179.961 167.193 179.56 167.193 179.56L163.768 178.15C163.768 178.15 171.42 176.94 172.43 174.123C173.44 171.307 176.256 162.644 176.256 162.644L181.093 165.06V165.056Z"
          fill="#BBDDEB"
        />
        <path
          d="M147.766 152.528H159.88C159.88 152.528 159.066 168.181 152.981 168.974C146.895 169.766 146.229 169.487 146.229 169.487L147.77 152.528H147.766Z"
          fill="#7B92B3"
        />
        <path
          d="M165.166 155.17C165.166 155.17 164.504 167.502 159.441 169.483C154.374 171.463 149.973 171.024 149.973 171.024L146.23 169.483C146.23 169.483 154.596 168.16 155.698 165.078C156.799 161.996 159.881 152.523 159.881 152.523L165.166 155.166V155.17Z"
          fill="#BBDDEB"
        />
        <path
          d="M128.83 142.49H140.944C140.944 142.49 140.13 158.143 134.045 158.936C127.959 159.723 127.293 159.449 127.293 159.449L128.834 142.49H128.83Z"
          fill="#7B92B3"
        />
        <path
          d="M146.225 145.132C146.225 145.132 145.563 157.465 140.501 159.445C135.434 161.426 131.033 160.986 131.033 160.986L127.289 159.445C127.289 159.445 135.656 158.122 136.757 155.04C137.858 151.958 140.94 142.486 140.94 142.486L146.225 145.128V145.132Z"
          fill="#BBDDEB"
        />
        <path
          d="M106.7 130.928H120.312C120.312 130.928 119.397 148.519 112.559 149.407C105.72 150.295 104.971 149.986 104.971 149.986L106.704 130.928H106.7Z"
          fill="#7B92B3"
        />
        <path
          d="M126.248 133.897C126.248 133.897 125.504 147.757 119.815 149.982C114.121 152.21 109.172 151.714 109.172 151.714L104.966 149.982C104.966 149.982 114.369 148.497 115.61 145.032C116.846 141.567 120.311 130.924 120.311 130.924L126.248 133.893V133.897Z"
          fill="#BBDDEB"
        />
        <path
          d="M84.6558 118.792H98.825C98.825 118.792 97.8716 137.106 90.7544 138.028C83.6372 138.951 82.8536 138.629 82.8536 138.629L84.6558 118.792Z"
          fill="#7B92B3"
        />
        <path
          d="M105.006 121.883C105.006 121.883 104.231 136.309 98.307 138.629C92.3825 140.949 87.2285 140.431 87.2285 140.431L82.8493 138.629C82.8493 138.629 92.6394 137.084 93.9279 133.475C95.2164 129.866 98.8207 118.792 98.8207 118.792L105.002 121.883H105.006Z"
          fill="#BBDDEB"
        />
        <path
          d="M60.4606 106.843H76.0488C76.0488 106.843 74.9998 126.989 67.1687 128.003C59.3376 129.018 58.4799 128.665 58.4799 128.665L60.465 106.843H60.4606Z"
          fill="#7B92B3"
        />
        <path
          d="M82.849 110.243C82.849 110.243 82.0002 126.114 75.4793 128.665C68.9629 131.216 63.2952 130.65 63.2952 130.65L58.4764 128.665C58.4764 128.665 69.2458 126.963 70.6605 122.997C72.0796 119.032 76.0453 106.843 76.0453 106.843L82.8447 110.243H82.849Z"
          fill="#BBDDEB"
        />
        <path
          d="M63.2081 106.482L-12.9961 130.702V120.755L65.698 96.7917L63.2081 106.482Z"
          fill="#7B92B3"
        />
        <path
          d="M117.447 237.073L113.203 267.03"
          stroke="#83A2CC"
          strokeWidth="1.06085"
          strokeMiterlimit="10"
        />
        <path
          d="M126.036 240.002L120.311 269.716"
          stroke="#83A2CC"
          strokeWidth="1.06085"
          strokeMiterlimit="10"
        />
        <path
          d="M158.992 255.86L154.748 284.804"
          stroke="#83A2CC"
          strokeWidth="1.04157"
          strokeMiterlimit="10"
        />
        <path
          d="M167.581 258.694L161.857 287.398"
          stroke="#83A2CC"
          strokeWidth="1.04157"
          strokeMiterlimit="10"
        />
        <path
          d="M190.992 277.086L166.328 264.971"
          stroke="#83A2CC"
          strokeWidth="1.04157"
          strokeMiterlimit="10"
        />
        <path
          d="M189.381 283.141L164.717 271.026"
          stroke="#83A2CC"
          strokeWidth="1.04157"
          strokeMiterlimit="10"
        />
        <path
          d="M188.737 288.029L164.077 275.915"
          stroke="#83A2CC"
          strokeWidth="1.04157"
          strokeMiterlimit="10"
        />
        <path
          d="M188.053 293.453L163.393 281.339"
          stroke="#83A2CC"
          strokeWidth="1.04157"
          strokeMiterlimit="10"
        />
        <path
          d="M14.9941 210.093L43.8678 209.009L44.0985 173.061L14.2105 181.115L14.9941 210.093Z"
          fill="#CCEAD6"
        />
        <path
          d="M43.8504 209.009L53.266 208.534L52.8438 176.235L44.0855 173.057L43.8504 209.009Z"
          fill="#9CC0BE"
        />
        <path
          d="M26.3374 205.435L40.4412 203.955L40.3541 180.083L26.3374 182.808V205.435Z"
          fill="#9CC0BE"
        />
        <path
          d="M49.9484 185.703L50.758 185.768L50.954 177.384L50.1966 176.857L49.9484 185.703Z"
          fill="#558296"
        />
        <path
          d="M48.1503 185.293L48.9774 185.363L49.1951 176.883L48.4159 176.347L48.1503 185.293Z"
          fill="#558296"
        />
        <path
          d="M46.1219 184.902L46.975 184.971L47.2145 176.387L46.4178 175.843L46.1219 184.902Z"
          fill="#558296"
        />
        <path
          d="M49.9441 197.234L50.7624 197.238L50.9584 188.632L50.1922 188.154L49.9441 197.234Z"
          fill="#558296"
        />
        <path
          d="M48.1203 196.96L48.9561 196.964L49.1781 188.262L48.3902 187.775L48.1203 196.96Z"
          fill="#558296"
        />
        <path
          d="M46.0652 196.72L46.9272 196.724L47.1709 187.91L46.3657 187.413L46.0652 196.72Z"
          fill="#558296"
        />
        <path
          d="M50.0095 207.241L50.8367 207.194L50.9672 200.033L50.1881 199.68L50.0095 207.241Z"
          fill="#558296"
        />
        <path
          d="M48.1641 207.124L49.013 207.076L49.161 199.832L48.3644 199.471L48.1641 207.124Z"
          fill="#558296"
        />
        <path
          d="M46.0919 207.05L46.9625 207.002L47.1323 199.659L46.3095 199.293L46.0919 207.05Z"
          fill="#558296"
        />
        <path
          d="M27.6119 183.63L39.0098 181.717L39.0811 182.142L27.6833 184.055L27.6119 183.63Z"
          fill="#558296"
        />
        <path
          d="M27.6872 185.868L39.0618 183.844L39.0487 183.23L27.6872 185.276V185.868Z"
          fill="#558296"
        />
        <path
          d="M27.6876 187.296L39.0883 185.32L39.0795 184.701L27.6876 186.7V187.296Z"
          fill="#558296"
        />
        <path
          d="M27.6876 188.728L39.1187 186.8L39.1056 186.181L27.6876 188.132V188.728Z"
          fill="#558296"
        />
        <path
          d="M27.6874 190.169L39.1489 188.293L39.1359 187.67L27.6874 189.568V190.169Z"
          fill="#558296"
        />
        <path
          d="M27.6876 191.618L39.1753 189.79L39.1666 189.168L27.6876 191.013V191.618Z"
          fill="#558296"
        />
        <path
          d="M27.6874 193.073L39.2056 191.297L39.1925 190.67L27.6874 192.468V193.073Z"
          fill="#558296"
        />
        <path
          d="M27.6878 194.535L39.2365 192.811L39.2234 192.18L27.6878 193.926V194.535Z"
          fill="#558296"
        />
        <path
          d="M27.6876 196.002L39.2667 194.33L39.2537 193.699L27.6876 195.392V196.002Z"
          fill="#558296"
        />
        <path
          d="M27.6875 197.478L39.2971 195.863L39.284 195.227L27.6875 196.864V197.478Z"
          fill="#558296"
        />
        <path
          d="M27.6869 198.962L39.3225 197.399L39.3139 196.759L27.6869 198.344V198.962Z"
          fill="#558296"
        />
        <path
          d="M27.6877 200.455L39.3539 198.945L39.3452 198.301L27.6877 199.833V200.455Z"
          fill="#558296"
        />
        <path
          d="M27.6881 201.953L39.3848 200.499L39.3717 199.85L27.6881 201.33V201.953Z"
          fill="#558296"
        />
        <path
          d="M27.6879 203.459L39.415 202.062L39.402 201.409L27.6879 202.832V203.459Z"
          fill="#558296"
        />
        <path
          d="M180.414 123.994C182.917 129.204 182.233 135.795 178.76 138.459C175.286 141.123 170.615 138.637 168.43 133.179C166.358 127.999 167.316 122.022 170.476 119.602C173.636 117.181 178.037 119.049 180.414 123.994Z"
          fill="#9CC0BE"
        />
        <path
          d="M177.445 138.294L176.705 136.622L191.348 126.475L191.501 127.089L177.445 138.294Z"
          fill="#9CC0BE"
        />
        <path
          d="M189.172 127.725L188.549 126.367L191.523 124.234L192.167 125.579L189.172 127.725Z"
          fill="#9CC0BE"
        />
        <path
          d="M190.387 127.637L190.069 126.954L191.353 126.031L191.675 126.71L190.387 127.637Z"
          fill="#9CC0BE"
        />
        <path
          d="M170.349 140.431L174.776 132.822L174.498 132.382L169.409 139.791L170.349 140.431Z"
          fill="#9CC0BE"
        />
        <path
          d="M175.551 143.308L172.761 136.444L172.121 136.274L174.158 142.512L175.551 143.308Z"
          fill="#9CC0BE"
        />
        <path
          d="M158.222 121.857L78.9226 71.9013L87.2107 9L171.281 72.7719L158.222 121.857Z"
          fill="#C3DEDB"
        />
        <path
          d="M78.9219 71.9013L62.4456 73.66L68.5442 10.2145L87.21 9L78.9219 71.9013Z"
          fill="#7B92B3"
        />
        <path
          d="M132.66 112.715L62.446 73.6599L78.9223 71.9012L158.221 121.857L132.66 112.715Z"
          fill="#7B92B3"
        />
        <path
          d="M153.703 111L87.1368 65.955L91.9077 18.594L162.592 75.7015L153.703 111Z"
          fill="#D5EDEA"
        />
        <path
          d="M129.779 109.929H136.204V120.99H129.779V109.929Z"
          fill="#7B92B3"
        />
        <path
          d="M78.6223 78.8313H85.0474V95.3685H78.6223V78.8313Z"
          fill="#7B92B3"
        />
        <path
          d="M18.716 212.922L43.3803 210.624L50.9676 209.692L53.266 208.534L43.8591 207.637L14.9942 210.093L18.716 212.922Z"
          fill="#9AAEC7"
        />
        <path
          d="M37.9474 208.686L35.0831 209.087L44.8034 217.162L48.1639 216.722L37.9474 208.686Z"
          fill="#9AAEC7"
        />
        <path
          d="M22.1982 210.223L19.3338 210.624L29.0585 218.698L32.4191 218.259L22.1982 210.223Z"
          fill="#9AAEC7"
        />
        <path
          d="M45.8395 209.622H48.1639V216.818H45.8395V209.622Z"
          fill="#9AAEC7"
        />
        <path
          d="M30.0945 210.863H32.4191V218.059H30.0945V210.863Z"
          fill="#9AAEC7"
        />
        <path
          d="M99.0986 166.201C99.0986 166.201 69.7027 150.891 67.265 150.034C64.8273 149.181 41.225 142.442 38.4609 152.437C35.8186 161.992 26.1984 165.295 19.7037 168.917C15.7555 171.12 15.9513 180.727 15.9513 180.727L18.894 179.891C18.894 179.891 18.8549 174.816 19.2597 173.688C21.8585 166.44 37.2073 165.504 39.4099 156.585C41.7039 147.304 54.824 150.796 58.35 151.762C61.8716 152.728 67.2562 153.721 67.2562 153.721L98.5371 168.482L99.0899 166.201H99.0986Z"
          fill="#9AAEC7"
        />
        <path
          d="M98.2629 169.753C96.3011 169.753 94.7108 168.163 94.7108 166.201C94.7108 164.239 96.3011 162.649 98.2629 162.649C100.225 162.649 101.815 164.239 101.815 166.201C101.815 168.163 100.225 169.753 98.2629 169.753Z"
          fill="#9AAEC7"
        />
        <path
          d="M49.196 275.937H53.266V500.962H49.196V275.937Z"
          fill="#C7E0D0"
        />
        <path
          d="M37.5778 236.607H45.8878V498.694H37.5778V236.607Z"
          fill="#C7E0D0"
        />
        <path
          d="M205.395 309.525L198.478 356.929L86.1567 327.15L90.2877 262.442L205.395 309.525Z"
          stroke="white"
          strokeWidth="0.57479"
          strokeMiterlimit="10"
        />
        <path
          d="M83.6067 347.919V473.351"
          stroke="#FFF3C5"
          strokeWidth="0.57479"
          strokeMiterlimit="10"
        />
        <path
          d="M50.9674 234.8H44.1288C40.5114 234.8 37.5775 237.739 37.5775 241.352V245.221H50.9674V234.796V234.8Z"
          fill="#C7E0D0"
        />
        <path
          d="M51.0934 245.222C50.0645 245.222 49.2303 242.889 49.2303 240.011C49.2303 237.133 50.0645 234.801 51.0934 234.801C52.1224 234.801 52.9565 237.133 52.9565 240.011C52.9565 242.889 52.1224 245.222 51.0934 245.222Z"
          fill="#9AAEC7"
        />
        <path
          d="M36.5157 253.005H37.4081C39.8545 252.482 43.2238 252.617 46.0446 253.005H46.8151L46.889 251.855L46.0097 251.807C44.8823 251.207 39.576 250.976 37.5562 251.524H36.5157V253.005V253.005Z"
          fill="#9AAEC7"
        />
        <path
          d="M56.3516 271.875H52.6471C50.6883 271.875 49.0951 273.468 49.0951 275.427V277.525H56.3516V271.875Z"
          fill="#C7E0D0"
        />
        <path
          d="M56.4211 277.525C55.8633 277.525 55.4113 276.261 55.4113 274.7C55.4113 273.14 55.8633 271.875 56.4211 271.875C56.9789 271.875 57.431 273.14 57.431 274.7C57.431 276.261 56.9789 277.525 56.4211 277.525Z"
          fill="#9AAEC7"
        />
        <path
          d="M153.054 194.535L120.55 179.595"
          stroke="#9AAEC7"
          strokeWidth="0.347189"
          strokeMiterlimit="10"
        />
      </g>
      <defs>
        <clipPath id="clip0_1284_22601">
          <rect width="444" height="536" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  rightBuilding: (
    <svg
      width="433"
      height="568"
      viewBox="0 0 433 568"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1284_22602"
        maskUnits="userSpaceOnUse"
        x="53"
        y="181"
        width="189"
        height="324"
      >
        <path
          d="M238 504.5L53.5 476.5L53.5 311.5C112 269.667 230.8 185.2 238 182C245.2 178.8 241 395.667 238 504.5Z"
          fill="black"
        />
      </mask>
      <g mask="url(#mask0_1284_22602)">
        <path
          d="M216.298 546.21L66.0099 517.352C64.7727 499.833 61.5001 457.004 61.5001 457.004L86.6963 451.4L86.9852 395.644L95.417 393.245L115.438 387.543L127.435 384.128L127.606 384.569L135.095 403.956L134.704 382.205L132.933 283.598L176.838 257.706L177.984 258.318L237.81 290.256L224.424 449.512L216.299 546.206L216.298 546.21Z"
          fill="#EFF9F8"
        />
        <path
          d="M119.861 409.646L93.1322 413.722L93.5975 402.942L120.172 398.334L119.861 409.646Z"
          fill="#E1F0F0"
        />
        <path
          d="M113.115 495.425L96.0698 493.966L97.5831 475.953L113.224 473.707L113.115 495.425Z"
          fill="#E1F0F0"
        />
        <path
          d="M96.2279 468.517C96.6655 468.636 115.316 467.668 115.316 467.668L115.348 469.905L95.9772 470.9L96.2241 468.517L96.2279 468.517Z"
          fill="#E1F0F0"
        />
        <path
          d="M95.0927 394.84C95.0927 394.84 95.5395 387.083 105.368 385.278C115.196 383.473 116.948 390.042 116.948 390.042L95.0927 394.84V394.84Z"
          fill="#EFF9F8"
        />
        <path
          d="M175.328 286.579L137.422 298.731L137.215 288.3L174.014 272.12L175.328 286.579Z"
          fill="#E1F0F0"
        />
        <path
          d="M176.474 345.78L138.433 351.232L138.247 341.904L175.16 331.321L176.474 345.78Z"
          fill="#E1F0F0"
        />
        <path
          d="M175.053 382.216L139.431 389.587L139.339 385.078L174.938 377.104L175.053 382.216Z"
          fill="#E1F0F0"
        />
        <path
          d="M187.818 446.767L187.903 469.192L168.34 466.77L167.488 450.513L187.818 446.767Z"
          stroke="#E1F0F0"
          strokeWidth="0.231459"
          strokeMiterlimit="10"
        />
        <path
          d="M186.143 482.89L184.749 521.118L163.181 513.457L164.946 478.045L186.143 482.89Z"
          stroke="#E1F0F0"
          strokeWidth="0.347189"
          strokeMiterlimit="10"
        />
        <path
          d="M187.33 471.317L187.097 477.723L165.445 473.222L165.982 468.12L187.33 471.317Z"
          stroke="#E1F0F0"
          strokeWidth="0.347189"
          strokeMiterlimit="10"
        />
        <path
          d="M132.363 500.922L122.034 496.52L127.228 384.696L127.602 384.572L135.091 403.96L132.363 500.922Z"
          fill="#E1F0F0"
        />
        <path
          d="M81.4732 469.769L67.8228 472.303L67.5324 463.314L84.3362 460.141L81.4732 469.769Z"
          fill="#E1F0F0"
        />
        <path
          d="M77.4557 492.34L72.1232 491.927L72.474 481.915L77.885 479.4L77.4557 492.34Z"
          fill="#E1F0F0"
        />
        <path
          d="M195.518 527.795L216.06 537.878L218.149 450.635L193.754 443.38L195.518 527.795Z"
          fill="#E1F0F0"
        />
        <path
          d="M224.423 449.52C220.976 447.902 218.106 446.073 218.106 446.073L194.141 437.769L186.967 439.337L186.092 428.612L177.98 258.321L237.805 290.26L224.42 449.516L224.423 449.52Z"
          fill="#E1F0F0"
        />
        <path
          d="M133.695 380.154L125.625 380.745L124.553 353.924L133.662 354.868L133.695 380.154Z"
          fill="#EFF9F8"
        />
      </g>
      <path
        d="M210.431 400.413L191.666 391.872L168.293 414.788L169.171 419.324L173.673 421.826L170.397 477.433L190.967 488.665L208.804 479.771L210.431 400.413Z"
        fill="#CFE9E4"
      />
      <path
        d="M174.018 370.14C173.997 370.911 174.156 371.647 174.46 372.304C175.187 373.887 176.746 375.018 178.59 375.123C178.636 375.126 178.684 375.129 178.729 375.131L186.267 374.035L186.306 372.739L186.317 372.321L195.578 372.589L192.342 484.75L200.492 484.984L198.325 363.864L195.836 363.794L195.618 371.384L186.356 371.116L186.375 370.5L174.024 370.143L174.018 370.14Z"
        fill="#CFE9E4"
      />
      <path
        d="M295.451 269.525L242.388 239.163L199.33 275.321L190.569 498.766L251.09 511.097L268.504 500.345L295.451 269.525Z"
        fill="#CBE7E2"
      />
      <path
        d="M197.822 370.198L248.981 342.137L248.231 337.134L197.271 367.216L197.822 370.198Z"
        fill="#BDDAD6"
      />
      <path
        d="M198.591 389.893L250.726 364.16L250.294 360.571L198.123 386.897L198.591 389.893Z"
        fill="#BDDAD6"
      />
      <path
        d="M245.347 356.586L250.063 354.199L247.358 348.975L242.731 351.496L245.347 356.586Z"
        fill="#BDDAD6"
      />
      <path
        d="M233.993 362.333L238.081 360.264L235.603 355.384L231.59 357.57L233.993 362.333Z"
        fill="#BDDAD6"
      />
      <path
        d="M224.086 367.345L227.662 365.537L225.375 360.956L221.864 362.872L224.086 367.345Z"
        fill="#BDDAD6"
      />
      <path
        d="M215.366 371.756L218.521 370.16L216.4 365.849L213.301 367.539L215.366 371.756Z"
        fill="#BDDAD6"
      />
      <path
        d="M207.631 375.669L210.439 374.251L208.46 370.178L205.703 371.68L207.631 375.669Z"
        fill="#BDDAD6"
      />
      <path
        d="M200.726 379.164L203.236 377.895L201.385 374.033L198.916 375.379L200.726 379.164Z"
        fill="#BDDAD6"
      />
      <path
        d="M241.822 280.602L233.103 284.536C231.229 276.623 227.79 271.415 217.616 277.817C211.623 282.666 207.69 290.616 208.891 297.575L202.183 301.644L201.684 279.75L242.931 247.007L241.822 280.602V280.602Z"
        fill="#BDDAD6"
      />
      <path
        d="M212.046 353.042L229.64 343.239L229.029 294.786C223.724 291.328 218.991 293.276 214.476 303.409L212.047 353.039L212.046 353.042Z"
        fill="#BDDAD6"
      />
      <path
        d="M203.429 359.705L207.739 357.315L208.283 305.279C206.145 304.233 204.749 305.266 203.899 307.818L203.429 359.705V359.705Z"
        fill="#BDDAD6"
      />
      <path
        d="M235.621 340.762L239.93 338.407L240.476 286.333C238.338 285.286 236.942 286.32 236.092 288.871L235.621 340.759L235.621 340.762Z"
        fill="#BDDAD6"
      />
      <path
        d="M202.215 395.8C202.215 395.8 190.778 409.606 181.61 411.048L181.34 415.791L225.927 408.341L247.155 398.731L246.364 377.876L202.212 395.8L202.215 395.8Z"
        fill="#BDDAD6"
      />
      <path
        d="M236.758 383.479C236.758 383.479 229.328 395.716 222.961 401.212L216.114 406.59L216.445 409.894L212.156 410.695L211.987 406.942C211.987 406.942 230.311 392.023 230.609 386.797L236.758 383.479V383.479Z"
        fill="#CFE9E4"
      />
      <path
        d="M225.727 388.444C225.727 388.444 218.725 398.413 212.648 403.666L206.106 408.805L206.42 411.566L202.322 412.332L202.163 409.145C202.163 409.145 219.966 396.124 220.25 391.131L225.727 388.447L225.727 388.444Z"
        fill="#CFE9E4"
      />
      <path
        d="M216.515 392.593C216.515 392.593 209.766 400.791 203.844 405.66L197.47 410.422L197.825 413.023L193.828 413.724L193.622 410.726C193.622 410.726 209.343 399.452 209.607 394.812L216.514 392.596L216.515 392.593Z"
        fill="#CFE9E4"
      />
      <path
        d="M208.154 394.973C208.154 394.973 201.866 402.61 196.349 407.145L190.412 411.582L190.768 414.157L187.044 414.811L186.825 411.867C186.825 411.867 201.469 401.367 201.715 397.044L208.15 394.979L208.154 394.973Z"
        fill="#CFE9E4"
      />
      <path
        d="M239.17 489.967C235.942 476.39 223.844 407.245 223.844 407.245L226.654 406.353L242.132 491.931L239.17 489.967Z"
        fill="#BDDAD6"
      />
      <path
        d="M196.98 491.37C193.953 478.639 182.611 413.818 182.611 413.818L185.246 412.982L199.757 493.21L196.98 491.37Z"
        fill="#BDDAD6"
      />
      <path
        d="M246.367 377.876L247.158 398.732L226.597 408.317L220.011 409.331C220.011 409.331 245.524 386.222 246.367 377.876Z"
        fill="#CFE9E4"
      />
      <path
        d="M236.767 210.336L236.347 235.69L204.072 262.455L203.398 242.229L236.767 210.336Z"
        fill="#CFE9E4"
      />
      <path
        d="M233.352 216.835L233.044 236.469L205.705 258.36L205.15 242.699L233.352 216.835Z"
        fill="#FFFDF3"
      />
      <path
        d="M227.573 251.196L229.213 249.813L229.754 240.316L228.198 240.228L227.573 251.196Z"
        fill="#CFE9E4"
      />
      <path
        d="M207.921 267.141L209.558 265.754L210.099 256.261L208.546 256.172L207.921 267.141Z"
        fill="#CFE9E4"
      />
      <path
        d="M237.841 237.219L205.618 263.247L204.073 262.455L236.348 235.69L237.841 237.219Z"
        fill="#CFE9E4"
      />
      <path
        d="M235.519 236.376L237.841 237.219L239.015 211.597L236.766 210.336L235.519 236.376Z"
        fill="#CFE9E4"
      />
      <path
        d="M250.019 293.745L261.387 293.572L264.004 257.791L251.954 251.534L250.019 293.745Z"
        fill="#CFE9E4"
      />
      <path
        d="M251.651 291.826L259.736 291.209L262.577 259.254L253.22 255.4L251.651 291.826Z"
        fill="#BDDAD6"
      />
      <path
        d="M176.687 348.203L195.193 347.914L196.104 309.432L175.923 304.997L176.687 348.203Z"
        fill="#CFE9E4"
      />
      <path
        d="M179.105 343.309L193.719 343.081L194.438 312.693L178.789 309.201L179.105 343.309Z"
        fill="#BDDAD6"
      />
      <path
        d="M195.314 314.98L198.695 315.172L198.588 317.055L195.207 316.863L195.314 314.98Z"
        fill="#CFE9E4"
      />
      <path
        d="M194.981 334.375L198.362 334.568L198.255 336.451L194.873 336.258L194.981 334.375Z"
        fill="#CFE9E4"
      />
      <path
        d="M221.713 423.087L204.43 428.919L204.279 483.688L222.272 486.94L221.713 423.087Z"
        fill="#BDDAD6"
      />
      <path
        d="M174.457 372.304C175.185 373.887 176.743 375.018 178.587 375.123C178.633 375.126 178.681 375.129 178.727 375.131L186.265 374.035L186.303 372.739L174.457 372.307L174.457 372.304Z"
        fill="#FFFDF3"
      />
      <path
        d="M272.893 295.295C271.323 293.792 272.12 290.412 274.673 287.744C277.226 285.077 280.568 284.132 282.138 285.634C283.708 287.137 282.911 290.517 280.358 293.185C277.805 295.852 274.463 296.797 272.893 295.295Z"
        fill="#BDDAD6"
      />
      <path
        d="M272.997 294.957L273.752 294.169L266.886 288.328L267.126 289.072L272.997 294.957Z"
        fill="#BDDAD6"
      />
      <path
        d="M267.258 288.169L267.861 287.487L269.252 288.718L268.648 289.4L267.258 288.169Z"
        fill="#BDDAD6"
      />
      <path
        d="M267.354 288.777L267.656 288.434L268.254 288.963L267.951 289.305L267.354 288.777Z"
        fill="#BDDAD6"
      />
      <path
        d="M278.175 299.041L277.008 295.024L277.273 294.818L278.722 298.734L278.175 299.041Z"
        fill="#BDDAD6"
      />
      <path
        d="M281.271 296.773L277.458 295.053L277.473 294.722L281.394 296.16L281.271 296.773Z"
        fill="#BDDAD6"
      />
      <path
        d="M227.815 230.594L226.939 230.174C226.54 230.914 226.045 231.623 225.638 231.992C225.203 232.386 225.018 232.386 225.012 232.1C225.007 231.794 225.28 231.443 225.742 230.8L226.434 229.817C227.044 228.966 227.585 227.848 227.579 226.864C227.571 225.692 226.671 225.605 225.433 226.816C224.804 227.43 224.13 228.381 223.651 229.445L224.375 229.84C224.733 229.182 225.049 228.719 225.454 228.33C225.814 227.987 226.039 227.925 226.041 228.221C226.046 228.539 225.727 228.949 225.229 229.655L224.576 230.581C223.919 231.515 223.56 232.4 223.579 233.264C223.6 234.314 224.354 234.594 225.69 233.417C226.384 232.804 227.198 231.786 227.815 230.594V230.594Z"
        fill="#CFE9E4"
      />
      <path
        d="M221.886 231.821L223.228 230.534L223.198 229.124L219.303 232.933L219.352 234.244L220.595 233.055L220.744 237.667L222.016 236.545L221.886 231.821V231.821Z"
        fill="#CFE9E4"
      />
      <path
        d="M218.626 233.596L215.835 236.329L215.898 237.553L217.508 236.012L217.549 236.9L216.17 238.198L216.231 239.406L217.605 238.14L217.649 239.133L215.989 240.632L216.051 241.814L218.858 239.335L218.626 233.596V233.596Z"
        fill="#CFE9E4"
      />
      <path
        d="M214.982 237.16L212.5 239.589L212.575 240.73L214.01 239.357L214.06 240.185L212.832 241.342L212.904 242.469L214.127 241.341L214.182 242.266L212.703 243.603L212.776 244.708L215.279 242.497L214.985 237.16L214.982 237.16Z"
        fill="#CFE9E4"
      />
      <path
        d="M211.74 240.331L210.809 241.242L211.084 245.063L209.818 246.208L209.898 247.244L212.083 245.314L211.74 240.328L211.74 240.331Z"
        fill="#CFE9E4"
      />
      <path
        d="M228.118 233.981L229.121 233.084L229.088 232.183L226.117 234.867L226.165 235.73L227.133 234.863L227.28 237.864L228.247 237.026L228.115 233.981L228.118 233.981Z"
        fill="#CFE9E4"
      />
      <path
        d="M225.58 235.349L224.232 236.567C223.479 237.248 222.863 238.096 222.937 239.019C223.006 239.903 223.66 239.713 224.405 239.06L224.801 238.713L224.883 239.948L225.809 239.147L225.583 235.352L225.58 235.349ZM224.413 238.227C224.051 238.55 223.846 238.548 223.823 238.229C223.799 237.909 223.983 237.631 224.349 237.304L224.684 237.005L224.745 237.934L224.41 238.23L224.413 238.227ZM224.551 238.656L223.885 238.554L222.938 241.625L223.935 240.76L224.548 238.656L224.551 238.656Z"
        fill="#CFE9E4"
      />
      <path
        d="M221.641 238.906L220.58 239.865L219.939 244.227L220.83 243.453L221.043 241.436C221.092 241.027 221.134 240.523 221.184 240.091L221.205 240.072C221.308 240.374 221.427 240.731 221.538 241L222.063 242.387L222.961 241.607L221.644 238.906L221.641 238.906ZM222.11 240.76L220.507 242.175L220.574 242.886L222.172 241.491L222.11 240.763L222.11 240.76Z"
        fill="#CFE9E4"
      />
      <path
        d="M219.331 240.995L218.394 241.844C217.442 242.702 216.859 243.762 217.003 244.945C217.144 246.112 217.832 246.054 218.72 245.29L219.686 244.452L219.331 240.998L219.331 240.995ZM218.736 244.496C218.288 244.886 217.918 244.998 217.827 244.213C217.735 243.423 218.068 242.938 218.523 242.536L218.571 242.493L218.784 244.453L218.736 244.496Z"
        fill="#CFE9E4"
      />
      <path
        d="M216.258 243.767L214.345 245.495L214.447 246.215L215.562 245.217L215.63 245.73L214.676 246.578L214.775 247.288L215.725 246.453L215.8 247.029L214.652 248.035L214.748 248.728L216.671 247.062L216.261 243.77L216.258 243.767Z"
        fill="#CFE9E4"
      />
      <path
        d="M213.743 246.042L212.668 247.01C212.069 247.553 211.595 248.24 211.72 249.01C211.84 249.748 212.39 249.61 212.985 249.089L213.302 248.812L213.458 249.843L214.199 249.2L213.743 246.039L213.743 246.042ZM212.94 248.398C212.649 248.654 212.474 248.648 212.431 248.382C212.388 248.114 212.53 247.891 212.821 247.629L213.088 247.387L213.203 248.16L212.937 248.395L212.94 248.398ZM213.088 248.76L212.509 248.656L211.904 251.196L212.703 250.501L213.084 248.763L213.088 248.76Z"
        fill="#CFE9E4"
      />
      <path
        d="M211.701 250.941L211.209 250.75C211.05 251.085 210.834 251.41 210.639 251.581C210.431 251.764 210.327 251.765 210.305 251.634C210.28 251.493 210.407 251.331 210.612 251.034L210.916 250.587C211.182 250.203 211.389 249.705 211.316 249.266C211.229 248.742 210.742 248.685 210.157 249.217C209.856 249.488 209.546 249.919 209.352 250.407L209.786 250.594C209.94 250.295 210.082 250.082 210.277 249.905C210.448 249.752 210.566 249.727 210.591 249.861C210.615 250.005 210.471 250.192 210.252 250.511L209.958 250.935C209.658 251.369 209.521 251.784 209.595 252.187C209.684 252.679 210.125 252.795 210.774 252.235C211.105 251.949 211.466 251.479 211.708 250.941L211.701 250.941Z"
        fill="#CFE9E4"
      />
      <path
        d="M271.764 256.152L273.046 256.836L273.375 236.089L272.572 235.593L271.764 256.152Z"
        fill="#B9D9CF"
      />
      <path
        d="M272.961 246.713L272.792 245.574L254.478 235.389L253.847 236.324L272.961 246.713Z"
        fill="#B9D9CF"
      />
      <path
        d="M272.346 236.261L273.374 236.106L253.749 219.744L253.721 221.437L272.346 236.261Z"
        fill="#B9D9CF"
      />
      <path
        d="M272.526 236.638L272.795 235.949L254.325 235.725L256.083 236.896L272.526 236.638Z"
        fill="#B9D9CF"
      />
      <path
        d="M271.235 244.862L272.476 245.65L256.874 222.72L256.165 223.261L271.235 244.862Z"
        fill="#B9D9CF"
      />
      <path
        d="M252.669 245.359L255.547 246.756L256.558 222.355L253.546 219.603L252.669 245.359Z"
        fill="#B9D9CF"
      />
      <path
        d="M166.648 293.909L199.445 300.3L199.597 299.347L166.712 292.893L166.648 293.909Z"
        fill="#B9D9CF"
      />
      <path
        d="M192.819 303.233L199.437 300.345L199.085 299.448L192.451 302.345L192.819 303.233Z"
        fill="#B9D9CF"
      />
      <path
        d="M193.364 302.433L186.732 297.027L186.191 297.804L192.825 303.184L193.364 302.433Z"
        fill="#B9D9CF"
      />
      <path
        d="M179.859 300.758L186.551 297.812L186.153 296.89L179.443 299.848L179.859 300.758Z"
        fill="#B9D9CF"
      />
      <path
        d="M180.386 299.941L173.35 294.382L172.825 295.179L179.859 300.709L180.386 299.941Z"
        fill="#B9D9CF"
      />
      <path
        d="M170.328 299.741L198.895 305.115L199.042 304.185L170.403 298.761L170.328 299.741Z"
        fill="#B9D9CF"
      />
      <path
        d="M185.502 302.316L186.273 302.461L186.959 296.864L186.179 296.713L185.502 302.316Z"
        fill="#B9D9CF"
      />
      <path
        d="M171.635 299.987L172.431 300.136L172.908 294.402L172.095 294.242L171.635 299.987Z"
        fill="#B9D9CF"
      />
      <path
        d="M184.682 316.705L189.519 316.98L188.597 333.158L183.76 332.882L184.682 316.705Z"
        fill="#CFE9E4"
      />
      <path
        d="M266.019 122.962L369.964 100.511L415.699 147.079L369.964 567.5L266.019 513.218V122.962Z"
        fill="#C3DEDB"
      />
      <path
        d="M370.28 91.4945L370.28 567L414.5 563L420.307 131.349L370.28 91.4945Z"
        fill="#9CC0BE"
      />
      <path
        d="M256.004 188.007L262.394 190.746L280.343 184.661C280.343 184.661 267.261 155.458 291.597 148.157C291.597 148.157 311.369 150.108 311.064 164.342C310.759 178.576 310.303 176.448 310.303 176.448L313.954 178.121L334.638 175.231C334.638 175.231 318.667 143.082 340.874 136.646C340.874 136.646 364.399 134.74 361.456 173.697C361.419 174.191 361.456 173.697 361.456 173.697L363.08 176.757L371.293 176.452L377.378 180.102L380.927 178.177C380.927 178.177 370.932 144.822 378.29 146.947C385.648 149.068 395.934 155.161 395.022 174.933L395.079 185.581L405.104 189.231L409.316 187.103C409.316 187.103 404.449 163.374 409.316 165.808C414.184 168.242 418.442 180.411 415.401 185.886L413.578 191.013L417.715 193.749L420.619 192.272V187.404L419.357 158.506L334.484 120.785L256 161.245V188.014L256.004 188.007Z"
        fill="#7B92B3"
      />
      <path
        d="M426.964 140.647L420.62 192.264L416.924 189.679C420.62 176.598 417.116 165.307 414.64 164.888C405.647 163.366 409.317 187.095 409.317 187.095L398.771 183.037C398.771 183.037 400.395 154.644 389.849 148.966C379.304 143.289 380.928 178.169 380.928 178.169L372.006 173.693H361.46C361.46 173.693 361.46 137.611 340.369 140.855C319.278 144.099 329.823 173.693 329.823 173.693L310.303 176.448C310.303 176.448 314.41 144.912 290.885 152.214C267.36 159.516 276.914 183.041 276.914 183.041L260.058 187.502L258.434 119.564L374.033 90.3608L374.112 90.4361L426.961 140.651L426.964 140.647Z"
        fill="#9CC0BE"
      />
      <path
        d="M269.255 369.46L331.504 374.5V389.5L269.873 382.462L269.255 369.46Z"
        fill="#9CC0BE"
      />
      <path
        d="M426.964 140.647L420.62 192.264L416.924 189.679C420.62 176.598 417.116 165.306 414.641 164.888C405.647 163.366 409.317 187.095 409.317 187.095L398.771 183.037C398.771 183.037 400.395 154.644 389.85 148.966C379.304 143.288 380.928 178.169 380.928 178.169L372.006 173.693H371.644L374.116 90.4322L426.964 140.647V140.647Z"
        fill="#C3DEDB"
      />
      <path
        d="M378.497 103.058L424.534 143.722L423.362 147.067L378.237 107.745L378.497 103.058Z"
        fill="#9CC0BE"
      />
      <path
        d="M271.821 125.449L368.498 100.511V106.607L271.821 129.555V125.449Z"
        fill="#7B92B3"
      />
      <path
        d="M332 405.476L283 396V510.122L329.031 534L332 405.476Z"
        fill="#7B92B3"
      />
      <path
        d="M364.833 340.739L265.325 338.535L265.729 327.24L365.025 327.91L364.833 340.739Z"
        fill="#7B92B3"
      />
      <path
        d="M364.896 334.078L265.672 331.392L265.924 324.278L365.183 326.004L364.896 334.078Z"
        fill="#9CC0BE"
      />
      <path
        d="M364.749 345.618L266.327 343.188L266.534 337.292L364.855 339.074L364.749 345.618Z"
        fill="#9CC0BE"
      />
      <path
        d="M376.5 379.5V475.5L395.942 471.804L398.18 385.988L376.5 379.5Z"
        fill="#9CC0BE"
      />
      <path
        d="M387.804 225.039L433 207.779L418.227 338.124L383.976 339.33L387.804 225.039Z"
        fill="#7B92B3"
      />
      <path
        d="M391.318 229.126L427.058 213.954L413.344 332.646L388.169 333.629L391.318 229.126Z"
        fill="#EFFBDB"
      />
      <path
        d="M385.445 228.351L391.062 226.934L389.608 229.063L385.445 229.771V228.351Z"
        fill="#7B92B3"
      />
      <path
        d="M382.672 312.124L388.625 310.636L386.575 314.03L382.261 314.547L382.672 312.124Z"
        fill="#7B92B3"
      />
      <path
        d="M397.531 96.4833C394.08 98.6195 391.993 102.779 393.04 105.669C394.088 108.559 397.795 108.852 401.148 106.449C404.332 104.165 406.023 100.27 405.07 97.6399C404.117 95.0139 400.805 94.4525 397.527 96.4833H397.531Z"
        fill="#9CC0BE"
      />
      <path
        d="M393.881 106.068L394.947 105.356L390.121 93.8195L389.797 94.1209L393.881 106.068Z"
        fill="#9CC0BE"
      />
      <path
        d="M390.935 95.379L391.816 94.8101L390.867 92.4252L389.978 92.979L390.935 95.379Z"
        fill="#9CC0BE"
      />
      <path
        d="M390.249 94.8702L390.697 94.5839L390.283 93.5516L389.838 93.8341L390.249 94.8702Z"
        fill="#9CC0BE"
      />
      <path
        d="M397.042 113.479L397.298 107.3L397.629 107.149L397.697 113.294L397.042 113.479Z"
        fill="#9CC0BE"
      />
      <path
        d="M393.124 108.931L397.37 105.925L397.814 106.068L393.904 109.27L393.124 108.931Z"
        fill="#9CC0BE"
      />
      <path
        d="M395.47 107.597C395.47 107.597 384.853 163.942 315.393 117.291"
        stroke="#7B92B3"
        strokeWidth="0.99"
        strokeMiterlimit="10"
      />
      <path
        d="M376.165 32L374.089 74.9661L304.211 100.134L306.569 66.5794L376.165 32Z"
        fill="#9CC0BE"
      />
      <path
        d="M368.393 41.0154L366.536 74.246L307.968 94.2898L309.629 68.2668L368.393 41.0154Z"
        fill="#7B92B3"
      />
      <path
        d="M353.221 97.0408L356.977 95.7033L358.952 78.9523L355.564 77.7919L353.221 97.0408Z"
        fill="#9CC0BE"
      />
      <path
        d="M310.616 111.082L314.022 109.865L316.629 93.6759L313.675 92.4778L310.616 111.082Z"
        fill="#9CC0BE"
      />
      <path
        d="M377.499 78.7111L306.942 102.583L304.211 100.134L374.089 74.966L377.499 78.7111Z"
        fill="#9CC0BE"
      />
      <path
        d="M372.153 75.6632L377.499 78.7112L381.116 35.048L376.166 32L372.153 75.6632Z"
        fill="#9CC0BE"
      />
      <path
        d="M333.666 208.103H301.174V285.034H333.666V208.103Z"
        fill="#EFFBDB"
      />
      <path
        d="M295.752 290.147C297.172 290.053 337.113 287.359 337.113 287.359L341.608 292.849L297.455 293.38L295.752 290.144V290.147Z"
        fill="#7B92B3"
      />
      <path
        d="M341.605 292.849L337.468 292.984L336.775 205.21L341.85 213.423L341.605 292.849Z"
        fill="#7B92B3"
      />
      <path
        d="M317.793 198.748L316.437 198.97C305.025 200.824 296.024 209.855 296.009 219.142L295.903 290.302L337.908 288.685L339.178 213.152C339.344 203.28 329.612 196.827 317.789 198.748H317.793ZM328.448 279.677L303.069 280.973L303.314 220.789C303.337 214.96 309.033 209.365 316.158 208.299C323.426 207.21 329.36 211.234 329.277 217.285L328.448 279.677V279.677Z"
        fill="#9CC0BE"
      />
      <path
        d="M320.912 210.488L311.418 211.871L310.261 196.548L321.1 192.03L320.912 210.488Z"
        fill="#9CC0BE"
      />
      <path
        d="M321.101 192.03L322.212 193.345L321.587 210.39L320.913 210.488L321.101 192.03Z"
        fill="#7B92B3"
      />
      <path
        d="M340.636 217.967L341.254 218.916L341.126 226.169L328.806 227.661L327.45 226.674L327.48 224.229L329.172 223.95L329.138 222.627L327.506 222.149L327.54 219.696L340.636 217.967Z"
        fill="#7B92B3"
      />
      <path
        d="M340.667 220.457L327.578 222.141L327.608 219.689L340.708 217.959L340.667 220.457Z"
        fill="#9CC0BE"
      />
      <path
        d="M340.587 225.061L327.521 226.666L327.551 224.221L340.629 222.575L340.587 225.061Z"
        fill="#9CC0BE"
      />
      <path
        d="M304.448 223.192L305.021 224.1L304.991 230.991L293.812 232.336L292.569 231.391V229.066L294.103 228.81L294.057 227.551L292.569 227.088V224.756L304.448 223.192Z"
        fill="#7B92B3"
      />
      <path
        d="M304.504 225.559L292.633 227.081V224.749L304.516 223.185L304.504 225.559Z"
        fill="#9CC0BE"
      />
      <path
        d="M304.486 229.937L292.633 231.383V229.059L304.497 227.57L304.486 229.937Z"
        fill="#9CC0BE"
      />
      <path
        d="M374.787 183.161H371.23V356.295H374.787V183.161Z"
        fill="#C3DEDB"
      />
      <path
        d="M391.507 227.499L429.398 211.705L414.859 335.257L386.349 334.696L391.507 227.499Z"
        stroke="white"
        strokeWidth="1.57"
        strokeMiterlimit="10"
      />
      <path
        d="M368.385 186.778L313.148 188.681V185.637L368.472 183.161L368.385 186.778Z"
        fill="#9CC0BE"
      />
      <path
        d="M371.99 187.984C369.504 188.165 367.043 188.01 364.621 187.445V182.935C366.546 181.963 369.059 181.869 371.99 182.397C373.384 184.205 373.305 186.07 371.99 187.988V187.984Z"
        fill="#9CC0BE"
      />
      <path
        d="M370.988 181.76H372.838C374.387 181.76 375.641 183.015 375.641 184.563V192.264H370.608V188.27L368.475 188.38L368.754 181.775L370.992 181.76H370.988Z"
        fill="#9CC0BE"
      />
      <path
        d="M375.43 361.544H373.58C372.032 361.544 370.777 360.289 370.777 358.741V351.04H375.811V355.033L377.943 354.924L377.664 361.529L375.426 361.544H375.43Z"
        fill="#9CC0BE"
      />
      <path
        d="M332.585 320.499H325.008L323.629 319.437L325.366 312.478L331.21 310.172L332.585 311.238V320.499Z"
        fill="#9CC0BE"
      />
      <path
        d="M331.21 319.437H323.629L323.991 311.415L331.21 310.172V319.437Z"
        fill="#9CC0BE"
      />
      <path
        d="M320.246 320.499H312.669L311.29 319.437L313.027 312.478L318.871 310.172L320.246 311.238V320.499Z"
        fill="#9CC0BE"
      />
      <path
        d="M318.871 319.437H311.29L311.652 311.415L318.871 310.172V319.437Z"
        fill="#9CC0BE"
      />
      <path
        d="M356.038 320.499H348.458L347.083 319.437L348.816 312.478L354.663 310.172L356.038 311.238V320.499Z"
        fill="#9CC0BE"
      />
      <path
        d="M354.663 319.437H347.083L347.44 311.415L354.663 310.172V319.437Z"
        fill="#9CC0BE"
      />
      <path
        d="M343.7 320.499H336.119L334.744 319.437L336.477 312.478L342.324 310.172L343.7 311.238V320.499Z"
        fill="#9CC0BE"
      />
      <path
        d="M342.324 319.437H334.744L335.102 311.415L342.324 310.172V319.437Z"
        fill="#9CC0BE"
      />
      <path
        d="M403.082 232.137L406.439 231.131C408.466 230.524 410.172 230.483 410.029 232.024C409.886 233.565 408.044 234.688 406.1 235.253L405.105 235.543L404.92 237.464L402.498 238.161L403.082 232.141V232.137ZM406.107 234.013C407.075 233.727 407.561 233.275 407.614 232.736C407.667 232.197 407.143 232.148 406.205 232.431L405.384 232.676L405.229 234.277L406.107 234.017V234.013Z"
        fill="#7B91B2"
      />
      <path
        d="M403.989 240.863L406.951 240.034L409.226 245.403L406.597 246.107L405.82 243.41C405.647 242.89 405.489 242.208 405.319 241.662L405.263 241.677C405.003 242.351 404.705 243.146 404.423 243.79L403.089 247.046L400.614 247.709L403.989 240.867V240.863ZM402.855 244.631L407.384 243.395L407.263 244.653L402.731 245.878L402.851 244.631H402.855Z"
        fill="#7B91B2"
      />
      <path
        d="M400.741 253.85C400.941 251.797 403.171 250.079 405.507 249.472C406.743 249.152 407.719 249.269 408.34 249.532L406.939 250.919C406.502 250.772 406.061 250.7 405.428 250.862C404.343 251.141 403.337 252.045 403.232 253.164C403.126 254.283 403.857 254.766 405.059 254.464C405.778 254.283 406.378 253.892 406.807 253.504L408.013 254.212C407.157 255.022 406.042 255.598 404.837 255.896C402.467 256.48 400.534 255.945 400.737 253.85H400.741Z"
        fill="#7B91B2"
      />
      <path
        d="M400.229 260.111L402.666 259.528L402.444 261.837L402.501 261.822L405.07 258.947L407.79 258.292L404.742 261.498L407.756 264.444L405.025 265.066L403.182 263.137L402.214 264.184L402.063 265.737L399.622 266.29L400.221 260.108L400.229 260.111Z"
        fill="#7B91B2"
      />
      <path
        d="M401.265 269.158L404.249 268.502L406.532 274.21L403.883 274.756L403.107 271.915C402.934 271.365 402.776 270.65 402.606 270.073L402.55 270.084C402.29 270.766 401.988 271.565 401.702 272.213L400.353 275.483L397.859 276L401.269 269.158H401.265ZM400.116 272.974L404.678 272.006L404.558 273.298L399.991 274.255L400.116 272.974V272.974Z"
        fill="#7B91B2"
      />
      <path
        d="M397.543 282.439C397.746 280.333 399.992 278.713 402.486 278.215C403.872 277.94 404.856 278.129 405.485 278.445L404.072 279.779C403.635 279.594 403.187 279.493 402.437 279.64C401.171 279.888 400.161 280.755 400.052 281.9C399.939 283.087 400.647 283.603 402.316 283.287C402.576 283.238 402.87 283.143 403.051 283.034L403.134 282.153L401.747 282.416L401.879 281.049L405.481 280.352L405.195 283.403C404.483 283.961 403.254 284.538 401.921 284.786C399.306 285.272 397.336 284.59 397.546 282.439H397.543Z"
        fill="#7B91B2"
      />
      <path
        d="M399.664 288.399L402.143 287.958L401.533 294.371L399.05 294.778L399.664 288.399V288.399Z"
        fill="#7B91B2"
      />
      <path
        d="M396.182 298.579L398.695 298.183L400.5 300.738L401.265 302.057L401.321 302.049C401.272 301.367 401.159 300.421 401.235 299.626L401.412 297.758L403.808 297.381L403.198 303.888L400.621 304.257L398.812 301.665L398.059 300.365L398.002 300.372C398.047 301.088 398.157 301.989 398.081 302.78L397.9 304.645L395.553 304.98L396.175 298.579H396.182Z"
        fill="#7B91B2"
      />
      <path
        d="M394.694 311.702C394.905 309.539 397.17 308.017 399.683 307.678C401.08 307.49 402.067 307.749 402.7 308.122L401.276 309.407C400.835 309.189 400.387 309.049 399.63 309.147C398.353 309.317 397.335 310.142 397.222 311.317C397.109 312.493 397.818 313.122 399.502 312.911C399.765 312.877 400.059 312.802 400.244 312.7L400.331 311.792L398.933 311.969L399.068 310.564L402.697 310.093L402.403 313.228C401.683 313.755 400.444 314.267 399.102 314.43C396.469 314.75 394.487 313.906 394.702 311.698L394.694 311.702Z"
        fill="#7B91B2"
      />
      <path
        d="M391.217 321.724L390.418 321.784L390.52 321.019L392.909 320.831L392.796 321.599L391.993 321.663L391.575 324.561L390.806 324.617L391.213 321.727L391.217 321.724Z"
        fill="#7B91B2"
      />
      <path
        d="M393.387 320.793L394.442 320.711C395.086 320.658 395.584 320.884 395.591 321.596C395.599 322.609 394.887 323.077 394.133 323.133L393.79 323.159L393.598 324.41L392.826 324.467L393.387 320.793V320.793ZM394.193 322.425C394.615 322.391 394.819 322.142 394.815 321.792C394.815 321.521 394.642 321.411 394.348 321.434L394.061 321.457L393.911 322.447L394.193 322.425ZM394.054 322.926L394.604 322.3L395.32 324.282L394.502 324.343L394.054 322.926Z"
        fill="#7B91B2"
      />
      <path
        d="M396.932 320.515L397.893 320.439L398.187 324.083L397.362 324.143L397.313 322.225C397.302 321.875 397.294 321.547 397.294 321.174H397.275C397.147 321.551 397.038 321.897 396.898 322.259L396.137 324.233L395.278 324.297L396.936 320.518L396.932 320.515ZM396.265 322.73L397.757 322.617L397.618 323.299L396.13 323.408L396.265 322.73Z"
        fill="#7B91B2"
      />
      <path
        d="M399.133 320.337L399.897 320.277C400.817 320.205 401.367 320.62 401.344 321.629C401.314 323.125 400.523 323.909 399.513 323.98L398.454 324.056L399.129 320.333L399.133 320.337ZM399.502 323.268C400.041 323.227 400.504 322.812 400.519 321.75C400.527 321.17 400.248 320.985 399.867 321.015H399.796L399.381 323.279L399.502 323.272V323.268Z"
        fill="#7B91B2"
      />
      <path
        d="M402.275 320.089L404.298 319.927L404.14 320.714L402.927 320.808L402.799 321.471L403.823 321.392L403.669 322.168L402.648 322.244L402.486 323.012L403.725 322.922L403.571 323.687L401.536 323.834L402.275 320.085V320.089Z"
        fill="#7B91B2"
      />
      <path
        d="M404.991 319.874L406.095 319.787C406.766 319.734 407.271 319.96 407.237 320.695C407.188 321.735 406.419 322.213 405.636 322.274L405.278 322.3L405.006 323.585L404.2 323.645L404.995 319.877L404.991 319.874ZM405.734 321.547C406.174 321.513 406.4 321.256 406.416 320.898C406.427 320.62 406.257 320.507 405.948 320.529L405.651 320.552L405.436 321.569L405.734 321.547V321.547ZM405.56 322.063L406.167 321.422L406.8 323.457L405.948 323.517L405.564 322.063H405.56Z"
        fill="#7B91B2"
      />
      <path
        d="M407.109 322.794L407.719 322.236C407.881 322.492 408.137 322.655 408.393 322.636C408.631 322.617 408.789 322.489 408.8 322.281C408.808 322.116 408.665 322.052 408.442 321.908L408.164 321.728C407.866 321.532 407.693 321.276 407.719 320.805C407.753 320.123 408.337 319.535 409.026 319.482C409.422 319.452 409.791 319.644 410.047 319.991L409.494 320.582C409.332 320.401 409.17 320.277 408.951 320.292C408.714 320.311 408.586 320.465 408.574 320.646C408.567 320.805 408.706 320.861 408.966 321.034L409.264 321.227C409.576 321.422 409.693 321.649 409.667 322.086C409.625 322.768 409.09 323.355 408.292 323.416C407.866 323.446 407.433 323.287 407.112 322.794H407.109Z"
        fill="#7B91B2"
      />
    </svg>
  ),
  ctaStripe: (
    <svg
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M14 0.5L0.5 14V27L27 0.5H14Z" fill="#2DA771" />
    </svg>
  ),
  ctaStripe2: (
    <svg
      width="28"
      height="36"
      viewBox="0 0 28 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8 35.5L27.5 13V0L0 31H6.5L8 35.5Z" fill="#2DA771" />
    </svg>
  ),
  createHeaderIcon: (
    <svg
      width="41"
      height="40"
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="19.7227"
        y="15.2568"
        width="19.5755"
        height="21.375"
        rx="1.5"
        fill="#D3DCEB"
      />
      <rect
        x="22.1738"
        y="12.8367"
        width="18.0755"
        height="22.25"
        rx="0.75"
        fill="white"
        stroke="#375A8D"
        strokeWidth="1.5"
      />
      <rect
        x="23.9775"
        y="15.2568"
        width="14.4688"
        height="5.54167"
        rx="1.5"
        fill="#DC343B"
      />
      <rect
        x="23.9775"
        y="23.167"
        width="2.55332"
        height="1.1875"
        rx="0.59375"
        fill="#DC343B"
      />
      <rect
        x="23.9775"
        y="26.7295"
        width="2.55332"
        height="1.1875"
        rx="0.59375"
        fill="#DC343B"
      />
      <rect
        x="23.9775"
        y="30.292"
        width="2.55332"
        height="1.1875"
        rx="0.59375"
        fill="#DC343B"
      />
      <rect
        x="27.8076"
        y="23.167"
        width="2.55332"
        height="1.1875"
        rx="0.59375"
        fill="#DC343B"
      />
      <rect
        x="27.8076"
        y="26.7295"
        width="2.55332"
        height="1.1875"
        rx="0.59375"
        fill="#DC343B"
      />
      <rect
        x="27.8076"
        y="30.292"
        width="2.55332"
        height="1.1875"
        rx="0.59375"
        fill="#DC343B"
      />
      <rect
        x="31.6377"
        y="23.167"
        width="2.55332"
        height="1.1875"
        rx="0.59375"
        fill="#DC343B"
      />
      <rect
        x="31.6377"
        y="26.7295"
        width="2.55332"
        height="1.1875"
        rx="0.59375"
        fill="#DC343B"
      />
      <rect
        x="31.6377"
        y="30.292"
        width="2.55332"
        height="1.1875"
        rx="0.59375"
        fill="#DC343B"
      />
      <rect
        x="35.4678"
        y="23.167"
        width="2.55332"
        height="1.1875"
        rx="0.59375"
        fill="#DC343B"
      />
      <rect
        x="35.4678"
        y="26.7295"
        width="2.55332"
        height="1.1875"
        rx="0.59375"
        fill="#DC343B"
      />
      <rect
        x="35.4678"
        y="30.292"
        width="2.55332"
        height="1.1875"
        rx="0.59375"
        fill="#DC343B"
      />
      <path
        d="M29.0865 10.5V5.5C29.0865 3.01472 27.0718 1 24.5865 1H9.75988C8.77055 1 7.80879 1.32603 7.0234 1.92765L2.76352 5.19078C1.65188 6.04232 1 7.36283 1 8.76314V34.5C1 36.9853 3.01472 39 5.5 39H27.3053C28.289 39 29.0865 38.2025 29.0865 37.2188V37.2188"
        stroke="#375A8D"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <rect
        x="5.25488"
        y="21.1943"
        width="12.7666"
        height="2.375"
        rx="1.1875"
        fill="#D3DCEB"
      />
      <rect
        x="5.25488"
        y="9.71167"
        width="12.7666"
        height="8.70833"
        rx="1.5"
        fill="#D3DCEB"
      />
      <rect
        x="5.25488"
        y="24.7568"
        width="12.7666"
        height="2.375"
        rx="1.1875"
        fill="#D3DCEB"
      />
      <rect
        x="5.25488"
        y="28.3193"
        width="12.7666"
        height="2.375"
        rx="1.1875"
        fill="#D3DCEB"
      />
    </svg>
  ),
  manageHeaderIcon: (
    <svg
      width="43"
      height="45"
      viewBox="0 0 43 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="4.47754"
        y="7.86035"
        width="23.4777"
        height="27.4446"
        rx="2"
        fill="#D3DCEB"
      />
      <rect
        x="8.8252"
        y="7.00195"
        width="26.9559"
        height="31.7329"
        rx="3"
        fill="white"
      />
      <path
        d="M4.47819 32.7329H3C1.89543 32.7329 1 31.8374 1 30.7329V3C1 1.89543 1.89543 1 3 1H25.9559C27.0605 1 27.9559 1.89543 27.9559 3V5.75993"
        stroke="#375A8D"
        strokeWidth="1.5"
      />
      <path
        d="M20.1293 38.7348H10.8252C9.72062 38.7348 8.8252 37.8394 8.8252 36.7348V9.00195C8.8252 7.89738 9.72063 7.00195 10.8252 7.00195H33.7811C34.8857 7.00195 35.7811 7.89738 35.7811 9.00195V22.8684"
        stroke="#375A8D"
        strokeWidth="1.5"
      />
      <path
        d="M41.1183 34.4487C41.1183 39.2351 37.1815 43.1328 32.3033 43.1328C27.4251 43.1328 23.4883 39.2351 23.4883 34.4487C23.4883 29.6624 27.4251 25.7646 32.3033 25.7646C37.1815 25.7646 41.1183 29.6624 41.1183 34.4487Z"
        fill="white"
      />
      <path
        d="M41.1183 34.4487C41.1183 39.2351 37.1815 43.1328 32.3033 43.1328C27.4251 43.1328 23.4883 39.2351 23.4883 34.4487C23.4883 29.6624 27.4251 25.7646 32.3033 25.7646C37.1815 25.7646 41.1183 29.6624 41.1183 34.4487Z"
        fill="white"
      />
      <path
        d="M41.1183 34.4487C41.1183 39.2351 37.1815 43.1328 32.3033 43.1328C27.4251 43.1328 23.4883 39.2351 23.4883 34.4487C23.4883 29.6624 27.4251 25.7646 32.3033 25.7646C37.1815 25.7646 41.1183 29.6624 41.1183 34.4487Z"
        stroke="#375A8D"
        strokeWidth="1.5"
      />
      <path
        d="M40.1304 34.4485C40.1304 35.4622 39.9279 36.4659 39.5346 37.4024C39.1413 38.3389 38.5649 39.1898 37.8382 39.9066C37.1115 40.6233 36.2488 41.1919 35.2993 41.5798C34.3498 41.9677 33.3321 42.1673 32.3044 42.1673L32.3044 34.4485H40.1304Z"
        fill="#DC343B"
      />
      <path
        d="M36.8301 28.1536C37.8663 28.8784 38.708 29.8411 39.2826 30.9585C39.8571 32.076 40.1473 33.3146 40.1279 34.5674L32.3029 34.4497L36.8301 28.1536Z"
        fill="#D3DCEB"
      />
      <rect
        x="13.1729"
        y="16.4395"
        width="2.60864"
        height="6.86116"
        fill="#DC343B"
      />
      <rect
        x="17.5205"
        y="14.7227"
        width="2.60864"
        height="8.57645"
        fill="#DC343B"
      />
      <rect
        x="21.8682"
        y="26.7297"
        width="1.71529"
        height="8.69546"
        transform="rotate(90 21.8682 26.7297)"
        fill="#D3DCEB"
      />
      <rect
        x="21.8682"
        y="30.1592"
        width="1.71529"
        height="8.69546"
        transform="rotate(90 21.8682 30.1592)"
        fill="#D3DCEB"
      />
      <rect
        x="21.8682"
        y="33.5908"
        width="1.71529"
        height="8.69546"
        transform="rotate(90 21.8682 33.5908)"
        fill="#D3DCEB"
      />
      <rect
        x="21.8682"
        y="12.1494"
        width="2.60864"
        height="11.1494"
        fill="#DC343B"
      />
    </svg>
  ),
  trackHeaderIcon: (
    <svg
      width="51"
      height="46"
      viewBox="0 0 51 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.10974 9.46264C1.10974 6.70122 3.34832 4.46265 6.10974 4.46265H34.1668C36.9282 4.46265 39.1668 6.70122 39.1668 9.46265V14.9228H1.10974V9.46264Z"
        fill="#DC343B"
      />
      <path
        d="M38.6181 21.7374V8.40061C38.6181 6.13796 36.9497 4.30371 34.8917 4.30371H4.72349C2.66545 4.30371 0.99707 6.13796 0.99707 8.40061V37.0789C0.99707 39.3416 2.66545 41.1758 4.72349 41.1758H15.8631"
        stroke="#375A8D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3881 1.33105V7.60716"
        stroke="#375A8D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.76929 1.33105V7.60716"
        stroke="#375A8D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.9476 1.33105V7.60716"
        stroke="#375A8D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.5072 1.33105V7.60716"
        stroke="#375A8D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.10974 14.9287H38.2154"
        stroke="#375A8D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="5.8689"
        y="19.1123"
        width="2.85428"
        height="3.13805"
        fill="#D3DCEB"
      />
      <rect
        x="5.8689"
        y="25.3887"
        width="2.85428"
        height="3.13805"
        fill="#DC343B"
      />
      <rect
        x="5.75623"
        y="31.665"
        width="2.85428"
        height="3.13805"
        fill="#DC343B"
      />
      <rect
        x="10.6281"
        y="19.1123"
        width="2.85428"
        height="3.13805"
        fill="#DC343B"
      />
      <rect
        x="10.6281"
        y="25.3887"
        width="2.85428"
        height="3.13805"
        fill="#D3DCEB"
      />
      <rect
        x="10.5154"
        y="31.665"
        width="2.85428"
        height="3.13805"
        fill="#DC343B"
      />
      <rect
        x="16.2158"
        y="19.1123"
        width="2.85428"
        height="3.13805"
        fill="#DC343B"
      />
      <rect
        x="16.2158"
        y="25.3887"
        width="2.85428"
        height="3.13805"
        fill="#DC343B"
      />
      <rect
        x="15.2755"
        y="31.665"
        width="2.85428"
        height="3.13805"
        fill="#DC343B"
      />
      <rect
        x="20.975"
        y="19.1123"
        width="2.85428"
        height="3.13805"
        fill="#DC343B"
      />
      <rect
        x="25.734"
        y="19.1123"
        width="2.85428"
        height="3.13805"
        fill="#DC343B"
      />
      <path
        d="M22.0464 42.1237V28.4795C22.0464 27.9272 22.4941 27.4795 23.0464 27.4795H47.7349"
        stroke="#375A8D"
        strokeWidth="1.5"
      />
      <path
        d="M23.7815 28.5176H49.7943C50.2302 28.5176 50.5836 28.9265 50.5836 29.4309V44.3405C50.5836 44.8449 50.2302 45.2538 49.7943 45.2538H23.7815C23.3456 45.2538 22.9922 44.8449 22.9922 44.3405V29.4309C22.9922 28.9265 23.3456 28.5176 23.7815 28.5176Z"
        fill="#D3DCEB"
      />
      <g clipPath="url(#clip0_144_5402)">
        <path
          d="M18.116 30.334H42.5649C42.9746 30.334 43.3068 30.6984 43.3068 31.1479V44.4347C43.3068 44.8842 42.9746 45.2486 42.5649 45.2486H36.4527H30.3404H18.116C17.7063 45.2486 17.3741 44.8842 17.3741 44.4347V31.1479C17.3741 30.6984 17.7063 30.334 18.116 30.334Z"
          fill="white"
          stroke="#375A8D"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
        <path
          d="M19.8025 39.7479V35.8336C21.1661 35.8336 22.2696 34.587 22.2696 33.0381H38.4109C38.4109 34.5823 39.5208 35.8336 40.8781 35.8336V39.7479C39.516 39.7479 38.4109 40.9945 38.4109 42.5434H22.2696C22.2696 41.0007 21.1661 39.7479 19.8025 39.7479Z"
          stroke="#375A8D"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M30.3397 39.9514C29.2619 39.9514 28.3883 38.9843 28.3883 37.7912C28.3883 36.5981 29.2619 35.6309 30.3397 35.6309C31.4174 35.6309 32.2911 36.5981 32.2911 37.7912C32.2911 38.9843 31.4174 39.9514 30.3397 39.9514Z"
          fill="#375A8D"
        />
      </g>
      <defs>
        <clipPath id="clip0_144_5402">
          <rect
            width="27.3202"
            height="16.4182"
            fill="white"
            transform="matrix(-1 0 0 1 44.0001 29.582)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  business_loans: (
    <svg
      width="591"
      height="347"
      viewBox="0 0 591 347"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_252_7047)">
        <g opacity="0.2" clipPath="url(#clip1_252_7047)">
          <path
            d="M263.971 411.1L163.02 402.346C161.01 390.892 155.928 362.908 155.928 362.908L172.138 357.5L168.525 320.762L173.911 318.603L186.709 313.484L194.373 310.421L194.514 310.702L200.768 322.958L199.025 308.662L191.131 243.837L218.285 223.792L219.078 224.118L260.662 241.07L262.717 346.869L263.963 411.108L263.971 411.1Z"
            fill="#CCE9E6"
          />
          <path
            d="M191.138 327.735L173.815 332.246L173.385 325.116L190.567 320.264L191.138 327.735Z"
            fill="#BFE4E0"
          />
          <path
            d="M173.818 319.679C173.818 319.679 173.58 314.538 179.931 312.683C186.282 310.821 187.884 315.027 187.884 315.027L173.818 319.679Z"
            fill="#CCE9E6"
          />
          <path
            d="M219.27 242.902L195.136 253.489L194.283 246.634L217.416 233.466L219.27 242.902Z"
            fill="#BFE4E0"
          />
          <path
            d="M224.065 281.814L199.382 287.994L198.625 281.866L222.217 272.378L224.065 281.814Z"
            fill="#BFE4E0"
          />
          <path
            d="M225.614 305.902L202.66 313.187L202.289 310.227L225.192 302.549L225.614 305.902Z"
            fill="#AFD5D0"
          />
          <path
            d="M205.597 386.997L198.497 384.801L194.283 310.807L194.521 310.695L200.782 322.951L205.597 386.997Z"
            fill="#A3D9D4"
          />
          <path
            d="M249.031 400.387L263.246 405.625L258.669 348.026L242.109 344.91L249.031 400.387Z"
            fill="#A3D9D4"
          />
          <path
            d="M262.725 346.861C260.343 346.03 258.326 345.021 258.326 345.021L241.974 341.185L237.359 342.706L236.054 335.703L219.094 224.103L260.677 241.055L262.732 346.853L262.725 346.861Z"
            fill="#A3D9D4"
          />
          <path
            d="M198.242 307.371L192.967 308.306L190.43 290.716H196.491L198.242 307.371Z"
            fill="#CCE9E6"
          />
          <path
            d="M147.168 378.503L144.786 334.74H143.874V337.529H140.468V337.307H135.928C135.928 338.293 136.729 339.087 137.708 339.087L140.468 338.605V337.974H143.874V378.562L147.168 378.503Z"
            fill="#A3D9D4"
          />
          <path
            d="M165.411 370.523L157.072 369.432L152.287 229.448L155.054 234.404L165.411 370.523Z"
            fill="#87BCB6"
          />
          <path
            d="M144.379 252.434L165.91 256.904L165.943 256.745L144.413 252.274L144.379 252.434Z"
            fill="#87BCB6"
          />
          <path
            d="M143.965 251.586L165.496 256.056L165.651 255.308L144.121 250.837L143.965 251.586Z"
            fill="#87BCB6"
          />
          <path
            d="M143.535 249.301L165.822 253.53L165.503 255.05L143.973 250.584L143.535 249.301Z"
            fill="#87BCB6"
          />
          <path
            d="M164.021 243.493L145.837 242.491L145.793 243.738L163.435 244.405L164.021 243.493Z"
            fill="#87BCB6"
          />
          <path
            d="M162.863 242.157L144.671 241.156L144.627 242.402L162.269 243.07L162.863 242.157Z"
            fill="#87BCB6"
          />
          <path
            d="M150.866 250.6L147.193 249.835L147.468 248.507L151.044 249.746L150.866 250.6Z"
            fill="#87BCB6"
          />
          <path
            d="M183.098 318.121L169.113 322.23L168.475 321.526L182.771 316.733L183.098 318.121Z"
            fill="#87BCB6"
          />
          <path
            d="M182.379 326.557L167.762 329.961L168.085 331.349L182.702 327.944L182.379 326.557Z"
            fill="#87BCB6"
          />
        </g>
        <g opacity="0.4" clipPath="url(#clip2_252_7047)">
          <path
            d="M374.106 384.402L273.155 375.648C271.145 364.193 266.062 336.21 266.062 336.21L282.273 330.801L278.66 294.064L284.046 291.905L296.844 286.786L304.508 283.722L304.649 284.004L310.903 296.26L309.16 281.964L301.266 217.139L328.419 197.094L329.213 197.42L370.797 214.372L372.852 320.17L374.098 384.409L374.106 384.402Z"
            fill="#CCE9E6"
          />
          <path
            d="M301.273 301.037L283.95 305.548L283.52 298.418L300.702 293.567L301.273 301.037Z"
            fill="#BFE4E0"
          />
          <path
            d="M302.682 357.992L291.36 358.192L291.123 346.226L301.272 343.681L302.682 357.992Z"
            fill="#A3D9D4"
          />
          <path
            d="M289.723 341.426C290.019 341.47 302.239 339.564 302.239 339.564L302.417 341.032L289.73 343.006V341.418L289.723 341.426Z"
            fill="#A3D9D4"
          />
          <path
            d="M283.952 292.981C283.952 292.981 283.715 287.839 290.066 285.985C296.416 284.123 298.019 288.329 298.019 288.329L283.952 292.981Z"
            fill="#CCE9E6"
          />
          <path
            d="M329.407 216.204L305.273 226.791L304.42 219.936L327.552 206.768L329.407 216.204Z"
            fill="#BFE4E0"
          />
          <path
            d="M334.2 255.116L309.517 261.296L308.76 255.168L332.352 245.679L334.2 255.116Z"
            fill="#BFE4E0"
          />
          <path
            d="M335.751 279.204L312.797 286.489L312.426 283.529L335.328 275.851L335.751 279.204Z"
            fill="#AFD5D0"
          />
          <path
            d="M350.234 335.692H350.145L337.028 335.425V335.365L335.336 324.652L335.403 324.63L348.624 320.75V320.839L350.234 335.692ZM337.161 335.276L350.063 335.536L348.498 320.951L335.514 324.764L337.161 335.284V335.276Z"
            fill="#A3D9D4"
          />
          <path
            d="M351.745 370.173L351.596 370.135L336.781 366.545V366.456L335.512 342.879L350.031 344.652V344.749L351.737 370.18L351.745 370.173ZM336.996 366.359L351.493 369.876L349.816 344.852L335.757 343.139L336.996 366.359Z"
            fill="#A3D9D4"
          />
          <path
            d="M350.319 341.41L335.518 339.897V336.276H335.644L350.022 336.929V337.033L350.319 341.403V341.41ZM335.748 339.697L350.074 341.158L349.807 337.159L335.748 336.521V339.697Z"
            fill="#A3D9D4"
          />
          <path
            d="M315.734 360.299L308.634 358.103L304.42 284.108L304.657 283.997L310.919 296.253L315.734 360.299Z"
            fill="#A3D9D4"
          />
          <path
            d="M280.091 343.258L271.277 345.854L270.469 339.956L281.323 336.714L280.091 343.258Z"
            fill="#BFE4E0"
          />
          <path
            d="M359.164 373.69L373.379 378.928L368.801 321.329L352.242 318.213L359.164 373.69Z"
            fill="#A3D9D4"
          />
          <path
            d="M372.86 320.163C370.478 319.332 368.46 318.323 368.46 318.323L352.109 314.488L347.494 316.009L346.188 309.005L329.229 197.405L370.812 214.357L372.867 320.156L372.86 320.163Z"
            fill="#A3D9D4"
          />
          <path
            d="M308.373 280.673L303.098 281.608L300.561 264.018H306.622L308.373 280.673Z"
            fill="#CCE9E6"
          />
          <path
            d="M275.144 354.912L272.392 296.097H271.183V299.791H266.679V299.494H260.67C260.67 300.8 261.723 301.854 263.029 301.854L266.679 301.216V300.385H271.183V354.92H275.144V354.912Z"
            fill="#6E9DB1"
          />
          <path
            d="M257.304 351.805L254.923 308.042H254.01V310.831H250.605V310.609H246.064C246.064 311.595 246.866 312.389 247.845 312.389L250.605 311.907V311.276H254.01V351.864L257.304 351.805Z"
            fill="#A3D9D4"
          />
          <path
            d="M293.495 370.395L285.156 369.305L280.371 229.32L283.138 234.276L293.495 370.395Z"
            fill="#87BCB6"
          />
          <path
            d="M272.465 252.306L293.996 256.776L294.029 256.616L272.498 252.146L272.465 252.306Z"
            fill="#87BCB6"
          />
          <path
            d="M272.049 251.457L293.58 255.927L293.735 255.179L272.204 250.709L272.049 251.457Z"
            fill="#87BCB6"
          />
          <path
            d="M271.621 249.173L293.907 253.402L293.588 254.923L272.058 250.456L271.621 249.173Z"
            fill="#87BCB6"
          />
          <path
            d="M292.105 243.364L273.921 242.363L273.877 243.609L291.519 244.277L292.105 243.364Z"
            fill="#87BCB6"
          />
          <path
            d="M290.949 242.029L272.757 241.027L272.713 242.274L290.355 242.942L290.949 242.029Z"
            fill="#87BCB6"
          />
          <path
            d="M278.949 250.472L275.277 249.708L275.551 248.38L279.127 249.619L278.949 250.472Z"
            fill="#87BCB6"
          />
          <path
            d="M293.238 291.423L279.253 295.533L278.615 294.828L292.911 290.036L293.238 291.423Z"
            fill="#87BCB6"
          />
          <path
            d="M292.516 299.86L277.898 303.264L278.221 304.651L292.839 301.247L292.516 299.86Z"
            fill="#87BCB6"
          />
          <path
            d="M339.663 238.899L331.436 195.15L346.882 198.326L346.815 198.63L331.814 195.544L339.967 238.847L339.663 238.899Z"
            fill="#FFF3C4"
          />
        </g>
        <g opacity="0.5" clipPath="url(#clip3_252_7047)">
          <path
            d="M538.13 347.05L535.356 349.632L544.407 349.558L546.544 346.264L538.13 347.05Z"
            fill="#365A8D"
          />
          <path
            d="M571.004 354.365L470.053 345.611C468.043 334.156 462.961 306.173 462.961 306.173L479.171 300.765L475.558 264.027L480.945 261.868L493.742 256.749L501.406 253.685L501.547 253.967L507.801 266.223L506.058 251.927L498.164 187.102L525.318 167.057L526.111 167.383L567.695 184.335L569.75 290.134L570.997 354.372L571.004 354.365Z"
            fill="#CCE9E6"
          />
          <path
            d="M498.172 271L480.848 275.511L480.418 268.382L497.6 263.53L498.172 271Z"
            fill="#BFE4E0"
          />
          <path
            d="M499.586 327.955L488.265 328.155L488.027 316.188L498.177 313.644L499.586 327.955Z"
            fill="#A3D9D4"
          />
          <path
            d="M486.621 311.388C486.918 311.433 499.137 309.526 499.137 309.526L499.315 310.995L486.629 312.968V311.381L486.621 311.388Z"
            fill="#A3D9D4"
          />
          <path
            d="M480.853 262.944C480.853 262.944 480.615 257.803 486.966 255.948C493.317 254.086 494.919 258.292 494.919 258.292L480.853 262.944Z"
            fill="#CCE9E6"
          />
          <path
            d="M526.304 186.167L502.17 196.754L501.316 189.899L524.449 176.731L526.304 186.167Z"
            fill="#BFE4E0"
          />
          <path
            d="M531.098 225.079L506.415 231.259L505.658 225.131L529.251 215.642L531.098 225.079Z"
            fill="#BFE4E0"
          />
          <path
            d="M532.652 249.168L509.697 256.453L509.326 253.493L532.229 245.814L532.652 249.168Z"
            fill="#AFD5D0"
          />
          <path
            d="M547.13 305.654H547.041L533.924 305.387V305.327L532.232 294.615L532.299 294.592L545.52 290.712V290.801L547.13 305.654ZM534.057 305.238L546.959 305.498L545.394 290.913L532.41 294.726L534.057 305.246V305.238Z"
            fill="#A3D9D4"
          />
          <path
            d="M548.647 340.136L548.498 340.099L533.683 336.509V336.42L532.414 312.843L546.933 314.616V314.712L548.639 340.144L548.647 340.136ZM533.898 336.323L548.395 339.84L546.718 314.816L532.659 313.102L533.898 336.323Z"
            fill="#A3D9D4"
          />
          <path
            d="M547.223 311.373L532.422 309.86V306.24H532.548L546.926 306.892V306.996L547.223 311.366V311.373ZM532.652 309.66L546.978 311.121L546.711 307.122L532.652 306.484V309.66Z"
            fill="#A3D9D4"
          />
          <path
            d="M512.638 330.262L505.538 328.066L501.324 254.072L501.562 253.961L507.823 266.216L512.638 330.262Z"
            fill="#A3D9D4"
          />
          <path
            d="M476.994 313.221L468.18 315.817L467.371 309.92L478.225 306.678L476.994 313.221Z"
            fill="#BFE4E0"
          />
          <path
            d="M475.888 328.355L472.349 328.451L471.896 321.826L475.287 319.809L475.888 328.355Z"
            fill="#BFE4E0"
          />
          <path
            d="M556.068 343.653L570.283 348.891L565.706 291.292L549.146 288.176L556.068 343.653Z"
            fill="#A3D9D4"
          />
          <path
            d="M569.762 290.126C567.38 289.295 565.362 288.286 565.362 288.286L549.011 284.45L544.396 285.971L543.09 278.968L526.131 167.368L567.714 184.32L569.769 290.118L569.762 290.126Z"
            fill="#A3D9D4"
          />
          <path
            d="M505.275 250.636L500 251.571L497.463 233.981H503.524L505.275 250.636Z"
            fill="#CCE9E6"
          />
          <path
            d="M472.047 324.876L469.294 266.06H468.085V269.755H463.582V269.458H457.572C457.572 270.764 458.626 271.817 459.932 271.817L463.582 271.179V270.348H468.085V324.883H472.047V324.876Z"
            fill="#6E9DB1"
          />
          <path
            d="M454.202 321.768L451.821 278.005H450.908V280.794H447.503V280.571H442.963C442.963 281.558 443.764 282.352 444.743 282.352L447.503 281.87V281.239H450.908V321.827L454.202 321.768Z"
            fill="#A3D9D4"
          />
          <path
            d="M490.394 340.359L482.055 339.268L477.27 199.284L480.037 204.24L490.394 340.359Z"
            fill="#87BCB6"
          />
          <path
            d="M469.358 222.27L490.889 226.74L490.922 226.58L469.391 222.11L469.358 222.27Z"
            fill="#87BCB6"
          />
          <path
            d="M468.942 221.42L490.473 225.891L490.628 225.143L469.097 220.672L468.942 221.42Z"
            fill="#87BCB6"
          />
          <path
            d="M468.514 219.136L490.8 223.365L490.481 224.886L468.951 220.42L468.514 219.136Z"
            fill="#87BCB6"
          />
          <path
            d="M488.998 213.328L470.814 212.326L470.77 213.573L488.412 214.24L488.998 213.328Z"
            fill="#87BCB6"
          />
          <path
            d="M487.841 211.993L469.65 210.991L469.605 212.238L487.248 212.905L487.841 211.993Z"
            fill="#87BCB6"
          />
          <path
            d="M475.842 220.435L472.17 219.671L472.444 218.343L476.02 219.582L475.842 220.435Z"
            fill="#87BCB6"
          />
          <path
            d="M490.133 261.386L476.148 265.496L475.51 264.791L489.806 259.999L490.133 261.386Z"
            fill="#87BCB6"
          />
          <path
            d="M489.416 269.823L474.799 273.228L475.122 274.615L489.739 271.211L489.416 269.823Z"
            fill="#87BCB6"
          />
          <path
            d="M536.567 208.862L528.339 165.113L543.786 168.289L543.719 168.593L528.718 165.507L536.871 208.81L536.567 208.862Z"
            fill="#FFF3C4"
          />
          <path
            d="M669.916 138.167L662.371 378.112L635.039 368.645L565.56 344.579L553.437 158.154L623.747 120.57L628.221 118.181L669.916 138.167Z"
            fill="#87BCB6"
          />
          <path
            d="M531.127 168.533L540.69 220.531L557.19 215.842L551.025 170.862L531.127 168.533Z"
            fill="#5C8EA3"
          />
          <path
            d="M580.78 349.853C580.78 346.737 577.709 287.373 577.709 287.373L607.192 278.418L608.334 359.394L580.78 349.853Z"
            fill="#355C90"
          />
          <path
            d="M534.666 172.116L542.856 215.642L554.927 213.639L549.89 175.247L534.666 172.116Z"
            fill="#FFF3C4"
          />
          <path
            d="M572.992 181.864L578.593 226.562L602.201 218.757L598.558 171.077L572.992 181.864Z"
            fill="#6E9DB1"
          />
          <path
            d="M570.929 181.375V183.185L572.992 184.216L600.695 173.103L600.502 169.556L597.935 168.533L570.929 181.375Z"
            fill="#5C8EA3"
          />
          <path
            d="M574.756 182.569L580.409 227.081L578.391 228.112L572.552 181.634L574.756 182.569Z"
            fill="#5C8EA3"
          />
          <path
            d="M586.479 177.643L592.132 222.155L590.122 223.187L584.283 176.701L586.479 177.643Z"
            fill="#5C8EA3"
          />
          <path
            d="M601.809 195.269L588.188 201.353L587.431 199.402L601.661 193.111L601.809 195.269Z"
            fill="#5C8EA3"
          />
          <path
            d="M559.62 177.547H551.941V179.313H559.62V177.547Z"
            fill="#5C8EA3"
          />
          <path
            d="M562.612 205.775H554.933V207.54H562.612V205.775Z"
            fill="#5C8EA3"
          />
          <path
            d="M576.536 294.28L609.306 288.524L611.732 284.762L611.672 263.04L609.476 262.58L574.933 273.337L576.536 294.28Z"
            fill="#6E9DB1"
          />
          <path
            d="M544.82 275.349L561.216 277.775L613.691 263.894L625.405 264.607L635.213 260.586L615.642 255.934L544.82 275.349Z"
            fill="#355C90"
          />
          <path
            d="M556.838 248.07C556.074 248.07 555.318 247.885 554.635 247.521C553.581 246.957 552.877 246.015 552.699 244.947L549.419 224.709C549.175 223.203 550.05 221.711 551.593 220.999L611.45 193.468C612.889 192.808 614.603 192.919 615.916 193.758C616.984 194.448 617.6 195.509 617.6 196.673V218.737C617.6 220.094 616.747 221.318 615.367 221.949L558.797 247.655C558.181 247.937 557.514 248.078 556.846 248.078L556.838 248.07ZM613.416 194.715C612.986 194.715 612.548 194.804 612.147 194.989L552.291 222.52C551.423 222.921 550.948 223.67 551.066 224.434L554.346 244.672C554.472 245.429 555.065 245.852 555.414 246.038C556.215 246.468 557.239 246.497 558.085 246.119L614.655 220.413C615.426 220.065 615.909 219.419 615.909 218.729V196.666C615.909 195.872 615.337 195.382 614.996 195.167C614.529 194.87 613.972 194.715 613.408 194.715H613.416Z"
            fill="#355C90"
          />
          <path
            d="M589.018 208.733L569.304 217.239L569.584 217.886L589.297 209.38L589.018 208.733Z"
            fill="#355C90"
          />
          <path
            d="M589.821 212.288L570.107 220.794L570.386 221.441L590.1 212.935L589.821 212.288Z"
            fill="#355C90"
          />
          <path
            d="M590.161 215.317L570.094 223.976L570.373 224.623L590.441 215.964L590.161 215.317Z"
            fill="#355C90"
          />
          <path
            d="M590.9 218.551L570.783 227.339L571.065 227.985L591.182 219.197L590.9 218.551Z"
            fill="#355C90"
          />
          <path
            d="M539.394 244.82L614.861 212L635.211 219.3V260.585L615.098 257.38L544.818 275.349L539.394 244.82Z"
            fill="#9DCAB4"
          />
          <path
            d="M538.791 244.464L544.822 275.349L616.119 257.544L612.847 213.521L538.791 244.464Z"
            fill="#FFF3C4"
          />
          <path
            d="M543.531 246.371L547.218 271.632L609.864 254.302L607.898 220.042L543.531 246.371Z"
            fill="#355C90"
          />
          <path
            d="M573.685 274.472C573.685 274.472 577.35 346.523 577.454 347.703C577.558 348.882 580.777 349.847 580.777 349.847L577.706 273.404L573.677 274.472H573.685Z"
            fill="#6E9DB1"
          />
          <path
            d="M575.963 288.078L609.697 281.052L609.133 279.65L575.599 287.165L575.963 288.078Z"
            fill="#355C90"
          />
          <path
            d="M575.963 284.798L609.638 277.142L609.074 275.762L575.599 283.893L575.963 284.798Z"
            fill="#355C90"
          />
          <path
            d="M575.963 281.564L609.578 273.285L609.022 271.92L575.599 280.667L575.963 281.564Z"
            fill="#355C90"
          />
          <path
            d="M575.963 278.359L609.519 269.471L608.963 268.121L575.599 277.476L575.963 278.359Z"
            fill="#355C90"
          />
          <path
            d="M575.599 276.267V277.477L608.963 268.122L608.94 266.571L575.599 276.267Z"
            fill="#87BCB6"
          />
          <path
            d="M575.599 279.569V280.778L609.022 272.053L609 270.495L575.599 279.569Z"
            fill="#87BCB6"
          />
          <path
            d="M575.599 282.618V283.827L609.074 275.681L609.052 274.123L575.599 282.618Z"
            fill="#87BCB6"
          />
          <path
            d="M575.599 285.822V287.039L609.133 279.501L609.111 277.944L575.599 285.822Z"
            fill="#87BCB6"
          />
          <path
            d="M546.373 155.401L548.369 163.235L553.117 165.728L554.578 175.729L625.979 142.478L669.914 155.401V127.492L623.909 110.948L546.373 155.401Z"
            fill="#355C90"
          />
          <path
            d="M548.367 163.236L623.737 120.771L628.047 124.903L553.115 165.728L548.367 163.236Z"
            fill="#244269"
          />
          <path
            d="M565.362 159.408H558.863C558.863 159.408 559.301 167.806 562.565 168.236C565.829 168.659 566.193 168.511 566.193 168.511L565.362 159.408Z"
            fill="#244269"
          />
          <path
            d="M556.027 160.826C556.027 160.826 556.383 167.443 559.099 168.511C561.814 169.58 564.181 169.342 564.181 169.342L566.191 168.511C566.191 168.511 561.703 167.799 561.109 166.145C560.516 164.491 558.861 159.409 558.861 159.409L556.027 160.826Z"
            fill="#6E9DB1"
          />
          <path
            d="M575.576 153.473H568.469C568.469 153.473 568.943 162.658 572.519 163.125C576.088 163.585 576.481 163.429 576.481 163.429L575.576 153.481V153.473Z"
            fill="#244269"
          />
          <path
            d="M565.371 155.023C565.371 155.023 565.757 162.257 568.732 163.421C571.707 164.586 574.289 164.327 574.289 164.327L576.485 163.421C576.485 163.421 571.573 162.642 570.928 160.84C570.282 159.03 568.472 153.473 568.472 153.473L565.371 155.023Z"
            fill="#6E9DB1"
          />
          <path
            d="M586.695 147.583H579.588C579.588 147.583 580.062 156.767 583.638 157.235C587.214 157.702 587.6 157.539 587.6 157.539L586.695 147.59V147.583Z"
            fill="#244269"
          />
          <path
            d="M576.488 149.132C576.488 149.132 576.874 156.365 579.849 157.53C582.824 158.695 585.406 158.435 585.406 158.435L587.602 157.53C587.602 157.53 582.69 156.751 582.045 154.948C581.399 153.146 579.589 147.582 579.589 147.582L576.488 149.132Z"
            fill="#6E9DB1"
          />
          <path
            d="M588.207 142.538C588.207 142.538 588.644 150.668 591.983 151.974C595.321 153.28 598.23 152.991 598.23 152.991L600.7 151.974C600.7 151.974 595.18 151.106 594.453 149.073C593.726 147.041 591.693 140.794 591.693 140.794L588.207 142.538Z"
            fill="#6E9DB1"
          />
          <path
            d="M588.68 204.729L587.988 204.862L591.348 222.294L592.04 222.161L588.68 204.729Z"
            fill="#355C90"
          />
          <path
            d="M569.333 214.057L568.65 214.157L571.143 231.142L571.826 231.042L569.333 214.057Z"
            fill="#355C90"
          />
          <path
            d="M564.29 215.708L563.613 215.843L566.973 232.686L567.649 232.551L564.29 215.708Z"
            fill="#355C90"
          />
          <path
            d="M564.538 219.131L550.072 226.246L550.377 226.865L564.843 219.75L564.538 219.131Z"
            fill="#355C90"
          />
          <path
            d="M565.474 222.691L551.008 229.806L551.312 230.425L565.778 223.31L565.474 222.691Z"
            fill="#355C90"
          />
          <path
            d="M565.855 225.559L551.388 232.674L551.693 233.293L566.159 226.178L565.855 225.559Z"
            fill="#355C90"
          />
          <path
            d="M566.255 228.744L551.789 235.859L552.093 236.478L566.56 229.363L566.255 228.744Z"
            fill="#355C90"
          />
          <path
            d="M556.423 136.728C554.954 139.784 555.355 143.657 557.395 145.215C559.435 146.78 562.173 145.319 563.456 142.114C564.74 138.909 564.109 135.571 562.254 134.146C560.399 132.722 557.818 133.82 556.423 136.72V136.728Z"
            fill="#6E9DB1"
          />
          <path
            d="M558.164 145.119L558.594 144.139L550.003 138.182L549.914 138.546L558.164 145.119Z"
            fill="#6E9DB1"
          />
          <path
            d="M551.283 138.916L551.647 138.122L549.904 136.869L549.525 137.655L551.283 138.916Z"
            fill="#6E9DB1"
          />
          <path
            d="M550.573 138.865L550.758 138.464L550.002 137.923L549.816 138.323L550.573 138.865Z"
            fill="#6E9DB1"
          />
          <path
            d="M562.329 146.372L559.732 141.906L559.895 141.654L562.878 146.001L562.329 146.372Z"
            fill="#6E9DB1"
          />
          <path
            d="M559.275 148.064L560.915 144.035L561.293 143.939L560.091 147.596L559.275 148.064Z"
            fill="#6E9DB1"
          />
          <path
            d="M548.429 254.248L550.188 253.684C551.249 253.343 552.206 253.477 552.554 254.56C553.059 256.14 552.065 257.097 550.729 257.527L550.188 257.698L550.403 259.575L549.09 259.998L548.437 254.248H548.429ZM550.551 256.429C551.226 256.214 551.508 255.776 551.323 255.175C551.182 254.745 550.833 254.634 550.351 254.79L549.876 254.945L550.076 256.585L550.566 256.429H550.551Z"
            fill="#FFF3C4"
          />
          <path
            d="M553.484 252.639L555.064 252.135L557.297 257.38L555.918 257.818L554.923 254.984C554.745 254.472 554.575 253.997 554.397 253.448H554.367C554.322 254.056 554.3 254.613 554.233 255.206L553.862 258.478L552.416 258.938L553.492 252.639H553.484ZM553.38 256.171L555.866 255.377L555.955 256.445L553.469 257.239L553.38 256.171Z"
            fill="#FFF3C4"
          />
          <path
            d="M557.142 251.475L558.901 250.911C559.962 250.569 560.919 250.703 561.267 251.786C561.772 253.366 560.778 254.323 559.442 254.754L558.901 254.924L559.116 256.794L557.795 257.217L557.142 251.467V251.475ZM559.264 253.656C559.939 253.441 560.221 253.003 560.036 252.402C559.895 251.972 559.546 251.86 559.064 252.016L558.589 252.172L558.789 253.811L559.272 253.656H559.264Z"
            fill="#FFF3C4"
          />
          <path
            d="M562.041 249.901L565.298 248.863L565.439 250.042L563.48 250.665L563.599 251.674L565.261 251.148L565.402 252.327L563.74 252.854L563.866 254.041L565.891 253.396L566.032 254.575L562.694 255.643L562.041 249.894V249.901Z"
            fill="#FFF3C4"
          />
          <path
            d="M566.459 248.499L568.217 247.935C569.285 247.594 570.235 247.713 570.569 248.759C571.044 250.257 570.042 251.251 568.773 251.659L568.195 251.845L568.425 253.826L567.112 254.248L566.459 248.499ZM568.558 250.576C569.263 250.354 569.501 249.894 569.337 249.374C569.211 248.974 568.87 248.877 568.38 249.041L567.905 249.196L568.091 250.732L568.566 250.576H568.558ZM568.543 251.385L569.204 250.22L571.34 252.891L569.961 253.329L568.543 251.385Z"
            fill="#FFF3C4"
          />
          <path
            d="M574.218 247.246L572.867 247.676L572.726 246.497L576.74 245.213L576.881 246.393L575.531 246.823L576.057 251.378L574.737 251.801L574.21 247.246H574.218Z"
            fill="#FFF3C4"
          />
          <path
            d="M577.582 244.946L579.34 244.382C580.408 244.041 581.358 244.159 581.692 245.205C582.167 246.704 581.165 247.698 579.897 248.106L579.318 248.292L579.548 250.272L578.235 250.695L577.582 244.946ZM579.681 247.023C580.386 246.8 580.624 246.34 580.46 245.821C580.334 245.421 579.993 245.324 579.503 245.487L579.029 245.643L579.214 247.179L579.689 247.023H579.681ZM579.667 247.832L580.327 246.667L582.464 249.338L581.084 249.775L579.667 247.832Z"
            fill="#FFF3C4"
          />
          <path
            d="M583.51 243.054L585.09 242.55L587.323 247.795L585.943 248.232L584.949 245.398C584.771 244.886 584.6 244.412 584.422 243.863H584.392C584.348 244.471 584.326 245.027 584.259 245.621L583.888 248.893L582.441 249.353L583.517 243.054H583.51ZM583.406 246.585L585.891 245.792L585.98 246.86L583.495 247.654L583.406 246.585Z"
            fill="#FFF3C4"
          />
          <path
            d="M587.166 241.889L588.42 241.489C589.918 241.014 591.031 241.385 591.498 242.854C592.196 245.05 591.261 246.541 589.584 247.075L587.826 247.639L587.173 241.889H587.166ZM589.206 246.021C590.096 245.74 590.668 244.931 590.17 243.366C589.896 242.52 589.34 242.364 588.716 242.564L588.598 242.601L588.998 246.081L589.199 246.021H589.206Z"
            fill="#FFF3C4"
          />
          <path
            d="M569.449 135.475L615.981 106.163L611.114 69.2551L561.785 106.675L569.449 135.475Z"
            fill="#87BCB6"
          />
          <path
            d="M584.448 130.111L625.646 107.195L615.979 106.164L569.447 135.475L584.448 130.111Z"
            fill="#355C90"
          />
          <path
            d="M572.094 129.102L611.155 102.677L608.358 74.8862L566.879 108.397L572.094 129.102Z"
            fill="#FFF3C4"
          />
          <path
            d="M586.132 128.478H582.363V134.97H586.132V128.478Z"
            fill="#355C90"
          />
          <path
            d="M581.83 101.52L582.587 100.911L583.032 106.787L582.282 107.351L581.83 101.52Z"
            fill="#E48889"
          />
          <path
            d="M583.304 100.326L584.054 99.7246L584.996 101.995L585.389 103.108L585.411 103.093C585.33 102.477 585.189 101.631 585.144 100.904L585.011 98.9531L585.768 98.3447L586.176 104.406L585.419 104.977L584.484 102.729L584.098 101.609L584.076 101.624C584.165 102.269 584.291 103.07 584.336 103.783L584.469 105.689L583.742 106.238L583.304 100.326Z"
            fill="#E48889"
          />
          <path
            d="M586.527 97.7365L588.56 96.0969L588.642 97.3952L587.417 98.3745L587.499 99.6505L588.538 98.8344L588.619 100.11L587.588 100.912L587.729 103.234L586.928 103.842L586.535 97.7365H586.527Z"
            fill="#E48889"
          />
          <path
            d="M589.195 95.5843L590.04 94.9017L590.382 101.215L589.543 101.846L589.187 95.5843H589.195Z"
            fill="#E48889"
          />
          <path
            d="M590.847 94.2489L591.686 93.5738L592.665 95.9923L593.073 97.1793L593.095 97.1645C593.021 96.5042 592.888 95.5917 592.851 94.8128L592.754 92.7133L593.607 92.0307L593.897 98.5592L593.051 99.1972L592.079 96.801L591.686 95.6066L591.663 95.6214C591.745 96.3188 591.864 97.1719 591.893 97.9435L591.997 99.991L591.181 100.607L590.847 94.2415V94.2489Z"
            fill="#E48889"
          />
          <path
            d="M575.083 117.202L576.716 116.03L576.819 117.113L575.833 117.811L575.929 118.716L576.76 118.13L576.864 119.198L576.033 119.777L576.129 120.83L577.138 120.14L577.242 121.193L575.588 122.306L575.076 117.202H575.083Z"
            fill="#E48889"
          />
          <path
            d="M577.302 115.6L577.985 115.11L578.371 119.302L579.38 118.612L579.476 119.688L577.8 120.815L577.31 115.592L577.302 115.6Z"
            fill="#E48889"
          />
          <path
            d="M579.519 114.013L581.278 112.744L581.374 113.879L580.313 114.628L580.395 115.578L581.292 114.947L581.389 116.06L580.491 116.676L580.58 117.781L581.671 117.039L581.767 118.145L579.987 119.347L579.519 114.005V114.013Z"
            fill="#E48889"
          />
          <path
            d="M582.067 115.629C581.704 113.827 582.156 112.009 583.039 111.371C583.395 111.119 583.751 111.208 584.033 111.623L583.662 112.654C583.492 112.447 583.358 112.402 583.217 112.499C582.787 112.81 582.572 113.945 582.794 115.043C582.943 115.778 583.188 116.082 583.596 115.807C583.751 115.704 583.885 115.429 583.989 115.132L584.456 115.726C584.345 116.104 584.085 116.705 583.662 116.987C582.972 117.454 582.349 116.987 582.075 115.637L582.067 115.629Z"
            fill="#E48889"
          />
          <path
            d="M585.106 111.223L584.327 111.772L584.238 110.607L586.582 108.923L586.664 110.117L585.87 110.681L586.182 115.17L585.425 115.681L585.106 111.223Z"
            fill="#E48889"
          />
          <path
            d="M587.083 108.559L588.144 107.795C588.797 107.32 589.376 107.35 589.576 108.411C589.851 109.917 589.227 111.045 588.456 111.571L588.107 111.809L588.233 113.782L587.447 114.309L587.076 108.559H587.083ZM588.337 110.481C588.767 110.184 588.916 109.687 588.819 109.168C588.745 108.767 588.537 108.708 588.241 108.915L587.951 109.123L588.055 110.681L588.345 110.481H588.337ZM588.322 111.312L588.73 110.058L590.006 112.588L589.161 113.159L588.322 111.312Z"
            fill="#E48889"
          />
          <path
            d="M590.252 109.962C589.881 107.929 590.482 106.001 591.379 105.355C592.173 104.784 592.871 105.259 593.138 106.787C593.501 108.864 592.871 110.786 591.966 111.387C591.187 111.906 590.511 111.431 590.244 109.962H590.252ZM592.285 107.477C592.144 106.668 591.869 106.342 591.55 106.564C591.164 106.839 590.845 108.018 591.075 109.287C591.216 110.081 591.491 110.4 591.802 110.192C592.188 109.925 592.515 108.753 592.285 107.477Z"
            fill="#E48889"
          />
          <path
            d="M574.627 113.553C573.989 114.035 573.514 114.087 573.18 113.723C572.713 113.211 572.735 112.188 572.795 111.616C572.869 110.815 573.099 109.762 573.499 108.397C573.863 107.143 574.39 106.475 575.05 106.423C575.584 106.379 576.111 106.727 576.675 107.098C577.795 107.84 578.537 108.204 579.301 107.009C579.657 106.46 579.828 105.778 579.761 105.184C579.717 104.799 579.576 104.531 579.375 104.45C579.205 104.383 578.574 104.331 577.624 106.349L576.86 105.155C578.114 102.432 579.153 102.336 579.665 102.528C580.266 102.751 580.696 103.552 580.815 104.665C580.956 105.978 580.637 107.388 579.954 108.419C579.694 108.812 579.435 109.101 579.182 109.294C578.144 110.081 577.135 109.413 576.296 108.849C575.139 108.078 574.738 107.944 574.353 109.235C573.789 111.134 573.722 111.921 573.722 112.18C573.856 112.173 574.189 112.032 574.768 111.446C575.332 110.882 575.762 110.266 575.836 110.125C575.836 110.125 575.829 110.147 575.814 110.185L576.645 111.156C576.46 111.661 575.696 112.559 575.221 113.026C575.013 113.226 574.82 113.397 574.642 113.538L574.627 113.553Z"
            fill="#E48889"
          />
          <path
            d="M545.667 273.649L545.637 273.434L541.556 245.472L541.697 245.413L609.485 217.682L609.5 217.949L611.933 256.074L611.785 256.111L545.667 273.641V273.649ZM541.979 245.717L545.986 273.174L611.54 255.792L609.144 218.246L541.979 245.717Z"
            fill="white"
          />
          <path
            d="M591.504 169.269L572.424 178.012L572.519 178.221L591.6 169.478L591.504 169.269Z"
            fill="#5C8EA3"
          />
        </g>
        <path
          d="M140.392 351.675L137.64 292.86H136.431V296.554H131.927V296.257H125.918C125.918 297.563 126.971 298.617 128.277 298.617L131.927 297.979V297.148H136.431V351.683H140.392V351.675Z"
          fill="#6E9DB1"
        />
        <path
          d="M302.98 307.672C293.309 301.474 299.934 305.849 286.965 294.743C249.991 263.086 346.451 165.686 369.208 153.064C439.848 113.855 330.265 254.497 353.908 287.833C356.203 291.071 357.053 291.937 356.827 294.933C349.325 321.322 330.807 317.253 302.989 307.681L302.98 307.672Z"
          fill="#C97764"
        />
        <path
          d="M205.105 203.424C212 211.57 230.953 205.878 239.557 214.629C249.173 224.399 259.151 246.918 268.966 266.243C275.066 278.251 281.103 289.014 286.951 294.734C291.876 299.551 297.227 303.873 302.975 307.671C315.709 307.545 325.009 303.431 330.377 296.457C337.843 286.785 337.752 271.602 328.796 253.874C326.762 252.34 322.415 245.474 320.589 243.706C311.94 235.334 282.721 199.436 267.727 189.016C251.008 177.396 256.963 154.769 250.818 157.223C237.27 162.636 243.081 177.441 243.081 177.441C235.273 177.693 221.653 174.283 212.507 166.993C212.507 166.993 216.357 138.123 202.212 138.719C198.191 138.89 200.54 158.829 200.342 165.55C200.061 175.086 193.374 189.548 205.105 203.424Z"
          fill="#C97764"
        />
        <path
          d="M257.847 191.588L257.061 191.136C257.323 190.685 257.576 190.279 257.829 189.891C259.519 187.257 260.74 185.353 256.79 175.032C254.747 169.692 254.169 165.136 253.753 161.806C253.455 159.407 253.211 157.512 252.551 157.196C252.253 157.052 251.747 157.196 251.042 157.62L250.662 157.846C245.945 160.67 240.079 164.188 243.513 177.333L243.595 177.631L243.351 177.811C243.053 178.028 240.124 179.841 228.475 175.835L228.764 174.978C238.118 178.19 241.625 177.513 242.546 177.189C239.148 163.692 245.529 159.867 250.201 157.07L250.581 156.844C251.214 156.466 252.154 155.996 252.949 156.375C254.052 156.908 254.277 158.703 254.648 161.689C255.064 164.973 255.624 169.475 257.631 174.708C261.743 185.462 260.423 187.528 258.589 190.379C258.345 190.758 258.091 191.155 257.838 191.588H257.847Z"
          fill="black"
        />
        <path
          d="M324.337 314.366C324.011 314.366 291.792 313.816 272.622 273.587C243.611 212.726 234.998 211.923 234.591 211.923L234.492 211.03C234.863 210.994 243.557 210.498 273.445 273.199C283.341 293.968 296.681 303.81 306.117 308.412C316.32 313.383 324.264 313.464 324.346 313.464V314.366H324.337Z"
          fill="#FFF3C4"
        />
        <path
          d="M320.352 247.135C305.25 222.514 259.383 181.708 258.922 181.293L259.518 180.617C259.979 181.032 305.945 221.928 321.12 246.657L320.352 247.126V247.135Z"
          fill="#573828"
        />
        <path
          d="M223.054 153.064C223.054 153.064 220.46 154.941 212.823 157.07C205.186 159.199 194.982 164.296 194.982 166.335C194.982 168.374 198.977 193.292 198.977 193.292C198.977 193.292 215.399 201.484 211.82 192.823C208.241 184.162 207.906 170.918 208.331 169.899C208.756 168.879 228.151 170.873 223.045 153.064H223.054Z"
          fill="#C97764"
        />
        <path
          d="M222.612 210.073C215.436 209.821 209.498 207.655 204.97 203.632C200.967 200.086 199.638 196.45 199.503 196.053C198.707 193.726 194.261 169.818 195.011 165.487C195.761 161.103 220.561 152.794 223.38 151.864L223.661 152.721C212.77 156.312 196.394 162.718 195.896 165.641C195.164 169.881 199.719 193.915 200.352 195.756C200.397 195.882 204.943 208.539 222.639 209.162L222.603 210.064L222.612 210.073Z"
          fill="black"
        />
        <path
          d="M206.181 175.402C206.181 175.402 220.695 170.567 216.511 165.983C216.511 165.983 202.629 167.878 198.598 168.78C194.567 169.682 197.116 163.945 196.104 173.12"
          fill="#C97764"
        />
        <path
          d="M236.63 210.84C234.136 210.84 231.858 210.75 230.277 210.497C228.614 210.226 226.436 210.064 224.14 209.902C218.6 209.496 212.318 209.036 209.191 206.834L209.707 206.094C212.635 208.151 218.78 208.603 224.203 209C226.526 209.171 228.713 209.333 230.421 209.604C233.91 210.172 240.932 209.893 246.066 209.685C249.617 209.541 251.497 209.478 252.04 209.613L251.823 210.488C251.38 210.38 248.822 210.488 246.102 210.587C243.228 210.705 239.757 210.84 236.63 210.84Z"
          fill="black"
        />
        <path
          d="M240.679 196.946C240.616 196.856 233.946 188.403 223.146 190.784L222.947 189.9C234.326 187.392 241.321 196.306 241.393 196.396L240.679 196.946Z"
          fill="black"
        />
        <path
          d="M270.467 266.244C276.567 278.252 281.104 289.015 286.952 294.735C291.877 299.552 307.214 311.939 324.332 313.906C337.066 313.78 321.982 304.352 327.351 297.378C329.601 288.239 328.553 282.059 320.744 288.239C310.396 296.431 289.772 282.149 270.467 266.244Z"
          fill="#B06858"
        />
        <path
          d="M493.091 317.469C493.253 319.877 493.262 322.277 493.118 324.677C512.829 343.027 531.438 344.39 548.79 326.346C549.604 325.516 550.399 324.641 551.194 323.721C551.628 317.234 551.402 310.711 550.526 304.225C549.125 293.867 546.676 276.627 543.503 258.285C537.99 226.546 530.335 191.506 522.265 183.088C482.715 141.867 491.409 292.668 493.091 317.469Z"
          fill="#C97764"
        />
        <path
          d="M548.79 326.346C549.603 325.516 550.399 324.641 551.194 323.721C551.628 317.234 551.402 310.711 550.525 304.225C549.124 293.867 546.675 276.627 543.503 258.285L532.893 265.954C532.893 265.954 551.004 305.199 548.79 326.346Z"
          fill="#995B4C"
        />
        <path
          d="M478.166 146.216L420.035 137.619C420.035 137.619 420.234 140.884 418.959 143.311C417.685 145.729 447.79 157.494 447.79 157.494L476.403 156.222L478.166 146.225V146.216Z"
          fill="#243B5C"
        />
        <path
          d="M435.785 167.932L466.731 166.335L464.887 145.603L463.242 127.153L443.323 138.367L441.895 143.979L435.785 167.932Z"
          fill="#C97764"
        />
        <path
          d="M441.895 143.979C442.464 146.081 444.19 144.899 459.916 149.302C462.175 149.933 464.634 149.211 465.194 148.995L463.251 127.153L443.332 138.367L441.904 143.979H441.895Z"
          fill="#602F2F"
        />
        <path
          d="M355.629 187.943C336.071 225.411 313.739 323.496 337.861 393.253C337.861 393.253 487.301 438.525 490.843 406.344C502.583 299.525 508.205 260.74 512.652 190.848C512.905 186.833 514.089 158.902 484.065 158.045C479.935 157.927 455.216 161.139 424.777 147.543C406.223 139.252 366.149 167.788 355.629 187.934V187.943Z"
          fill="#C97764"
        />
        <path
          d="M336.894 261.065C331.634 276.438 307.412 353.981 334.11 408.139C334.11 408.139 334.11 408.148 334.128 408.148C334.128 408.148 334.137 408.148 334.146 408.148L334.164 408.166C334.164 408.166 334.182 408.175 334.191 408.184C334.336 408.274 334.49 408.364 334.634 408.445C336.397 409.501 342.551 413.137 351.517 417.982C351.553 418.009 351.598 418.027 351.634 418.045C392.395 440.067 490.825 486.791 500.134 430.17C500.134 430.17 504.219 372.448 501.155 342.162C500.704 337.633 501.291 326.816 502.113 315.908C503.207 301.338 504.725 286.624 504.725 286.624L549.2 253.504C549.2 247.388 524.12 171.911 524.12 171.911C524.12 171.911 517.487 164.423 506.262 160.318C495.028 156.204 479.266 152.64 479.266 152.64L478.163 146.208L472.18 150.935L452.668 155.392L450.923 167.409L442.69 172.245L440.864 161.806C440.864 161.806 439.59 148.526 434.339 146.208C429.079 143.88 420.032 137.61 420.032 137.61L418.957 143.294L378.666 145.125C361.458 149.383 337.626 176.909 314.109 203.325L331.39 243.373L337.852 258.349C337.852 258.349 337.499 259.296 336.894 261.056V261.065Z"
          fill="#DC343B"
        />
        <path
          d="M337.851 258.358C337.851 258.358 337.498 259.305 336.893 261.064L339.206 256.923L362.831 208.449C362.09 209.414 341.466 236.434 331.389 243.381L337.851 258.358Z"
          fill="#243B5C"
        />
        <path
          d="M499.935 337.272C499.935 337.272 492.831 381.191 475.442 406.1C448.582 444.569 413.877 434.889 413.877 434.889C418.179 445.525 449.576 456.965 472.125 440.257C502.294 417.9 499.935 337.272 499.935 337.272Z"
          fill="#C1291E"
        />
        <path
          d="M351.637 418.054C392.397 440.077 490.828 486.801 500.137 430.18C500.137 430.18 504.222 372.458 501.158 342.172C500.706 337.643 501.293 326.825 502.116 315.918C500.444 303.747 499.368 296.025 499.368 296.025C499.368 296.025 501.366 413.363 473.575 430.18C448.721 445.219 400.947 443.234 351.637 418.054Z"
          fill="#C1291E"
        />
        <path
          d="M439.927 95.7756C439.927 101.703 441.788 106.25 438.408 106.25C435.028 106.25 431.079 102.046 430.401 96.0373C429.732 90.155 432.037 86.5734 435.417 86.5734C438.797 86.5734 439.927 89.8483 439.927 95.7756Z"
          fill="#C97764"
        />
        <path
          d="M439.928 95.7753C439.928 97.8323 440.191 99.8712 440.417 101.91C440.489 103.327 440.986 105.483 439.368 106.259C436.675 107.071 434.09 104.941 432.563 102.948C429.662 98.8608 428.532 92.2297 431.758 88.0255C433.132 86.3475 435.789 85.8062 437.615 87.0512C440.073 89.1713 439.793 92.8251 439.919 95.7753H439.928ZM439.928 95.7753C439.793 92.9063 439.956 89.2164 437.461 87.2948C435.771 86.2753 433.385 86.8527 432.237 88.4315C428.74 93.4657 431.469 104.418 437.814 105.979C440.561 106.538 440.407 103.868 440.29 101.919C440.145 99.8712 439.919 97.8323 439.928 95.7753Z"
          fill="black"
        />
        <path
          d="M439.448 97.4631C439.448 97.4631 438.653 102.091 437.505 98.5276C436.357 94.964 436.366 90.1283 433.953 91.3102C431.54 92.492 430.419 96.7774 434.197 99.6554"
          fill="#C97764"
        />
        <path
          d="M439.45 97.4633C438.844 101.379 437.66 100.215 436.955 97.1927C436.278 95.4334 436.16 89.1813 433.132 92.1675C430.99 94.3418 431.894 97.8964 434.199 99.6556C433.413 99.0873 432.699 98.3745 432.211 97.5084C430.864 95.271 431.75 91.527 434.533 90.9315C434.741 90.8864 434.976 90.9676 435.184 91.0398L435.365 91.1661C437.208 91.978 437.552 104.897 439.459 97.4814L439.45 97.4633Z"
          fill="black"
        />
        <path
          d="M481.64 110.897C481.64 110.897 488.545 91.2289 489.837 82.9378C491.13 74.6468 484.984 68.8818 480.149 66.7797C479.588 66.5361 480.203 65.1287 478.341 63.8296C476.94 62.8552 473.705 62.2778 470.108 61.7997C467.93 61.511 464.676 60.6539 454.527 62.783C445.814 64.6055 440.139 74.8904 439.867 82.7845C439.596 90.6876 435.602 103.869 435.602 103.869C437.979 103.859 444.377 76.1444 451.201 70.2261C455.15 66.7978 474.88 67.8263 479.715 73.2123C484.55 78.5983 478.594 105.141 480.646 109.02C482.697 112.899 481.649 110.906 481.649 110.906L481.64 110.897Z"
          fill="#4D4D4D"
        />
        <path
          d="M435.47 139.217H435.506L437.06 139.235L467.111 139.65C485.187 138.756 479.854 123.347 482.096 112.819C482.222 112.214 482.204 111.583 482.277 110.978L482.313 108.957V108.939L482.358 106.133V106.115L482.376 104.681L482.548 93.9088L482.737 81.9188C483.298 77.3538 482.304 73.4563 477.505 71.4264C477.279 71.3272 477.053 71.2369 476.809 71.1557C476.791 71.1467 476.763 71.1377 476.745 71.1377C475.968 70.858 475.101 70.6144 474.142 70.434L454.521 69.9558C452.958 70.0551 451.62 70.4069 450.427 70.9753H450.418C448.195 72.0399 446.505 73.8443 445.014 76.0997C443.513 78.3913 442.203 81.1249 440.748 84.048L439.23 88.4596L439.004 89.1092L436.78 95.6049L435.587 99.0693L433.906 103.959L433.617 104.816L433.165 106.837L428.258 128.715C426.052 134.688 430.264 138.702 435.47 139.217Z"
          fill="#C97764"
        />
        <path
          d="M478.85 70.6137C478.85 70.6137 455.596 85.7163 443.377 74.845C451.701 70.4694 458.398 61.7272 478.85 70.6137Z"
          fill="#4D4D4D"
        />
        <path
          d="M458.374 116.047C457.822 117.662 454.515 118.04 451.885 117.256C449.255 116.471 446.977 114.423 447.528 112.808C448.08 111.193 448.902 110.128 451.532 110.922C454.162 111.707 458.934 114.441 458.383 116.056L458.374 116.047Z"
          fill="#B05441"
        />
        <path
          d="M456.284 93.9531C453.898 99.9256 451.223 105.799 448.457 111.6C448.132 112.222 447.96 112.764 447.987 113.44C448.041 114.803 448.945 115.804 450.192 116.363C452.596 117.608 455.714 118.691 458.146 116.941C457.106 117.969 455.534 118.312 454.079 118.195C450.4 117.771 445.429 115.732 447.644 111.221L448.547 109.272C451.006 104.103 453.518 98.9602 456.266 93.9441L456.284 93.9531Z"
          fill="black"
        />
        <path
          d="M480.367 102.361C480.367 108.288 478.505 112.835 481.885 112.835C485.265 112.835 489.215 108.631 489.893 102.622C490.562 96.7401 488.257 93.1584 484.877 93.1584C481.497 93.1584 480.367 96.4334 480.367 102.361Z"
          fill="#C97764"
        />
        <path
          d="M480.368 102.361C480.368 104.418 480.151 106.457 479.998 108.505C479.88 110.445 479.726 113.124 482.474 112.565C488.818 111.004 491.548 100.052 488.05 95.0176C486.911 93.4387 484.526 92.8613 482.835 93.8808C480.332 95.8025 480.495 99.4924 480.368 102.361ZM480.368 102.361C480.495 99.4202 480.214 95.7574 482.673 93.6372C484.498 92.3922 487.165 92.9335 488.529 94.6116C491.756 98.8158 490.617 105.447 487.725 109.534C486.207 111.519 483.613 113.657 480.919 112.845C479.293 112.069 479.799 109.904 479.871 108.496C480.097 106.457 480.35 104.418 480.359 102.361H480.368Z"
          fill="black"
        />
        <path
          d="M480.848 104.048C480.848 104.048 481.643 108.676 482.791 105.113C483.939 101.549 483.93 96.7133 486.343 97.8952C488.756 99.077 489.876 103.362 486.099 106.24"
          fill="#C97764"
        />
        <path
          d="M480.848 104.048C482.755 111.464 483.098 98.5627 484.942 97.7327L485.123 97.6064C485.33 97.5432 485.556 97.453 485.773 97.4981C488.557 98.0935 489.434 101.838 488.096 104.075C487.608 104.941 486.903 105.654 486.108 106.222C487.599 104.995 488.647 103.11 488.349 101.215C488.213 100.286 487.834 99.3927 487.174 98.7341C486.569 98.0935 485.511 97.5432 484.996 98.301C483.758 100.286 483.803 102.983 482.926 105.176C481.905 108.081 481.056 105.708 480.857 104.039L480.848 104.048Z"
          fill="black"
        />
        <path
          d="M473.158 93.7455L469.145 100.792L465.62 100.638L463.479 93.1501C466.804 91.6163 470.058 91.49 473.167 93.7455H473.158Z"
          fill="#B05441"
        />
        <path
          d="M452.098 92.2213L451.158 98.4825L445.591 97.7788L444.461 92.7897C446.503 90.9583 448.998 90.5974 452.098 92.2303V92.2213Z"
          fill="#B05441"
        />
        <path
          d="M454.839 83.9023C450.537 83.6136 446.181 84.1008 442.268 85.9863C445.72 83.2347 450.682 82.6663 454.839 83.9023Z"
          fill="black"
        />
        <path
          d="M477.751 86.3836C473.711 84.895 469.391 84.1282 465.098 84.8319C469.183 83.1718 474.108 84.0199 477.751 86.3836Z"
          fill="black"
        />
        <path
          d="M466.96 100.801C467.674 100.801 468.253 99.7708 468.253 98.5003C468.253 97.2297 467.674 96.1997 466.96 96.1997C466.247 96.1997 465.668 97.2297 465.668 98.5003C465.668 99.7708 466.247 100.801 466.96 100.801Z"
          fill="black"
        />
        <path
          d="M469.244 97.7785C469.198 97.7063 468.177 96.0282 464.779 96.4162L464.725 95.9651C468.421 95.532 469.587 97.4627 469.632 97.5439L469.244 97.7694V97.7785Z"
          fill="black"
        />
        <path
          d="M467.463 101.18C466.984 101.18 466.351 101.099 465.547 100.855L465.682 100.422C467.662 101.026 468.439 100.548 468.448 100.539L468.701 100.909C468.701 100.909 468.303 101.171 467.463 101.171V101.18Z"
          fill="black"
        />
        <path
          d="M448.806 97.8629C449.517 97.8078 450.014 96.7362 449.916 95.4694C449.817 94.2026 449.16 93.2205 448.449 93.2756C447.737 93.3308 447.24 94.4024 447.339 95.6692C447.437 96.9359 448.094 97.9181 448.806 97.8629Z"
          fill="black"
        />
        <path
          d="M450.699 94.7471C447.943 92.645 446.189 93.6014 446.171 93.6104L445.945 93.2224C446.027 93.1773 447.979 92.1037 450.97 94.3863L450.699 94.7471Z"
          fill="black"
        />
        <path
          d="M449.242 98.0037C448.763 98.0037 448.121 97.9225 447.299 97.6608L447.434 97.2278C449.405 97.8503 450.191 97.3721 450.2 97.3721L450.453 97.7511C450.453 97.7511 450.064 98.0037 449.242 98.0037Z"
          fill="black"
        />
        <path
          d="M477.46 87.674C477.46 87.674 472.48 83.5691 466.335 86.5192C466.335 86.5192 464.03 89.1717 465.91 89.5867C467.79 90.0017 472.489 90.0558 473.782 90.949C475.074 91.8511 480.28 90.137 477.46 87.674Z"
          fill="#4D4D4D"
        />
        <path
          d="M453.152 85.0306C453.152 85.0306 447.115 82.0443 442.18 87.2048C442.18 87.2048 440.825 90.8497 442.741 90.7234C444.657 90.597 449.157 89.1987 450.676 89.7941C452.194 90.3895 456.614 86.88 453.152 85.0396V85.0306Z"
          fill="#4D4D4D"
        />
        <path
          d="M464.751 122.093L444.461 123.879C444.461 123.879 451.583 133.036 463.467 127.154C463.467 127.154 466.775 125.07 467.092 122.084"
          fill="white"
        />
        <path
          d="M464.753 122.093C458.02 122.995 451.268 123.681 444.508 124.303L444.806 123.617C447.843 127.118 452.579 129.139 457.224 128.67C457.64 128.597 458.715 128.453 459.122 128.39C460.559 128.065 462.023 127.524 463.379 126.946C465.006 125.9 466.768 124.186 467.112 122.093C467.066 122.625 466.949 123.157 466.741 123.662C466.081 125.169 464.933 126.405 463.596 127.361C462.439 127.903 461.147 128.498 459.908 128.841C456.085 130.059 451.747 129.563 448.268 127.56C446.46 126.567 444.915 125.151 443.613 123.527C450.654 122.941 457.703 122.399 464.762 122.102L464.753 122.093Z"
          fill="black"
        />
        <path
          d="M544.809 242.128C531.812 188.476 523.254 168.591 520.669 168.312C513.927 167.59 488.295 155.636 487.211 155.122L487.591 154.301C487.853 154.427 514.171 166.706 520.768 167.41C527.637 168.14 543.869 234.361 545.694 241.912L544.818 242.119L544.809 242.128Z"
          fill="black"
        />
        <path
          d="M321.603 337.291C320.907 303.549 332.186 270.303 341.775 248.362C353.109 222.406 365.057 204.868 368.129 201.413L368.807 202.008C365.762 205.427 353.895 222.867 342.607 248.714C333.063 270.574 321.82 303.684 322.516 337.263L321.612 337.282L321.603 337.291Z"
          fill="#602F2F"
        />
        <path
          d="M478.323 146.225C473.325 152.423 460.563 154.597 452.944 155.915L453.369 155.491L451.815 167.544L451.77 167.86L451.48 168.031L443.31 172.948C435.854 179.669 430.269 189.368 425.677 198.525C416.36 217.407 410.367 237.77 405.623 258.24C394.145 309.818 391.081 362.813 389.897 415.527C388.686 348.991 393.024 265.945 420.219 204.714C423.599 197.478 427.34 190.396 431.886 183.801C435.032 179.398 438.258 175.032 442.524 171.613L450.784 166.849L450.45 167.345L452.375 155.346L452.438 154.976L452.809 154.931C460.274 153.912 473.243 152.044 478.314 146.225H478.323Z"
          fill="#243B5C"
        />
        <path
          d="M509.776 340.556C504.723 335.928 500.087 330.857 495.93 325.381C483.024 308.384 459.751 258.962 446.647 241.036C439.407 231.13 431.716 223.335 425.137 214.936C423.139 212.392 418.096 206.374 421.088 201.728C421.467 201.132 419.714 200.302 419.651 198.209C419.542 194.366 421.061 195.458 422.172 192.138C423.962 186.788 425.815 180.283 425.598 176.674C425.155 169.43 414.843 159.542 420.799 159.488C438.757 159.316 434.907 177.315 434.907 177.315C442.824 185.885 445.219 189.981 452.693 191.01C452.693 191.01 451.301 172.407 464.822 169.375C470.958 167.995 461.405 190.631 472.847 207.366C485.13 225.338 528.918 264.213 536.229 273.749C537.775 275.77 538.588 290.737 540.359 292.56C551.675 324.686 538.814 345.238 509.785 340.556H509.776Z"
          fill="#C97764"
        />
        <path
          d="M477.917 214.837C477.682 214.684 472.079 210.886 468.554 199.644C466.457 192.932 466.376 184.262 466.322 177.929C466.286 174.293 466.258 170.179 465.68 169.827C465.237 169.593 463.339 169.782 460.935 171.316C458.278 173.021 452.205 178.344 453.145 190.974L453.172 191.29L452.873 191.416C452.611 191.525 446.285 194.015 434.545 177.568L434.436 177.424L434.464 177.243C434.473 177.162 435.494 169.349 431.472 164.261C429.484 161.753 426.592 160.291 422.859 159.93C422.208 159.822 420.455 159.759 419.877 160.652C419.497 161.238 419.434 162.51 421.268 165.289C426.04 172.498 427.794 177.243 423.302 189.522C423.257 189.639 422.281 192.481 424.585 194.782C427.152 197.344 427.703 198.318 427.721 198.354L426.926 198.787C426.926 198.787 426.375 197.849 423.944 195.413C421.223 192.697 422.398 189.341 422.452 189.206C426.808 177.306 425.118 172.723 420.518 165.776C418.801 163.178 418.34 161.347 419.117 160.147C420.13 158.577 422.859 159.001 422.976 159.028C426.935 159.416 430.044 160.986 432.186 163.701C436.145 168.717 435.53 175.917 435.385 177.18C445.218 190.902 450.912 190.893 452.223 190.659C451.391 177.811 457.691 172.317 460.456 170.549C462.679 169.123 465.111 168.474 466.132 169.024C467.135 169.575 467.198 172.146 467.244 177.911C467.298 184.19 467.37 192.779 469.431 199.365C472.856 210.308 478.369 214.043 478.423 214.079L477.926 214.828L477.917 214.837Z"
          fill="black"
        />
        <path
          d="M446.658 241.037C448.493 240.631 451.638 238.727 455.307 236.12C455.759 231.158 459.935 227.269 465.023 227.269C465.556 227.269 466.071 227.324 466.587 227.405C474.567 220.873 481.707 214.467 481.707 214.467L487.382 221.604C487.382 225.591 481.58 230.842 474.675 235.687C474.739 236.12 474.775 236.562 474.775 237.013C474.775 242.39 470.41 246.748 465.023 246.748C462.98 246.748 461.083 246.116 459.51 245.042C455.109 247.487 451.972 249.048 451.972 249.048L446.658 241.037Z"
          fill="#573828"
        />
        <path
          d="M465.015 243.373C468.539 243.373 471.396 240.521 471.396 237.004C471.396 233.486 468.539 230.634 465.015 230.634C461.491 230.634 458.635 233.486 458.635 237.004C458.635 240.521 461.491 243.373 465.015 243.373Z"
          fill="#BD9539"
        />
        <path
          d="M516.298 342.261C513.768 342.261 511.535 341.828 509.601 340.971C498.467 336.009 458.728 261.669 457.047 258.502C456.92 258.295 442.658 235.181 434.651 227.594C426.408 219.79 419.431 208.467 419.594 205.752C419.711 203.695 420.317 202.269 420.588 201.728C420.064 200.781 418.419 197.479 419.675 195.692C420.904 193.951 421.645 192.381 421.655 192.363L422.477 192.742C422.45 192.805 421.7 194.393 420.425 196.207C419.522 197.488 420.895 200.456 421.501 201.493L421.636 201.719L421.501 201.945C421.501 201.945 420.642 203.424 420.507 205.797C420.38 208.025 427.14 219.212 435.284 226.926C443.372 234.586 457.697 257.799 457.842 258.033C458.267 258.827 499.126 335.287 509.981 340.123C520.754 344.932 539.2 333.727 539.39 333.618L539.86 334.385C539.815 334.412 535.079 337.308 529.042 339.555C524.215 341.35 519.959 342.243 516.307 342.243L516.298 342.261Z"
          fill="#573828"
        />
        <path
          d="M435.468 139.215H435.504C435.585 139.215 435.667 139.206 435.748 139.206L447.542 139.369C435.423 135.471 433.931 134.001 432.937 131.962C431.066 128.137 430.081 128.543 430.895 124.366C431.771 119.846 433.525 107.973 433.859 104.806L433.163 106.836L428.256 128.714C426.05 134.686 430.262 138.701 435.468 139.215Z"
          fill="#E39C6B"
        />
        <path
          d="M481.889 112.827C481.997 120.071 481.446 134.118 475.092 138.801C474.432 139.234 473.637 139.495 472.86 139.631C465.982 140.939 458.933 140.812 452.019 140.596C446.478 140.361 440.956 139.91 435.47 139.216C446.469 139.369 457.568 139.694 468.486 138.53C470.935 138.115 473.8 138.25 475.445 136.085C477.08 134.082 478.011 131.457 478.78 128.967C480.307 123.725 481.166 118.258 481.889 112.827Z"
          fill="black"
        />
        <path
          d="M406.187 219.925C408.184 219.925 409.802 218.309 409.802 216.316C409.802 214.323 408.184 212.707 406.187 212.707C404.191 212.707 402.572 214.323 402.572 216.316C402.572 218.309 404.191 219.925 406.187 219.925Z"
          fill="#243B5C"
        />
        <path
          d="M388.5 268.282C390.496 268.282 392.115 266.667 392.115 264.674C392.115 262.681 390.496 261.065 388.5 261.065C386.503 261.065 384.885 262.681 384.885 264.674C384.885 266.667 386.503 268.282 388.5 268.282Z"
          fill="#243B5C"
        />
        <path
          d="M381.642 321.123C383.639 321.123 385.258 319.508 385.258 317.515C385.258 315.522 383.639 313.906 381.642 313.906C379.646 313.906 378.027 315.522 378.027 317.515C378.027 319.508 379.646 321.123 381.642 321.123Z"
          fill="#C1291E"
        />
        <path
          d="M205.176 182.104L219.79 207.139L249.352 192.01"
          fill="#AA5F53"
        />
        <path
          d="M188.683 144.074L183.816 156.459C183.816 156.459 201.519 168.837 222.471 200.509L224.303 191.817C224.303 191.817 202.952 159.025 188.691 144.074H188.683Z"
          fill="#93D8A8"
        />
        <path
          d="M251.054 179.136L249.702 188.403L222.473 200.501L224.297 191.809L251.054 179.136Z"
          fill="#67B27C"
        />
        <path
          d="M188.684 144.074L208.764 140.085L251.053 179.144L224.296 191.817"
          fill="#67B27C"
        />
        <path
          d="M192.828 139.178C192.828 139.178 194.49 153.93 205.176 164.34L224.29 191.817L251.047 179.144C251.047 179.144 228.854 158.641 221.52 149.153C221.52 149.153 217.635 143.941 217.938 139.186H192.828V139.178Z"
          fill="#93D8A8"
        />
        <path
          d="M197.769 142.252C197.511 142.252 200.207 151.18 200.413 151.681C203.36 158.715 208.847 164.347 213.16 170.547C216.558 175.428 219.955 180.308 223.352 185.196C223.485 185.388 224.711 187.725 224.844 187.916L246.358 178.023C246.358 178.023 227.274 160.211 221.624 152.898C221.624 152.898 215.236 145.761 215.465 142.097L197.769 142.26V142.252Z"
          fill="#B5EAC3"
        />
        <path
          d="M200.918 172.288L202.594 162.682L204.921 165.896L203.377 174.971L200.918 172.288Z"
          fill="#C9F7D3"
        />
        <path
          d="M197.146 180.87C194.236 175.872 189.925 164.504 188.994 162.023C188.894 161.762 189.03 161.455 189.301 161.365C192.139 160.471 195.51 161.094 197.507 163.367C198.275 164.243 198.827 165.28 199.224 166.363C199.938 168.293 199.785 170.242 201.086 171.974C203.02 174.536 204.701 177.017 205.578 180.157"
          fill="#C97764"
        />
        <path
          d="M196.748 181.105C193.585 175.186 191.307 168.943 188.948 162.7C188.867 162.42 188.731 162.231 188.695 161.897C188.65 161.527 189.021 161.13 189.337 161.112C195.392 159.506 199.396 163.557 200.065 169.34C200.363 171.406 201.981 172.859 203.02 174.618C204.132 176.341 205.045 178.2 205.578 180.175C205.009 178.209 204.06 176.368 202.921 174.681C201.827 172.958 200.209 171.478 199.839 169.394C199.441 167.4 198.935 165.407 197.625 163.81C195.718 161.383 192.075 160.616 189.265 161.699C189.102 161.843 189.391 162.303 189.445 162.52C191.886 168.645 194.317 174.916 197.525 180.663L196.748 181.114V181.105Z"
          fill="black"
        />
        <path
          d="M196.947 180.292C195.835 174.572 195.492 162.294 195.438 159.767C195.438 159.515 195.636 159.298 195.898 159.298C198.89 159.371 201.9 161.067 203.047 163.881C203.481 164.955 203.662 166.119 203.68 167.274C203.716 169.331 202.939 171.126 203.599 173.183C204.584 176.232 205.361 179.128 205.153 182.376"
          fill="#C97764"
        />
        <path
          d="M196.504 180.373C195.456 173.742 195.365 167.093 195.185 160.417C195.203 160.128 195.148 159.912 195.185 159.587C195.248 159.199 195.745 158.964 196.043 159.046C202.297 159.497 204.765 164.639 203.49 170.332C203.093 172.38 204.141 174.283 204.548 176.286C205.036 178.271 205.289 180.337 205.144 182.376C205.253 180.328 204.963 178.28 204.439 176.313C203.978 174.329 202.93 172.398 203.273 170.314C203.554 168.302 203.725 166.245 203.011 164.314C202.008 161.382 198.809 159.506 195.79 159.578C195.618 159.632 195.727 160.137 195.718 160.408C196.016 167.003 196.242 173.724 197.39 180.202L196.504 180.373Z"
          fill="black"
        />
        <path
          d="M227.467 164.48L225.655 162.24C225.641 162.869 225.394 163.499 224.802 164.056L226.001 165.535L225.281 166.052L224.097 164.587C222.518 165.508 220.685 165.084 219.225 163.387C218.915 165.283 218.379 167.49 217.815 169.691L216.758 168.392C217.258 166.363 217.71 164.474 218.118 162.16L219.014 161.517L219.62 162.26C220.805 163.725 222.095 164.043 223.166 163.426L220.657 160.337L221.376 159.82L223.85 162.869C224.534 162.081 224.365 161.06 223.413 159.88L222.631 158.918L223.568 158.249L228.2 163.957L227.481 164.474L227.467 164.48Z"
          fill="#5A9B69"
        />
        <g opacity="0.3" clipPath="url(#clip4_252_7047)">
          <path
            d="M-59.8167 365.347L41.134 356.593C43.1445 345.139 48.2266 317.155 48.2266 317.155L32.016 311.747L35.6291 275.009L30.2429 272.85L17.445 267.731L9.78119 264.668L9.64023 264.949L3.38599 277.205L5.12946 262.909L13.0233 198.084L-14.1303 178.039L-14.9242 178.365L-56.5078 195.317L-58.5628 301.116L-59.8092 365.355L-59.8167 365.347Z"
            fill="#CCE9E6"
          />
          <path
            d="M13.0178 281.983L30.3412 286.494L30.7715 279.364L13.589 274.512L13.0178 281.983Z"
            fill="#BFE4E0"
          />
          <path
            d="M11.6052 338.937L22.9267 339.137L23.1641 327.17L13.0148 324.626L11.6052 338.937Z"
            fill="#A3D9D4"
          />
          <path
            d="M24.5684 322.371C24.2716 322.415 12.0525 320.509 12.0525 320.509L11.8744 321.978L24.5609 323.951V322.363L24.5684 322.371Z"
            fill="#A3D9D4"
          />
          <path
            d="M30.3386 273.926C30.3386 273.926 30.576 268.785 24.2253 266.93C17.8746 265.068 16.2721 269.274 16.2721 269.274L30.3386 273.926Z"
            fill="#CCE9E6"
          />
          <path
            d="M-15.1162 197.15L9.01791 207.736L9.87109 200.881L-13.2614 187.713L-15.1162 197.15Z"
            fill="#BFE4E0"
          />
          <path
            d="M-19.9086 236.061L4.77451 242.241L5.53125 236.113L-18.0612 226.624L-19.9086 236.061Z"
            fill="#BFE4E0"
          />
          <path
            d="M-21.46 260.149L1.49441 267.435L1.86536 264.475L-21.0372 256.796L-21.46 260.149Z"
            fill="#AFD5D0"
          />
          <path
            d="M-1.44291 341.244L5.65709 339.048L9.87109 265.054L9.63369 264.942L3.37203 277.198L-1.44291 341.244Z"
            fill="#A3D9D4"
          />
          <path
            d="M34.1978 324.203L43.0116 326.8L43.8203 320.902L32.9663 317.66L34.1978 324.203Z"
            fill="#BFE4E0"
          />
          <path
            d="M35.3015 339.337L38.8404 339.434L39.293 332.809L35.9025 330.791L35.3015 339.337Z"
            fill="#BFE4E0"
          />
          <path
            d="M5.91433 261.619L11.1893 262.554L13.7266 244.964H7.66522L5.91433 261.619Z"
            fill="#CCE9E6"
          />
          <path
            d="M39.1466 335.858L41.899 277.042H43.1083V280.737H47.6117V280.44H53.6211C53.6211 281.746 52.5676 282.799 51.2618 282.799L47.6117 282.161V281.33H43.1083V335.865H39.1466V335.858Z"
            fill="#6E9DB1"
          />
          <path
            d="M56.9869 332.749L59.3684 288.986H60.2809V291.776H63.6862V291.553H68.2267C68.2267 292.54 67.4254 293.334 66.4461 293.334L63.6862 292.852V292.221H60.2809V332.809L56.9869 332.749Z"
            fill="#A3D9D4"
          />
          <path
            d="M20.7957 351.341L29.1347 350.25L33.9199 210.266L31.1526 215.222L20.7957 351.341Z"
            fill="#87BCB6"
          />
          <path
            d="M41.8315 233.252L20.3008 237.723L20.2676 237.563L41.7984 233.092L41.8315 233.252Z"
            fill="#87BCB6"
          />
          <path
            d="M42.2456 232.402L20.7148 236.872L20.5595 236.124L42.0902 231.654L42.2456 232.402Z"
            fill="#87BCB6"
          />
          <path
            d="M42.6758 230.119L20.389 234.347L20.7081 235.868L42.2381 231.402L42.6758 230.119Z"
            fill="#87BCB6"
          />
          <path
            d="M22.1933 224.31L40.3774 223.308L40.4219 224.554L22.7794 225.222L22.1933 224.31Z"
            fill="#87BCB6"
          />
          <path
            d="M23.348 222.975L41.5395 221.973L41.584 223.219L23.9416 223.887L23.348 222.975Z"
            fill="#87BCB6"
          />
          <path
            d="M35.3452 231.417L39.0176 230.653L38.7431 229.325L35.1671 230.564L35.3452 231.417Z"
            fill="#87BCB6"
          />
          <path
            d="M21.0548 272.368L35.0397 276.478L35.6777 275.773L21.3813 270.981L21.0548 272.368Z"
            fill="#87BCB6"
          />
          <path
            d="M21.7752 280.805L36.3927 284.209L36.0696 285.596L21.4521 282.192L21.7752 280.805Z"
            fill="#87BCB6"
          />
        </g>
        <g opacity="0.4" clipPath="url(#clip5_252_7047)">
          <path
            d="M56.9919 432.095L157.943 423.341C159.953 411.886 165.035 383.903 165.035 383.903L148.825 378.494L152.438 341.757L147.051 339.598L134.254 334.479L126.59 331.415L126.449 331.697L120.195 343.953L121.938 329.657L129.832 264.832L102.678 244.786L101.884 245.113L60.3008 262.065L58.2458 367.863L56.9994 432.102L56.9919 432.095Z"
            fill="#CCE9E6"
          />
          <path
            d="M129.824 348.73L147.148 353.241L147.578 346.112L130.396 341.26L129.824 348.73Z"
            fill="#BFE4E0"
          />
          <path
            d="M147.149 340.674C147.149 340.674 147.387 335.532 141.036 333.678C134.685 331.816 133.083 336.022 133.083 336.022L147.149 340.674Z"
            fill="#CCE9E6"
          />
          <path
            d="M101.692 263.897L125.826 274.484L126.68 267.629L103.547 254.461L101.692 263.897Z"
            fill="#BFE4E0"
          />
          <path
            d="M96.9 302.808L121.583 308.988L122.34 302.86L98.7474 293.372L96.9 302.808Z"
            fill="#BFE4E0"
          />
          <path
            d="M95.3465 326.897L118.301 334.182L118.672 331.222L95.7694 323.544L95.3465 326.897Z"
            fill="#AFD5D0"
          />
          <path
            d="M115.366 407.991L122.466 405.795L126.68 331.801L126.442 331.69L120.181 343.945L115.366 407.991Z"
            fill="#A3D9D4"
          />
          <path
            d="M58.2379 367.856C60.6194 367.025 62.6374 366.016 62.6374 366.016L78.9889 362.181L83.6035 363.701L84.9093 356.698L101.869 245.098L60.2855 262.05L58.2305 367.848L58.2379 367.856Z"
            fill="#A3D9D4"
          />
          <path
            d="M122.723 328.366L127.998 329.301L130.535 311.711H124.474L122.723 328.366Z"
            fill="#CCE9E6"
          />
          <path
            d="M155.951 402.605L158.704 343.789H159.913V347.484H164.416V347.187H170.426C170.426 348.493 169.372 349.546 168.067 349.546L164.416 348.908V348.077H159.913V402.612H155.951V402.605Z"
            fill="#6E9DB1"
          />
          <path
            d="M137.604 418.088L145.943 416.998L150.728 277.013L147.961 281.969L137.604 418.088Z"
            fill="#87BCB6"
          />
          <path
            d="M158.64 299.999L137.109 304.47L137.076 304.31L158.607 299.84L158.64 299.999Z"
            fill="#87BCB6"
          />
          <path
            d="M159.054 299.15L137.523 303.62L137.368 302.872L158.899 298.402L159.054 299.15Z"
            fill="#87BCB6"
          />
          <path
            d="M159.484 296.866L137.198 301.095L137.517 302.616L159.047 298.15L159.484 296.866Z"
            fill="#87BCB6"
          />
          <path
            d="M139.002 291.057L157.186 290.056L157.23 291.302L139.588 291.97L139.002 291.057Z"
            fill="#87BCB6"
          />
          <path
            d="M140.159 289.722L158.35 288.72L158.395 289.967L140.752 290.634L140.159 289.722Z"
            fill="#87BCB6"
          />
          <path
            d="M152.156 298.165L155.828 297.4L155.554 296.073L151.978 297.311L152.156 298.165Z"
            fill="#87BCB6"
          />
          <path
            d="M137.867 339.116L151.852 343.226L152.49 342.521L138.194 337.728L137.867 339.116Z"
            fill="#87BCB6"
          />
          <path
            d="M91.4401 286.591L99.6678 242.843L84.2214 246.018L84.2882 246.322L99.2895 243.236L91.136 286.539L91.4401 286.591Z"
            fill="#FFF3C4"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_252_7047">
          <rect width="591" height="347" fill="white" />
        </clipPath>
        <clipPath id="clip1_252_7047">
          <rect
            width="226.94"
            height="323.724"
            fill="white"
            transform="translate(135.928 125.991)"
          />
        </clipPath>
        <clipPath id="clip2_252_7047">
          <rect
            width="226.94"
            height="323.724"
            fill="white"
            transform="translate(246.064 99.2927)"
          />
        </clipPath>
        <clipPath id="clip3_252_7047">
          <rect
            width="226.94"
            height="323.724"
            fill="white"
            transform="translate(442.963 69.2555)"
          />
        </clipPath>
        <clipPath id="clip4_252_7047">
          <rect
            width="226.94"
            height="323.724"
            fill="white"
            transform="matrix(-1 0 0 1 68.2266 80.2382)"
          />
        </clipPath>
        <clipPath id="clip5_252_7047">
          <rect
            width="226.94"
            height="323.724"
            fill="white"
            transform="matrix(-1 0 0 1 185.035 146.985)"
          />
        </clipPath>
      </defs>
    </svg>
  )
};
